(function() {
    'use strict';

    angular
        .module('gwApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ngSanitize',
            'com.2fdevs.videogular',
            'angular-loading-bar',
            'ui.calendar',
            'daterangepicker',
            'me-lazyload'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('WgaccessService', WgaccessService);

    WgaccessService.$inject = ['$resource'];

    function WgaccessService($resource) {
        var service = $resource('api/wgaccess/:param', {}, {
            'queryByCompany': {method: 'GET', params: {param: 'getCompanyRecords'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('CityManagerService', CityManagerService)
        .factory('RegionManagerService', RegionManagerService)
        .factory('BuildingManagerService', BuildingManagerService)
        .factory('RoomManagerService', RoomManagerService)
        .factory('FacilitiesManagerService', FacilitiesManagerService);

    CityManagerService.$inject = ['$resource'];
    RegionManagerService.$inject = ['$resource'];
    BuildingManagerService.$inject = ['$resource'];
    RoomManagerService.$inject = ['$resource'];
    FacilitiesManagerService.$inject = ['$resource'];

    function CityManagerService($resource) {
        return $resource('api/city/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByPage'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'findAll': {method: 'GET', params: {param: 'findAll'}, isArray: false},
            'delete': {method: 'POST', params: {param: 'delete'}, isArray: false}
        });
    }
    function RegionManagerService($resource) {
        return $resource('api/region/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByPage'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'findAll': {method: 'GET', params: {param: 'findAll'}, isArray: false},
            'findByCity': {method: 'GET', params: {param: 'findByCity'}, isArray: false},
            'delete': {method: 'POST', params: {param: 'delete'}, isArray: false}
        });
    }
    function BuildingManagerService($resource) {
        return $resource('api/building/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByPage'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'update': {method: 'POST', params: {param: 'update'}, isArray: false},
            'findAll': {method: 'GET', params: {param: 'findAll'}, isArray: false},
            'findByArea': {method: 'GET', params: {param: 'findByArea'}, isArray: false},
            'delete': {method: 'GET', params: {param: 'delete'}, isArray: false},
            'findOne': {method: 'GET', params: {param: 'findOne'}, isArray: false},
            'findLevel': {method: 'GET', params: {param: 'getLevel'}, isArray: false}
        });
    }
    function RoomManagerService($resource) {
        return $resource('api/room/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByBuilding'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'update': {method: 'POST', params: {param: 'update'}, isArray: false},
            'findAll': {method: 'GET', params: {param: 'findAll'}, isArray: false},
            'findOne': {method: 'GET', params: {param: 'findOne'}, isArray: false},
            'findNonPhantom': {method: 'GET', params: {param: 'findNonPhantom'}, isArray: false},
            'findConference': {method: 'GET', params: {param: 'findConference'}, isArray: false},
            'delete': {method: 'GET', params: {param: 'delete'}, isArray: false}
        });
    }
    function FacilitiesManagerService($resource) {
        return $resource('api/facility/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByPage'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'update': {method: 'POST', params: {param: 'update'}, isArray: false},
            'findAll': {method: 'GET', params: {param: 'findAll'}, isArray: false},
            'delete': {method: 'POST', params: {param: 'delete'}, isArray: false},
            'disable': {method: 'GET', params: {param: 'disable'}, isArray: false},
            'enable': {method: 'GET', params: {param: 'enable'}, isArray: false}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('OfficeService', OfficeService)
        .factory('OfficeItemService', OfficeItemService);

    OfficeService.$inject = ['$resource'];
    OfficeItemService.$inject = ['$resource'];

    function OfficeService($resource) {
        var service = $resource('api/bookJob/:param', {}, {
            'findByOffice': {method: 'GET', params: {param: 'findByOffice'}, isArray: false},
            'getByOffice': {method: 'GET', params: {param: 'getByOffice'}, isArray: false},
            'getPrice': {method: 'POST', params: {param: 'getPrice'}, isArray: false},
            'create': {method: 'POST', params: {param: 'create'}, isArray: false},
            'update': {method: 'POST', params: {param: 'update'}, isArray: false},
            'cancelled': {method: 'POST', params: {param: 'cancelled'}, isArray: false},
            'cancelPrice': {method: 'POST', params: {param: 'getCancelledPrice'}, isArray: false},
            'updatePrice': {method: 'POST', params: {param: 'getUpdatePrice'}, isArray: false}
        });
        return service;
    }

    function OfficeItemService($resource) {
        var service = $resource('api/bookItem/:param', {}, {
            'queryCalenderItems': {method: 'GET', params: {param: 'queryCalenderItems'}, isArray: false},
            'queryByCompany': {method: 'GET', params: {param: 'queryByCompany'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('MemberAccountService', MemberAccountService)
        .factory('MemberService', MemberService);

    MemberAccountService.$inject = ['$resource'];

    function MemberAccountService($resource) {
        var service = $resource('api/member/:param', {}, {
            'register': {method: 'POST', params: {param: 'registry'}, isArray: false},
            'login': {method: 'POST', params: {param: 'authenticate'}, isArray: false},
            'update': {method: 'POST', params: {param: 'account/profile'}, isArray: false},
            'resetPassword': {method: 'POST', params: {param: 'account/resetPassword'}, isArray: false},
            'forgotPassword': {method: 'POST', params: {param: 'account/recoverPassword'}, isArray: false}
        });
        return service;
    }

    MemberService.$inject = ['$resource'];

    function MemberService($resource) {
        var service = $resource('api/members/:param', {}, {
            'check': {method: 'GET', params: {param: 'checkMember'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('EmployeeService', EmployeeService);

    EmployeeService.$inject = ['$resource'];

    function EmployeeService($resource) {
        var service = $resource('api/employee/:param', {}, {
            'account': {method: 'GET', params: {param: 'accountInfo'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('CompanyService', CompanyService);

    CompanyService.$inject = ['$resource'];

    function CompanyService($resource) {
        var service = $resource('api/company/:param', {}, {
            'findOne': {method: 'GET', params: {param: 'findEffectiveOffice'}, isArray: false},
            'getWifi': {method: 'GET', params: {param: 'getWifi'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('ProjectCache', ProjectCache);

    ProjectCache.$inject = ['$cacheFactory'];

    function ProjectCache ($cacheFactory) {
        return $cacheFactory('project');
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('BookItemService', BookItemService);

    BookItemService.$inject = ['$resource'];

    function BookItemService($resource) {
        var service = $resource('api/bookItem/:param', {}, {
            'queryCalenderItems': {method: 'GET', params: {param: 'queryCalenderItems'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('VerificationService', VerificationService);

    VerificationService.$inject = ['$resource'];

    function VerificationService($resource) {
        var service = $resource('api/:param', {}, {
            'get': {method: 'POST', params: {param: 'account/generateVCode'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$state', 'EmployeeService'];

    function Principal ($q, Account, $state, EmployeeService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }
            // if (_identity) {
            //     deferred.resolve(_identity);
            //     return deferred.promise;
            // }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                if (_identity.data.employeeId) {
                    EmployeeService.account({id:_identity.data.employeeId}).$promise.then(function (res) {
                        _identity.data.authorities = res.data.authorities||[];
                    })
                }
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var resourceUrl =  'api/account/:id';

        return $resource(resourceUrl, {}, {
            'change': { method: 'POST', isArray: true,
                params: {
                    id: 'change_password'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'MessageService', '$localStorage'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, MessageService, $localStorage) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function permitAll() {
            return ["login","home","building","register", "default","buildingDetail", "roomDetail", "activities", "activity", "promotion",'preview','negotiation'];
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);
            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();
                var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
                if(!token){
                    isAuthenticated = false;
                }

                // 账户失效
                if (!isAuthenticated && permitAll().indexOf($rootScope.toState.name) === -1) {
                    $state.go('home');
                    $rootScope.$emit('userlogout');
                    if ($rootScope.toState.name !== 'home') {
                        MessageService.error('登录认证失效，请重新登录 !');
                    }
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                } else if (isAuthenticated && $rootScope.toState.name === 'login') {
                    $state.go('home');
                }
                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('home');
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        // account.langKey 一般是中文，由于不考虑其他语言，所以为：zh-cn
                        $translate.use('zh-cn').then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function register(credentials, callback) {

        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            // return PasswordResetFinish.save(keyAndPassword, function () {
            //     return cb();
            // }, function (err) {
            //     return cb(err);
            // }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            // return PasswordResetInit.save(mail, function() {
            //     return cb();
            // }, function (err) {
            //     return cb(err);
            // }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http','$rootScope' ,'$localStorage', '$sessionStorage', '$q', 'MessageService'];

    function AuthServerProvider ($http,$rootScope ,$localStorage, $sessionStorage, $q, MessageService) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {
            var deferred = $q.defer();
            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            $http.post('api/authenticate', data).success(authenticateSuccess).error(authenticateError);
            return deferred.promise;

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    deferred.resolve(jwt);
                    return;
                }
                deferred.reject();
            }

            function authenticateError (data, status, headers) {
                // MessageService.error("用户名或者密码有误");
                $rootScope.$broadcast('loginError');
                deferred.reject();
            }

        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/member/account/current', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('RoomDetailController', RoomDetailController);
    RoomDetailController.$inject = ['$state', '$scope', '$stateParams', 'RoomService', '$uibModal'];

    function RoomDetailController($state, $scope, $stateParams, RoomService, $uibModal) {
        /**
         * Created by vimpans on 2019/7/8
         */
        var vm = $scope;

        vm.roomModel = null;
        vm.buildingModel = null;
        vm.map = null;
        vm.centerPoint = null;
        vm.local = null;
        vm.agencyContentTop = 0;
        vm.roomPage = 0;
        vm.statusValueList = ["NOTRENT","SHARED","RENTED"];
        vm.statusNameList = ["未租","共享","已租"];

        initRoomAction();
        addListener();
        function initRoomAction() {
            RoomService.findOne({id: $stateParams.id}, function (res) {
                if (!res || !res.data) {return}
                vm.roomModel = res.data;
                vm.buildingModel = vm.roomModel.building;
                vm.buildingModel.address = (vm.buildingModel.addrProvince||'')+(vm.buildingModel.addrCity||'')+(vm.buildingModel.addrDistrict||'')+(vm.buildingModel.addrAddress||'');
                if (vm.buildingModel.address) {
                    initMapAction();
                }
            })
        }

        function initMapAction(){
            if (!BMap) {return}
            vm.map = new BMap.Map("baiduMap");
            vm.map.addControl(new BMap.NavigationControl({type: BMAP_NAVIGATION_CONTROL_ZOOM} ));
            vm.map.enableScrollWheelZoom();
            vm.map.enableKeyboard();
            vm.map.enableDragging();
            vm.map.enableDoubleClickZoom();
            vm.local = new BMap.LocalSearch(vm.map, {renderOptions: {map: vm.map, autoViewport: false}});
            // addMapOverlay();
            addressToPoint(function (point) {
                vm.centerPoint = point;
                vm.map.centerAndZoom(point, 17);
                vm.map.addOverlay(new BMap.Marker(point));
            });
        }

        function addressToPoint(cb) {
            var geo = new BMap.Geocoder();
            geo.getPoint(vm.buildingModel.address, cb, vm.buildingModel.addrProvince);
        }
        vm.nearbySearch = function (keys) {
            if (!keys) {return}
            vm.local.clearResults();
            vm.local.searchNearby(keys,vm.centerPoint,1000);
        };

        function addMapOverlay() {
            var icon = new BMap.Icon('../image/aboutus-map-annotation.png', new BMap.Size(50, 45), {
                anchor: new BMap.Size(15, 50)
            });
            var mkr = new BMap.Marker(new BMap.Point(121.456618,31.232689), {
                icon: icon
            });
            vm.map.addOverlay(mkr);
        }

        vm.managerExtend = false;
        vm.extendManagerAction = function () {
            vm.managerExtend = !vm.managerExtend;
            calculateAgency();
        };
        function addListener() {
            window.onscroll = function (ev) {
                calculateAgency();
                vm.$apply();
            }
        }
        function calculateAgency() {
            var totalHeight = $('.agency-container')[0].clientHeight;
            var contentHeight = $('.agency-content')[0].clientHeight;
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            vm.agencyContentTop = (t-284)>0 ? (t-284) : 0;
            if (contentHeight + vm.agencyContentTop > totalHeight) {
                vm.agencyContentTop = totalHeight-contentHeight-5;
            }
        }

        vm.swiper_animation = { transform: 'translateX(0)' };
        vm.swiper_countor = 0;
        function autoSwiper() {
            if (!vm.roomModel.previewImages.images || vm.roomModel.previewImages.images.length===0 || vm.roomModel.previewImages.images.length===1) {
                return;
            }
            vm.interval = $interval(function () {
                vm.swiper_countor++;
                if (vm.swiper_countor === vm.roomModel.previewImages.images.length) {
                    vm.swiper_countor = 0;
                }
                vm.swiper_animation.transform = 'translateX('+(-vm.swiper_countor * 830)+'px)';
            }, 5000);
        }
        vm.tapSwiperBtn = function (idex) {
            if (!vm.roomModel.previewImages.images || vm.roomModel.previewImages.images.length===0 || vm.roomModel.previewImages.images.length===1) {
                return;
            }
            $interval.cancel(vm.interval);
            vm.swiper_animation.transform = 'translateX('+(-idex * 830)+'px)';
            vm.swiper_countor = idex;
            autoSwiper();
        };
        vm.previousImageAction = function () {
            vm.swiper_countor--;
            vm.tapSwiperBtn(vm.swiper_countor);
        };
        vm.nextImageAction = function () {
            vm.swiper_countor++;
            vm.tapSwiperBtn(vm.swiper_countor);
        };

        vm.rooms_animation = {transform: 'translateX(0)'};
        vm.rooms_countor = 0;
        function roomAutoSwiper() {
            if (!vm.roomModel.roomImages.images || vm.roomModel.roomImages.images.length===0 || vm.roomModel.roomImages.images.length===1) {
                return;
            }
            vm.roomTnterval = $interval(function () {
                vm.rooms_countor++;
                if (vm.rooms_countor === vm.roomModel.roomImages.images.length) {
                    vm.rooms_countor = 0;
                }
                vm.rooms_animation.transform = 'translateX('+(-vm.rooms_countor * 830)+'px)';
            }, 5000);
        }
        vm.tapRoomSwiperBtn = function (idex) {
            if (!vm.roomModel.roomImages.images || vm.roomModel.roomImages.images.length===0 || vm.roomModel.roomImages.images.length===1) {
                return;
            }
            $interval.cancel(vm.roomTnterval);
            vm.rooms_animation.transform = 'translateX('+(-idex * 830)+'px)';
            vm.rooms_countor = idex;
            roomAutoSwiper();
        };
        vm.previousRoomImageAction = function () {
            vm.rooms_countor--;
            vm.tapRoomSwiperBtn(vm.rooms_countor);
        };
        vm.nextRoomImageAction = function () {
            vm.rooms_countor++;
            vm.tapRoomSwiperBtn(vm.rooms_countor);
        };

        vm.appointmentAction = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/appointment/appointment.html',
                controller: 'AppointmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {source: vm.buildingModel.name+'/'+vm.roomModel.name, buildingId: vm.buildingModel.id, managerName: vm.roomModel.managerName, managerPhone: vm.roomModel.managerPhone};
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/8
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('roomDetail', {
                parent: 'module',
                url: '/room-detail?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/room/room-detail.html',
                        controller: 'RoomDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('RoomService', RoomService);

    RoomService.$inject = ['$resource'];

    function RoomService($resource) {
        var service = $resource('api/room/:param', {}, {
            'search': {method: 'GET', params: {param: 'search'}, isArray: false},
            'filtration': {method: 'GET', params: {param: 'filtration'}, isArray: false},
            'findOne': {method: 'GET', params: {param: 'findOne'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('RegisterController', RegisterController);
    RegisterController.$inject = ['$state', '$scope', 'VerificationService', '$interval', 'MemberAccountService', 'MessageService', '$rootScope', 'AuthServerProvider', '$uibModalInstance', '$window', '$uibModal'];

    function RegisterController($state, $scope, VerificationService, $interval, MemberAccountService, MessageService, $rootScope, AuthServerProvider, $uibModalInstance, $window, $uibModal) {
        /**
         * Created by vimpans on 2019/6/19
         */
        var vm = $scope;

        vm.agree = false;
        vm.agreementNegotiate = true;
        vm.canVerify = true;
        vm.counter = 0;

        vm.registerModel = {};

        vm.getVerification = function () {
            if (!vm.registerModel.phone) {return}
            VerificationService.get({phone:vm.registerModel.phone, type: 'REGISTRY'},function (res) {
                countDownAction();
            }, function (error) {
                MessageService.error("获取验证码失败 ！"+(error.data.detail||''));
            })
        };

        function countDownAction() {
            vm.canVerify = false;
            vm.counter = 60;
            var interval = $interval(function () {
                vm.counter --;
                if (vm.counter <= 0) {
                    vm.counter = 0;
                    vm.canVerify = true;
                    $interval.cancel(interval);
                }
            },1000);
        }

        vm.registerAction = function () {
            MemberAccountService.register(vm.registerModel, function (res) {
                AuthServerProvider.storeAuthenticationToken(res.data.id_token, false);
                $rootScope.$broadcast('authenticationSuccess');
                $uibModalInstance.close();
                $rootScope.$emit("requestLogin");
                MessageService.success("注册成功 ！");
            }, function (error) {
                console.log("error: ",error);
                MessageService.error("注册失败 ！"+(error.data.detail||''));
            });
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };
        vm.requestLoginAction = function () {
            $uibModalInstance.dismiss();
            $rootScope.$emit("requestLogin");
        };

        vm.jumpNegotiation = function () {
            // $window.open($state.href('negotiation'),'_blank');
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/negotiation/negotiation.html',
                controller: 'NegotiationController',
                controllerAs: 'vm',
                size: 'negotiate',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/16
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('promotion', {
                parent: 'module',
                url: '/promotion',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/promotion/promotion.html',
                        controller: 'PromotionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('PromotionController', PromotionController);
    PromotionController.$inject = ['$state', '$scope', 'HomeConfigService'];

    function PromotionController($state, $scope, HomeConfigService) {
        /**
         * Created by vimpans on 2019/7/16
         */
        var vm = $scope;

        vm.advertiseModel = {};

        initDataAction();
        function initDataAction() {
            HomeConfigService.findPublish({}, function (res) {
                var homeModel = res.data;

                vm.advertiseModel.mainTitle = homeModel.mainTitle;
                vm.advertiseModel.subHead = homeModel.subHead;
                vm.advertiseModel.content = homeModel.advertiseIntroduce;

                $("#advertise-container").html(vm.advertiseModel.content);

                if (!homeModel) {return}
                for (var i = 0; i<homeModel.resources.length; i++) {
                    var resource = homeModel.resources[i];
                    if (resource.type === "ADVERTISE") {
                        vm.advertiseModel.imageUrl = resource.category.images[0].imageUrl;
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/8/20
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('preview', {
                parent: 'module',
                url: '/preview',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/preview/preview.html',
                        controller: 'PreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('PreviewController', PreviewController);
    PreviewController.$inject = ['$state', '$scope', 'HomeConfigService'];

    function PreviewController($state, $scope, HomeConfigService) {
        /**
         * Created by vimpans on 2019/8/20
         */
        var vm = $scope;

        vm.myInterval = 5000;
        vm.noWrapSlides = false;
        vm.active = 0;
        vm.keyword = null;

        // var $API = null;
        // vm.playerReady = function (a) {
        //     $API = a;
        // };
        // vm.playVideo = function () {
        //     $API.play();
        // };

        vm.homeModel = {};
        vm.bannerModel = {};
        vm.buildingModel = null;
        vm.buildingList = [];
        vm.advertiseModel = {};
        vm.activityList = [];
        vm.videoModel = null;
        initDataAction();
        function initDataAction() {
            HomeConfigService.findSave({}, function (res) {
                vm.homeModel = res.data;
                if (!vm.homeModel) {return}
                for (var i = 0; i<vm.homeModel.resources.length; i++) {
                    var resource = vm.homeModel.resources[i];
                    if (resource.type === "BANNER") {
                        if (vm.homeModel.type === 'SLIDE') {
                            vm.bannerModel = resource;
                        } else if (vm.homeModel.type === 'VIDEO') {
                            vm.videoModel = resource.category.images[0]||{};
                        }
                    } else if (resource.type === "ADVERTISE") {
                        vm.advertiseModel = resource;
                    } else if (resource.type === "BUILDING") {
                        if (!vm.buildingModel) {
                            vm.buildingModel = resource;
                        } else {
                            vm.buildingList.push(resource);
                        }
                    } else if (resource.type === "ACTIVITY") {
                        vm.activityList.push(resource);
                    }
                }
            });
        }
        vm.translateLevel = function (level) {
            if (level === 'ORGANIZATION') {
                return "租户会员";
            }
            if (level === 'PLATFOMEUSER') {
                return "平台以上会员";
            }
            if (level === 'OPEN') {
                return "完全开放";
            }
        };

        // vm.appointmentAction = function () {
        //     $uibModal.open({
        //         animation: true,
        //         keyboard: false,
        //         backdrop: 'static',
        //         templateUrl: 'app/module/appointment/appointment.html',
        //         controller: 'AppointmentController',
        //         controllerAs: 'vm',
        //         size: 'md',
        //         resolve: {
        //             entity: function () {
        //                 return null;
        //             }
        //         }
        //     }).result.then(function () {
        //
        //     });
        // };

        // vm.searchAction = function () {
        //     if (!vm.keyword) {return;}
        //     $state.go('building', {keyword: vm.keyword});
        // };
        // vm.keyupAction = function (e) {
        //     if (e.keyCode === 13) {
        //         vm.searchAction();
        //     }
        // }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/8/21
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('negotiation', {
                parent: 'module',
                url: '/negotiation',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/negotiation/negotiation.html',
                        controller: 'NegotiationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('NegotiationController', NegotiationController);
    NegotiationController.$inject = ['$state', '$scope', '$uibModalInstance'];

    function NegotiationController($state, $scope, $uibModalInstance) {
        /**
         * Created by vimpans on 2019/8/21
         */
        var vm = $scope;

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('module', {
                parent: 'app',
                url: '/module',
                data: {
                    authorities: []
                },
                views: {
                    'index@': {
                        templateUrl: 'app/module/module.html',
                        controller: 'ModuleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('register', {
                parent: 'module',
                url: '/register',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/register/register.html',
                        controller: 'RegisterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('login', {
                parent: 'module',
                url: '/login',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('home', {
                parent: 'module',
                url: '/home',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('memberCenter', {
                parent: 'module',
                url: '/mcenter',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/member-center/member-center.html',
                        controller: 'MemberCenterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('ModuleController', ModuleController);
    ModuleController.$inject = ['$state', '$scope', 'Principal', 'AuthServerProvider', '$rootScope','$uibModal', 'CityManagerService', '$localStorage'];

    function ModuleController($state, $scope, Principal, AuthServerProvider, $rootScope,$uibModal, CityManagerService, $localStorage) {
        /**
         * Created by vimpans on 2019/6/17
         */
        var vm = $scope;

        vm.locationId = $localStorage.location_id;
        vm.locationName = $localStorage.location_name;

        vm.preview = false;

        //配置导航栏透明router表
        vm.transparentList = ['/home','/preview'];

        vm.transparent = false;

        $rootScope.$on('$stateChangeStart', function (event, to) {
            checkTransparent(to.url);
        });

        $rootScope.$on('requestLogin', function (event, to) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        });

        $rootScope.$on('requestRegister', function (event, to) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/register/register.html',
                controller: 'RegisterController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        });

        $rootScope.$on('userlogout', function (event, to) {
            vm.logoutAction();
        });
        $rootScope.$on('userlogin', function (event, to) {
            initUserInfo(true);
        });

        checkTransparent($state.current.url);
        function checkTransparent(state) {
            if (vm.transparentList.indexOf(state) !== -1) {
                checkScroll();
                window.onscroll = function (ev) {
                    checkScroll(true);
                };
                if (state === '/preview') {
                    vm.preview = true;
                }
            } else {
                vm.transparent = false;
                window.onscroll = null;
            }
        }
        function checkScroll(apply) {
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            var total = document.documentElement.clientWidth * 0.41 - 85;
            vm.transparent = t<total;
            if (apply) {vm.$apply()}
        }

        vm.userModel = null;
        initUserInfo();
        function initUserInfo(force) {
            Principal.identity(force).then(function (account) {
                if(!account) {return}
                vm.userModel = account.data;
            })
        }

        vm.cityList = [];
        initCityAction();
        function initCityAction() {
            CityManagerService.findAll({}, function (res) {
                vm.cityList = res.data;
                if (vm.cityList && vm.cityList.length>0 && !$localStorage.location_id) {
                    $localStorage.location_id = vm.cityList[0].id;
                    $localStorage.location_name = vm.cityList[0].name;
                    vm.locationId = $localStorage.location_id;
                    vm.locationName = $localStorage.location_name;
                }
            });
        }

        vm.selCityAction = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/city-selector/city-selector.html',
                controller: 'CitySelectorController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function (res) {
                $localStorage.location_id = res.id;
                $localStorage.location_name = res.name;
                vm.locationId = res.id;
                vm.locationName = res.name;
            });
        };

        vm.logoutAction = function () {
            AuthServerProvider.logout();
            vm.userModel = null;
        };

        vm.loginAction = function () {
            $rootScope.$emit("requestLogin");
        };

        vm.agentAction = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/appointment/appointment.html',
                controller: 'AppointmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {isAgent: true, source:'中介合作'};
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberWifiController', MemberWifiController);
    MemberWifiController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', 'CompanyService'];

    function MemberWifiController($state, entity, $scope, $uibModalInstance, CompanyService) {
        /**
         * Created by vimpans on 2019/7/29
         */
        var vm = $scope;

        if (entity) {
            vm.entity = entity;
        }

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        initDataAction();
        vm.wifiModel = {};
        function initDataAction() {
            CompanyService.getWifi({officeId: vm.entity.id, companyId: vm.entity.companyId}, function (res) {
                vm.wifiModel = res.data;
            })
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberResetPasswordController', MemberResetPasswordController);
    MemberResetPasswordController.$inject = ['$state', '$scope', 'MemberAccountService', 'MessageService', '$uibModalInstance'];

    function MemberResetPasswordController($state, $scope, MemberAccountService, MessageService, $uibModalInstance) {
        /**
         * Created by vimpans on 2019/8/13
         */
        var vm = $scope;

        vm.resetModel = {};

        vm.resetPassword = function () {
            MemberAccountService.resetPassword(vm.resetModel, function (res) {
                MessageService.success("密码修改成功 !");
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error("密码修改失败 "+(error.data.detail||""));
            })
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberInfoController', MemberInfoController);
    MemberInfoController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', 'Principal', 'Funcs', 'MemberAccountService', 'MessageService', '$uibModal'];

    function MemberInfoController($state, entity, $scope, $uibModalInstance, Principal, Funcs, MemberAccountService, MessageService, $uibModal) {
        /**
         * Created by vimpans on 2019/7/29
         */
        var vm = $scope;

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        if (entity) {
            vm.accessCardId = entity.accessCardId;
            vm.companyName = entity.companyName;
            vm.roomName = entity.roomName;
        }

        vm.userModel = null;
        vm.userImageModel = null;

        userAccountInfo();
        function userAccountInfo(force) {
            Principal.identity(force).then(function (account) {
                if(!account) {return}
                vm.userModel = account.data;
                vm.userImageModel = angular.copy(account.data);
            })
        }

        vm.updateProfile = function () {
            MemberAccountService.update(vm.userModel, function () {
                userAccountInfo(true);
                MessageService.success('用户信息修改成功 !');
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error('用户信息修改失败 '+(error.data.detail || ""));
            })
        };

        vm.headerUpload = function () {
            Funcs.imageUpload(function (res) {
                vm.userImageModel.imageUrl = res.imageUrl;
                MemberAccountService.update(vm.userImageModel, function () {
                    userAccountInfo(true);
                    MessageService.success('头像上传成功 !');
                }, function (error) {
                    MessageService.error('头像上传失败 '+(error.data.detail || ""));
                })
            })
        };

        vm.resetPassword = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-reset-password.html',
                controller: 'MemberResetPasswordController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberForgotPasswordController', MemberForgotPasswordController);
    MemberForgotPasswordController.$inject = ['$state', '$scope', 'MemberAccountService', 'VerificationService', '$interval', '$uibModalInstance', 'MessageService'];

    function MemberForgotPasswordController($state, $scope, MemberAccountService, VerificationService, $interval, $uibModalInstance, MessageService) {
        /**
         * Created by vimpans on 2019/8/13
         */
        var vm = $scope;

        vm.canVerify = true;
        vm.counter = 0;

        vm.forgotModel = {};

        vm.getVerification = function () {
            if (!vm.forgotModel.phone) {return}
            VerificationService.get({phone:vm.forgotModel.phone, type: 'PASSWORD'},function (res) {
                countDownAction();
            }, function (error) {
                MessageService.error("获取验证码失败 ！"+(error.data.detail||''));
            })
        };

        function countDownAction() {
            vm.canVerify = false;
            vm.counter = 60;
            var interval = $interval(function () {
                vm.counter --;
                if (vm.counter <= 0) {
                    vm.counter = 0;
                    vm.canVerify = true;
                    $interval.cancel(interval);
                }
            },1000);
        }

        vm.forgotPassword = function () {
            MemberAccountService.forgotPassword(vm.forgotModel, function (res) {
                MessageService.success("密码重置成功 ！");
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error("密码重置失败 "+(error.data.detail||""));
            });
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberCenterController', MemberCenterController);
    MemberCenterController.$inject = ['$state', '$scope', '$uibModal', 'EmployeeService', 'CompanyService', 'OfficeService', 'Principal', '$interval', 'MessageService', '$filter', 'AuthServerProvider', 'BuildingService'];

    function MemberCenterController($state, $scope, $uibModal, EmployeeService, CompanyService, OfficeService, Principal, $interval, MessageService, $filter, AuthServerProvider, BuildingService) {
        /**
         * Created by vimpans on 2019/7/17
         */
        var vm = $scope;

        vm.userModel = null;
        vm.employeeModel = null;
        vm.companyModel = null;
        vm.defaultBuilding = null;

        vm.meetingModel = null;
        vm.offices = [];

        userAccountInfo();
        function userAccountInfo() {
            Principal.identity().then(function (account) {
                if(!account) {return}
                vm.userModel = account.data;
                if (vm.userModel.employeeId) {
                    employeeInfo(vm.userModel.employeeId);
                } else {
                    BuildingService.getOne({}, function (res) {
                        vm.defaultBuilding = res.data;
                    })
                }
            })
        }
        function employeeInfo(id) {
            EmployeeService.account({id:id}, function (res) {
                if (res.data && res.data.companyId) {
                    vm.employeeModel = res.data;
                    vm.employeeModel.roomQuotaString = '本月已用'+(vm.employeeModel.roomQuota.consumed||0)+'元，剩余'+(vm.employeeModel.roomQuota.available||0)+'元，截止'+getCurrentMonthLastDay()+'有效。<br>注：抵用券由平台配置，仅供会议室结算抵扣费用，不可提现，不使用过期自动失效，不可叠加。';
                    companyInfo(res.data.companyId);
                }
            })
        }

        function getCurrentMonthLastDay() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            var day = new Date(year, month, 0);
            return  year + '年' + month + '月' + day.getDate() + '日'
        }

        function companyInfo(id) {
            CompanyService.findOne({companyId: id}, function (res) {
                vm.companyModel = res.data;
                vm.offices = vm.companyModel.offices||[];
                vm.offices = vm.offices.map(function (value, index) {
                    var initial = new Date(value.initialTime);
                    var now = new Date();
                    var rentDays = (now-initial)/86400000;
                    rentDays = Math.ceil(rentDays);
                    rentDays = rentDays<0?0:rentDays;
                    value.rentDays = rentDays;
                    value.extendArea = false;
                    value.meetings = [];
                    value.managerExtend = false;
                    return value;
                }).sort(function (a,b) {
                    return a.id - b.id;
                });
                if (vm.offices && vm.offices.length > 0) {
                    vm.extendMeetingAtIndex(vm.offices[0])
                }
            })
        }

        vm.extendManagerAction = function (office) {
            office.managerExtend = !office.managerExtend;
        };

        vm.extendMeetingAtIndex = function (office) {
            office.extendArea = !office.extendArea;
            if (office.extendArea && (!office.meetings || office.meetings.length===0)) {
                meetingInfo(office);
            }
        };

        function meetingInfo(office) {
            OfficeService.getByOffice({officeId: office.id, companyId: vm.companyModel.id}, function (res) {
                office.meetings = res.data.filter(function (val) {
                    return val.inProgressItem;
                });
            });
        }

        vm.appointmentMeetingAction = function (office) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-appointment.html',
                controller: 'MemberAppointmentController',
                controllerAs: 'vm',
                size: 'appointment',
                resolve: {
                    entity: function () {
                        return {companyId: vm.companyModel.id, office: angular.copy(office), buildingIds: vm.offices.map(function (value) { return value.buildingId })};
                    }
                }
            }).result.then(function () {
                meetingInfo(office);
            });
        };

        // vm.rooms_animation = {transform: 'translateX(0)'};
        // vm.rooms_countor = 0;
        // function roomAutoSwiper() {
        //     if (!vm.companyModel || vm.companyModel.rooms ||) {
        //         return;
        //     }
        //     vm.roomTnterval = $interval(function () {
        //         vm.rooms_countor++;
        //         if (vm.rooms_countor === vm.buildingModel.roomImages.images.length) {
        //             vm.rooms_countor = 0;
        //         }
        //         vm.rooms_animation.transform = 'translateX('+(-vm.rooms_countor * 830)+'px)';
        //     }, 5000);
        // }
        // vm.tapRoomSwiperBtn = function (idex) {
        //     if (!vm.buildingModel.roomImages.images || vm.buildingModel.roomImages.images.length===0 || vm.buildingModel.roomImages.images.length===1) {
        //         return;
        //     }
        //     $interval.cancel(vm.roomTnterval);
        //     vm.rooms_animation.transform = 'translateX('+(-idex * 830)+'px)';
        //     vm.rooms_countor = idex;
        //     roomAutoSwiper();
        // };
        // vm.previousRoomImageAction = function () {
        //     vm.rooms_countor--;
        //     vm.tapRoomSwiperBtn(vm.rooms_countor);
        // };
        // vm.nextRoomImageAction = function () {
        //     vm.rooms_countor++;
        //     vm.tapRoomSwiperBtn(vm.rooms_countor);
        // };

        vm.appointmentRecord = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-appointment-record.html',
                controller: 'MemberAppointmentRecordController',
                controllerAs: 'vm',
                size: 'appointment',
                resolve: {
                    entity: function () {
                        return {companyId: vm.companyModel.id};
                    }
                }
            }).result.then(function () {

            });
        };

        vm.accessRecords = function (office) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-access-record.html',
                controller: 'MemberAccessRecordsController',
                controllerAs: 'vm',
                size: 'appointment',
                resolve: {
                    entity: function () {
                        return {companyId: vm.companyModel.id, buildingId: office.buildingId};
                    }
                }
            }).result.then(function () {

            });
        };


        vm.memberWiFi = function (office) {
            office.companyId = vm.companyModel.id;
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-wifi.html',
                controller: 'MemberWifiController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return office;
                    }
                }
            }).result.then(function () {

            });
        };
        vm.memberAccountInfo = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-info.html',
                controller: 'MemberInfoController',
                controllerAs: 'vm',
                size: 'account',
                resolve: {
                    entity: function () {
                        return {

                        };
                    }
                }
            }).result.then(function () {

            });
        };
        vm.cancelAppointment = function (meeting, office) {

            meeting.timeType = timeString2Type(meeting.inProgressItem.startTime, meeting.inProgressItem.amount);

            if (meeting.repeat) {
                $uibModal.open({
                    animation: true,
                    keyboard: false,
                    backdrop: 'static',
                    templateUrl: 'app/module/member-center/member-appointment-cancel.html',
                    controller: 'MemberAppointmentCancelController',
                    controllerAs: 'vm',
                    size: 'normal',
                    resolve: {
                        entity: function () {
                            return meeting;
                        }
                    }
                }).result.then(function () {
                    meetingInfo(office);
                })
            } else {
                var content = '预定日期：' +
                    $filter('date')(meeting.date, 'yyyy-MM-dd') +
                    ' ' +
                    $filter('date')(meeting.startTime, 'HH:mm') +
                    '-' +
                    $filter('date')(meeting.endTime, 'HH:mm') +
                    ' 共' +
                    meeting.durationInHours +
                    '小时' + (meeting.timeType.insertHtml||"");
                MessageService.contentConfirm({
                    title: '是否确定取消预定',
                    content: content,
                    cancel: '保留预定',
                    issue: '取消预定',
                    descTitle: '取消会议室说明',
                    descContent: '1.会议开始前3小时(不含)，免费取消。2.会议开始前1-3小时，按单次预订总费用45%计。3.会议开始前不足1(含)小时，将扣除预定用时总费用(预定用时*单价)。4.取消预定产生的费用不可使用配额额度扣费。'
                }, function () {
                    OfficeService.cancelled({
                        id: meeting.id,
                        itemId: meeting.inProgressItem.id
                    }, function (res) {
                        MessageService.success("会议室预定 取消成功!");
                        meetingInfo(office);
                    }, function (error) {
                        MessageService.error("会议室预定 取消失败"+(error.data.detail||''));
                    })
                })
            }
        };
        vm.editAppointment = function (meeting, office) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-appointment-edit.html',
                controller: 'MemberAppointmentEditController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return meeting;
                    }
                }
            }).result.then(function () {
                meetingInfo(office);
            })
        };

        vm.logoutAction = function () {
            MessageService.confirm("确认退出登录 ？", function () {
                AuthServerProvider.logout();
                window.location.reload();
            })
        };

        vm.appointmentAction = function (source) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/appointment/appointment.html',
                controller: 'AppointmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {source: source};
                    }
                }
            }).result.then(function () {

            });
        };

        function timeString2Type (str, amount) {
            var start = new Date(str);
            var now = new Date();
            var subtractRes = (start - now) / (1000 * 60 * 60);
            var res = {type: 'Normal'};
            if (subtractRes < 3 && subtractRes > 1) {
                var subtractHour = start.getHours()-now.getHours();
                var subtractMinutes = start.getMinutes()-now.getMinutes();
                if (subtractMinutes < 0) {
                    subtractHour = subtractHour-1;
                    subtractMinutes = 60+subtractMinutes;
                }
                res.type = "UserCancelLess3H";
                var s = subtractHour+"小时"+(subtractMinutes===0?"":(subtractMinutes+"分钟"));
                res.insertHtml = '<br><br>距离会议开始有'+s+'<br>需从余额扣除45%的预扣款(<span style="color: red">'+(amount*0.45)+'</span>元)';
            } else if (subtractRes < 1 && subtractRes > 0) {
                var subtractMinutes = (start.getMinutes())-now.getMinutes();
                if (subtractMinutes < 0) {
                    subtractMinutes = 60+subtractMinutes;
                }
                res.type = "UserCancelLess1H";
                var s = subtractMinutes===0?"不到1分钟":(subtractMinutes+"分钟");
                res.insertHtml = '<br><br>距离会议开始有'+s+'<br>需从余额扣除全部的预扣款(<span style="color: red">'+amount+'</span>元)';
            } else if (subtractRes < 0) {
                res.type = "Running";
                res.insertHtml = '<br><br>会议已经开始<br>需从余额扣除全部的预扣款(<span style="color: red">'+amount+'</span>元)';
            }
            return res;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAppointmentRecordController', MemberAppointmentRecordController);
    MemberAppointmentRecordController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', 'OfficeItemService'];

    function MemberAppointmentRecordController($state, entity, $scope, $uibModalInstance, OfficeItemService) {
        /**
         * Created by vimpans on 2019/7/29
         */
        var vm = $scope;

        if (entity) {
            vm.companyId = entity.companyId;
        }

        vm.pageparams = {
            page: 0,
            size: 10,
            count: 0,
            startTime: null,
            endTime: null
        };
        vm.startTimeSel = false;
        vm.endTimeSel = false;

        vm.reloadDataAction = function () {
            initDataAction();
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.appointmentRecords = [];

        initDataAction();
        function initDataAction() {
            var params = {cId: vm.companyId, page: vm.pageparams.page-1, size: vm.pageparams.size};
            if (vm.pageparams.startTime) {
                params.start = vm.pageparams.startTime.toStartISOString();
            }
            if (vm.pageparams.endTime) {
                params.end = vm.pageparams.endTime.toEndISOString();
            }
            OfficeItemService.queryByCompany(params, function (res) {
                vm.appointmentRecords = res.data.map(function (val) {
                    var start = new Date(val.startTime);
                    var end = new Date(val.endTime);
                    var now = new Date();
                    var beforeStart = (now-start)<0;
                    var afterEnd = (now-end)>0;
                    if (beforeStart) {
                        val.stateString = '未开始';
                    } else if (afterEnd) {
                        val.stateString = '已结束';
                    } else {
                        val.stateString = '进行中';
                    }
                    return val;
                });
                vm.pageparams.count = res.info.count;
            })
        }

        vm.pageChangeAction = function () {
            initDataAction();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAppointmentEditController', MemberAppointmentEditController);
    MemberAppointmentEditController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', '$filter', 'OfficeService', 'MessageService'];

    function MemberAppointmentEditController($state, entity, $scope, $uibModalInstance, $filter, OfficeService, MessageService) {
        /**
         * Created by vimpans on 2019/7/30
         */
        var vm = $scope;

        vm.showDescription = false;

        vm.meeting = entity;
        vm.appointmentModel = {
            global:false,
            id: vm.meeting.id,
            itemId: vm.meeting.inProgressItem.id,
            subject: vm.meeting.inProgressItem.subject,
            numberOfParticipants: vm.meeting.inProgressItem.numberOfParticipants
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.translateCycleType = function (type) {
            if (type === 'MONTH') {
                return '月';
            } else if (type === 'WEEK') {
                return '周';
            } else if (type === 'DAY') {
                return '日';
            }
        };

        vm.editAppointmentAction = function () {
            var tempModel = angular.copy(vm.appointmentModel);
            tempModel.date = $filter('date')(tempModel.dateShow, 'yyyy-MM-dd');
            tempModel.endTime = tempModel.endTime.split(' ')[0];
            OfficeService.updatePrice(tempModel, function (res) {
                var option = {
                    title: '是否确定更改预定',
                    content: '修改预定时间：' +
                    tempModel.date +
                    ' ' +
                    tempModel.startTime +
                    '-' +
                    tempModel.endTime +
                    ' 共' +
                    2 +
                    '小时',
                    cancel: '取消',
                    issue: '修改',
                    descTitle: '更改会议室说明',
                    descContent: '1.会议开始前3小时(不含)，免费修改。2.会议开始不足3小时，不支持修改。'
                };
                if (tempModel.global) {
                    option.content += ('<br>重复设定：每'+vm.translateCycleType(vm.meeting.cycleType)+'重复截止'+$filter('date')(vm.meeting.endDate,'yyyy-MM-dd'));
                }
                option.content += ('<br><br><span style="font-size: 20px">共计：<span style="color: red">￥<span style="font-size: 42px">'+res.data.amount.toFixed(2)+'</span></span></span>');
                MessageService.contentConfirm(option, function () {
                    OfficeService.update(tempModel, function (res) {
                        MessageService.success("会议室修改成功 ！");
                        $uibModalInstance.close();
                    }, function (error) {
                        MessageService.error("会议室修改失败 ! "+(error.data.detail||""));
                    })
                });
            }, function (error) {
                MessageService.error("会议室修改失败 ! "+(error.data.detail||""));
            })
        };

        //================================start time selector================================
        vm.now = new Date();
        vm.timeEnumList = [];
        vm.initStartTimeEnum = initStartTimeEnum;
        vm.initEndTimeEnum = initStartTimeEnum;
        vm.appointmentModel.dateShow = new Date();
        initTimeEnum();
        function initTimeEnum() {
            for (var i=0; i<24; i++) {
                vm.timeEnumList.push(i<10?'0'+i+':00':i+':00');
                vm.timeEnumList.push(i<10?'0'+i+':30':i+':30');
            }
        }
        vm.$watch('appointmentModel.dateShow', function (newVal) {
            initStartTimeEnum();
        });
        vm.startTimeEnum = [];
        vm.endTimeEnum = [];
        initStartTimeEnum();
        initEndTimeEnum();
        function initStartTimeEnum() {
            if (vm.appointmentModel.dateShow &&
                vm.appointmentModel.dateShow.toLocaleDateString()=== vm.now.toLocaleDateString()) {
                var now_h = vm.now.getHours();
                now_h = now_h<10?'0'+now_h:now_h.toString();
                var now_m = vm.now.getMinutes()>=30?'30':'00';
                var now_string = now_h+':'+now_m;
                var now_index = vm.timeEnumList.indexOf(now_string);
                vm.startTimeEnum =vm.timeEnumList.slice(now_index+1);
            } else {
                vm.startTimeEnum = vm.timeEnumList;
            }
        }
        function initEndTimeEnum() {
            if (vm.appointmentModel.startTime) {
                var start_index = vm.timeEnumList.indexOf(vm.appointmentModel.startTime);
                vm.endTimeEnum = vm.timeEnumList.slice(start_index+1);
                var nextTimeEnum = vm.timeEnumList.slice(0, start_index);
                vm.endTimeEnum = vm.endTimeEnum.concat(nextTimeEnum.map(function (val) {
                    return val+" (次日)"
                }));
            } else {
                vm.endTimeEnum = vm.timeEnumList;
            }
        }
        vm.sStartTime = function (item) {
            vm.appointmentModel.startTime=item;
            initEndTimeEnum()
        };
        vm.sEndTime = function (item) {
            vm.appointmentModel.endTime=item;
        };
        //================================end time selector==================================
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAppointmentConfirmController', MemberAppointmentConfirmController);
    MemberAppointmentConfirmController.$inject = ['$state', '$scope'];

    function MemberAppointmentConfirmController($state, $scope) {
        /**
         * Created by vimpans on 2019/8/12
         */

    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAppointmentCancelController', MemberAppointmentCancelController);
    MemberAppointmentCancelController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', 'OfficeService', 'MessageService'];

    function MemberAppointmentCancelController($state, entity, $scope, $uibModalInstance, OfficeService, MessageService) {
        /**
         * Created by vimpans on 2019/7/30
         */
        var vm = $scope;

        vm.showDescription = false;

        vm.selectAll = false;
        vm.meeting = entity;

        vm.insertAction = function () {
            $('#time-type').html(vm.meeting.timeType.insertHtml);
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.translateCycleType = function (type) {
            if (type === 'MONTH') {
                return '月';
            } else if (type === 'WEEK') {
                return '周';
            } else if (type === 'DAY') {
                return '日';
            }
        };

        vm.cancelAction = function () {
            OfficeService.cancelled({
                id: vm.meeting.id,
                itemId: vm.meeting.inProgressItem.id,
                global: vm.selectAll
            }, function (res) {
                MessageService.success("会议室预定 取消成功!");
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error("会议室预定 取消失败"+(error.data.detail?(','+error.data.detail):''));
            })
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAppointmentController', MemberAppointmentController);
    MemberAppointmentController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', '$timeout', 'CityManagerService', 'RegionManagerService', 'BuildingManagerService', 'RoomManagerService', 'OfficeService', 'MessageService', '$filter', 'OfficeItemService', '$compile'];

    function MemberAppointmentController($state, entity, $scope, $uibModalInstance, $timeout, CityManagerService, RegionManagerService, BuildingManagerService, RoomManagerService, OfficeService, MessageService, $filter, OfficeItemService, $compile) {
        /**
         * Created by vimpans on 2019/7/17
         */
        var vm = $scope;

        vm.companyId = null;
        vm.office = null;
        if (entity) {
            vm.companyId = entity.companyId;
            vm.buildingIds = entity.buildingIds||[];
            vm.office = entity.office;
        }

        vm.notMatch = false;
        vm.showDescription = false;
        vm.calendarStart = null;
        vm.calendarEnd = null;
        vm.calendar = null;
        vm._timeout = null;

        vm.uiConfig = {
            calendar: {
                height: 'parent',
                editable: false,
                header: {
                    left: '',
                    center: '',
                    right: 'month agendaWeek agendaDay'
                },
                buttonText: {
                    month: '月',
                    agendaWeek: '周',
                    agendaDay: '日'
                },
                firstDay: 1,
                slotLabelFormat: "HH:mm",
                columnFormat: 'ddd',
                timeFormat: "HH:mm",
                allDayText: "全天",
                dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                eventRender: function (event, element, view) {
                    element.attr({
                        'uib-tooltip-html': "'<b style=\"text-align: left\">"+ event.title + " <br>开始时间: " + $filter('date')(new Date(event.start._d), 'yyyy-MM-dd HH:mm') + " <br>结束时间: " + $filter('date')(new Date(event.end._d), 'yyyy-MM-dd HH:mm') + "</b>'"
                    });

                    $compile(element)($scope);
                },
                viewRender: function(view, element) {
                    if (!vm.calendar) {
                        vm.calendar = view.calendar;
                    }
                    vm.calendarStart = view.start._d.toStartISOString();
                    vm.calendarEnd = view.end._d.toEndISOString();
                    if (vm.bsModel.meeting.id) {

                        if(vm._timeout) {
                            $timeout.cancel(vm._timeout);
                        }
                        vm._timeout = $timeout(function () {
                            initMeetingDataAction();
                            vm._timeout = null;
                        }, 1000);
                    }
                    updateTitle(view);
                }
            }
        };

        vm.titleDate = '';
        function updateTitle(view) {
            switch (view.type) {
                case 'month':
                    vm.titleDate = $filter('date')(new Date(view.intervalStart._d), 'yyyy年MM月');
                    break;
                case 'agendaWeek':
                    vm.titleDate = $filter('date')(new Date(view.start._d), 'yyyy年MM月') +'第'+ getMonthWeek(view.start._d) +'周';
                    break;
                case 'agendaDay':
                    vm.titleDate = $filter('date')(new Date(view.start._d), 'yyyy年MM月dd日');
                    break;
                default:
                    break;
            }
        }
        vm.next = function () {
            if (vm.calendar) {
                vm.calendar.next();
            }
        };
        vm.prev = function () {
            if (vm.calendar) {
                vm.calendar.prev();
            }
        };

        function getMonthWeek(s) {
            const date = new Date(s.getFullYear(), s.getMonth() - 1, s.getDate());
            const w = date.getDay();
            const d = date.getDate();
            return Math.ceil((d + 6 - w) / 7);
        }

        vm.events = [];
        vm.eventSources = [vm.events];

        vm.cancelAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.cityList = [];
        vm.regionList = [];
        vm.buildingList = [];
        vm.meetingList = [];
        vm.startTimeSel = false;
        vm.endTimeSel = false;
        vm.dateSel = false;
        vm.bsModel = {
            city: {id: vm.office.cityId, name: vm.office.cityName},
            region: {id: vm.office.regionId, name: vm.office.regionName},
            building: {id: vm.office.buildingId, name: vm.office.buildingName},
            meeting: {}
        };
        vm.appointmentModel = {cycleName:'月', cycleType:'MONTH', companyId:vm.companyId};

        initCityAction();
        if (vm.bsModel.city.id) {
            initRegionByCity(vm.bsModel.city.id)
        }
        if (vm.bsModel.city.id && vm.bsModel.region.id) {
            initBuildingByCityAndRegion(vm.bsModel.city.id, vm.bsModel.region.id)
        }
        if (vm.bsModel.building.id) {
            initRoomsByBuilding(vm.bsModel.building.id)
        }
        function initCityAction() {
            CityManagerService.findAll({}, function (res) {
                vm.cityList = res.data;
            });
        }
        function initRegionByCity(city) {
            RegionManagerService.findByCity({cId: city}, function (res) {
                vm.regionList = res.data;
            })
        }
        function initBuildingByCityAndRegion(city, region) {
            BuildingManagerService.findByArea({cityId: city, regionId: region}, function (res) {
                vm.buildingList = res.data;
            })
        }
        function initRoomsByBuilding(building) {
            RoomManagerService.findConference({bId: building, available: true}, function (res) {
                vm.meetingList = res.data.map(function (val) {
                    val.name = (val.title+"("+val.name+")");
                    return val;
                });
            })
        }

        vm.sCity = function (item) {
            if (vm.bsModel.city.id === item.id) {return;}
            vm.bsModel.city.id = item.id;
            vm.bsModel.city.name = item.name;
            dataCleanerBy_meeting_building_region(true, true, true);
            initRegionByCity(item.id);
        };
        vm.sRegion = function (item) {
            if (vm.bsModel.region.id === item.id) {return;}
            vm.bsModel.region.id = item.id;
            vm.bsModel.region.name = item.name;
            dataCleanerBy_meeting_building_region(true, true);
            initBuildingByCityAndRegion(vm.bsModel.city.id, item.id);
        };
        vm.sBuilding = function (item) {
            if (vm.bsModel.building.id === item.id) {return;}
            vm.bsModel.building.id = item.id;
            vm.bsModel.building.name = item.name;

            // vm.notMatch = vm.bsModel.building.id !== vm.office.buildingId;
            vm.notMatch = vm.buildingIds.indexOf(vm.bsModel.building.id)===-1;
            dataCleanerBy_meeting_building_region(true);
            initRoomsByBuilding(item.id);
        };
        vm.sMeeting = function (item) {
            if (vm.bsModel.meeting.id === item.id) {return;}
            vm.bsModel.meeting = item;
            initMeetingDataAction();
        };

        function dataCleanerBy_meeting_building_region(meeting, building, region) {
            if (meeting) {vm.bsModel.meeting = {}; vm.meetingList = []}
            if (building) {vm.bsModel.building = {}; vm.buildingList = []}
            if (region) {vm.bsModel.region = {}; vm.regionList = []}
        }

        function initMeetingDataAction() {
            if (!vm.calendarStart || !vm.calendarEnd) {return}
            OfficeItemService.queryCalenderItems({
                rId: vm.bsModel.meeting.id,
                startTime: vm.calendarStart,
                endTime: vm.calendarEnd
            }, function (res) {
                var s = vm.events.length - 1;
                while (s >= 0) {
                    vm.events.splice(s--, 1);
                }
                for (var i=0; i<res.data.length; i++) {
                    var result = res.data[i];
                    vm.events.push({
                        title: vm.companyId===result.companyId?result.subject:'',
                        start: new Date(result.startTime),
                        end: new Date(result.endTime)
                    });
                }
            })
        }

        vm.changeQuantity = function (plus) {
            if (!vm.appointmentModel.numberOfParticipants) {
                vm.appointmentModel.numberOfParticipants = 0;
            }
            if (plus) {
                vm.appointmentModel.numberOfParticipants ++;
            } else {
                vm.appointmentModel.numberOfParticipants --;
                vm.appointmentModel.numberOfParticipants = vm.appointmentModel.numberOfParticipants < 0 ? 0 : vm.appointmentModel.numberOfParticipants;
            }
        };

        vm.createBookJobAction = function () {
            if (!vm.bsModel.meeting.id) {
                MessageService.error("请先选择会议室 !");
                return;
            }
            vm.appointmentModel.roomId = vm.bsModel.meeting.id;
            vm.appointmentModel.date = $filter('date')(vm.appointmentModel.dateShow, 'yyyy-MM-dd');
            vm.appointmentModel.endDate = $filter('date')(vm.appointmentModel.endDateShow, 'yyyy-MM-dd');
            vm.appointmentModel.endTime = vm.appointmentModel.endTimeShow.split(' ')[0];

            var duration = calculateTime(vm.appointmentModel.date, vm.appointmentModel.startTime, vm.appointmentModel.endTimeShow);
            // var price = vm.bsModel.meeting.price;
            // if (vm.bsModel.meeting.promotionEnabled) {
            //     price = vm.bsModel.meeting.promotionPrice;
            // }
            // if (vm.notMatch) {
            //     price += price*0.3;
            // }

            initAmountAction(function (res) {
                var tempContent = '预定时间：'+vm.appointmentModel.date+' '+vm.appointmentModel.startTime+'-'+vm.appointmentModel.endTime+' 共'+duration+'小时';
                if (vm.appointmentModel.repeat) {
                    tempContent += ('<br>每'+vm.appointmentModel.cycleName+'重复 截止日期 '+vm.appointmentModel.endDate);
                }
                tempContent += ('<br><br><span style="font-size: 20px">共计：<span style="color: red">￥<span style="font-size: 42px">'+res.data.toFixed(2)+'</span></span></span>');
                MessageService.contentConfirm({
                    title: vm.bsModel.meeting.name+'<br><span style="font-size: 20px">'+vm.bsModel.city.name+'-'+vm.bsModel.region.name+'-'+vm.bsModel.building.name+'</span>',
                    content: tempContent,
                    issue: '预定',
                    desc: '预定需多付一小时费用作为押金，结算时多退少补。'
                }, function () {
                    OfficeService.create(vm.appointmentModel, function (res) {
                        MessageService.success("预约会议室成功 ！");
                        $uibModalInstance.close();
                    }, function (error) {
                        MessageService.error("预约会议室失败 "+(error.data.detail?(','+error.data.detail):''));
                    })
                })
            });

        };

        function initAmountAction(cb) {
            OfficeService.getPrice(vm.appointmentModel, function (res) {
                cb(res);
            }, function (error) {
                MessageService.error("预约会议室失败 "+(error.data.detail?(','+error.data.detail):''));
            })
        }

        function calculateTime(dateString, startTimeString, endTimeString) {
            if (!dateString || !startTimeString || !endTimeString) {return 0}
            var startTime = new Date(dateString+'T'+startTimeString);
            var endTimeArray = endTimeString.split(' ');
            var endTime = new Date(dateString+'T'+endTimeArray[0]);
            if (endTimeArray.length > 1) {
                endTime.setDate(endTime.getDate()+1);
            }
            return (endTime-startTime)/(3600000);
        }

        //================================start time selector================================
        vm.now = new Date();
        vm.timeEnumList = [];
        vm.initStartTimeEnum = initStartTimeEnum;
        vm.initEndTimeEnum = initStartTimeEnum;
        vm.appointmentModel.dateShow = new Date();
        initTimeEnum();
        function initTimeEnum() {
            for (var i=0; i<24; i++) {
                vm.timeEnumList.push(i<10?'0'+i+':00':i+':00');
                vm.timeEnumList.push(i<10?'0'+i+':30':i+':30');
            }
        }
        vm.$watch('appointmentModel.dateShow', function (newVal) {
            initStartTimeEnum();
        });
        vm.startTimeEnum = [];
        vm.endTimeEnum = [];
        initStartTimeEnum();
        initEndTimeEnum();
        function initStartTimeEnum() {
            if (vm.appointmentModel.dateShow &&
                vm.appointmentModel.dateShow.toLocaleDateString()=== vm.now.toLocaleDateString()) {
                var now_h = vm.now.getHours();
                now_h = now_h<10?'0'+now_h:now_h.toString();
                var now_m = vm.now.getMinutes()>=30?'30':'00';
                var now_string = now_h+':'+now_m;
                var now_index = vm.timeEnumList.indexOf(now_string);
                // vm.startTimeEnum =vm.timeEnumList.slice(now_index+1);
                // 开始时间包括当前时间
                vm.startTimeEnum =vm.timeEnumList.slice(now_index);
            } else {
                vm.startTimeEnum = vm.timeEnumList;
            }
        }
        function initEndTimeEnum() {
            if (vm.appointmentModel.startTime) {
                var start_index = vm.timeEnumList.indexOf(vm.appointmentModel.startTime);
                vm.endTimeEnum = vm.timeEnumList.slice(start_index+1);
                var nextTimeEnum = vm.timeEnumList.slice(0, start_index);
                vm.endTimeEnum = vm.endTimeEnum.concat(nextTimeEnum.map(function (val) {
                    return val+" (次日)"
                }));
            } else {
                vm.endTimeEnum = vm.timeEnumList;
            }
        }
        vm.sStartTime = function (item) {
            vm.appointmentModel.startTime=item;
            initEndTimeEnum()
        };
        vm.sEndTime = function (item) {
            vm.appointmentModel.endTimeShow = item;
        };

        //================================end time selector==================================

        vm.repeatList = [
            {value: 'MONTH', name: '月'},
            {value: 'WEEK', name: '周'},
            {value: 'DAY', name: '日'}
        ];
        vm.sCycleType = function (item) {
            vm.appointmentModel.cycleName=item.name;
            vm.appointmentModel.cycleType=item.value;
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('MemberAccessRecordsController', MemberAccessRecordsController);
    MemberAccessRecordsController.$inject = ['$state', '$scope', 'entity', '$uibModalInstance', 'WgaccessService'];

    function MemberAccessRecordsController($state, $scope, entity, $uibModalInstance, WgaccessService) {
        /**
         * Created by vimpans on 2019/8/14
         */
        var vm = $scope;

        if (entity) {
            vm.companyId = entity.companyId;
            vm.buildingId = entity.buildingId;
        }

        vm.pageparams = {
            page: 0,
            size: 10,
            count: 0,
            startTime: null,
            endTime: null
        };
        vm.startTimeSel = false;
        vm.endTimeSel = false;

        vm.reloadDataAction = function () {
            initDataAction();
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.accessRecords = [];

        initDataAction();
        function initDataAction() {
            var params = {companyId: vm.companyId, page: vm.pageparams.page-1, size: vm.pageparams.size, buildingId: vm.buildingId};
            if (vm.pageparams.startTime) {
                params.start = vm.pageparams.startTime.toStartISOString();
            }
            if (vm.pageparams.endTime) {
                params.end = vm.pageparams.endTime.toEndISOString();
            }
            WgaccessService.queryByCompany(params, function (res) {
                vm.accessRecords = res.data;
                vm.pageparams.count = res.info.count;
            })
        }

        vm.pageChangeAction = function () {
            initDataAction();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('LoginController', LoginController);
    LoginController.$inject = ['$state', '$scope', 'MemberAccountService', '$rootScope', 'MessageService', 'AuthServerProvider', '$uibModalInstance', '$uibModal'];

    function LoginController($state, $scope, MemberAccountService, $rootScope, MessageService, AuthServerProvider, $uibModalInstance, $uibModal) {
        /**
         * Created by vimpans on 2019/6/25
         */
        var vm = $scope;

        vm.loginModel = {rememberMe:false};

        vm.logining = false;
        vm.loginAction = function () {
            if (vm.logining) {return}
            vm.logining = true;
            MemberAccountService.login(vm.loginModel, function (res) {
                MessageService.success("登录成功 ！");
                AuthServerProvider.storeAuthenticationToken(res.id_token, vm.loginModel.rememberMe);
                // $rootScope.$broadcast('authenticationSuccess');
                $uibModalInstance.dismiss();
                $rootScope.$emit('userlogin');
                vm.logining = false;
            }, function (error) {
                MessageService.error("登录失败 ！"+(error.data.detail||''));
                vm.logining = false;
            });
        };

        vm.keyupAction = function (e) {
            if (e.keyCode === 13 && vm.loginModel.username && vm.loginModel.password) {
                vm.loginAction();
            }
        };

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.requestRegisterAction = function () {
            $uibModalInstance.dismiss();
            $rootScope.$emit("requestRegister");
        };

        vm.forgotPassword = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/member-center/member-forgot-password.html',
                controller: 'MemberForgotPasswordController',
                controllerAs: 'vm',
                size: 'normal',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('HomeConfigService', HomeConfigService);

    HomeConfigService.$inject = ['$resource'];

    function HomeConfigService($resource) {
        var service = $resource('api/home/:param', {}, {
            'findPublish': {method: 'GET', params: {param: 'findPublish'}, isArray: false},
            'findSave': {method: 'GET', params: {param: 'findSave'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('HomeController', HomeController);
    HomeController.$inject = ['$state', '$scope', 'HomeConfigService', '$uibModal'];

    function HomeController($state, $scope, HomeConfigService, $uibModal) {
        /**
         * Created by vimpans on 2019/6/17
         */
        var vm = $scope;

        vm.myInterval = 5000;
        vm.noWrapSlides = false;
        vm.active = 0;
        vm.keyword = null;

        // var $API = null;
        // vm.playerReady = function (a) {
        //     $API = a;
        // };
        // vm.playVideo = function () {
        //     $API.play();
        // };

        vm.homeModel = {};
        vm.bannerModel = {};
        vm.buildingModel = null;
        vm.buildingList = [];
        vm.advertiseModel = {};
        vm.activityList = [];
        vm.videoModel = null;
        initDataAction();
        function initDataAction() {
            HomeConfigService.findPublish({}, function (res) {
                vm.homeModel = res.data;
                if (!vm.homeModel) {return}
                for (var i = 0; i<vm.homeModel.resources.length; i++) {
                    var resource = vm.homeModel.resources[i];
                    if (resource.type === "BANNER") {
                        if (vm.homeModel.type === 'SLIDE') {
                            vm.bannerModel = resource;
                        } else if (vm.homeModel.type === 'VIDEO') {
                            vm.videoModel = resource.category.images[0]||{};
                        }
                    } else if (resource.type === "ADVERTISE") {
                        vm.advertiseModel = resource;
                    } else if (resource.type === "BUILDING") {
                        if (!vm.buildingModel) {
                            vm.buildingModel = resource;
                        } else {
                            vm.buildingList.push(resource);
                        }
                    } else if (resource.type === "ACTIVITY") {
                        vm.activityList.push(resource);
                    }
                }
            });
        }
        vm.translateLevel = function (level) {
            if (level === 'ORGANIZATION') {
                return "租户会员";
            }
            if (level === 'PLATFOMEUSER') {
                return "平台以上会员";
            }
            if (level === 'OPEN') {
                return "完全开放";
            }
        };

        vm.appointmentAction = function () {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/appointment/appointment.html',
                controller: 'AppointmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        };

        vm.searchAction = function () {
            if (!vm.keyword) {return;}
            $state.go('building', {keyword: vm.keyword});
        };
        vm.keyupAction = function (e) {
            if (e.keyCode === 13) {
                vm.searchAction();
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('CitySelectorController', CitySelectorController);
    CitySelectorController.$inject = ['$state', '$scope', '$localStorage', 'CityManagerService', '$uibModalInstance'];

    function CitySelectorController($state, $scope, $localStorage, CityManagerService, $uibModalInstance) {
        /**
         * Created by vimpans on 2019/8/19
         */
        var vm = $scope;

        vm.locationId = $localStorage.location_id;
        vm.locationName = $localStorage.location_name;

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.cityList = [];
        initCityAction();
        function initCityAction() {
            CityManagerService.findAll({}, function (res) {
                vm.cityList = res.data;
            });
        }

        vm.selCity = function (city) {
            if (vm.locationId === city.id) {return}
            vm.locationId = city.id;
            vm.locationName = city.name;
        };

        vm.saveAction = function () {
            $uibModalInstance.close({id:vm.locationId, name:vm.locationName});
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('BuildingDetailController', BuildingDetailController);
    BuildingDetailController.$inject = ['$state', '$stateParams', '$scope', 'BuildingService', 'RoomService', '$interval', '$uibModal'];

    function BuildingDetailController($state, $stateParams, $scope, BuildingService, RoomService, $interval, $uibModal) {
        /**
         * Created by vimpans on 2019/7/4
         */

        var vm = $scope;

        vm.buildingModel = null;
        vm.map = null;
        vm.centerPoint = null;
        vm.local = null;
        vm.agencyContentTop = 0;
        vm.roomList = [];
        vm.roomPage = 0;
        vm.extendArea = false;

        vm.holdQuantityStatus = false;
        vm.holdQuantity = null;
        vm.tempQuantity = null;

        vm.priceSelStatus = false;
        vm.priceIndex = -1;
        vm.priceRegionIndex = -1;

        vm.typeSelStatus = false;
        vm.typeValueList = ["OFFICE","CONFERENCE","MEETING","SHOW","INDEPENDENT"];
        vm.typeNameList = ["办公室","会议室","洽谈室","路演室","独立办公区域"];
        vm.typeIndex = -1;
        vm.typeRegionIndex = -1;

        vm.statusSelStatus = false;
        vm.statusValueList = ["NOTRENT","SHARED","RENTED"];
        vm.statusNameList = ["未租","共享","已租"];
        vm.statusIndex = -1;
        vm.statusRegionIndex = -1;

        vm.floorSelStatus = false;
        vm.floorList = [];
        vm.selectedFloor = null;
        vm.tempFloor = null;

        vm.pageparams = {
            page: 1,
            size: 10,
            count: 0,
            keyword: null
        };

        initBuildingAction();
        addListener();
        function initBuildingAction() {
            BuildingService.findOne({id: $stateParams.id}, function (res) {
                vm.buildingModel = res.data;
                vm.buildingModel.address = (vm.buildingModel.addrProvince||'')+(vm.buildingModel.addrCity||'')+(vm.buildingModel.addrDistrict||'')+(vm.buildingModel.addrAddress||'');
                initMapAction();
                initRoomAction();
                autoSwiper();
                roomAutoSwiper();
            });
            BuildingService.getLevel({bId: $stateParams.id}, function (res) {
                vm.floorList = group(res.data, 5);
            })
        }

        vm.pageChangeAction = function () {
            // initDataAction();
            initRoomAction();
        };

        function initRoomAction() {
            var params = {page:vm.roomPage, size: 10, bId: vm.buildingModel.id};
            if (vm.holdQuantity) {params.sCapacity = vm.holdQuantity;params.eCapacity = 100000000}
            if (vm.roomType) {params.type = vm.roomType}
            if (vm.priceIndex !== -1) {
                switch (vm.priceIndex) {
                    case 0: params.sPrice = 1000;params.ePrice = 2000; break;
                    case 1: params.sPrice = 2000;params.ePrice = 4000; break;
                    case 2: params.sPrice = 4000;params.ePrice = 100000000000; break;
                }
            }
            if (vm.selectedFloor) {params.level = vm.selectedFloor}
            if (vm.typeIndex!==-1) {params.type = vm.typeValueList[vm.typeIndex]}
            if (vm.statusIndex!==-1) {params.state = vm.statusValueList[vm.statusIndex]}
            params.page = vm.pageparams.page-1;
            params.size = vm.pageparams.size;
            RoomService.filtration(params, function (res) {
                vm.roomList = res.data;
                vm.pageparams.count = res.info.count;
            })
        }

        function group(array, subGroupLength) {
            var groupIndex = 0;
            var newArray = [];
            while(groupIndex < array.length) {
                newArray.push(array.slice(groupIndex, groupIndex += subGroupLength));
            }
            return newArray;
        }

        function initMapAction(){
            if (!BMap) {return}
            vm.map = new BMap.Map("baiduMap");
            vm.map.addControl(new BMap.NavigationControl({type: BMAP_NAVIGATION_CONTROL_ZOOM} ));
            vm.map.enableScrollWheelZoom();
            vm.map.enableKeyboard();
            vm.map.enableDragging();
            vm.map.enableDoubleClickZoom();
            vm.local = new BMap.LocalSearch(vm.map, {renderOptions: {map: vm.map, autoViewport: false}});
            // addMapOverlay();
            addressToPoint(function (point) {
                vm.centerPoint = point;
                vm.map.centerAndZoom(point, 17);
                vm.map.addOverlay(new BMap.Marker(point));
            });
        }

        function addressToPoint(cb) {
            var geo = new BMap.Geocoder();
            geo.getPoint(vm.buildingModel.address, cb, vm.buildingModel.addrProvince);
        }
        vm.nearbySearch = function (keys) {
            if (!keys) {return}
            vm.local.clearResults();
            vm.local.searchNearby(keys,vm.centerPoint,1000);
        };

        function addMapOverlay() {
            var icon = new BMap.Icon('../image/aboutus-map-annotation.png', new BMap.Size(50, 45), {
                anchor: new BMap.Size(15, 50)
            });
            var mkr = new BMap.Marker(new BMap.Point(121.456618,31.232689), {
                icon: icon
            });
            vm.map.addOverlay(mkr);
        }

        vm.managerExtend = false;
        vm.extendManagerAction = function () {
            vm.managerExtend = !vm.managerExtend;
            calculateAgency();
        };
        function addListener() {
            window.onscroll = function (ev) {
                calculateAgency();
                vm.$apply();
            }
        }
        function calculateAgency() {
            var totalHeight = $('.agency-container')[0].clientHeight;
            var contentHeight = $('.agency-content')[0].clientHeight;
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            vm.agencyContentTop = (t-284)>0 ? (t-284) : 0;
            if (contentHeight + vm.agencyContentTop > totalHeight) {
                vm.agencyContentTop = totalHeight-contentHeight-5;
            }
        }

        vm.cancelPopover = function (index) {
            switch (index) {
                case 0: vm.holdQuantityStatus=false; break;
                case 1: vm.floorSelStatus = false; break;
                case 2: vm.priceSelStatus = false; break;
                case 3: vm.typeSelStatus = false; break;
                case 4: vm.statusSelStatus = false; break;
            }
        };
        vm.issuePopover = function (index) {
            switch (index) {
                case 0: vm.holdQuantity=vm.tempQuantity;vm.holdQuantityStatus=false; break;
                case 1: vm.selectedFloor=vm.tempFloor;vm.floorSelStatus = false; break;
                case 2: vm.priceIndex=vm.priceRegionIndex;vm.priceSelStatus = false; break;
                case 3: vm.typeIndex=vm.typeRegionIndex;vm.typeSelStatus = false; break;
                case 4: vm.statusIndex=vm.statusRegionIndex;vm.statusSelStatus = false; break;
            }
            initRoomAction();
        };
        vm.radioClick = function (index) {
            if (vm.priceRegionIndex === index) {
                vm.priceRegionIndex = -1;
            } else {
                vm.priceRegionIndex = index;
            }
        };
        vm.getRadioContent = function (index) {
            if (index === -1) {
                return "价格区间";
            } else if (index === 0) {
                return "1000-2000￥/月";
            } else if (index === 1) {
                return "2000-4000￥/月";
            } else if (index === 2) {
                return ">4000￥/月";
            }
        };
        vm.radioTypeClick = function (index) {
            if (vm.typeRegionIndex === index) {
                vm.typeRegionIndex = -1;
            } else {
                vm.typeRegionIndex = index;
            }
        };
        vm.radioStatusClick = function (index) {
            if (vm.statusRegionIndex === index) {
                vm.statusRegionIndex = -1;
            } else {
                vm.statusRegionIndex = index;
            }
        };
        vm.changeQuantity = function (plus) {
            if (plus) {
                if (!vm.tempQuantity) {vm.tempQuantity=0}
                vm.tempQuantity++;
            } else {
                if (vm.tempQuantity&&vm.tempQuantity!==1) {
                    vm.tempQuantity--;
                }
            }
        };
        vm.selectFloor = function (a,b) {
            vm.tempFloor = vm.floorList[a][b];
        };
        vm.tonull = function (a) {vm[a] = null; initRoomAction()};
        vm.to_1 = function (a) {vm[a] = -1; initRoomAction()};

        vm.swiper_animation = { transform: 'translateX(0)' };
        vm.swiper_countor = 0;
        function autoSwiper() {
            if (!vm.buildingModel.previewImages.images || vm.buildingModel.previewImages.images.length===0 || vm.buildingModel.previewImages.images.length===1) {
                return;
            }
            vm.interval = $interval(function () {
                vm.swiper_countor++;
                if (vm.swiper_countor === vm.buildingModel.previewImages.images.length) {
                    vm.swiper_countor = 0;
                }
                vm.swiper_animation.transform = 'translateX('+(-vm.swiper_countor * 830)+'px)';
            }, 5000);
        }
        vm.tapSwiperBtn = function (idex) {
            if (!vm.buildingModel.previewImages.images || vm.buildingModel.previewImages.images.length===0 || vm.buildingModel.previewImages.images.length===1) {
                return;
            }
            $interval.cancel(vm.interval);
            vm.swiper_animation.transform = 'translateX('+(-idex * 830)+'px)';
            vm.swiper_countor = idex;
            autoSwiper();
        };
        vm.previousImageAction = function () {
            vm.swiper_countor--;
            vm.tapSwiperBtn(vm.swiper_countor);
        };
        vm.nextImageAction = function () {
            vm.swiper_countor++;
            vm.tapSwiperBtn(vm.swiper_countor);
        };

        vm.rooms_animation = {transform: 'translateX(0)'};
        vm.rooms_countor = 0;
        function roomAutoSwiper() {
            if (!vm.buildingModel.roomImages.images || vm.buildingModel.roomImages.images.length===0 || vm.buildingModel.roomImages.images.length===1) {
                return;
            }
            vm.roomTnterval = $interval(function () {
                vm.rooms_countor++;
                if (vm.rooms_countor === vm.buildingModel.roomImages.images.length) {
                    vm.rooms_countor = 0;
                }
                vm.rooms_animation.transform = 'translateX('+(-vm.rooms_countor * 830)+'px)';
            }, 5000);
        }
        vm.tapRoomSwiperBtn = function (idex) {
            if (!vm.buildingModel.roomImages.images || vm.buildingModel.roomImages.images.length===0 || vm.buildingModel.roomImages.images.length===1) {
                return;
            }
            $interval.cancel(vm.roomTnterval);
            vm.rooms_animation.transform = 'translateX('+(-idex * 830)+'px)';
            vm.rooms_countor = idex;
            roomAutoSwiper();
        };
        vm.previousRoomImageAction = function () {
            vm.rooms_countor--;
            vm.tapRoomSwiperBtn(vm.rooms_countor);
        };
        vm.nextRoomImageAction = function () {
            vm.rooms_countor++;
            vm.tapRoomSwiperBtn(vm.rooms_countor);
        };

        vm.appointmentAction = function (roomName) {
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/appointment/appointment.html',
                controller: 'AppointmentController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {source: vm.buildingModel.name+(roomName?('/'+roomName):''), buildingId: vm.buildingModel.id, managerName: vm.buildingModel.managerName, managerPhone: vm.buildingModel.managerPhone};
                    }
                }
            }).result.then(function () {

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/3
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('building', {
                parent: 'module',
                url: '/building?:keyword',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/building/building.html',
                        controller: 'BuildingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('buildingDetail', {
                parent: 'module',
                url: '/building-d?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/building/building-detail.html',
                        controller: 'BuildingDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('BuildingService', BuildingService);

    BuildingService.$inject = ['$resource'];

    function BuildingService($resource) {
        var service = $resource('api/building/:param', {}, {
            'query': {method: 'GET', params: {param: 'findByKeyWord'}, isArray: false},
            'search': {method: 'GET', params: {param: 'search'}, isArray: false},
            'findOne': {method: 'GET', params: {param: 'findOne'}, isArray: false},
            'getOne': {method: 'GET', params: {param: 'getOne'}, isArray: false},
            'getLevel': {method: 'GET', params: {param: 'getLevel'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('BuildingController', BuildingController);
    BuildingController.$inject = ['$state', '$scope', '$stateParams', 'BuildingService', 'RoomService', 'RegionManagerService', '$localStorage'];

    function BuildingController($state, $scope, $stateParams, BuildingService, RoomService, RegionManagerService, $localStorage) {
        /**
         * Created by vimpans on 2019/7/3
         */
        var vm = $scope;

        vm.locationId = $localStorage.location_id;
        vm.locationName = $localStorage.location_name;

        vm.extendMore = false;

        vm.buildingList = [];
        vm.holdQuantityStatus = false;
        vm.regionSelStatus = false;
        vm.priceSelStatus = false;
        vm.regionList = [];
        vm.selectedRegion = null;
        vm.tempRegion = null;
        vm.holdQuantity = null;
        vm.tempQuantity = null;
        vm.priceIndex = -1;
        vm.priceRegionIndex = -1;
        vm.roomType = null;
        vm.priceSort = false;

        vm.pageparams = {
            page: 1,
            size: 10,
            count: 0,
            keyword: null
        };

        if ($stateParams.keyword) {
            vm.pageparams.keyword = $stateParams.keyword;
        }

        vm.searchAction = function () {
            vm.pageparams.page = 1;
            vm.selectedRegion = null;
            vm.tempRegion = null;
            vm.holdQuantity = null;
            vm.tempQuantity = null;
            vm.priceIndex = -1;
            vm.priceRegionIndex = -1;
            vm.roomType = null;
            initDataAction();
        };
        vm.keyupAction = function (e) {
            if (e.keyCode == 13) {
                vm.searchAction();
            }
        };

        function initCityAction() {
            RegionManagerService.findByCity({cId: vm.locationId}, function (res) {
                vm.regionList = group(res.data, 5);
            })
        }

        function initDataAction() {
            BuildingService.query({keyword: vm.keyword, priceSort: vm.priceSort, page: vm.pageparams.page-1, size: vm.pageparams.size}, function (res) {
                vm.buildingList = res.data;
                vm.pageparams.count = res.info.count;
            });
        }

        vm.searchAction();
        initCityAction();

        vm.initByRoom = function () {
            vm.pageparams.keyword = null;
            vm.pageparams.page = 1;
            initByRoomAction();
        };

        vm.conditionSearchMode = false;

        vm.pageChangeAction = function () {
            if (vm.conditionSearchMode) {
                initByRoomAction()
            } else {
                initDataAction()
            }
        };

        function initByRoomAction() {
            vm.conditionSearchMode = true;
            var params = {priceSort: vm.priceSort, city: vm.locationName};
            if (vm.selectedRegion) {params.region = vm.selectedRegion.name}
            if (vm.holdQuantity) {params.sCapacity = vm.holdQuantity;params.eCapacity = 100000000}
            if (vm.roomType) {params.type = vm.roomType}
            if (vm.priceIndex !== -1) {
                switch (vm.priceIndex) {
                    case 0: params.sPrice = 1000;params.ePrice = 2000; break;
                    case 1: params.sPrice = 2000;params.ePrice = 4000; break;
                    case 2: params.sPrice = 4000;params.ePrice = 100000000000; break;
                }
            }
            params.page = vm.pageparams.page-1;
            params.size = vm.pageparams.size;
            BuildingService.search(params, function (res) {
                vm.buildingList = res.data;
                vm.pageparams.count = res.info.count;
            })
        }

        function group(array, subGroupLength) {
            var groupIndex = 0;
            var newArray = [];
            while(groupIndex < array.length) {
                newArray.push(array.slice(groupIndex, groupIndex += subGroupLength));
            }
            return newArray;
        }

        vm.radioClick = function (index) {
            if (vm.priceRegionIndex === index) {
                vm.priceRegionIndex = -1;
            } else {
                vm.priceRegionIndex = index;
            }
        };
        vm.getRadioContent = function (index) {
            if (index === -1) {
                return "价格区间";
            } else if (index === 0) {
                return "1000-2000￥/月";
            } else if (index === 1) {
                return "2000-4000￥/月";
            } else if (index === 2) {
                return ">4000￥/月";
            }
        };

        vm.selectRegion = function (a,b) {
            vm.tempRegion = vm.regionList[a][b];
        };
        vm.cancelPopover = function (index) {
            switch (index) {
                case 0: vm.holdQuantityStatus=false; break;
                case 1: vm.regionSelStatus = false; break;
                case 2: vm.priceSelStatus = false; break;
            }
        };
        vm.issuePopover = function (index) {
            switch (index) {
                case 0: vm.holdQuantity=vm.tempQuantity;vm.holdQuantityStatus=false; break;
                case 1: vm.selectedRegion=vm.tempRegion;vm.regionSelStatus = false; break;
                case 2: vm.priceIndex=vm.priceRegionIndex;vm.priceSelStatus = false; break;
            }
            initByRoomAction();
        };
        vm.selRoomType = function (type) {
            vm.roomType = type;
            initByRoomAction();
        };
        vm.changeQuantity = function (plus) {
            if (plus) {
                if (!vm.tempQuantity) {vm.tempQuantity=0}
                vm.tempQuantity++;
            } else {
                if (vm.tempQuantity&&vm.tempQuantity!==1) {
                    vm.tempQuantity--;
                }
            }
        };
        vm.clearTempRegion = function () {
            vm.tempRegion=null
        };
        vm.changeSort = function (sort) {
            vm.priceSort = sort;
            initByRoomAction();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('AppointmentService', AppointmentService);

    AppointmentService.$inject = ['$resource'];

    function AppointmentService($resource) {
        var service = $resource('api/arrangement/:param', {}, {
            'create': {method: 'POST', params: {param: 'create'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('AppointmentController', AppointmentController);
    AppointmentController.$inject = ['$state', 'entity', '$scope', '$uibModalInstance', 'VerificationService', '$interval', 'AppointmentService', 'Principal', '$filter', 'MessageService', '$localStorage', '$window', '$uibModal', 'MemberService', '$timeout'];

    function AppointmentController($state, entity, $scope, $uibModalInstance, VerificationService, $interval, AppointmentService, Principal, $filter, MessageService, $localStorage, $window, $uibModal, MemberService, $timeout) {
        /**
         * Created by vimpans on 2019/7/9
         */
        var vm = $scope;

        vm.cityId = $localStorage.location_id;
        vm.cityName = $localStorage.location_name;

        vm.dateSel = false;
        vm.agreementNegotiate = true;
        vm.canVerify = true;
        vm.counter = 0;
        vm.isAgent = false;
        vm.appointmentModel = {source:"首页", cityId: vm.cityId};

        if (entity) {
            if (entity.cityId) {
                vm.appointmentModel.cityId = entity.cityId;
            }
            vm.appointmentModel.regionId = entity.regionId;
            vm.appointmentModel.buildingId = entity.buildingId;
            vm.appointmentModel.managerName = entity.managerName;
            vm.appointmentModel.managerPhone = entity.managerPhone;
            vm.appointmentModel.source = entity.source;
            vm.isAgent = entity.isAgent||false;
            vm.appointmentModel.agent = vm.isAgent;
        }

        vm.datePicker = { date: {startDate: moment(), endDate:  moment()}, time:'08:00 - 21:00' };

        vm.startDateSel = false;
        vm.startTimeSel = false;
        vm.endDateSel = false;
        vm.endTimeSel = false;
        vm.now = new Date();
        // vm.datePicker.date.startDate = vm.now;
        // vm.datePicker.date.endDate = vm.now;
        vm.nowString = vm.now.toLocaleDateString();
        vm.dateRangeOptions = {
            pickerClasses: 'daterangepicker-customer',
            parentEl: "#date-range-picker-parent",
            autoApply: true,
            locale: {
                applyLabel: "确定",
                cancelLabel: '取消',
                separator: ' - ',
                format: "YYYY-MM-DD",
                daysOfWeek: ['日', '一', '二', '三', '四', '五','六'],
                monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
            }
        };

        vm.userModel = null;
        initUserInfo();
        function initUserInfo() {
            Principal.identity().then(function (account) {
                if(!account || !account.data) {return}
                vm.userModel = account.data;
                vm.appointmentModel.phone = vm.userModel.phone;
                vm.appointmentModel.fullname = vm.userModel.fullname;
            })
        }

        vm.$watch('appointmentModel.startDateShow', function (newVal) {
            if (newVal && !vm.appointmentModel.startTimeShow) {
                vm.startDateSel = false;
                vm.startTimeSel = true;
                vm.endDateSel = false;
                vm.endTimeSel = false;
            }
        });
        vm.$watch('appointmentModel.endTimeShow', function (newVal) {
            if (newVal && !vm.appointmentModel.endTimeShow) {
                vm.startDateSel = false;
                vm.startTimeSel = false;
                vm.endDateSel = false;
                vm.endTimeSel = true;
            }
        });

        vm.dismissModalAction = function () {
            $uibModalInstance.dismiss();
        };

        vm.getVerification = function () {
            if (!vm.appointmentModel.phone) {return}
            VerificationService.get({phone:vm.appointmentModel.phone, type: 'REGISTRY'},function (res) {
                countDownAction();
            }, function (error) {
                MessageService.error("获取验证码失败 ！"+(error.data.detail||''));
            })
        };

        function countDownAction() {
            vm.canVerify = false;
            vm.counter = 60;
            var interval = $interval(function () {
                vm.counter --;
                if (vm.counter <= 0) {
                    vm.counter = 0;
                    vm.canVerify = true;
                    $interval.cancel(interval);
                }
            },1000);
        }

        vm.saveAction = function () {
            vm.appointmentModel.startDate = $filter('date')(vm.datePicker.date.startDate, 'yyyy-MM-dd');
            vm.appointmentModel.endDate = $filter('date')(vm.datePicker.date.endDate, 'yyyy-MM-dd');
            vm.appointmentModel.startTime = vm.issueSelector.startH+':'+vm.issueSelector.startM;
            vm.appointmentModel.endTime = vm.issueSelector.endH+':'+vm.issueSelector.endM;
            AppointmentService.create(vm.appointmentModel, function (res) {
                MessageService.success("恭喜预约成功，工作人员会在指定的时间段内联系你！");
                $uibModalInstance.close();
            }, function (error) {
                MessageService.error("预约失败"+(error.data.detail||''));
            })
        };
        // '00','01','02','03','04','05','06','07',
        // '00','01','02','03','04','05','06','07',
        vm.startHours = ['08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
        vm.startMinutes = ['00','10','20','30','40','50'];
        vm.endHours = ['08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
        vm.endMinutes = ['00','10','20','30','40','50'];
        vm.timeSelector = {startH: '08', startM: '00', endH: '21', endM: '00'};
        vm.timeSelectorError = false;
        vm.issueSelector = angular.copy(vm.timeSelector);
        vm.startHSel = function (idex) {
            vm.timeSelector.startH = vm.startHours[idex];
            event.stopPropagation();
        };
        vm.startMSel = function (idex) {
            vm.timeSelector.startM = vm.startMinutes[idex];
            event.stopPropagation();
        };
        vm.endHSel = function (idex) {
            vm.timeSelector.endH = vm.endHours[idex];
            event.stopPropagation();
        };
        vm.endMSel = function (idex) {
            vm.timeSelector.endM = vm.endMinutes[idex];
            event.stopPropagation();
            // var startH = parseInt(vm.timeSelector.startH);
            // var startM = parseInt(vm.timeSelector.startM);
            // var endH = parseInt(vm.timeSelector.endH);
            // var endM = parseInt(vm.timeSelector.endM);
            // if (endH < startH) {
            //     event.stopPropagation();
            //     vm.timeSelectorError = true;
            //     return;
            // }
            // if (endH === startH) {
            //     if (endM <= startM) {
            //         event.stopPropagation();
            //         vm.timeSelectorError = true;
            //         return;
            //     }
            // }
            // vm.issueSelector = angular.copy(vm.timeSelector);
            // vm.datePicker.time = vm.timeSelector.startH+':'+vm.timeSelector.startM+' - '+vm.timeSelector.endH+':'+vm.timeSelector.endM;
            // vm.timeSelector = angular.copy(vm.issueSelector);
        };
        vm.allTimeSel = function () {
            var startH = parseInt(vm.timeSelector.startH);
            var startM = parseInt(vm.timeSelector.startM);
            var endH = parseInt(vm.timeSelector.endH);
            var endM = parseInt(vm.timeSelector.endM);
            if (endH < startH) {
                event.stopPropagation();
                vm.timeSelectorError = true;
                return;
            }
            if (endH === startH) {
                if (endM <= startM) {
                    event.stopPropagation();
                    vm.timeSelectorError = true;
                    return;
                }
            }
            vm.issueSelector = angular.copy(vm.timeSelector);
            vm.datePicker.time = vm.timeSelector.startH+':'+vm.timeSelector.startM+' - '+vm.timeSelector.endH+':'+vm.timeSelector.endM;
            vm.timeSelector = angular.copy(vm.issueSelector);
            // vm.timeSelectorError = false;
            // vm.issueSelector = {startH: '08', startM: '00', endH: '23', endM: '50'};
            // vm.timeSelector = angular.copy(vm.issueSelector);
            // vm.datePicker.time = vm.timeSelector.startH+':'+vm.timeSelector.startM+' - '+vm.timeSelector.endH+':'+vm.timeSelector.endM;
        };
        vm.timeSelectAction = function () {
            vm.timeSelectorError = false;
            vm.timeSelector = angular.copy(vm.issueSelector);
        };

        vm.jumpNegotiation = function () {
            // $window.open($state.href('negotiation'),'_blank');
            $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/module/negotiation/negotiation.html',
                controller: 'NegotiationController',
                controllerAs: 'vm',
                size: 'negotiate',
                resolve: {
                    entity: function () {
                        return null;
                    }
                }
            }).result.then(function () {

            });
        };

        vm.phoneExists = false;
        vm.pcTimeout = null;
        vm.phoneChangeAction = function () {
            if (!vm.pcTimeout && vm.appointmentModel.phone) {
                vm.pcTimeout = $timeout(function () {
                    MemberService.check({login: vm.appointmentModel.phone}, function (res) {
                        vm.phoneExists = !!res.data.exists;
                    }, function () {vm.phoneExists = false;});
                    vm.pcTimeout = null;
                }, 800);
            } else {
                $timeout.cancel(vm.pcTimeout);
                vm.pcTimeout = null;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/11
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('activities', {
                parent: 'module',
                url: '/activities',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/activity/activities.html',
                        controller: 'ActivitiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('activity', {
                parent: 'module',
                url: '/activity?:id',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/module/activity/activity.html',
                        controller: 'ActivityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('ActivityService', ActivityService);

    ActivityService.$inject = ['$resource'];

    function ActivityService($resource) {
        var service = $resource('api/activity/:param', {}, {
            'findRecently': {method: 'GET', params: {param: 'findRecently'}, isArray: false},
            'findHistory': {method: 'GET', params: {param: 'findHistory'}, isArray: false},
            'appliers': {method: 'GET', params: {param: 'getHideApplicants'}, isArray: false},
            'applyInfo': {method: 'GET', params: {param: 'getMyApplicant'}, isArray: false},
            'apply': {method: 'POST', params: {param: 'apply'}, isArray: false},
            'cancelApply': {method: 'POST', params: {param: 'cancelMyApplicant'}, isArray: false},
            'findOne': {method: 'GET', params: {param: 'findOne'}, isArray: false}
        });
        return service;
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('ActivityController', ActivityController);
    ActivityController.$inject = ['$state', '$stateParams', '$scope', 'ActivityService', '$rootScope', 'MemberAccountService', 'Principal', 'MessageService', '$filter', 'AuthServerProvider'];

    function ActivityController($state, $stateParams, $scope, ActivityService, $rootScope, MemberAccountService, Principal, MessageService, $filter, AuthServerProvider) {
        /**
         * Created by vimpans on 2019/7/11
         */
        var vm = $scope;

        vm.activityModel = {};
        vm.recentlyList = [];
        vm.showApplyInfo = false;
        initDataAction();
        addListener();
        initRecentlyAction();
        function initDataAction() {
            ActivityService.findOne({id: $stateParams.id}, function (res) {
                vm.activityModel = res.data;
                vm.activityModel.insertHtml = '<br>'+
                    vm.activityModel.name+'<br>时间：'+
                    $filter('date')(vm.activityModel.startTime, 'yyyy-MM-dd HH:mm')+'-'+
                    $filter('date')(vm.activityModel.endTime, 'yyyy-MM-dd HH:mm')+'<br>地点：'+
                    vm.activityModel.addrProvince+
                    vm.activityModel.addrCity+
                    vm.activityModel.addrDistrict+
                    vm.activityModel.addrAddress;
                $('#activity-content').html(vm.activityModel.introduction);
            })
        }

        vm.currentPage = 0;
        vm.totalCount = null;
        vm.appliesList = [];
        initApplicantsData();
        function initApplicantsData() {
            ActivityService.appliers({page: vm.currentPage, size:10, activityId: $stateParams.id}, function (res) {
                vm.appliesList = vm.appliesList.concat(res.data);
                vm.totalCount = res.info.count;
            })
        }
        vm.loadMoreAction = function () {
            vm.currentPage++;
            initApplicantsData();
        };

        // vm.managerExtend = false;
        // vm.extendManagerAction = function () {
        //     vm.managerExtend = !vm.managerExtend;
        //     calculateAgency();
        // };
        function addListener() {
            window.onscroll = function (ev) {
                calculateAgency();
                vm.$apply();
            }
        }
        function calculateAgency() {
            var totalHeight = $('.agency-container')[0].clientHeight;
            var contentHeight = $('.agency-content')[0].clientHeight;
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            vm.agencyContentTop = (t-284)>0 ? (t-284) : 0;
            if (contentHeight + vm.agencyContentTop > totalHeight) {
                vm.agencyContentTop = totalHeight-contentHeight-5;
            }
        }
        function initRecentlyAction() {
            ActivityService.findRecently({
                page: 0,
                size: 2
            }, function (res) {
                vm.recentlyList = res.data;
            });
        }

        vm.userModel = null;
        vm.isApply = false;
        initUserInfo();
        function initUserInfo() {
            Principal.identity().then(function (account) {
                if(!account) {return}
                vm.userModel = account.data;
                initApplyInfo();
            });
        }

        function initApplyInfo() {
            ActivityService.applyInfo({id: $stateParams.id}, function (res) {
                if (res.data) {
                    vm.isApply = true;
                }
            })
        }

        vm.loginModel = {rememberMe:false};

        vm.loginAction = function () {
            MemberAccountService.login(vm.loginModel, function (res) {
                AuthServerProvider.storeAuthenticationToken(res.id_token, vm.loginModel.rememberMe);
                $rootScope.$broadcast('authenticationSuccess');
                window.location.reload();
                MessageService.success("登录成功 ！");
                initUserInfo();
            }, function (error) {
                MessageService.error("登录失败 ！"+(error.data.detail||''));
            });
        };

        vm.keyupAction = function (e) {
            if (e.keyCode === 13 && vm.loginModel.username && vm.loginModel.password) {
                vm.loginAction();
            }
        };

        vm.applyAction = function () {
            ActivityService.apply({activityId: vm.activityModel.id}, function (res) {
                vm.isApply = true;
                MessageService.contentKnow({
                    title: '报名成功',
                    content: vm.activityModel.insertHtml,
                    issue: '知道了'
                })
            }, function (error) {
                MessageService.contentKnow({
                    title: '报名失败',
                    content: error.data.detail,
                    issue: '知道了'
                })
            })
        };
        vm.cancelApplyAction = function () {
            MessageService.contentConfirm({
                title: '确定取消报名？',
                content: vm.activityModel.insertHtml,
                issue: '取消报名',
                cancel: '关闭'
            }, function () {
                //取消
                ActivityService.cancelApply({id: vm.activityModel.id}, function (res) {
                    vm.isApply = false;
                }, function (error) {
                    MessageService.contentKnow({
                        title: '取消失败',
                        content: error.data.detail,
                        issue: '知道了'
                    })
                });
            });
        };

        vm.requestRegisterAction = function () {
            $rootScope.$emit("requestRegister");
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('ActivitiesController', ActivitiesController);
    ActivitiesController.$inject = ['$state', '$scope', 'ActivityService', '$filter', 'MessageService', 'Principal', '$rootScope'];

    function ActivitiesController($state, $scope, ActivityService, $filter, MessageService, Principal, $rootScope) {
        /**
         * Created by vimpans on 2019/7/11
         */
        var vm = $scope;

        vm.recentlyList = [];
        vm.historyList = [];
        vm.recommendModel = {};
        vm.recentlyPage = 1;
        vm.recentlySize = 10;
        vm.recentlyCount = 0;
        vm.historyPage = 1;
        vm.historySize = 10;
        vm.historyCount = 0;
        initRecentlyAction();
        initHistoryAction();

        vm.userModel = null;
        initUserInfo();
        function initUserInfo() {
            Principal.identity().then(function (account) {
                if(!account) {return}
                vm.userModel = account.data;
            })
        }

        function initRecentlyAction() {
            ActivityService.findRecently({
                page: vm.recentlyPage-1,
                size: vm.recentlySize
            }, function (res) {
                vm.recentlyList = res.data.map(function (val) {
                    val.insertHtml = '<br>'+
                        val.name+'<br>时间：'+
                        $filter('date')(val.startTime, 'yyyy-MM-dd HH:mm')+'-'+
                        $filter('date')(val.endTime, 'yyyy-MM-dd HH:mm')+'<br>地点：'+
                        val.addrProvince+
                        val.addrCity+
                        val.addrDistrict+
                        val.addrAddress;
                    return val;
                });
                vm.recommendModel = vm.recentlyList[0]||{};
                vm.recentlyCount = res.info.count;
            });
        }
        function initHistoryAction() {
            ActivityService.findHistory({
                page: vm.historyPage-1,
                size: vm.historySize
            }, function (res) {
                vm.historyList = res.data;
                vm.historyCount = res.info.count;
            })
        }
        vm.recentlyPageChange = function () {
            initRecentlyAction();
        };
        vm.historyPageChange = function () {
            initHistoryAction();
        };

        vm.applyAction = function (activity) {
            if (!vm.userModel) {
                $rootScope.$emit("requestLogin");
                return;
            }
            ActivityService.apply({activityId: activity.id}, function (res) {
                MessageService.contentKnow({
                    title: '报名成功',
                    content: activity.insertHtml,
                    issue: '知道了'
                })
            }, function (error) {
                MessageService.contentKnow({
                    title: '报名失败',
                    content: error.data.detail,
                    issue: '知道了'
                })
            })
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$rootScopeProvider'];

    /**
     * Created by vimpans on 2019/7/3
     */

    function stateConfig($stateProvider) {
        $stateProvider
            .state('default', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'index@': {
                        templateUrl: 'app/default/default.html',
                        controller: 'DefaultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .controller('DefaultController', DefaultController);
    DefaultController.$inject = ['$state', '$scope'];

    function DefaultController($state, $scope) {
        /**
         * Created by vimpans on 2019/7/3
         */
        $state.go('home');
    }
})();

/**
 * Modify: @Nathan
 * Date: 2018/04/26
 * Detail: Need Bootstrap
 */
angular.module('waterfall', ['ngSanitize'])

    .factory('waterfall', function () {
        'use strict';

        // find the distances of all upstream path
        function upstream(node) {
            if (node.upstream)
                return node.upstream;

            // if this is a head node
            if (node.previous.length === 0)
                return node.upstream = [0];

            node.upstream = [];
            node.previous.forEach(function (previous) {
                upstream(previous).forEach(function (distance) {
                    node.upstream.push(distance + 1);
                });
            });
            return node.upstream;
        }

        // find the distances of all downstream path
        function downstream(node) {
            if (node.downstream)
                return node.downstream;

            // if this is a tail node
            if (node.next.length === 0)
                return node.downstream = [0];

            node.downstream = [];
            node.next.forEach(function (next) {
                downstream(next).forEach(function (distance) {
                    if (node.downstream.indexOf(distance) === -1)
                        node.downstream.push(distance + 1);
                });
            });
            return node.downstream;
        }

        function calculateScore(node) {
            node.score = node.upstream.reduce(function (a, b) {
                return a + b;
            }) + node.downstream.reduce(function (a, b) {
                return a + b;
            });
            node.scoreUp = node.upstream.reduce(function (a, b) {
                return a + b;
            });
            node.scoreDown = node.downstream.reduce(function (a, b) {
                return a + b;
            });
        }

        function buildOptions(options) {
            return {
                hide: options && typeof options.hide !== 'undefined' ? options.hide : true,
                node: {
                    background: options && options.node && typeof options.node.background !== 'undefined' ? options.node.background : '#000',
                    color: options && options.node && typeof options.node.color !== 'undefined' ? options.node.color : '#fff',
                    width: options && options.node && typeof options.node.width !== 'undefined' ? options.node.width : 180,
                    height: options && options.node && typeof options.node.height !== 'undefined' ? options.node.height : 30,
                    add: options && options.node && typeof options.node.add !== 'undefined' ? options.node.add : null,
                    remove: options && options.node && typeof options.node.remove !== 'undefined' ? options.node.remove : null,
                    ok: options && options.node && typeof options.node.ok !== 'undefined' ? options.node.ok : null,
                    cancel: options && options.node && typeof options.node.cancel !== 'undefined' ? options.node.cancel : null,
                    onclick: options && options.node && typeof options.node.onclick !== 'undefined' ? options.node.onclick : null,
                    mouseenter: options && options.node && typeof options.node.mouseenter !== 'undefined' ? options.node.mouseenter : null,
                    mouseleave: options && options.node && typeof options.node.mouseleave !== 'undefined' ? options.node.mouseleave : null,
                    keyup: options && options.node && typeof options.node.keyup !== 'undefined' ? options.node.keyup : null,
                    dblclick: options && options.node && typeof options.node.dblclick !== 'undefined' ? options.node.dblclick : null,
                    synchronize: options && options.node && typeof options.node.synchronize !== 'undefined' ? options.node.synchronize : null,
                    margin: {
                        x: options && options.node && options.node.margin && typeof options.node.margin.x !== 'undefined' ? options.node.margin.x : 20,
                        y: options && options.node && options.node.margin && typeof options.node.margin.y !== 'undefined' ? options.node.margin.y : 10
                    }
                }
            };
        }

        // empty
        function isEmpty(target) {
            return target === null || target === undefined || target === '';
        }

        var service = function (flow, options) {

            // default options
            options = options || buildOptions({});

            var index = {}, key;
            var nodes = [];
            // map nodes to index
            for (key in flow) {
                index[key] = {
                    id: key,
                    isActive: isEmpty(flow[key].isActive) ? false : flow[key].isActive,  // 是否为激活状态
                    isEdit: isEmpty(flow[key].isEdit) ? false : flow[key].isEdit,  // 是否为编辑状态
                    canAdd: isEmpty(flow[key].canAdd) ? false : flow[key].canAdd,  // 是否存在新增功能
                    html: flow[key].html || (flow[key].title ? flow[key].title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : ''),
                    class: flow[key].class || '',
                    color: flow[key].color || undefined,
                    background: flow[key].background || undefined,
                    needBorder: flow[key].needBorder || false,
                    visible: flow[key].visible || flow[key].visible === undefined,
                    next: Array.isArray(flow[key].next) ? flow[key].next.slice() : [],
                    previous: []
                };
            }

            if (Object.keys(index).length === 0)
                return nodes;

            // relate nodes
            for (key in index) {
                var node = index[key];
                node.next.forEach(function (id, i, list) {
                    // build the relationships

                    var next = list[i] = index[id];
                    if (next.previous)
                        next.previous.push(node);
                    else
                        next.previous = [node];
                });

                // add node to nodes array
                nodes.push(node);
            }

            // remove hidden nodes
            if (options.hide) {
                for (key in index) {
                    var node = index[key];

                    if (!node.visible) {
                        node.next.forEach(function (next) {
                            // remove self from next nodes
                            next.previous.splice(next.previous.indexOf(node), 1);

                            // add next nodes to previous nodes
                            node.previous.forEach(function (previous) {
                                if (previous.next.indexOf(next) === -1) {
                                    previous.next.push(next);
                                }
                            });
                        });

                        node.previous.forEach(function (previous) {
                            // remove self from previous nodes
                            previous.next.splice(previous.next.indexOf(node), 1);

                            // add previous nodes to next nodes
                            node.next.forEach(function (next) {
                                if (next.previous.indexOf(previous) === -1)
                                    next.previous.push(previous);
                            });
                        });

                        // remove self from the array
                        nodes.splice(nodes.indexOf(node), 1);

                    }
                }
            }

            // calculate distances
            for (var i in nodes) {
                var node = nodes[i];
                upstream(node);
                downstream(node);
                // calculateX(node); // calculate x
                calculateScore(node); // calculate score from total upstream and downstream
            }

            // sort by score
            nodes.sort(function (a, b) {
                if (a.score === 1 && b.score === 1) {
                    return 1;
                } else {
                    return a.score < b.score ? 1 : -1;
                }
            });

            // assign y values, beginning with the lowest score
            // calculateY(nodes[0], 0);

            return nodes;
        };

        service.buildOptions = buildOptions;

        return service;
    })

    .directive('waterfall', ['waterfall', function (waterfall) {
        return {
            // 被声明的方式
            restrict: 'A',
            // 内容
            template: '' +
            '<svg class="waterfall" ng-attr-width="{{width}}" ng-attr-height="{{height}}">\n' +
            '    <g ng-attr-transform="translate({{options.node.width / -2 + options.node.margin.x}}, {{0}})">\n' +
            '        <g ng-repeat="node in nodes track by node.id" ng-attr-transform="translate({{node.x}}, {{node.y}})" ng-click="options.node.onclick(node,nodes);" ng-dblclick="options.node.dblclick(node,nodes);" style="outline: none;">\n' +
            '            <foreignObject\n' +
            '				ng-attr-width="{{options.node.width}}"\n' +
            '				ng-attr-height="{{options.node.height}}"\n' +
            '				ng-attr-rx="{{options.node.radius}}"\n' +
            '				ng-attr-ry="{{options.node.radius}}"\n' +
            '            >\n' +
            // '                <img class="svg-remove" src="content/images/remove.png" ng-if="!node.isEdit && node.canAdd" ng-click="options.node.remove(node);" style="float: right;margin-bottom: -8px;margin-right: -8px;outline: none;"/>' +
            '                <div id="{{node.id}}" ng-attr-style="\n' +
            '                    width: {{options.node.width}}px;\n' +
            '                    height: {{options.node.height}}px;\n' +
            '                    line-height: {{options.node.height}}px;\n' +
            '                    background: {{node.background == undefined ? options.node.background : node.background}};\n' +
            '                    color: {{node.color == undefined ? options.node.color : node.color}};\n' +
            '                " ng-class="{true:\'product-border\',false:\'component-border\'}[node.needBorder]"' +
            '                  ng-mouseenter="options.node.mouseenter(node)" ng-mouseleave="options.node.mouseleave(node)">\n' +
            '                    <input ng-keyup="options.node.keyup($event, node)" class="n_inputStyle" ng-model="node.html"\n' +
            '                           ng-if="node.isEdit" input-select focus-me="node.isEdit" ng-change="options.node.synchronize(node)" \n' +
            '                           style="font-size: 14px;width: 70%;float: left;background: #fff !important;padding: 0 10px;font-family: \'微软雅黑\' !important;" autofocus />\n' +
            '                    <span ng-if="node.isEdit" style="padding: 0;color: #669BC1;float: right;width: 30%;text-align: center;outline: none;font-family: \'微软雅黑\' !important;font-size: 14px;background: #E9F5FF;" ng-click="options.node.ok(node);">保存</span>\n' +
            '                    <span ng-if="!node.isEdit" ng-bind-html="node.html" style="margin: 0 10px;float: left;font-family: \'微软雅黑\' !important;font-size: 14px;"></span>\n' +
            '                    <div ng-if="!node.isEdit && node.canAdd" ng-click="options.node.add(node);" style="float: right;padding: 0 10px;outline: none;border-radius: 0;margin-top: 2px;line-height: 28px;" ng-class="{\'svg-border-left\': node.isActive}">\n' +
            '                        <img class="plus" src="content/images/plus_active.png" ng-if="!node.isEdit && node.canAdd"/>\n' +
            '                    </div>\n' +
            // '                    <div ng-if="!node.isEdit && node.canAdd" ng-click="options.node.remove(node);" style="float: right;padding: 0 10px;outline: none;">\n' +
            // '                        <img class="minus" src="content/images/minus_active.png" ng-if="!node.isEdit && node.canAdd"/>\n' +
            // '                    </div>\n' +
            '                    <span ng-if="node.isActive && !node.isEdit" style="padding: 0 15px;color: #669BC1;float: right;outline: none;font-family: \'微软雅黑\' !important;font-size: 14px;" ng-click="options.node.remove(node);">删除</span>\n' +
            '                </div>\n' +
            '            </foreignObject>\n' +
            '        </g>\n' +
            '        <path stroke-dasharray="5,5" stroke="red" \n' +
            '			ng-repeat="link in links"\n' +
            '			ng-attr-d="\n' +
            '				M {{link.source.x}} {{link.source.y}}\n' +
            '				Q {{link.q1[0][0]}} {{link.q1[0][1]}},\n' +
            '					{{link.q1[1][0]}} {{link.q1[1][1]}}\n' +
            '				Q {{link.q2[0][0]}} {{link.q2[0][1]}},\n' +
            '					{{link.q2[1][0]}} {{link.q2[1][1]}}\n' +
            '				T {{link.target.x}} {{link.target.y}}"\n' +
            '        />\n' +
            '    </g>\n' +
            '</svg>\n',
            require: 'ngModel',
            // 创建一个全新的作用域[不继承且隔离]
            // flow 与元素中 ng-model 父级作用域变量绑定
            // opts 与元素中属性 waterfall 指定的内容一致
            scope: {
                flow: '=ngModel',
                opts: '=waterfall'
            },
            controller: ['$scope', '$element', '$attrs', '$parse', function ($scope, $element, $attrs, $parse) {
                function calculateX(node) {
                    node.x = (Math.max.apply(Math, node.upstream) + 0.5) * ($scope.options.node.width + $scope.options.node.margin.x * 2);

                    // calculate canvas width
                    $scope.width = Math.max($scope.width, node.x);
                }

                function calculateY(node, level, n) {
                    if (node.level != null)
                        return;

                    node.level = level;
                    node.y = level * ($scope.options.node.height + $scope.options.node.margin.y * 2);

                    // 临时处理方法[40为向下偏离量]
                    if(node.id.indexOf('product_') === -1) {
                        node.y += $scope.options.node.height;    // 8 -- 新加删除 x 的偏移量
                    }

                    if(node.next!=null&&node.next.length>0){
                        for(var i=0;i<node.next.length;i++){
                            node.next[i].y = (i+1)* ($scope.options.node.height + $scope.options.node.margin.y * 2);
                        }
                    }

                    // node.next.sort(function (a, b) {
                    //     // put tail nodes on top
                    //     if (a.scoreDown === 0)
                    //         return 1;
                    //     if (b.scoreDown === 0)
                    //         return -1;

                    //     // upstream sort
                    //     return a.scoreUp < b.scoreUp ? 1 : -1;
                    // }).forEach(function (next, index) {
                    //     calculateY(next, level + index, node);
                    // });

                    // node.previous.sort(function (a, b) {
                    //     // put head nodes on top
                    //     if (a.scoreUp === 0)
                    //         return 1;
                    //     if (b.scoreUp === 0)
                    //         return -1;

                    //     // downstream sort
                    //     return a.scoreDown < b.scoreDown ? 1 : -1;
                    // }).forEach(function (previous, index) {
                    //     calculateY(previous, level + index, node);
                    // });

                    // calculate canvas height
                    $scope.height = Math.max($scope.height, -node.y);
                }

                // build the waterfall
                // $scope.$watch(watchExpression, listener, objectEquality)
                // - watchExpression: 监听对象
                // - listener: 监听对象变化时回调，接收参数(newValue, oldValue, scope)
                // - objectEquality: true -> 检查所监控的对象中每一个属性的变化
                // opts -> results[0]; flow -> results[1]
                $scope.$watch('[opts, flow]', function (results) {
                    if (!results[0] || !results[1])
                        return;

                    $scope.options = waterfall.buildOptions(results[0]);

                    $scope.nodes = waterfall(results[1], $scope.options);

                    var size = $scope.nodes.length - 1;
                    var height = size * $scope.options.node.height + (size - 1) * 20;
                    $scope.links = [];

                    $scope.width = 0;
                    $scope.height = 0;

                    // calculate x values
                    for (i in $scope.nodes) {
                        calculateX($scope.nodes[i]);
                    }

                    // assign y values, beginning with the lowest score
                    calculateY($scope.nodes[0], 0);

                    // build links
                    for (i in $scope.nodes) {
                        var node = $scope.nodes[i];
                        node.color = node.color === undefined ? undefined : node.color;
                        node.next.forEach(function (next) {
                            var l = {
                                // source: {
                                //     x: node.x + $scope.options.node.width,
                                //     y: node.y + $scope.options.node.height / 2
                                // },
                                source: {
                                    x: node.x + $scope.options.node.width / 2,
                                    y: node.y + $scope.options.node.height
                                },
                                target: {
                                    x: next.x,
                                    y: next.y + $scope.options.node.height / 2
                                }
                            };

                            var offset = Math.min(Math.abs(l.target.y - l.source.y), $scope.options.node.margin.x) * ((l.target.y - l.source.y < 0) ? 1 : -1);

                            // the x middle
                            var c = (l.source.x + l.target.x) / 2;

                            // bezier points and handles
                            // l.q1 = [[c, l.source.y], [c, l.source.y - offset]];
                            // l.q2 = [[c, l.target.y + 2 * offset], [c, l.target.y + offset]];
                            l.q1 = [[l.source.x, l.source.y], [l.source.x, l.source.y]];
                            l.q2 = [[l.source.x, l.target.y], [l.source.x, l.target.y]];

                            $scope.links.push(l);
                        });
                    }

                    // 重新排序
                    // for(var i=1;i<=parseInt($scope.nodes.length/2);i++){
                    //     var y = $scope.nodes[i].y;
                    //     $scope.nodes[i].y = $scope.nodes[$scope.nodes.length-i].y;
                    //     $scope.nodes[$scope.nodes.length-i].y = y;
                    // }

                    // pad the canvas
                    $scope.width += $scope.options.node.width;
                    $scope.height = height + 60;  // 暂时添加80增加间隔
                }, true);

            }]
        };
    }]);

/* 
 *  
 * uuid.js - Version 0.3 JavaScript Class to create a UUID like identifier 
 *  
 * Copyright (C) 2006-2008, Erik Giberti (AF-Design), All rights reserved. 
 *  
 * This program is free software; you can redistribute it and/or modify it under 
 * the terms of the GNU General Public License as published by the Free Software 
 * Foundation; either version 2 of the License, or (at your option) any later 
 * version. 
 *  
 * This program is distributed in the hope that it will be useful, but WITHOUT 
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS 
 * FOR A PARTICULAR PURPOSE. See the GNU General Public License for more 
 * details. 
 *  
 * You should have received a copy of the GNU General Public License along with 
 * this program; if not, write to the Free Software Foundation, Inc., 59 Temple 
 * Place, Suite 330, Boston, MA 02111-1307 USA 
 *  
 * The latest version of this file can be downloaded from 
 * http://www.af-design.com/resources/javascript_uuid.php 
 *  
 * HISTORY: 6/5/06 - Initial Release 5/22/08 - Updated code to run faster, 
 * removed randrange(min,max) in favor of a simpler rand(max) function. Reduced 
 * overhead by using getTime() method of date class (suggestion by James Hall). 
 * 9/5/08 - Fixed a bug with rand(max) and additional efficiencies pointed out 
 * by Robert Kieffer http://broofa.com/ 
 *  
 * KNOWN ISSUES: - Still no way to get MAC address in JavaScript - Research into 
 * other versions of UUID show promising possibilities (more research needed) - 
 * Documentation needs improvement 
 *  
 */  
  
// On creation of a UUID object, set it's initial value  
function UUID() {  
    this.id = this.createUUID();  
}; 
  
// When asked what this Object is, lie and return it's value  
UUID.prototype.valueOf = function() {  
    return this.id;  
};  
UUID.prototype.toString = function() {  
    return this.id;  
};  
  
//  
// INSTANCE SPECIFIC METHODS  
//  
  
UUID.prototype.createUUID = function() {  
    //  
    // Loose interpretation of the specification DCE 1.1: Remote Procedure Call  
    // described at  
    // http://www.opengroup.org/onlinepubs/009629399/apdxa.htm#tagtcjh_37  
    // since JavaScript doesn't allow access to internal systems, the last 48  
    // bits  
    // of the node section is made up using a series of random numbers (6 octets  
    // long).  
    //    
    var dg = new Date(1582, 10, 15, 0, 0, 0, 0);  
    var dc = new Date();  
    var t = dc.getTime() - dg.getTime();  
    var tl = UUID.getIntegerBits(t, 0, 31);  
    var tm = UUID.getIntegerBits(t, 32, 47);  
    var thv = UUID.getIntegerBits(t, 48, 59) + '1'; // version 1, security version is 2  
    var csar = UUID.getIntegerBits(UUID.rand(4095), 0, 7);  
    var csl = UUID.getIntegerBits(UUID.rand(4095), 0, 7);  
  
    // since detection of anything about the machine/browser is far to buggy,  
    // include some more random numbers here  
    // if NIC or an IP can be obtained reliably, that should be put in  
    // here instead.  
    var n = UUID.getIntegerBits(UUID.rand(8191), 0, 7)  
            + UUID.getIntegerBits(UUID.rand(8191), 8, 15)  
            + UUID.getIntegerBits(UUID.rand(8191), 0, 7)  
            + UUID.getIntegerBits(UUID.rand(8191), 8, 15)  
            + UUID.getIntegerBits(UUID.rand(8191), 0, 15); // this last number is two octets long  
    return tl + tm + thv + csar + csl + n;  
};  
  
//  
// GENERAL METHODS (Not instance specific)  
//  
  
// Pull out only certain bits from a very large integer, used to get the time  
// code information for the first part of a UUID. Will return zero's if there  
// aren't enough bits to shift where it needs to.  
UUID.getIntegerBits = function(val, start, end) {  
    var base16 = UUID.returnBase(val, 16);  
    var quadArray = new Array();  
    var quadString = '';  
    var i = 0;  
    for (i = 0; i < base16.length; i++) {  
        quadArray.push(base16.substring(i, i + 1));  
    }  
    for (i = Math.floor(start / 4); i <= Math.floor(end / 4); i++) {  
        if (!quadArray[i] || quadArray[i] == '')  
            quadString += '0';  
        else  
            quadString += quadArray[i];  
    }  
    return quadString;  
};  
  
// Replaced from the original function to leverage the built in methods in  
// JavaScript. Thanks to Robert Kieffer for pointing this one out  
UUID.returnBase = function(number, base) {  
    return (number).toString(base).toUpperCase();  
}; 
  
// pick a random number within a range of numbers  
// int b rand(int a); where 0 <= b <= a  
UUID.rand = function(max) {  
    return Math.floor(Math.random() * (max + 1));  
};  
  
// end of UUID class file  
(function () {
    'use strict';
    angular
        .module('gwApp')
        .directive('vpRadio', vpRadio);

    function vpRadio() {
        return {
            restrict: 'E',
            terminal: false,
            replace:true,
            template: function(tElement, tAttrs){
                var template =  "<span ng-click='vpRadioClick()' class='radio-container'>" +
                    "<span class='iconfont radio-style' ng-class=\"{'icon-radio-active':vpModel,'icon-radio-normal':!vmModel}\"></span>" +
                    "<span style='color: #58585B'>"+tElement[0].innerText+"</span>" +
                    "</span>";
                return template;
            },
            scope: {
                vpModel: '=',
                vpChange: '&'
            },
            link: function ($scope) {
                var s = $scope;
                if (!s.vpModel) {s.vpModel = false}
                s.vpRadioClick = function () {
                    s.vpModel = !s.vpModel;
                    setTimeout(function () {
                        s.vpChange();
                    });
                };
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .directive('vpEditor', vpEditor);

    function vpEditor() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var id = attrs.id;
                var editor = new wangEditor(id);
                editor.onchange = function () {
                    // 从 onchange 函数中更新数据
                    scope.$apply(function () {
                        var html = editor.$txt.html();
                        ctrl.$setViewValue(html);
                    });
                };
                editor.create();
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .directive('vpCheckbox', vpCheckbox);

    function vpCheckbox() {
        return {
            restrict: 'E',
            terminal: false,
            replace:true,
            template: function(tElement, tAttrs){
                var template =  "<span ng-click='vpRadioClick()' class='checkbox-container'>" +
                    "<span class='iconfont radio-style' ng-class=\"{'icon-checkbox-active':vpModel,'icon-checkbox-normal':!vpModel}\"></span>" +
                    "<span style='color: #333333'>"+tElement[0].innerText+"</span>" +
                    "</span>";
                return template;
            },
            scope: {
                vpModel: '=',
                vpChange: '&'
            },
            link: function ($scope) {
                var s = $scope;
                if (!s.vpModel) {s.vpModel = false}
                s.vpRadioClick = function () {
                    s.vpModel = !s.vpModel;
                    setTimeout(function () {
                        if (s.vpChange) {
                            s.vpChange();
                        }
                    });
                };
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('gwApp')
        .directive('validateAuthority', validateAuthority);

    validateAuthority.$inject = ['Principal'];

    function validateAuthority(Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var needAuths = attrs.validateAuthority?JSON.parse(attrs.validateAuthority):[];
                Principal.identity().then(function(data) {

                    var hasAuthorities = data.data.authorities;
                    for (var i=0; i<needAuths.length; i++) {
                        var auth = needAuths[i];
                        var index = hasAuthorities.indexOf(auth);
                        if (index === -1) {
                            element.css('display','none');
                            return;
                        }
                    }

                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('validateInput', validateInput);

    function validateInput() {
        var mathod = {};

        //印厂缩写
        mathod.isIdentifier = function (identifier) {
            return identifier.match("^[A-Za-z]+[A-Za-z0-9]*$") === null;
        };

        //用户名称
        mathod.isUserName = function (name) {
            return name.match("^[\u4e00-\u9fa5_'.@A-Za-z0-9-]{8,20}$") === null;
        };

        //密码
        mathod.isPassword = function (password) {
            return password.match("^[_*'.@A-Za-z0-9-]{8,32}$") === null;
        };

        //邮箱
        mathod.isEmail = function (email) {
            return email.match("^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\\.[a-zA-Z]{2,3}$") === null;
        };

        //手机号码
        mathod.isPhone = function (phone) {
            return phone.match("^1[3|4|5|7|8][0-9]{9}$") === null;
        };

        return mathod;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('sub', sub);

    function sub() {
        return function (iArr, x) {
            if (!iArr) {return []}
            if (!x) {return iArr}
            return iArr.slice(0, x>iArr.length?iArr.length:x);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .filter('unique', unique);

    function unique() {
        return uniqueAction;
        function uniqueAction (list,keyName) {
            var output = [],
                keys = [];
            angular.forEach(list, function(item) {
                var key = item[keyName];
                if(keys.indexOf(key) === -1) {
                    keys.push(key);
                    output.push(item);
                }
            });
            return output;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gwApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('gwApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('Funcs', Funcs);

    Funcs.$inject = ['Upload', 'MessageService'];

    function Funcs(Upload, MessageService) {
        var method = {};

        /**
         * 文件选择器
         * accept: 接受文件类型（数组）
         * cb: 成功返回
         * ecd: 错误返回
         * */
        method.fileSelection = function (accept, cb, ecb) {
            if (!accept || !cb) {return;}
            var as = accept.join(',');
            var input = $('<input type="file" accept='+as+' />');
            input.click();
            input.on('change',function () {
                var file = input[0].files[0];
                if (!file) {return;}
                if (accept.indexOf(file.type) === -1) {
                    if (ecb) {
                        ecb("文件格式不支持 !");
                    }
                    return;
                }
                cb(file);
            })
        };

        method.imageUpload = function (cb) {
            method.fileSelection(["image/png","image/jpg","image/jpeg"], function (file) {
                // if (file.size() > )
                //TODO 限制上传文件大小
                Upload.upload({
                    url: 'api/files/user/upload',
                    data: {file: file}
                }).then(function (resp) {
                    if (resp && resp.data && resp.data.data && resp.data.data.path) {
                        resp.data.data.imageUrl = "api/files?accessPath="+resp.data.data.path;
                        cb(resp.data.data);
                    } else {
                        MessageService.error("图片上传失败 !");
                    }
                });
            }, function (error) {
                MessageService.error(error);
            })
        };

        return method;
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('gwApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('gwApp')
		.factory('RegionService', RegionService);
 
	 RegionService.$inject = ['regions'];

	function RegionService(regions) {
		var $regions = {};
		var root = {};
		$regions['root'] = root;
		for (var i = 0; i < regions.length; i++) {
			var region = regions[i];
			$regions[region.c] = region;
			if (region.pc && $regions[region.pc]) {
				$regions[region.pc].children = $regions[region.pc].children || [];
				if ($regions[region.pc].children.indexOf(region) === -1) {
					$regions[region.pc].children.push(region);
					region.parent = $regions[region.pc];
				}
			}
			if (!region.pc) {
				region.parent = root;
				root.children = root.children || [];
				root.children.push(region);
			}
		}

		return {
			get: function(key) {
				return $regions[key];
			},
			getCountries: function() {
				return $regions['root'].children;
			}
		};
	}
})();

(function() {
		'use strict';
		angular
			.module('gwApp')
			.factory('regions', regions);

		function regions() {
			var regions = [{
				"c": "86",
				"n": "中国"
			}, {
				"c": "110000",
				"n": "北京市",
				"pc": "86"
			}, {
				"c": "110100",
				"n": "北京市",
				"pc": "110000"
			}, {
				"c": "110101",
				"n": "东城区",
				"pc": "110100"
			}, {
				"c": "110102",
				"n": "西城区",
				"pc": "110100"
			}, {
				"c": "110105",
				"n": "朝阳区",
				"pc": "110100"
			}, {
				"c": "110106",
				"n": "丰台区",
				"pc": "110100"
			}, {
				"c": "110107",
				"n": "石景山区",
				"pc": "110100"
			}, {
				"c": "110108",
				"n": "海淀区",
				"pc": "110100"
			}, {
				"c": "110109",
				"n": "门头沟区",
				"pc": "110100"
			}, {
				"c": "110111",
				"n": "房山区",
				"pc": "110100"
			}, {
				"c": "110112",
				"n": "通州区",
				"pc": "110100"
			}, {
				"c": "110113",
				"n": "顺义区",
				"pc": "110100"
			}, {
				"c": "110114",
				"n": "昌平区",
				"pc": "110100"
			}, {
				"c": "110115",
				"n": "大兴区",
				"pc": "110100"
			}, {
				"c": "110116",
				"n": "怀柔区",
				"pc": "110100"
			}, {
				"c": "110117",
				"n": "平谷区",
				"pc": "110100"
			}, {
				"c": "110228",
				"n": "密云县",
				"pc": "110100"
			}, {
				"c": "110229",
				"n": "延庆县",
				"pc": "110100"
			}, {
				"c": "120000",
				"n": "天津市",
				"pc": "86"
			}, {
				"c": "120100",
				"n": "天津市",
				"pc": "120000"
			}, {
				"c": "120101",
				"n": "和平区",
				"pc": "120100"
			}, {
				"c": "120102",
				"n": "河东区",
				"pc": "120100"
			}, {
				"c": "120103",
				"n": "河西区",
				"pc": "120100"
			}, {
				"c": "120104",
				"n": "南开区",
				"pc": "120100"
			}, {
				"c": "120105",
				"n": "河北区",
				"pc": "120100"
			}, {
				"c": "120106",
				"n": "红桥区",
				"pc": "120100"
			}, {
				"c": "120110",
				"n": "东丽区",
				"pc": "120100"
			}, {
				"c": "120111",
				"n": "西青区",
				"pc": "120100"
			}, {
				"c": "120112",
				"n": "津南区",
				"pc": "120100"
			}, {
				"c": "120113",
				"n": "北辰区",
				"pc": "120100"
			}, {
				"c": "120114",
				"n": "武清区",
				"pc": "120100"
			}, {
				"c": "120115",
				"n": "宝坻区",
				"pc": "120100"
			}, {
				"c": "120116",
				"n": "滨海新区",
				"pc": "120100"
			}, {
				"c": "120221",
				"n": "宁河县",
				"pc": "120100"
			}, {
				"c": "120223",
				"n": "静海县",
				"pc": "120100"
			}, {
				"c": "120225",
				"n": "蓟县",
				"pc": "120100"
			}, {
				"c": "130000",
				"n": "河北省",
				"pc": "86"
			}, {
				"c": "130100",
				"n": "石家庄市",
				"pc": "130000"
			}, {
				"c": "130101",
				"n": "市辖区",
				"pc": "130100"
			}, {
				"c": "130102",
				"n": "长安区",
				"pc": "130100"
			}, {
				"c": "130103",
				"n": "桥东区",
				"pc": "130100"
			}, {
				"c": "130104",
				"n": "桥西区",
				"pc": "130100"
			}, {
				"c": "130105",
				"n": "新华区",
				"pc": "130100"
			}, {
				"c": "130107",
				"n": "井陉矿区",
				"pc": "130100"
			}, {
				"c": "130108",
				"n": "裕华区",
				"pc": "130100"
			}, {
				"c": "130121",
				"n": "井陉县",
				"pc": "130100"
			}, {
				"c": "130123",
				"n": "正定县",
				"pc": "130100"
			}, {
				"c": "130124",
				"n": "栾城县",
				"pc": "130100"
			}, {
				"c": "130125",
				"n": "行唐县",
				"pc": "130100"
			}, {
				"c": "130126",
				"n": "灵寿县",
				"pc": "130100"
			}, {
				"c": "130127",
				"n": "高邑县",
				"pc": "130100"
			}, {
				"c": "130128",
				"n": "深泽县",
				"pc": "130100"
			}, {
				"c": "130129",
				"n": "赞皇县",
				"pc": "130100"
			}, {
				"c": "130130",
				"n": "无极县",
				"pc": "130100"
			}, {
				"c": "130131",
				"n": "平山县",
				"pc": "130100"
			}, {
				"c": "130132",
				"n": "元氏县",
				"pc": "130100"
			}, {
				"c": "130133",
				"n": "赵县",
				"pc": "130100"
			}, {
				"c": "130181",
				"n": "辛集市",
				"pc": "130100"
			}, {
				"c": "130182",
				"n": "藁城市",
				"pc": "130100"
			}, {
				"c": "130183",
				"n": "晋州市",
				"pc": "130100"
			}, {
				"c": "130184",
				"n": "新乐市",
				"pc": "130100"
			}, {
				"c": "130185",
				"n": "鹿泉市",
				"pc": "130100"
			}, {
				"c": "130200",
				"n": "唐山市",
				"pc": "130000"
			}, {
				"c": "130201",
				"n": "市辖区",
				"pc": "130200"
			}, {
				"c": "130202",
				"n": "路南区",
				"pc": "130200"
			}, {
				"c": "130203",
				"n": "路北区",
				"pc": "130200"
			}, {
				"c": "130204",
				"n": "古冶区",
				"pc": "130200"
			}, {
				"c": "130205",
				"n": "开平区",
				"pc": "130200"
			}, {
				"c": "130207",
				"n": "丰南区",
				"pc": "130200"
			}, {
				"c": "130208",
				"n": "丰润区",
				"pc": "130200"
			}, {
				"c": "130209",
				"n": "曹妃甸区",
				"pc": "130200"
			}, {
				"c": "130223",
				"n": "滦县",
				"pc": "130200"
			}, {
				"c": "130224",
				"n": "滦南县",
				"pc": "130200"
			}, {
				"c": "130225",
				"n": "乐亭县",
				"pc": "130200"
			}, {
				"c": "130227",
				"n": "迁西县",
				"pc": "130200"
			}, {
				"c": "130229",
				"n": "玉田县",
				"pc": "130200"
			}, {
				"c": "130281",
				"n": "遵化市",
				"pc": "130200"
			}, {
				"c": "130283",
				"n": "迁安市",
				"pc": "130200"
			}, {
				"c": "130300",
				"n": "秦皇岛市",
				"pc": "130000"
			}, {
				"c": "130301",
				"n": "市辖区",
				"pc": "130300"
			}, {
				"c": "130302",
				"n": "海港区",
				"pc": "130300"
			}, {
				"c": "130303",
				"n": "山海关区",
				"pc": "130300"
			}, {
				"c": "130304",
				"n": "北戴河区",
				"pc": "130300"
			}, {
				"c": "130321",
				"n": "青龙满族自治县",
				"pc": "130300"
			}, {
				"c": "130322",
				"n": "昌黎县",
				"pc": "130300"
			}, {
				"c": "130323",
				"n": "抚宁县",
				"pc": "130300"
			}, {
				"c": "130324",
				"n": "卢龙县",
				"pc": "130300"
			}, {
				"c": "130400",
				"n": "邯郸市",
				"pc": "130000"
			}, {
				"c": "130401",
				"n": "市辖区",
				"pc": "130400"
			}, {
				"c": "130402",
				"n": "邯山区",
				"pc": "130400"
			}, {
				"c": "130403",
				"n": "丛台区",
				"pc": "130400"
			}, {
				"c": "130404",
				"n": "复兴区",
				"pc": "130400"
			}, {
				"c": "130406",
				"n": "峰峰矿区",
				"pc": "130400"
			}, {
				"c": "130421",
				"n": "邯郸县",
				"pc": "130400"
			}, {
				"c": "130423",
				"n": "临漳县",
				"pc": "130400"
			}, {
				"c": "130424",
				"n": "成安县",
				"pc": "130400"
			}, {
				"c": "130425",
				"n": "大名县",
				"pc": "130400"
			}, {
				"c": "130426",
				"n": "涉县",
				"pc": "130400"
			}, {
				"c": "130427",
				"n": "磁县",
				"pc": "130400"
			}, {
				"c": "130428",
				"n": "肥乡县",
				"pc": "130400"
			}, {
				"c": "130429",
				"n": "永年县",
				"pc": "130400"
			}, {
				"c": "130430",
				"n": "邱县",
				"pc": "130400"
			}, {
				"c": "130431",
				"n": "鸡泽县",
				"pc": "130400"
			}, {
				"c": "130432",
				"n": "广平县",
				"pc": "130400"
			}, {
				"c": "130433",
				"n": "馆陶县",
				"pc": "130400"
			}, {
				"c": "130434",
				"n": "魏县",
				"pc": "130400"
			}, {
				"c": "130435",
				"n": "曲周县",
				"pc": "130400"
			}, {
				"c": "130481",
				"n": "武安市",
				"pc": "130400"
			}, {
				"c": "130500",
				"n": "邢台市",
				"pc": "130000"
			}, {
				"c": "130501",
				"n": "市辖区",
				"pc": "130500"
			}, {
				"c": "130502",
				"n": "桥东区",
				"pc": "130500"
			}, {
				"c": "130503",
				"n": "桥西区",
				"pc": "130500"
			}, {
				"c": "130521",
				"n": "邢台县",
				"pc": "130500"
			}, {
				"c": "130522",
				"n": "临城县",
				"pc": "130500"
			}, {
				"c": "130523",
				"n": "内丘县",
				"pc": "130500"
			}, {
				"c": "130524",
				"n": "柏乡县",
				"pc": "130500"
			}, {
				"c": "130525",
				"n": "隆尧县",
				"pc": "130500"
			}, {
				"c": "130526",
				"n": "任县",
				"pc": "130500"
			}, {
				"c": "130527",
				"n": "南和县",
				"pc": "130500"
			}, {
				"c": "130528",
				"n": "宁晋县",
				"pc": "130500"
			}, {
				"c": "130529",
				"n": "巨鹿县",
				"pc": "130500"
			}, {
				"c": "130530",
				"n": "新河县",
				"pc": "130500"
			}, {
				"c": "130531",
				"n": "广宗县",
				"pc": "130500"
			}, {
				"c": "130532",
				"n": "平乡县",
				"pc": "130500"
			}, {
				"c": "130533",
				"n": "威县",
				"pc": "130500"
			}, {
				"c": "130534",
				"n": "清河县",
				"pc": "130500"
			}, {
				"c": "130535",
				"n": "临西县",
				"pc": "130500"
			}, {
				"c": "130581",
				"n": "南宫市",
				"pc": "130500"
			}, {
				"c": "130582",
				"n": "沙河市",
				"pc": "130500"
			}, {
				"c": "130600",
				"n": "保定市",
				"pc": "130000"
			}, {
				"c": "130601",
				"n": "市辖区",
				"pc": "130600"
			}, {
				"c": "130602",
				"n": "新市区",
				"pc": "130600"
			}, {
				"c": "130603",
				"n": "北市区",
				"pc": "130600"
			}, {
				"c": "130604",
				"n": "南市区",
				"pc": "130600"
			}, {
				"c": "130621",
				"n": "满城县",
				"pc": "130600"
			}, {
				"c": "130622",
				"n": "清苑县",
				"pc": "130600"
			}, {
				"c": "130623",
				"n": "涞水县",
				"pc": "130600"
			}, {
				"c": "130624",
				"n": "阜平县",
				"pc": "130600"
			}, {
				"c": "130625",
				"n": "徐水县",
				"pc": "130600"
			}, {
				"c": "130626",
				"n": "定兴县",
				"pc": "130600"
			}, {
				"c": "130627",
				"n": "唐县",
				"pc": "130600"
			}, {
				"c": "130628",
				"n": "高阳县",
				"pc": "130600"
			}, {
				"c": "130629",
				"n": "容城县",
				"pc": "130600"
			}, {
				"c": "130630",
				"n": "涞源县",
				"pc": "130600"
			}, {
				"c": "130631",
				"n": "望都县",
				"pc": "130600"
			}, {
				"c": "130632",
				"n": "安新县",
				"pc": "130600"
			}, {
				"c": "130633",
				"n": "易县",
				"pc": "130600"
			}, {
				"c": "130634",
				"n": "曲阳县",
				"pc": "130600"
			}, {
				"c": "130635",
				"n": "蠡县",
				"pc": "130600"
			}, {
				"c": "130636",
				"n": "顺平县",
				"pc": "130600"
			}, {
				"c": "130637",
				"n": "博野县",
				"pc": "130600"
			}, {
				"c": "130638",
				"n": "雄县",
				"pc": "130600"
			}, {
				"c": "130681",
				"n": "涿州市",
				"pc": "130600"
			}, {
				"c": "130682",
				"n": "定州市",
				"pc": "130600"
			}, {
				"c": "130683",
				"n": "安国市",
				"pc": "130600"
			}, {
				"c": "130684",
				"n": "高碑店市",
				"pc": "130600"
			}, {
				"c": "130700",
				"n": "张家口市",
				"pc": "130000"
			}, {
				"c": "130701",
				"n": "市辖区",
				"pc": "130700"
			}, {
				"c": "130702",
				"n": "桥东区",
				"pc": "130700"
			}, {
				"c": "130703",
				"n": "桥西区",
				"pc": "130700"
			}, {
				"c": "130705",
				"n": "宣化区",
				"pc": "130700"
			}, {
				"c": "130706",
				"n": "下花园区",
				"pc": "130700"
			}, {
				"c": "130721",
				"n": "宣化县",
				"pc": "130700"
			}, {
				"c": "130722",
				"n": "张北县",
				"pc": "130700"
			}, {
				"c": "130723",
				"n": "康保县",
				"pc": "130700"
			}, {
				"c": "130724",
				"n": "沽源县",
				"pc": "130700"
			}, {
				"c": "130725",
				"n": "尚义县",
				"pc": "130700"
			}, {
				"c": "130726",
				"n": "蔚县",
				"pc": "130700"
			}, {
				"c": "130727",
				"n": "阳原县",
				"pc": "130700"
			}, {
				"c": "130728",
				"n": "怀安县",
				"pc": "130700"
			}, {
				"c": "130729",
				"n": "万全县",
				"pc": "130700"
			}, {
				"c": "130730",
				"n": "怀来县",
				"pc": "130700"
			}, {
				"c": "130731",
				"n": "涿鹿县",
				"pc": "130700"
			}, {
				"c": "130732",
				"n": "赤城县",
				"pc": "130700"
			}, {
				"c": "130733",
				"n": "崇礼县",
				"pc": "130700"
			}, {
				"c": "130800",
				"n": "承德市",
				"pc": "130000"
			}, {
				"c": "130801",
				"n": "市辖区",
				"pc": "130800"
			}, {
				"c": "130802",
				"n": "双桥区",
				"pc": "130800"
			}, {
				"c": "130803",
				"n": "双滦区",
				"pc": "130800"
			}, {
				"c": "130804",
				"n": "鹰手营子矿区",
				"pc": "130800"
			}, {
				"c": "130821",
				"n": "承德县",
				"pc": "130800"
			}, {
				"c": "130822",
				"n": "兴隆县",
				"pc": "130800"
			}, {
				"c": "130823",
				"n": "平泉县",
				"pc": "130800"
			}, {
				"c": "130824",
				"n": "滦平县",
				"pc": "130800"
			}, {
				"c": "130825",
				"n": "隆化县",
				"pc": "130800"
			}, {
				"c": "130826",
				"n": "丰宁满族自治县",
				"pc": "130800"
			}, {
				"c": "130827",
				"n": "宽城满族自治县",
				"pc": "130800"
			}, {
				"c": "130828",
				"n": "围场满族蒙古族自治县",
				"pc": "130800"
			}, {
				"c": "130900",
				"n": "沧州市",
				"pc": "130000"
			}, {
				"c": "130901",
				"n": "市辖区",
				"pc": "130900"
			}, {
				"c": "130902",
				"n": "新华区",
				"pc": "130900"
			}, {
				"c": "130903",
				"n": "运河区",
				"pc": "130900"
			}, {
				"c": "130921",
				"n": "沧县",
				"pc": "130900"
			}, {
				"c": "130922",
				"n": "青县",
				"pc": "130900"
			}, {
				"c": "130923",
				"n": "东光县",
				"pc": "130900"
			}, {
				"c": "130924",
				"n": "海兴县",
				"pc": "130900"
			}, {
				"c": "130925",
				"n": "盐山县",
				"pc": "130900"
			}, {
				"c": "130926",
				"n": "肃宁县",
				"pc": "130900"
			}, {
				"c": "130927",
				"n": "南皮县",
				"pc": "130900"
			}, {
				"c": "130928",
				"n": "吴桥县",
				"pc": "130900"
			}, {
				"c": "130929",
				"n": "献县",
				"pc": "130900"
			}, {
				"c": "130930",
				"n": "孟村回族自治县",
				"pc": "130900"
			}, {
				"c": "130981",
				"n": "泊头市",
				"pc": "130900"
			}, {
				"c": "130982",
				"n": "任丘市",
				"pc": "130900"
			}, {
				"c": "130983",
				"n": "黄骅市",
				"pc": "130900"
			}, {
				"c": "130984",
				"n": "河间市",
				"pc": "130900"
			}, {
				"c": "131000",
				"n": "廊坊市",
				"pc": "130000"
			}, {
				"c": "131001",
				"n": "市辖区",
				"pc": "131000"
			}, {
				"c": "131002",
				"n": "安次区",
				"pc": "131000"
			}, {
				"c": "131003",
				"n": "广阳区",
				"pc": "131000"
			}, {
				"c": "131022",
				"n": "固安县",
				"pc": "131000"
			}, {
				"c": "131023",
				"n": "永清县",
				"pc": "131000"
			}, {
				"c": "131024",
				"n": "香河县",
				"pc": "131000"
			}, {
				"c": "131025",
				"n": "大城县",
				"pc": "131000"
			}, {
				"c": "131026",
				"n": "文安县",
				"pc": "131000"
			}, {
				"c": "131028",
				"n": "大厂回族自治县",
				"pc": "131000"
			}, {
				"c": "131081",
				"n": "霸州市",
				"pc": "131000"
			}, {
				"c": "131082",
				"n": "三河市",
				"pc": "131000"
			}, {
				"c": "131100",
				"n": "衡水市",
				"pc": "130000"
			}, {
				"c": "131101",
				"n": "市辖区",
				"pc": "131100"
			}, {
				"c": "131102",
				"n": "桃城区",
				"pc": "131100"
			}, {
				"c": "131121",
				"n": "枣强县",
				"pc": "131100"
			}, {
				"c": "131122",
				"n": "武邑县",
				"pc": "131100"
			}, {
				"c": "131123",
				"n": "武强县",
				"pc": "131100"
			}, {
				"c": "131124",
				"n": "饶阳县",
				"pc": "131100"
			}, {
				"c": "131125",
				"n": "安平县",
				"pc": "131100"
			}, {
				"c": "131126",
				"n": "故城县",
				"pc": "131100"
			}, {
				"c": "131127",
				"n": "景县",
				"pc": "131100"
			}, {
				"c": "131128",
				"n": "阜城县",
				"pc": "131100"
			}, {
				"c": "131181",
				"n": "冀州市",
				"pc": "131100"
			}, {
				"c": "131182",
				"n": "深州市",
				"pc": "131100"
			}, {
				"c": "140000",
				"n": "山西省",
				"pc": "86"
			}, {
				"c": "140100",
				"n": "太原市",
				"pc": "140000"
			}, {
				"c": "140101",
				"n": "市辖区",
				"pc": "140100"
			}, {
				"c": "140105",
				"n": "小店区",
				"pc": "140100"
			}, {
				"c": "140106",
				"n": "迎泽区",
				"pc": "140100"
			}, {
				"c": "140107",
				"n": "杏花岭区",
				"pc": "140100"
			}, {
				"c": "140108",
				"n": "尖草坪区",
				"pc": "140100"
			}, {
				"c": "140109",
				"n": "万柏林区",
				"pc": "140100"
			}, {
				"c": "140110",
				"n": "晋源区",
				"pc": "140100"
			}, {
				"c": "140121",
				"n": "清徐县",
				"pc": "140100"
			}, {
				"c": "140122",
				"n": "阳曲县",
				"pc": "140100"
			}, {
				"c": "140123",
				"n": "娄烦县",
				"pc": "140100"
			}, {
				"c": "140181",
				"n": "古交市",
				"pc": "140100"
			}, {
				"c": "140200",
				"n": "大同市",
				"pc": "140000"
			}, {
				"c": "140201",
				"n": "市辖区",
				"pc": "140200"
			}, {
				"c": "140202",
				"n": "城区",
				"pc": "140200"
			}, {
				"c": "140203",
				"n": "矿区",
				"pc": "140200"
			}, {
				"c": "140211",
				"n": "南郊区",
				"pc": "140200"
			}, {
				"c": "140212",
				"n": "新荣区",
				"pc": "140200"
			}, {
				"c": "140221",
				"n": "阳高县",
				"pc": "140200"
			}, {
				"c": "140222",
				"n": "天镇县",
				"pc": "140200"
			}, {
				"c": "140223",
				"n": "广灵县",
				"pc": "140200"
			}, {
				"c": "140224",
				"n": "灵丘县",
				"pc": "140200"
			}, {
				"c": "140225",
				"n": "浑源县",
				"pc": "140200"
			}, {
				"c": "140226",
				"n": "左云县",
				"pc": "140200"
			}, {
				"c": "140227",
				"n": "大同县",
				"pc": "140200"
			}, {
				"c": "140300",
				"n": "阳泉市",
				"pc": "140000"
			}, {
				"c": "140301",
				"n": "市辖区",
				"pc": "140300"
			}, {
				"c": "140302",
				"n": "城区",
				"pc": "140300"
			}, {
				"c": "140303",
				"n": "矿区",
				"pc": "140300"
			}, {
				"c": "140311",
				"n": "郊区",
				"pc": "140300"
			}, {
				"c": "140321",
				"n": "平定县",
				"pc": "140300"
			}, {
				"c": "140322",
				"n": "盂县",
				"pc": "140300"
			}, {
				"c": "140400",
				"n": "长治市",
				"pc": "140000"
			}, {
				"c": "140401",
				"n": "市辖区",
				"pc": "140400"
			}, {
				"c": "140402",
				"n": "城区",
				"pc": "140400"
			}, {
				"c": "140411",
				"n": "郊区",
				"pc": "140400"
			}, {
				"c": "140421",
				"n": "长治县",
				"pc": "140400"
			}, {
				"c": "140423",
				"n": "襄垣县",
				"pc": "140400"
			}, {
				"c": "140424",
				"n": "屯留县",
				"pc": "140400"
			}, {
				"c": "140425",
				"n": "平顺县",
				"pc": "140400"
			}, {
				"c": "140426",
				"n": "黎城县",
				"pc": "140400"
			}, {
				"c": "140427",
				"n": "壶关县",
				"pc": "140400"
			}, {
				"c": "140428",
				"n": "长子县",
				"pc": "140400"
			}, {
				"c": "140429",
				"n": "武乡县",
				"pc": "140400"
			}, {
				"c": "140430",
				"n": "沁县",
				"pc": "140400"
			}, {
				"c": "140431",
				"n": "沁源县",
				"pc": "140400"
			}, {
				"c": "140481",
				"n": "潞城市",
				"pc": "140400"
			}, {
				"c": "140500",
				"n": "晋城市",
				"pc": "140000"
			}, {
				"c": "140501",
				"n": "晋城市市辖区",
				"pc": "140500"
			}, {
				"c": "140502",
				"n": "城区",
				"pc": "140500"
			}, {
				"c": "140521",
				"n": "沁水县",
				"pc": "140500"
			}, {
				"c": "140522",
				"n": "阳城县",
				"pc": "140500"
			}, {
				"c": "140524",
				"n": "陵川县",
				"pc": "140500"
			}, {
				"c": "140525",
				"n": "泽州县",
				"pc": "140500"
			}, {
				"c": "140581",
				"n": "高平市",
				"pc": "140500"
			}, {
				"c": "140600",
				"n": "朔州市",
				"pc": "140000"
			}, {
				"c": "140601",
				"n": "市辖区",
				"pc": "140600"
			}, {
				"c": "140602",
				"n": "朔城区",
				"pc": "140600"
			}, {
				"c": "140603",
				"n": "平鲁区",
				"pc": "140600"
			}, {
				"c": "140621",
				"n": "山阴县",
				"pc": "140600"
			}, {
				"c": "140622",
				"n": "应县",
				"pc": "140600"
			}, {
				"c": "140623",
				"n": "右玉县",
				"pc": "140600"
			}, {
				"c": "140624",
				"n": "怀仁县",
				"pc": "140600"
			}, {
				"c": "140700",
				"n": "晋中市",
				"pc": "140000"
			}, {
				"c": "140701",
				"n": "市辖区",
				"pc": "140700"
			}, {
				"c": "140702",
				"n": "榆次区",
				"pc": "140700"
			}, {
				"c": "140721",
				"n": "榆社县",
				"pc": "140700"
			}, {
				"c": "140722",
				"n": "左权县",
				"pc": "140700"
			}, {
				"c": "140723",
				"n": "和顺县",
				"pc": "140700"
			}, {
				"c": "140724",
				"n": "昔阳县",
				"pc": "140700"
			}, {
				"c": "140725",
				"n": "寿阳县",
				"pc": "140700"
			}, {
				"c": "140726",
				"n": "太谷县",
				"pc": "140700"
			}, {
				"c": "140727",
				"n": "祁县",
				"pc": "140700"
			}, {
				"c": "140728",
				"n": "平遥县",
				"pc": "140700"
			}, {
				"c": "140729",
				"n": "灵石县",
				"pc": "140700"
			}, {
				"c": "140781",
				"n": "介休市",
				"pc": "140700"
			}, {
				"c": "140800",
				"n": "运城市",
				"pc": "140000"
			}, {
				"c": "140801",
				"n": "市辖区",
				"pc": "140800"
			}, {
				"c": "140802",
				"n": "盐湖区",
				"pc": "140800"
			}, {
				"c": "140821",
				"n": "临猗县",
				"pc": "140800"
			}, {
				"c": "140822",
				"n": "万荣县",
				"pc": "140800"
			}, {
				"c": "140823",
				"n": "闻喜县",
				"pc": "140800"
			}, {
				"c": "140824",
				"n": "稷山县",
				"pc": "140800"
			}, {
				"c": "140825",
				"n": "新绛县",
				"pc": "140800"
			}, {
				"c": "140826",
				"n": "绛县",
				"pc": "140800"
			}, {
				"c": "140827",
				"n": "垣曲县",
				"pc": "140800"
			}, {
				"c": "140828",
				"n": "夏县",
				"pc": "140800"
			}, {
				"c": "140829",
				"n": "平陆县",
				"pc": "140800"
			}, {
				"c": "140830",
				"n": "芮城县",
				"pc": "140800"
			}, {
				"c": "140881",
				"n": "永济市",
				"pc": "140800"
			}, {
				"c": "140882",
				"n": "河津市",
				"pc": "140800"
			}, {
				"c": "140900",
				"n": "忻州市",
				"pc": "140000"
			}, {
				"c": "140901",
				"n": "市辖区",
				"pc": "140900"
			}, {
				"c": "140902",
				"n": "忻府区",
				"pc": "140900"
			}, {
				"c": "140921",
				"n": "定襄县",
				"pc": "140900"
			}, {
				"c": "140922",
				"n": "五台县",
				"pc": "140900"
			}, {
				"c": "140923",
				"n": "代县",
				"pc": "140900"
			}, {
				"c": "140924",
				"n": "繁峙县",
				"pc": "140900"
			}, {
				"c": "140925",
				"n": "宁武县",
				"pc": "140900"
			}, {
				"c": "140926",
				"n": "静乐县",
				"pc": "140900"
			}, {
				"c": "140927",
				"n": "神池县",
				"pc": "140900"
			}, {
				"c": "140928",
				"n": "五寨县",
				"pc": "140900"
			}, {
				"c": "140929",
				"n": "岢岚县",
				"pc": "140900"
			}, {
				"c": "140930",
				"n": "河曲县",
				"pc": "140900"
			}, {
				"c": "140931",
				"n": "保德县",
				"pc": "140900"
			}, {
				"c": "140932",
				"n": "偏关县",
				"pc": "140900"
			}, {
				"c": "140981",
				"n": "原平市",
				"pc": "140900"
			}, {
				"c": "141000",
				"n": "临汾市",
				"pc": "140000"
			}, {
				"c": "141001",
				"n": "市辖区",
				"pc": "141000"
			}, {
				"c": "141002",
				"n": "尧都区",
				"pc": "141000"
			}, {
				"c": "141021",
				"n": "曲沃县",
				"pc": "141000"
			}, {
				"c": "141022",
				"n": "翼城县",
				"pc": "141000"
			}, {
				"c": "141023",
				"n": "襄汾县",
				"pc": "141000"
			}, {
				"c": "141024",
				"n": "洪洞县",
				"pc": "141000"
			}, {
				"c": "141025",
				"n": "古县",
				"pc": "141000"
			}, {
				"c": "141026",
				"n": "安泽县",
				"pc": "141000"
			}, {
				"c": "141027",
				"n": "浮山县",
				"pc": "141000"
			}, {
				"c": "141028",
				"n": "吉县",
				"pc": "141000"
			}, {
				"c": "141029",
				"n": "乡宁县",
				"pc": "141000"
			}, {
				"c": "141030",
				"n": "大宁县",
				"pc": "141000"
			}, {
				"c": "141031",
				"n": "隰县",
				"pc": "141000"
			}, {
				"c": "141032",
				"n": "永和县",
				"pc": "141000"
			}, {
				"c": "141033",
				"n": "蒲县",
				"pc": "141000"
			}, {
				"c": "141034",
				"n": "汾西县",
				"pc": "141000"
			}, {
				"c": "141081",
				"n": "侯马市",
				"pc": "141000"
			}, {
				"c": "141082",
				"n": "霍州市",
				"pc": "141000"
			}, {
				"c": "141100",
				"n": "吕梁市",
				"pc": "140000"
			}, {
				"c": "141101",
				"n": "市辖区",
				"pc": "141100"
			}, {
				"c": "141102",
				"n": "离石区",
				"pc": "141100"
			}, {
				"c": "141121",
				"n": "文水县",
				"pc": "141100"
			}, {
				"c": "141122",
				"n": "交城县",
				"pc": "141100"
			}, {
				"c": "141123",
				"n": "兴县",
				"pc": "141100"
			}, {
				"c": "141124",
				"n": "临县",
				"pc": "141100"
			}, {
				"c": "141125",
				"n": "柳林县",
				"pc": "141100"
			}, {
				"c": "141126",
				"n": "石楼县",
				"pc": "141100"
			}, {
				"c": "141127",
				"n": "岚县",
				"pc": "141100"
			}, {
				"c": "141128",
				"n": "方山县",
				"pc": "141100"
			}, {
				"c": "141129",
				"n": "中阳县",
				"pc": "141100"
			}, {
				"c": "141130",
				"n": "交口县",
				"pc": "141100"
			}, {
				"c": "141181",
				"n": "孝义市",
				"pc": "141100"
			}, {
				"c": "141182",
				"n": "汾阳市",
				"pc": "141100"
			}, {
				"c": "150000",
				"n": "内蒙古自治区",
				"pc": "86"
			}, {
				"c": "150100",
				"n": "呼和浩特市",
				"pc": "150000"
			}, {
				"c": "150101",
				"n": "市辖区",
				"pc": "150100"
			}, {
				"c": "150102",
				"n": "新城区",
				"pc": "150100"
			}, {
				"c": "150103",
				"n": "回民区",
				"pc": "150100"
			}, {
				"c": "150104",
				"n": "玉泉区",
				"pc": "150100"
			}, {
				"c": "150105",
				"n": "赛罕区",
				"pc": "150100"
			}, {
				"c": "150121",
				"n": "土默特左旗",
				"pc": "150100"
			}, {
				"c": "150122",
				"n": "托克托县",
				"pc": "150100"
			}, {
				"c": "150123",
				"n": "和林格尔县",
				"pc": "150100"
			}, {
				"c": "150124",
				"n": "清水河县",
				"pc": "150100"
			}, {
				"c": "150125",
				"n": "武川县",
				"pc": "150100"
			}, {
				"c": "150200",
				"n": "包头市",
				"pc": "150000"
			}, {
				"c": "150201",
				"n": "市辖区",
				"pc": "150200"
			}, {
				"c": "150202",
				"n": "东河区",
				"pc": "150200"
			}, {
				"c": "150203",
				"n": "昆都仑区",
				"pc": "150200"
			}, {
				"c": "150204",
				"n": "青山区",
				"pc": "150200"
			}, {
				"c": "150205",
				"n": "石拐区",
				"pc": "150200"
			}, {
				"c": "150206",
				"n": "白云鄂博矿区",
				"pc": "150200"
			}, {
				"c": "150207",
				"n": "九原区",
				"pc": "150200"
			}, {
				"c": "150221",
				"n": "土默特右旗",
				"pc": "150200"
			}, {
				"c": "150222",
				"n": "固阳县",
				"pc": "150200"
			}, {
				"c": "150223",
				"n": "达尔罕茂明安联合旗",
				"pc": "150200"
			}, {
				"c": "150300",
				"n": "乌海市",
				"pc": "150000"
			}, {
				"c": "150301",
				"n": "市辖区",
				"pc": "150300"
			}, {
				"c": "150302",
				"n": "海勃湾区",
				"pc": "150300"
			}, {
				"c": "150303",
				"n": "海南区",
				"pc": "150300"
			}, {
				"c": "150304",
				"n": "乌达区",
				"pc": "150300"
			}, {
				"c": "150400",
				"n": "赤峰市",
				"pc": "150000"
			}, {
				"c": "150401",
				"n": "市辖区",
				"pc": "150400"
			}, {
				"c": "150402",
				"n": "红山区",
				"pc": "150400"
			}, {
				"c": "150403",
				"n": "元宝山区",
				"pc": "150400"
			}, {
				"c": "150404",
				"n": "松山区",
				"pc": "150400"
			}, {
				"c": "150421",
				"n": "阿鲁科尔沁旗",
				"pc": "150400"
			}, {
				"c": "150422",
				"n": "巴林左旗",
				"pc": "150400"
			}, {
				"c": "150423",
				"n": "巴林右旗",
				"pc": "150400"
			}, {
				"c": "150424",
				"n": "林西县",
				"pc": "150400"
			}, {
				"c": "150425",
				"n": "克什克腾旗",
				"pc": "150400"
			}, {
				"c": "150426",
				"n": "翁牛特旗",
				"pc": "150400"
			}, {
				"c": "150428",
				"n": "喀喇沁旗",
				"pc": "150400"
			}, {
				"c": "150429",
				"n": "宁城县",
				"pc": "150400"
			}, {
				"c": "150430",
				"n": "敖汉旗",
				"pc": "150400"
			}, {
				"c": "150500",
				"n": "通辽市",
				"pc": "150000"
			}, {
				"c": "150501",
				"n": "市辖区",
				"pc": "150500"
			}, {
				"c": "150502",
				"n": "科尔沁区",
				"pc": "150500"
			}, {
				"c": "150521",
				"n": "科尔沁左翼中旗",
				"pc": "150500"
			}, {
				"c": "150522",
				"n": "科尔沁左翼后旗",
				"pc": "150500"
			}, {
				"c": "150523",
				"n": "开鲁县",
				"pc": "150500"
			}, {
				"c": "150524",
				"n": "库伦旗",
				"pc": "150500"
			}, {
				"c": "150525",
				"n": "奈曼旗",
				"pc": "150500"
			}, {
				"c": "150526",
				"n": "扎鲁特旗",
				"pc": "150500"
			}, {
				"c": "150581",
				"n": "霍林郭勒市",
				"pc": "150500"
			}, {
				"c": "150600",
				"n": "鄂尔多斯市",
				"pc": "150000"
			}, {
				"c": "150601",
				"n": "市辖区",
				"pc": "150600"
			}, {
				"c": "150602",
				"n": "东胜区",
				"pc": "150600"
			}, {
				"c": "150621",
				"n": "达拉特旗",
				"pc": "150600"
			}, {
				"c": "150622",
				"n": "准格尔旗",
				"pc": "150600"
			}, {
				"c": "150623",
				"n": "鄂托克前旗",
				"pc": "150600"
			}, {
				"c": "150624",
				"n": "鄂托克旗",
				"pc": "150600"
			}, {
				"c": "150625",
				"n": "杭锦旗",
				"pc": "150600"
			}, {
				"c": "150626",
				"n": "乌审旗",
				"pc": "150600"
			}, {
				"c": "150627",
				"n": "伊金霍洛旗",
				"pc": "150600"
			}, {
				"c": "150700",
				"n": "呼伦贝尔市",
				"pc": "150000"
			}, {
				"c": "150701",
				"n": "市辖区",
				"pc": "150700"
			}, {
				"c": "150702",
				"n": "海拉尔区",
				"pc": "150700"
			}, {
				"c": "150721",
				"n": "阿荣旗",
				"pc": "150700"
			}, {
				"c": "150722",
				"n": "莫力达瓦达斡尔族自治旗",
				"pc": "150700"
			}, {
				"c": "150723",
				"n": "鄂伦春自治旗",
				"pc": "150700"
			}, {
				"c": "150724",
				"n": "鄂温克族自治旗",
				"pc": "150700"
			}, {
				"c": "150725",
				"n": "陈巴尔虎旗",
				"pc": "150700"
			}, {
				"c": "150726",
				"n": "新巴尔虎左旗",
				"pc": "150700"
			}, {
				"c": "150727",
				"n": "新巴尔虎右旗",
				"pc": "150700"
			}, {
				"c": "150781",
				"n": "满洲里市",
				"pc": "150700"
			}, {
				"c": "150782",
				"n": "牙克石市",
				"pc": "150700"
			}, {
				"c": "150783",
				"n": "扎兰屯市",
				"pc": "150700"
			}, {
				"c": "150784",
				"n": "额尔古纳市",
				"pc": "150700"
			}, {
				"c": "150785",
				"n": "根河市",
				"pc": "150700"
			}, {
				"c": "150800",
				"n": "巴彦淖尔市",
				"pc": "150000"
			}, {
				"c": "150801",
				"n": "市辖区",
				"pc": "150800"
			}, {
				"c": "150802",
				"n": "临河区",
				"pc": "150800"
			}, {
				"c": "150821",
				"n": "五原县",
				"pc": "150800"
			}, {
				"c": "150822",
				"n": "磴口县",
				"pc": "150800"
			}, {
				"c": "150823",
				"n": "乌拉特前旗",
				"pc": "150800"
			}, {
				"c": "150824",
				"n": "乌拉特中旗",
				"pc": "150800"
			}, {
				"c": "150825",
				"n": "乌拉特后旗",
				"pc": "150800"
			}, {
				"c": "150826",
				"n": "杭锦后旗",
				"pc": "150800"
			}, {
				"c": "150900",
				"n": "乌兰察布市",
				"pc": "150000"
			}, {
				"c": "150901",
				"n": "市辖区",
				"pc": "150900"
			}, {
				"c": "150902",
				"n": "集宁区",
				"pc": "150900"
			}, {
				"c": "150921",
				"n": "卓资县",
				"pc": "150900"
			}, {
				"c": "150922",
				"n": "化德县",
				"pc": "150900"
			}, {
				"c": "150923",
				"n": "商都县",
				"pc": "150900"
			}, {
				"c": "150924",
				"n": "兴和县",
				"pc": "150900"
			}, {
				"c": "150925",
				"n": "凉城县",
				"pc": "150900"
			}, {
				"c": "150926",
				"n": "察哈尔右翼前旗",
				"pc": "150900"
			}, {
				"c": "150927",
				"n": "察哈尔右翼中旗",
				"pc": "150900"
			}, {
				"c": "150928",
				"n": "察哈尔右翼后旗",
				"pc": "150900"
			}, {
				"c": "150929",
				"n": "四子王旗",
				"pc": "150900"
			}, {
				"c": "150981",
				"n": "丰镇市",
				"pc": "150900"
			}, {
				"c": "152200",
				"n": "兴安盟",
				"pc": "150000"
			}, {
				"c": "152201",
				"n": "乌兰浩特市",
				"pc": "152200"
			}, {
				"c": "152202",
				"n": "阿尔山市",
				"pc": "152200"
			}, {
				"c": "152221",
				"n": "科尔沁右翼前旗",
				"pc": "152200"
			}, {
				"c": "152222",
				"n": "科尔沁右翼中旗",
				"pc": "152200"
			}, {
				"c": "152223",
				"n": "扎赉特旗",
				"pc": "152200"
			}, {
				"c": "152224",
				"n": "突泉县",
				"pc": "152200"
			}, {
				"c": "152500",
				"n": "锡林郭勒盟",
				"pc": "150000"
			}, {
				"c": "152501",
				"n": "二连浩特市",
				"pc": "152500"
			}, {
				"c": "152502",
				"n": "锡林浩特市",
				"pc": "152500"
			}, {
				"c": "152522",
				"n": "阿巴嘎旗",
				"pc": "152500"
			}, {
				"c": "152523",
				"n": "苏尼特左旗",
				"pc": "152500"
			}, {
				"c": "152524",
				"n": "苏尼特右旗",
				"pc": "152500"
			}, {
				"c": "152525",
				"n": "东乌珠穆沁旗",
				"pc": "152500"
			}, {
				"c": "152526",
				"n": "西乌珠穆沁旗",
				"pc": "152500"
			}, {
				"c": "152527",
				"n": "太仆寺旗",
				"pc": "152500"
			}, {
				"c": "152528",
				"n": "镶黄旗",
				"pc": "152500"
			}, {
				"c": "152529",
				"n": "正镶白旗",
				"pc": "152500"
			}, {
				"c": "152530",
				"n": "正蓝旗",
				"pc": "152500"
			}, {
				"c": "152531",
				"n": "多伦县",
				"pc": "152500"
			}, {
				"c": "152900",
				"n": "阿拉善盟",
				"pc": "150000"
			}, {
				"c": "152921",
				"n": "阿拉善左旗",
				"pc": "152900"
			}, {
				"c": "152922",
				"n": "阿拉善右旗",
				"pc": "152900"
			}, {
				"c": "152923",
				"n": "额济纳旗",
				"pc": "152900"
			}, {
				"c": "210000",
				"n": "辽宁省",
				"pc": "86"
			}, {
				"c": "210100",
				"n": "沈阳市",
				"pc": "210000"
			}, {
				"c": "210101",
				"n": "市辖区",
				"pc": "210100"
			}, {
				"c": "210102",
				"n": "和平区",
				"pc": "210100"
			}, {
				"c": "210103",
				"n": "沈河区",
				"pc": "210100"
			}, {
				"c": "210104",
				"n": "大东区",
				"pc": "210100"
			}, {
				"c": "210105",
				"n": "皇姑区",
				"pc": "210100"
			}, {
				"c": "210106",
				"n": "铁西区",
				"pc": "210100"
			}, {
				"c": "210111",
				"n": "苏家屯区",
				"pc": "210100"
			}, {
				"c": "210112",
				"n": "东陵区",
				"pc": "210100"
			}, {
				"c": "210113",
				"n": "沈北新区",
				"pc": "210100"
			}, {
				"c": "210114",
				"n": "于洪区",
				"pc": "210100"
			}, {
				"c": "210122",
				"n": "辽中县",
				"pc": "210100"
			}, {
				"c": "210123",
				"n": "康平县",
				"pc": "210100"
			}, {
				"c": "210124",
				"n": "法库县",
				"pc": "210100"
			}, {
				"c": "210181",
				"n": "新民市",
				"pc": "210100"
			}, {
				"c": "210200",
				"n": "大连市",
				"pc": "210000"
			}, {
				"c": "210201",
				"n": "市辖区",
				"pc": "210200"
			}, {
				"c": "210202",
				"n": "中山区",
				"pc": "210200"
			}, {
				"c": "210203",
				"n": "西岗区",
				"pc": "210200"
			}, {
				"c": "210204",
				"n": "沙河口区",
				"pc": "210200"
			}, {
				"c": "210211",
				"n": "甘井子区",
				"pc": "210200"
			}, {
				"c": "210212",
				"n": "旅顺口区",
				"pc": "210200"
			}, {
				"c": "210213",
				"n": "金州区",
				"pc": "210200"
			}, {
				"c": "210224",
				"n": "长海县",
				"pc": "210200"
			}, {
				"c": "210281",
				"n": "瓦房店市",
				"pc": "210200"
			}, {
				"c": "210282",
				"n": "普兰店市",
				"pc": "210200"
			}, {
				"c": "210283",
				"n": "庄河市",
				"pc": "210200"
			}, {
				"c": "210300",
				"n": "鞍山市",
				"pc": "210000"
			}, {
				"c": "210301",
				"n": "市辖区",
				"pc": "210300"
			}, {
				"c": "210302",
				"n": "铁东区",
				"pc": "210300"
			}, {
				"c": "210303",
				"n": "铁西区",
				"pc": "210300"
			}, {
				"c": "210304",
				"n": "立山区",
				"pc": "210300"
			}, {
				"c": "210311",
				"n": "千山区",
				"pc": "210300"
			}, {
				"c": "210321",
				"n": "台安县",
				"pc": "210300"
			}, {
				"c": "210323",
				"n": "岫岩满族自治县",
				"pc": "210300"
			}, {
				"c": "210381",
				"n": "海城市",
				"pc": "210300"
			}, {
				"c": "210400",
				"n": "抚顺市",
				"pc": "210000"
			}, {
				"c": "210401",
				"n": "市辖区",
				"pc": "210400"
			}, {
				"c": "210402",
				"n": "新抚区",
				"pc": "210400"
			}, {
				"c": "210403",
				"n": "东洲区",
				"pc": "210400"
			}, {
				"c": "210404",
				"n": "望花区",
				"pc": "210400"
			}, {
				"c": "210411",
				"n": "顺城区",
				"pc": "210400"
			}, {
				"c": "210421",
				"n": "抚顺县",
				"pc": "210400"
			}, {
				"c": "210422",
				"n": "新宾满族自治县",
				"pc": "210400"
			}, {
				"c": "210423",
				"n": "清原满族自治县",
				"pc": "210400"
			}, {
				"c": "210500",
				"n": "本溪市",
				"pc": "210000"
			}, {
				"c": "210501",
				"n": "市辖区",
				"pc": "210500"
			}, {
				"c": "210502",
				"n": "平山区",
				"pc": "210500"
			}, {
				"c": "210503",
				"n": "溪湖区",
				"pc": "210500"
			}, {
				"c": "210504",
				"n": "明山区",
				"pc": "210500"
			}, {
				"c": "210505",
				"n": "南芬区",
				"pc": "210500"
			}, {
				"c": "210521",
				"n": "本溪满族自治县",
				"pc": "210500"
			}, {
				"c": "210522",
				"n": "桓仁满族自治县",
				"pc": "210500"
			}, {
				"c": "210600",
				"n": "丹东市",
				"pc": "210000"
			}, {
				"c": "210601",
				"n": "市辖区",
				"pc": "210600"
			}, {
				"c": "210602",
				"n": "元宝区",
				"pc": "210600"
			}, {
				"c": "210603",
				"n": "振兴区",
				"pc": "210600"
			}, {
				"c": "210604",
				"n": "振安区",
				"pc": "210600"
			}, {
				"c": "210624",
				"n": "宽甸满族自治县",
				"pc": "210600"
			}, {
				"c": "210681",
				"n": "东港市",
				"pc": "210600"
			}, {
				"c": "210682",
				"n": "凤城市",
				"pc": "210600"
			}, {
				"c": "210700",
				"n": "锦州市",
				"pc": "210000"
			}, {
				"c": "210701",
				"n": "市辖区",
				"pc": "210700"
			}, {
				"c": "210702",
				"n": "古塔区",
				"pc": "210700"
			}, {
				"c": "210703",
				"n": "凌河区",
				"pc": "210700"
			}, {
				"c": "210711",
				"n": "太和区",
				"pc": "210700"
			}, {
				"c": "210726",
				"n": "黑山县",
				"pc": "210700"
			}, {
				"c": "210727",
				"n": "义县",
				"pc": "210700"
			}, {
				"c": "210781",
				"n": "凌海市",
				"pc": "210700"
			}, {
				"c": "210782",
				"n": "北镇市",
				"pc": "210700"
			}, {
				"c": "210800",
				"n": "营口市",
				"pc": "210000"
			}, {
				"c": "210801",
				"n": "市辖区",
				"pc": "210800"
			}, {
				"c": "210802",
				"n": "站前区",
				"pc": "210800"
			}, {
				"c": "210803",
				"n": "西市区",
				"pc": "210800"
			}, {
				"c": "210804",
				"n": "鲅鱼圈区",
				"pc": "210800"
			}, {
				"c": "210811",
				"n": "老边区",
				"pc": "210800"
			}, {
				"c": "210881",
				"n": "盖州市",
				"pc": "210800"
			}, {
				"c": "210882",
				"n": "大石桥市",
				"pc": "210800"
			}, {
				"c": "210900",
				"n": "阜新市",
				"pc": "210000"
			}, {
				"c": "210901",
				"n": "市辖区",
				"pc": "210900"
			}, {
				"c": "210902",
				"n": "海州区",
				"pc": "210900"
			}, {
				"c": "210903",
				"n": "新邱区",
				"pc": "210900"
			}, {
				"c": "210904",
				"n": "太平区",
				"pc": "210900"
			}, {
				"c": "210905",
				"n": "清河门区",
				"pc": "210900"
			}, {
				"c": "210911",
				"n": "细河区",
				"pc": "210900"
			}, {
				"c": "210921",
				"n": "阜新蒙古族自治县",
				"pc": "210900"
			}, {
				"c": "210922",
				"n": "彰武县",
				"pc": "210900"
			}, {
				"c": "211000",
				"n": "辽阳市",
				"pc": "210000"
			}, {
				"c": "211001",
				"n": "市辖区",
				"pc": "211000"
			}, {
				"c": "211002",
				"n": "白塔区",
				"pc": "211000"
			}, {
				"c": "211003",
				"n": "文圣区",
				"pc": "211000"
			}, {
				"c": "211004",
				"n": "宏伟区",
				"pc": "211000"
			}, {
				"c": "211005",
				"n": "弓长岭区",
				"pc": "211000"
			}, {
				"c": "211011",
				"n": "太子河区",
				"pc": "211000"
			}, {
				"c": "211021",
				"n": "辽阳县",
				"pc": "211000"
			}, {
				"c": "211081",
				"n": "灯塔市",
				"pc": "211000"
			}, {
				"c": "211100",
				"n": "盘锦市",
				"pc": "210000"
			}, {
				"c": "211101",
				"n": "市辖区",
				"pc": "211100"
			}, {
				"c": "211102",
				"n": "双台子区",
				"pc": "211100"
			}, {
				"c": "211103",
				"n": "兴隆台区",
				"pc": "211100"
			}, {
				"c": "211121",
				"n": "大洼县",
				"pc": "211100"
			}, {
				"c": "211122",
				"n": "盘山县",
				"pc": "211100"
			}, {
				"c": "211200",
				"n": "铁岭市",
				"pc": "210000"
			}, {
				"c": "211201",
				"n": "市辖区",
				"pc": "211200"
			}, {
				"c": "211202",
				"n": "银州区",
				"pc": "211200"
			}, {
				"c": "211204",
				"n": "清河区",
				"pc": "211200"
			}, {
				"c": "211221",
				"n": "铁岭县",
				"pc": "211200"
			}, {
				"c": "211223",
				"n": "西丰县",
				"pc": "211200"
			}, {
				"c": "211224",
				"n": "昌图县",
				"pc": "211200"
			}, {
				"c": "211281",
				"n": "调兵山市",
				"pc": "211200"
			}, {
				"c": "211282",
				"n": "开原市",
				"pc": "211200"
			}, {
				"c": "211300",
				"n": "朝阳市",
				"pc": "210000"
			}, {
				"c": "211301",
				"n": "市辖区",
				"pc": "211300"
			}, {
				"c": "211302",
				"n": "双塔区",
				"pc": "211300"
			}, {
				"c": "211303",
				"n": "龙城区",
				"pc": "211300"
			}, {
				"c": "211321",
				"n": "朝阳县",
				"pc": "211300"
			}, {
				"c": "211322",
				"n": "建平县",
				"pc": "211300"
			}, {
				"c": "211324",
				"n": "喀喇沁左翼蒙古族自治县",
				"pc": "211300"
			}, {
				"c": "211381",
				"n": "北票市",
				"pc": "211300"
			}, {
				"c": "211382",
				"n": "凌源市",
				"pc": "211300"
			}, {
				"c": "211400",
				"n": "葫芦岛市",
				"pc": "210000"
			}, {
				"c": "211401",
				"n": "市辖区",
				"pc": "211400"
			}, {
				"c": "211402",
				"n": "连山区",
				"pc": "211400"
			}, {
				"c": "211403",
				"n": "龙港区",
				"pc": "211400"
			}, {
				"c": "211404",
				"n": "南票区",
				"pc": "211400"
			}, {
				"c": "211421",
				"n": "绥中县",
				"pc": "211400"
			}, {
				"c": "211422",
				"n": "建昌县",
				"pc": "211400"
			}, {
				"c": "211481",
				"n": "兴城市",
				"pc": "211400"
			}, {
				"c": "220000",
				"n": "吉林省",
				"pc": "86"
			}, {
				"c": "220100",
				"n": "长春市",
				"pc": "220000"
			}, {
				"c": "220101",
				"n": "市辖区",
				"pc": "220100"
			}, {
				"c": "220102",
				"n": "南关区",
				"pc": "220100"
			}, {
				"c": "220103",
				"n": "宽城区",
				"pc": "220100"
			}, {
				"c": "220104",
				"n": "朝阳区",
				"pc": "220100"
			}, {
				"c": "220105",
				"n": "二道区",
				"pc": "220100"
			}, {
				"c": "220106",
				"n": "绿园区",
				"pc": "220100"
			}, {
				"c": "220112",
				"n": "双阳区",
				"pc": "220100"
			}, {
				"c": "220122",
				"n": "农安县",
				"pc": "220100"
			}, {
				"c": "220181",
				"n": "九台市",
				"pc": "220100"
			}, {
				"c": "220182",
				"n": "榆树市",
				"pc": "220100"
			}, {
				"c": "220183",
				"n": "德惠市",
				"pc": "220100"
			}, {
				"c": "220200",
				"n": "吉林市",
				"pc": "220000"
			}, {
				"c": "220201",
				"n": "市辖区",
				"pc": "220200"
			}, {
				"c": "220202",
				"n": "昌邑区",
				"pc": "220200"
			}, {
				"c": "220203",
				"n": "龙潭区",
				"pc": "220200"
			}, {
				"c": "220204",
				"n": "船营区",
				"pc": "220200"
			}, {
				"c": "220211",
				"n": "丰满区",
				"pc": "220200"
			}, {
				"c": "220221",
				"n": "永吉县",
				"pc": "220200"
			}, {
				"c": "220281",
				"n": "蛟河市",
				"pc": "220200"
			}, {
				"c": "220282",
				"n": "桦甸市",
				"pc": "220200"
			}, {
				"c": "220283",
				"n": "舒兰市",
				"pc": "220200"
			}, {
				"c": "220284",
				"n": "磐石市",
				"pc": "220200"
			}, {
				"c": "220300",
				"n": "四平市",
				"pc": "220000"
			}, {
				"c": "220301",
				"n": "市辖区",
				"pc": "220300"
			}, {
				"c": "220302",
				"n": "铁西区",
				"pc": "220300"
			}, {
				"c": "220303",
				"n": "铁东区",
				"pc": "220300"
			}, {
				"c": "220322",
				"n": "梨树县",
				"pc": "220300"
			}, {
				"c": "220323",
				"n": "伊通满族自治县",
				"pc": "220300"
			}, {
				"c": "220381",
				"n": "公主岭市",
				"pc": "220300"
			}, {
				"c": "220382",
				"n": "双辽市",
				"pc": "220300"
			}, {
				"c": "220400",
				"n": "辽源市",
				"pc": "220000"
			}, {
				"c": "220401",
				"n": "市辖区",
				"pc": "220400"
			}, {
				"c": "220402",
				"n": "龙山区",
				"pc": "220400"
			}, {
				"c": "220403",
				"n": "西安区",
				"pc": "220400"
			}, {
				"c": "220421",
				"n": "东丰县",
				"pc": "220400"
			}, {
				"c": "220422",
				"n": "东辽县",
				"pc": "220400"
			}, {
				"c": "220500",
				"n": "通化市",
				"pc": "220000"
			}, {
				"c": "220501",
				"n": "市辖区",
				"pc": "220500"
			}, {
				"c": "220502",
				"n": "东昌区",
				"pc": "220500"
			}, {
				"c": "220503",
				"n": "二道江区",
				"pc": "220500"
			}, {
				"c": "220521",
				"n": "通化县",
				"pc": "220500"
			}, {
				"c": "220523",
				"n": "辉南县",
				"pc": "220500"
			}, {
				"c": "220524",
				"n": "柳河县",
				"pc": "220500"
			}, {
				"c": "220581",
				"n": "梅河口市",
				"pc": "220500"
			}, {
				"c": "220582",
				"n": "集安市",
				"pc": "220500"
			}, {
				"c": "220600",
				"n": "白山市",
				"pc": "220000"
			}, {
				"c": "220601",
				"n": "市辖区",
				"pc": "220600"
			}, {
				"c": "220602",
				"n": "浑江区",
				"pc": "220600"
			}, {
				"c": "220605",
				"n": "江源区",
				"pc": "220600"
			}, {
				"c": "220621",
				"n": "抚松县",
				"pc": "220600"
			}, {
				"c": "220622",
				"n": "靖宇县",
				"pc": "220600"
			}, {
				"c": "220623",
				"n": "长白朝鲜族自治县",
				"pc": "220600"
			}, {
				"c": "220681",
				"n": "临江市",
				"pc": "220600"
			}, {
				"c": "220700",
				"n": "松原市",
				"pc": "220000"
			}, {
				"c": "220701",
				"n": "市辖区",
				"pc": "220700"
			}, {
				"c": "220702",
				"n": "宁江区",
				"pc": "220700"
			}, {
				"c": "220721",
				"n": "前郭尔罗斯蒙古族自治县",
				"pc": "220700"
			}, {
				"c": "220722",
				"n": "长岭县",
				"pc": "220700"
			}, {
				"c": "220723",
				"n": "乾安县",
				"pc": "220700"
			}, {
				"c": "220724",
				"n": "扶余县",
				"pc": "220700"
			}, {
				"c": "220800",
				"n": "白城市",
				"pc": "220000"
			}, {
				"c": "220801",
				"n": "市辖区",
				"pc": "220800"
			}, {
				"c": "220802",
				"n": "洮北区",
				"pc": "220800"
			}, {
				"c": "220821",
				"n": "镇赉县",
				"pc": "220800"
			}, {
				"c": "220822",
				"n": "通榆县",
				"pc": "220800"
			}, {
				"c": "220881",
				"n": "洮南市",
				"pc": "220800"
			}, {
				"c": "220882",
				"n": "大安市",
				"pc": "220800"
			}, {
				"c": "222400",
				"n": "延边朝鲜族自治州",
				"pc": "220000"
			}, {
				"c": "222401",
				"n": "延吉市",
				"pc": "222400"
			}, {
				"c": "222402",
				"n": "图们市",
				"pc": "222400"
			}, {
				"c": "222403",
				"n": "敦化市",
				"pc": "222400"
			}, {
				"c": "222404",
				"n": "珲春市",
				"pc": "222400"
			}, {
				"c": "222405",
				"n": "龙井市",
				"pc": "222400"
			}, {
				"c": "222406",
				"n": "和龙市",
				"pc": "222400"
			}, {
				"c": "222424",
				"n": "汪清县",
				"pc": "222400"
			}, {
				"c": "222426",
				"n": "安图县",
				"pc": "222400"
			}, {
				"c": "230000",
				"n": "黑龙江省",
				"pc": "86"
			}, {
				"c": "230100",
				"n": "哈尔滨市",
				"pc": "230000"
			}, {
				"c": "230101",
				"n": "市辖区",
				"pc": "230100"
			}, {
				"c": "230102",
				"n": "道里区",
				"pc": "230100"
			}, {
				"c": "230103",
				"n": "南岗区",
				"pc": "230100"
			}, {
				"c": "230104",
				"n": "道外区",
				"pc": "230100"
			}, {
				"c": "230108",
				"n": "平房区",
				"pc": "230100"
			}, {
				"c": "230109",
				"n": "松北区",
				"pc": "230100"
			}, {
				"c": "230110",
				"n": "香坊区",
				"pc": "230100"
			}, {
				"c": "230111",
				"n": "呼兰区",
				"pc": "230100"
			}, {
				"c": "230112",
				"n": "阿城区",
				"pc": "230100"
			}, {
				"c": "230123",
				"n": "依兰县",
				"pc": "230100"
			}, {
				"c": "230124",
				"n": "方正县",
				"pc": "230100"
			}, {
				"c": "230125",
				"n": "宾县",
				"pc": "230100"
			}, {
				"c": "230126",
				"n": "巴彦县",
				"pc": "230100"
			}, {
				"c": "230127",
				"n": "木兰县",
				"pc": "230100"
			}, {
				"c": "230128",
				"n": "通河县",
				"pc": "230100"
			}, {
				"c": "230129",
				"n": "延寿县",
				"pc": "230100"
			}, {
				"c": "230182",
				"n": "双城市",
				"pc": "230100"
			}, {
				"c": "230183",
				"n": "尚志市",
				"pc": "230100"
			}, {
				"c": "230184",
				"n": "五常市",
				"pc": "230100"
			}, {
				"c": "230200",
				"n": "齐齐哈尔市",
				"pc": "230000"
			}, {
				"c": "230201",
				"n": "市辖区",
				"pc": "230200"
			}, {
				"c": "230202",
				"n": "龙沙区",
				"pc": "230200"
			}, {
				"c": "230203",
				"n": "建华区",
				"pc": "230200"
			}, {
				"c": "230204",
				"n": "铁锋区",
				"pc": "230200"
			}, {
				"c": "230205",
				"n": "昂昂溪区",
				"pc": "230200"
			}, {
				"c": "230206",
				"n": "富拉尔基区",
				"pc": "230200"
			}, {
				"c": "230207",
				"n": "碾子山区",
				"pc": "230200"
			}, {
				"c": "230208",
				"n": "梅里斯达斡尔族区",
				"pc": "230200"
			}, {
				"c": "230221",
				"n": "龙江县",
				"pc": "230200"
			}, {
				"c": "230223",
				"n": "依安县",
				"pc": "230200"
			}, {
				"c": "230224",
				"n": "泰来县",
				"pc": "230200"
			}, {
				"c": "230225",
				"n": "甘南县",
				"pc": "230200"
			}, {
				"c": "230227",
				"n": "富裕县",
				"pc": "230200"
			}, {
				"c": "230229",
				"n": "克山县",
				"pc": "230200"
			}, {
				"c": "230230",
				"n": "克东县",
				"pc": "230200"
			}, {
				"c": "230231",
				"n": "拜泉县",
				"pc": "230200"
			}, {
				"c": "230281",
				"n": "讷河市",
				"pc": "230200"
			}, {
				"c": "230300",
				"n": "鸡西市",
				"pc": "230000"
			}, {
				"c": "230301",
				"n": "市辖区",
				"pc": "230300"
			}, {
				"c": "230302",
				"n": "鸡冠区",
				"pc": "230300"
			}, {
				"c": "230303",
				"n": "恒山区",
				"pc": "230300"
			}, {
				"c": "230304",
				"n": "滴道区",
				"pc": "230300"
			}, {
				"c": "230305",
				"n": "梨树区",
				"pc": "230300"
			}, {
				"c": "230306",
				"n": "城子河区",
				"pc": "230300"
			}, {
				"c": "230307",
				"n": "麻山区",
				"pc": "230300"
			}, {
				"c": "230321",
				"n": "鸡东县",
				"pc": "230300"
			}, {
				"c": "230381",
				"n": "虎林市",
				"pc": "230300"
			}, {
				"c": "230382",
				"n": "密山市",
				"pc": "230300"
			}, {
				"c": "230400",
				"n": "鹤岗市",
				"pc": "230000"
			}, {
				"c": "230401",
				"n": "市辖区",
				"pc": "230400"
			}, {
				"c": "230402",
				"n": "向阳区",
				"pc": "230400"
			}, {
				"c": "230403",
				"n": "工农区",
				"pc": "230400"
			}, {
				"c": "230404",
				"n": "南山区",
				"pc": "230400"
			}, {
				"c": "230405",
				"n": "兴安区",
				"pc": "230400"
			}, {
				"c": "230406",
				"n": "东山区",
				"pc": "230400"
			}, {
				"c": "230407",
				"n": "兴山区",
				"pc": "230400"
			}, {
				"c": "230421",
				"n": "萝北县",
				"pc": "230400"
			}, {
				"c": "230422",
				"n": "绥滨县",
				"pc": "230400"
			}, {
				"c": "230500",
				"n": "双鸭山市",
				"pc": "230000"
			}, {
				"c": "230501",
				"n": "市辖区",
				"pc": "230500"
			}, {
				"c": "230502",
				"n": "尖山区",
				"pc": "230500"
			}, {
				"c": "230503",
				"n": "岭东区",
				"pc": "230500"
			}, {
				"c": "230505",
				"n": "四方台区",
				"pc": "230500"
			}, {
				"c": "230506",
				"n": "宝山区",
				"pc": "230500"
			}, {
				"c": "230521",
				"n": "集贤县",
				"pc": "230500"
			}, {
				"c": "230522",
				"n": "友谊县",
				"pc": "230500"
			}, {
				"c": "230523",
				"n": "宝清县",
				"pc": "230500"
			}, {
				"c": "230524",
				"n": "饶河县",
				"pc": "230500"
			}, {
				"c": "230600",
				"n": "大庆市",
				"pc": "230000"
			}, {
				"c": "230601",
				"n": "市辖区",
				"pc": "230600"
			}, {
				"c": "230602",
				"n": "萨尔图区",
				"pc": "230600"
			}, {
				"c": "230603",
				"n": "龙凤区",
				"pc": "230600"
			}, {
				"c": "230604",
				"n": "让胡路区",
				"pc": "230600"
			}, {
				"c": "230605",
				"n": "红岗区",
				"pc": "230600"
			}, {
				"c": "230606",
				"n": "大同区",
				"pc": "230600"
			}, {
				"c": "230621",
				"n": "肇州县",
				"pc": "230600"
			}, {
				"c": "230622",
				"n": "肇源县",
				"pc": "230600"
			}, {
				"c": "230623",
				"n": "林甸县",
				"pc": "230600"
			}, {
				"c": "230624",
				"n": "杜尔伯特蒙古族自治县",
				"pc": "230600"
			}, {
				"c": "230700",
				"n": "伊春市",
				"pc": "230000"
			}, {
				"c": "230701",
				"n": "市辖区",
				"pc": "230700"
			}, {
				"c": "230702",
				"n": "伊春区",
				"pc": "230700"
			}, {
				"c": "230703",
				"n": "南岔区",
				"pc": "230700"
			}, {
				"c": "230704",
				"n": "友好区",
				"pc": "230700"
			}, {
				"c": "230705",
				"n": "西林区",
				"pc": "230700"
			}, {
				"c": "230706",
				"n": "翠峦区",
				"pc": "230700"
			}, {
				"c": "230707",
				"n": "新青区",
				"pc": "230700"
			}, {
				"c": "230708",
				"n": "美溪区",
				"pc": "230700"
			}, {
				"c": "230709",
				"n": "金山屯区",
				"pc": "230700"
			}, {
				"c": "230710",
				"n": "五营区",
				"pc": "230700"
			}, {
				"c": "230711",
				"n": "乌马河区",
				"pc": "230700"
			}, {
				"c": "230712",
				"n": "汤旺河区",
				"pc": "230700"
			}, {
				"c": "230713",
				"n": "带岭区",
				"pc": "230700"
			}, {
				"c": "230714",
				"n": "乌伊岭区",
				"pc": "230700"
			}, {
				"c": "230715",
				"n": "红星区",
				"pc": "230700"
			}, {
				"c": "230716",
				"n": "上甘岭区",
				"pc": "230700"
			}, {
				"c": "230722",
				"n": "嘉荫县",
				"pc": "230700"
			}, {
				"c": "230781",
				"n": "铁力市",
				"pc": "230700"
			}, {
				"c": "230800",
				"n": "佳木斯市",
				"pc": "230000"
			}, {
				"c": "230801",
				"n": "市辖区",
				"pc": "230800"
			}, {
				"c": "230803",
				"n": "向阳区",
				"pc": "230800"
			}, {
				"c": "230804",
				"n": "前进区",
				"pc": "230800"
			}, {
				"c": "230805",
				"n": "东风区",
				"pc": "230800"
			}, {
				"c": "230811",
				"n": "郊区",
				"pc": "230800"
			}, {
				"c": "230822",
				"n": "桦南县",
				"pc": "230800"
			}, {
				"c": "230826",
				"n": "桦川县",
				"pc": "230800"
			}, {
				"c": "230828",
				"n": "汤原县",
				"pc": "230800"
			}, {
				"c": "230833",
				"n": "抚远县",
				"pc": "230800"
			}, {
				"c": "230881",
				"n": "同江市",
				"pc": "230800"
			}, {
				"c": "230882",
				"n": "富锦市",
				"pc": "230800"
			}, {
				"c": "230900",
				"n": "七台河市",
				"pc": "230000"
			}, {
				"c": "230901",
				"n": "市辖区",
				"pc": "230900"
			}, {
				"c": "230902",
				"n": "新兴区",
				"pc": "230900"
			}, {
				"c": "230903",
				"n": "桃山区",
				"pc": "230900"
			}, {
				"c": "230904",
				"n": "茄子河区",
				"pc": "230900"
			}, {
				"c": "230921",
				"n": "勃利县",
				"pc": "230900"
			}, {
				"c": "231000",
				"n": "牡丹江市",
				"pc": "230000"
			}, {
				"c": "231001",
				"n": "市辖区",
				"pc": "231000"
			}, {
				"c": "231002",
				"n": "东安区",
				"pc": "231000"
			}, {
				"c": "231003",
				"n": "阳明区",
				"pc": "231000"
			}, {
				"c": "231004",
				"n": "爱民区",
				"pc": "231000"
			}, {
				"c": "231005",
				"n": "西安区",
				"pc": "231000"
			}, {
				"c": "231024",
				"n": "东宁县",
				"pc": "231000"
			}, {
				"c": "231025",
				"n": "林口县",
				"pc": "231000"
			}, {
				"c": "231081",
				"n": "绥芬河市",
				"pc": "231000"
			}, {
				"c": "231083",
				"n": "海林市",
				"pc": "231000"
			}, {
				"c": "231084",
				"n": "宁安市",
				"pc": "231000"
			}, {
				"c": "231085",
				"n": "穆棱市",
				"pc": "231000"
			}, {
				"c": "231100",
				"n": "黑河市",
				"pc": "230000"
			}, {
				"c": "231101",
				"n": "市辖区",
				"pc": "231100"
			}, {
				"c": "231102",
				"n": "爱辉区",
				"pc": "231100"
			}, {
				"c": "231121",
				"n": "嫩江县",
				"pc": "231100"
			}, {
				"c": "231123",
				"n": "逊克县",
				"pc": "231100"
			}, {
				"c": "231124",
				"n": "孙吴县",
				"pc": "231100"
			}, {
				"c": "231181",
				"n": "北安市",
				"pc": "231100"
			}, {
				"c": "231182",
				"n": "五大连池市",
				"pc": "231100"
			}, {
				"c": "231200",
				"n": "绥化市",
				"pc": "230000"
			}, {
				"c": "231201",
				"n": "市辖区",
				"pc": "231200"
			}, {
				"c": "231202",
				"n": "北林区",
				"pc": "231200"
			}, {
				"c": "231221",
				"n": "望奎县",
				"pc": "231200"
			}, {
				"c": "231222",
				"n": "兰西县",
				"pc": "231200"
			}, {
				"c": "231223",
				"n": "青冈县",
				"pc": "231200"
			}, {
				"c": "231224",
				"n": "庆安县",
				"pc": "231200"
			}, {
				"c": "231225",
				"n": "明水县",
				"pc": "231200"
			}, {
				"c": "231226",
				"n": "绥棱县",
				"pc": "231200"
			}, {
				"c": "231281",
				"n": "安达市",
				"pc": "231200"
			}, {
				"c": "231282",
				"n": "肇东市",
				"pc": "231200"
			}, {
				"c": "231283",
				"n": "海伦市",
				"pc": "231200"
			}, {
				"c": "232700",
				"n": "大兴安岭地区",
				"pc": "230000"
			}, {
				"c": "232721",
				"n": "呼玛县",
				"pc": "232700"
			}, {
				"c": "232722",
				"n": "塔河县",
				"pc": "232700"
			}, {
				"c": "232723",
				"n": "漠河县",
				"pc": "232700"
			}, {
				"c": "310000",
				"n": "上海市",
				"pc": "86"
			}, {
				"c": "310100",
				"n": "上海市",
				"pc": "310000"
			}, {
				"c": "310101",
				"n": "黄浦区",
				"pc": "310100"
			}, {
				"c": "310104",
				"n": "徐汇区",
				"pc": "310100"
			}, {
				"c": "310105",
				"n": "长宁区",
				"pc": "310100"
			}, {
				"c": "310106",
				"n": "静安区",
				"pc": "310100"
			}, {
				"c": "310107",
				"n": "普陀区",
				"pc": "310100"
			}, {
				"c": "310108",
				"n": "闸北区",
				"pc": "310100"
			}, {
				"c": "310109",
				"n": "虹口区",
				"pc": "310100"
			}, {
				"c": "310110",
				"n": "杨浦区",
				"pc": "310100"
			}, {
				"c": "310112",
				"n": "闵行区",
				"pc": "310100"
			}, {
				"c": "310113",
				"n": "宝山区",
				"pc": "310100"
			}, {
				"c": "310114",
				"n": "嘉定区",
				"pc": "310100"
			}, {
				"c": "310115",
				"n": "浦东新区",
				"pc": "310100"
			}, {
				"c": "310116",
				"n": "金山区",
				"pc": "310100"
			}, {
				"c": "310117",
				"n": "松江区",
				"pc": "310100"
			}, {
				"c": "310118",
				"n": "青浦区",
				"pc": "310100"
			}, {
				"c": "310120",
				"n": "奉贤区",
				"pc": "310100"
			}, {
				"c": "310230",
				"n": "崇明县",
				"pc": "310100"
			}, {
				"c": "320000",
				"n": "江苏省",
				"pc": "86"
			}, {
				"c": "320100",
				"n": "南京市",
				"pc": "320000"
			}, {
				"c": "320101",
				"n": "市辖区",
				"pc": "320100"
			}, {
				"c": "320102",
				"n": "玄武区",
				"pc": "320100"
			}, {
				"c": "320103",
				"n": "白下区",
				"pc": "320100"
			}, {
				"c": "320104",
				"n": "秦淮区",
				"pc": "320100"
			}, {
				"c": "320105",
				"n": "建邺区",
				"pc": "320100"
			}, {
				"c": "320106",
				"n": "鼓楼区",
				"pc": "320100"
			}, {
				"c": "320107",
				"n": "下关区",
				"pc": "320100"
			}, {
				"c": "320111",
				"n": "浦口区",
				"pc": "320100"
			}, {
				"c": "320113",
				"n": "栖霞区",
				"pc": "320100"
			}, {
				"c": "320114",
				"n": "雨花台区",
				"pc": "320100"
			}, {
				"c": "320115",
				"n": "江宁区",
				"pc": "320100"
			}, {
				"c": "320116",
				"n": "六合区",
				"pc": "320100"
			}, {
				"c": "320124",
				"n": "溧水县",
				"pc": "320100"
			}, {
				"c": "320125",
				"n": "高淳县",
				"pc": "320100"
			}, {
				"c": "320200",
				"n": "无锡市",
				"pc": "320000"
			}, {
				"c": "320201",
				"n": "市辖区",
				"pc": "320200"
			}, {
				"c": "320202",
				"n": "崇安区",
				"pc": "320200"
			}, {
				"c": "320203",
				"n": "南长区",
				"pc": "320200"
			}, {
				"c": "320204",
				"n": "北塘区",
				"pc": "320200"
			}, {
				"c": "320205",
				"n": "锡山区",
				"pc": "320200"
			}, {
				"c": "320206",
				"n": "惠山区",
				"pc": "320200"
			}, {
				"c": "320211",
				"n": "滨湖区",
				"pc": "320200"
			}, {
				"c": "320281",
				"n": "江阴市",
				"pc": "320200"
			}, {
				"c": "320282",
				"n": "宜兴市",
				"pc": "320200"
			}, {
				"c": "320300",
				"n": "徐州市",
				"pc": "320000"
			}, {
				"c": "320301",
				"n": "市辖区",
				"pc": "320300"
			}, {
				"c": "320302",
				"n": "鼓楼区",
				"pc": "320300"
			}, {
				"c": "320303",
				"n": "云龙区",
				"pc": "320300"
			}, {
				"c": "320305",
				"n": "贾汪区",
				"pc": "320300"
			}, {
				"c": "320311",
				"n": "泉山区",
				"pc": "320300"
			}, {
				"c": "320312",
				"n": "铜山区",
				"pc": "320300"
			}, {
				"c": "320321",
				"n": "丰县",
				"pc": "320300"
			}, {
				"c": "320322",
				"n": "沛县",
				"pc": "320300"
			}, {
				"c": "320324",
				"n": "睢宁县",
				"pc": "320300"
			}, {
				"c": "320381",
				"n": "新沂市",
				"pc": "320300"
			}, {
				"c": "320382",
				"n": "邳州市",
				"pc": "320300"
			}, {
				"c": "320400",
				"n": "常州市",
				"pc": "320000"
			}, {
				"c": "320401",
				"n": "市辖区",
				"pc": "320400"
			}, {
				"c": "320402",
				"n": "天宁区",
				"pc": "320400"
			}, {
				"c": "320404",
				"n": "钟楼区",
				"pc": "320400"
			}, {
				"c": "320405",
				"n": "戚墅堰区",
				"pc": "320400"
			}, {
				"c": "320411",
				"n": "新北区",
				"pc": "320400"
			}, {
				"c": "320412",
				"n": "武进区",
				"pc": "320400"
			}, {
				"c": "320481",
				"n": "溧阳市",
				"pc": "320400"
			}, {
				"c": "320482",
				"n": "金坛市",
				"pc": "320400"
			}, {
				"c": "320500",
				"n": "苏州市",
				"pc": "320000"
			}, {
				"c": "320501",
				"n": "市辖区",
				"pc": "320500"
			}, {
				"c": "320505",
				"n": "虎丘区",
				"pc": "320500"
			}, {
				"c": "320506",
				"n": "吴中区",
				"pc": "320500"
			}, {
				"c": "320507",
				"n": "相城区",
				"pc": "320500"
			}, {
				"c": "320508",
				"n": "姑苏区",
				"pc": "320500"
			}, {
				"c": "320509",
				"n": "吴江区",
				"pc": "320500"
			}, {
				"c": "320581",
				"n": "常熟市",
				"pc": "320500"
			}, {
				"c": "320582",
				"n": "张家港市",
				"pc": "320500"
			}, {
				"c": "320583",
				"n": "昆山市",
				"pc": "320500"
			}, {
				"c": "320585",
				"n": "太仓市",
				"pc": "320500"
			}, {
				"c": "320600",
				"n": "南通市",
				"pc": "320000"
			}, {
				"c": "320601",
				"n": "市辖区",
				"pc": "320600"
			}, {
				"c": "320602",
				"n": "崇川区",
				"pc": "320600"
			}, {
				"c": "320611",
				"n": "港闸区",
				"pc": "320600"
			}, {
				"c": "320612",
				"n": "通州区",
				"pc": "320600"
			}, {
				"c": "320621",
				"n": "海安县",
				"pc": "320600"
			}, {
				"c": "320623",
				"n": "如东县",
				"pc": "320600"
			}, {
				"c": "320681",
				"n": "启东市",
				"pc": "320600"
			}, {
				"c": "320682",
				"n": "如皋市",
				"pc": "320600"
			}, {
				"c": "320684",
				"n": "海门市",
				"pc": "320600"
			}, {
				"c": "320700",
				"n": "连云港市",
				"pc": "320000"
			}, {
				"c": "320701",
				"n": "市辖区",
				"pc": "320700"
			}, {
				"c": "320703",
				"n": "连云区",
				"pc": "320700"
			}, {
				"c": "320705",
				"n": "新浦区",
				"pc": "320700"
			}, {
				"c": "320706",
				"n": "海州区",
				"pc": "320700"
			}, {
				"c": "320721",
				"n": "赣榆县",
				"pc": "320700"
			}, {
				"c": "320722",
				"n": "东海县",
				"pc": "320700"
			}, {
				"c": "320723",
				"n": "灌云县",
				"pc": "320700"
			}, {
				"c": "320724",
				"n": "灌南县",
				"pc": "320700"
			}, {
				"c": "320800",
				"n": "淮安市",
				"pc": "320000"
			}, {
				"c": "320801",
				"n": "市辖区",
				"pc": "320800"
			}, {
				"c": "320802",
				"n": "清河区",
				"pc": "320800"
			}, {
				"c": "320803",
				"n": "淮安区",
				"pc": "320800"
			}, {
				"c": "320804",
				"n": "淮阴区",
				"pc": "320800"
			}, {
				"c": "320811",
				"n": "清浦区",
				"pc": "320800"
			}, {
				"c": "320826",
				"n": "涟水县",
				"pc": "320800"
			}, {
				"c": "320829",
				"n": "洪泽县",
				"pc": "320800"
			}, {
				"c": "320830",
				"n": "盱眙县",
				"pc": "320800"
			}, {
				"c": "320831",
				"n": "金湖县",
				"pc": "320800"
			}, {
				"c": "320900",
				"n": "盐城市",
				"pc": "320000"
			}, {
				"c": "320901",
				"n": "市辖区",
				"pc": "320900"
			}, {
				"c": "320902",
				"n": "亭湖区",
				"pc": "320900"
			}, {
				"c": "320903",
				"n": "盐都区",
				"pc": "320900"
			}, {
				"c": "320921",
				"n": "响水县",
				"pc": "320900"
			}, {
				"c": "320922",
				"n": "滨海县",
				"pc": "320900"
			}, {
				"c": "320923",
				"n": "阜宁县",
				"pc": "320900"
			}, {
				"c": "320924",
				"n": "射阳县",
				"pc": "320900"
			}, {
				"c": "320925",
				"n": "建湖县",
				"pc": "320900"
			}, {
				"c": "320981",
				"n": "东台市",
				"pc": "320900"
			}, {
				"c": "320982",
				"n": "大丰市",
				"pc": "320900"
			}, {
				"c": "321000",
				"n": "扬州市",
				"pc": "320000"
			}, {
				"c": "321001",
				"n": "市辖区",
				"pc": "321000"
			}, {
				"c": "321002",
				"n": "广陵区",
				"pc": "321000"
			}, {
				"c": "321003",
				"n": "邗江区",
				"pc": "321000"
			}, {
				"c": "321012",
				"n": "江都区",
				"pc": "321000"
			}, {
				"c": "321023",
				"n": "宝应县",
				"pc": "321000"
			}, {
				"c": "321081",
				"n": "仪征市",
				"pc": "321000"
			}, {
				"c": "321084",
				"n": "高邮市",
				"pc": "321000"
			}, {
				"c": "321100",
				"n": "镇江市",
				"pc": "320000"
			}, {
				"c": "321101",
				"n": "市辖区",
				"pc": "321100"
			}, {
				"c": "321102",
				"n": "京口区",
				"pc": "321100"
			}, {
				"c": "321111",
				"n": "润州区",
				"pc": "321100"
			}, {
				"c": "321112",
				"n": "丹徒区",
				"pc": "321100"
			}, {
				"c": "321181",
				"n": "丹阳市",
				"pc": "321100"
			}, {
				"c": "321182",
				"n": "扬中市",
				"pc": "321100"
			}, {
				"c": "321183",
				"n": "句容市",
				"pc": "321100"
			}, {
				"c": "321200",
				"n": "泰州市",
				"pc": "320000"
			}, {
				"c": "321201",
				"n": "市辖区",
				"pc": "321200"
			}, {
				"c": "321202",
				"n": "海陵区",
				"pc": "321200"
			}, {
				"c": "321203",
				"n": "高港区",
				"pc": "321200"
			}, {
				"c": "321281",
				"n": "兴化市",
				"pc": "321200"
			}, {
				"c": "321282",
				"n": "靖江市",
				"pc": "321200"
			}, {
				"c": "321283",
				"n": "泰兴市",
				"pc": "321200"
			}, {
				"c": "321284",
				"n": "姜堰市",
				"pc": "321200"
			}, {
				"c": "321300",
				"n": "宿迁市",
				"pc": "320000"
			}, {
				"c": "321301",
				"n": "市辖区",
				"pc": "321300"
			}, {
				"c": "321302",
				"n": "宿城区",
				"pc": "321300"
			}, {
				"c": "321311",
				"n": "宿豫区",
				"pc": "321300"
			}, {
				"c": "321322",
				"n": "沭阳县",
				"pc": "321300"
			}, {
				"c": "321323",
				"n": "泗阳县",
				"pc": "321300"
			}, {
				"c": "321324",
				"n": "泗洪县",
				"pc": "321300"
			}, {
				"c": "330000",
				"n": "浙江省",
				"pc": "86"
			}, {
				"c": "330100",
				"n": "杭州市",
				"pc": "330000"
			}, {
				"c": "330101",
				"n": "市辖区",
				"pc": "330100"
			}, {
				"c": "330102",
				"n": "上城区",
				"pc": "330100"
			}, {
				"c": "330103",
				"n": "下城区",
				"pc": "330100"
			}, {
				"c": "330104",
				"n": "江干区",
				"pc": "330100"
			}, {
				"c": "330105",
				"n": "拱墅区",
				"pc": "330100"
			}, {
				"c": "330106",
				"n": "西湖区",
				"pc": "330100"
			}, {
				"c": "330108",
				"n": "滨江区",
				"pc": "330100"
			}, {
				"c": "330109",
				"n": "萧山区",
				"pc": "330100"
			}, {
				"c": "330110",
				"n": "余杭区",
				"pc": "330100"
			}, {
				"c": "330122",
				"n": "桐庐县",
				"pc": "330100"
			}, {
				"c": "330127",
				"n": "淳安县",
				"pc": "330100"
			}, {
				"c": "330182",
				"n": "建德市",
				"pc": "330100"
			}, {
				"c": "330183",
				"n": "富阳市",
				"pc": "330100"
			}, {
				"c": "330185",
				"n": "临安市",
				"pc": "330100"
			}, {
				"c": "330200",
				"n": "宁波市",
				"pc": "330000"
			}, {
				"c": "330201",
				"n": "市辖区",
				"pc": "330200"
			}, {
				"c": "330203",
				"n": "海曙区",
				"pc": "330200"
			}, {
				"c": "330204",
				"n": "江东区",
				"pc": "330200"
			}, {
				"c": "330205",
				"n": "江北区",
				"pc": "330200"
			}, {
				"c": "330206",
				"n": "北仑区",
				"pc": "330200"
			}, {
				"c": "330211",
				"n": "镇海区",
				"pc": "330200"
			}, {
				"c": "330212",
				"n": "鄞州区",
				"pc": "330200"
			}, {
				"c": "330225",
				"n": "象山县",
				"pc": "330200"
			}, {
				"c": "330226",
				"n": "宁海县",
				"pc": "330200"
			}, {
				"c": "330281",
				"n": "余姚市",
				"pc": "330200"
			}, {
				"c": "330282",
				"n": "慈溪市",
				"pc": "330200"
			}, {
				"c": "330283",
				"n": "奉化市",
				"pc": "330200"
			}, {
				"c": "330300",
				"n": "温州市",
				"pc": "330000"
			}, {
				"c": "330301",
				"n": "市辖区",
				"pc": "330300"
			}, {
				"c": "330302",
				"n": "鹿城区",
				"pc": "330300"
			}, {
				"c": "330303",
				"n": "龙湾区",
				"pc": "330300"
			}, {
				"c": "330304",
				"n": "瓯海区",
				"pc": "330300"
			}, {
				"c": "330322",
				"n": "洞头县",
				"pc": "330300"
			}, {
				"c": "330324",
				"n": "永嘉县",
				"pc": "330300"
			}, {
				"c": "330326",
				"n": "平阳县",
				"pc": "330300"
			}, {
				"c": "330327",
				"n": "苍南县",
				"pc": "330300"
			}, {
				"c": "330328",
				"n": "文成县",
				"pc": "330300"
			}, {
				"c": "330329",
				"n": "泰顺县",
				"pc": "330300"
			}, {
				"c": "330381",
				"n": "瑞安市",
				"pc": "330300"
			}, {
				"c": "330382",
				"n": "乐清市",
				"pc": "330300"
			}, {
				"c": "330400",
				"n": "嘉兴市",
				"pc": "330000"
			}, {
				"c": "330401",
				"n": "市辖区",
				"pc": "330400"
			}, {
				"c": "330402",
				"n": "南湖区",
				"pc": "330400"
			}, {
				"c": "330411",
				"n": "秀洲区",
				"pc": "330400"
			}, {
				"c": "330421",
				"n": "嘉善县",
				"pc": "330400"
			}, {
				"c": "330424",
				"n": "海盐县",
				"pc": "330400"
			}, {
				"c": "330481",
				"n": "海宁市",
				"pc": "330400"
			}, {
				"c": "330482",
				"n": "平湖市",
				"pc": "330400"
			}, {
				"c": "330483",
				"n": "桐乡市",
				"pc": "330400"
			}, {
				"c": "330500",
				"n": "湖州市",
				"pc": "330000"
			}, {
				"c": "330501",
				"n": "市辖区",
				"pc": "330500"
			}, {
				"c": "330502",
				"n": "吴兴区",
				"pc": "330500"
			}, {
				"c": "330503",
				"n": "南浔区",
				"pc": "330500"
			}, {
				"c": "330521",
				"n": "德清县",
				"pc": "330500"
			}, {
				"c": "330522",
				"n": "长兴县",
				"pc": "330500"
			}, {
				"c": "330523",
				"n": "安吉县",
				"pc": "330500"
			}, {
				"c": "330600",
				"n": "绍兴市",
				"pc": "330000"
			}, {
				"c": "330601",
				"n": "市辖区",
				"pc": "330600"
			}, {
				"c": "330602",
				"n": "越城区",
				"pc": "330600"
			}, {
				"c": "330621",
				"n": "绍兴县",
				"pc": "330600"
			}, {
				"c": "330624",
				"n": "新昌县",
				"pc": "330600"
			}, {
				"c": "330681",
				"n": "诸暨市",
				"pc": "330600"
			}, {
				"c": "330682",
				"n": "上虞市",
				"pc": "330600"
			}, {
				"c": "330683",
				"n": "嵊州市",
				"pc": "330600"
			}, {
				"c": "330700",
				"n": "金华市",
				"pc": "330000"
			}, {
				"c": "330701",
				"n": "市辖区",
				"pc": "330700"
			}, {
				"c": "330702",
				"n": "婺城区",
				"pc": "330700"
			}, {
				"c": "330703",
				"n": "金东区",
				"pc": "330700"
			}, {
				"c": "330723",
				"n": "武义县",
				"pc": "330700"
			}, {
				"c": "330726",
				"n": "浦江县",
				"pc": "330700"
			}, {
				"c": "330727",
				"n": "磐安县",
				"pc": "330700"
			}, {
				"c": "330781",
				"n": "兰溪市",
				"pc": "330700"
			}, {
				"c": "330782",
				"n": "义乌市",
				"pc": "330700"
			}, {
				"c": "330783",
				"n": "东阳市",
				"pc": "330700"
			}, {
				"c": "330784",
				"n": "永康市",
				"pc": "330700"
			}, {
				"c": "330800",
				"n": "衢州市",
				"pc": "330000"
			}, {
				"c": "330801",
				"n": "市辖区",
				"pc": "330800"
			}, {
				"c": "330802",
				"n": "柯城区",
				"pc": "330800"
			}, {
				"c": "330803",
				"n": "衢江区",
				"pc": "330800"
			}, {
				"c": "330822",
				"n": "常山县",
				"pc": "330800"
			}, {
				"c": "330824",
				"n": "开化县",
				"pc": "330800"
			}, {
				"c": "330825",
				"n": "龙游县",
				"pc": "330800"
			}, {
				"c": "330881",
				"n": "江山市",
				"pc": "330800"
			}, {
				"c": "330900",
				"n": "舟山市",
				"pc": "330000"
			}, {
				"c": "330901",
				"n": "市辖区",
				"pc": "330900"
			}, {
				"c": "330902",
				"n": "定海区",
				"pc": "330900"
			}, {
				"c": "330903",
				"n": "普陀区",
				"pc": "330900"
			}, {
				"c": "330921",
				"n": "岱山县",
				"pc": "330900"
			}, {
				"c": "330922",
				"n": "嵊泗县",
				"pc": "330900"
			}, {
				"c": "331000",
				"n": "台州市",
				"pc": "330000"
			}, {
				"c": "331001",
				"n": "市辖区",
				"pc": "331000"
			}, {
				"c": "331002",
				"n": "椒江区",
				"pc": "331000"
			}, {
				"c": "331003",
				"n": "黄岩区",
				"pc": "331000"
			}, {
				"c": "331004",
				"n": "路桥区",
				"pc": "331000"
			}, {
				"c": "331021",
				"n": "玉环县",
				"pc": "331000"
			}, {
				"c": "331022",
				"n": "三门县",
				"pc": "331000"
			}, {
				"c": "331023",
				"n": "天台县",
				"pc": "331000"
			}, {
				"c": "331024",
				"n": "仙居县",
				"pc": "331000"
			}, {
				"c": "331081",
				"n": "温岭市",
				"pc": "331000"
			}, {
				"c": "331082",
				"n": "临海市",
				"pc": "331000"
			}, {
				"c": "331100",
				"n": "丽水市",
				"pc": "330000"
			}, {
				"c": "331101",
				"n": "市辖区",
				"pc": "331100"
			}, {
				"c": "331102",
				"n": "莲都区",
				"pc": "331100"
			}, {
				"c": "331121",
				"n": "青田县",
				"pc": "331100"
			}, {
				"c": "331122",
				"n": "缙云县",
				"pc": "331100"
			}, {
				"c": "331123",
				"n": "遂昌县",
				"pc": "331100"
			}, {
				"c": "331124",
				"n": "松阳县",
				"pc": "331100"
			}, {
				"c": "331125",
				"n": "云和县",
				"pc": "331100"
			}, {
				"c": "331126",
				"n": "庆元县",
				"pc": "331100"
			}, {
				"c": "331127",
				"n": "景宁畲族自治县",
				"pc": "331100"
			}, {
				"c": "331181",
				"n": "龙泉市",
				"pc": "331100"
			}, {
				"c": "340000",
				"n": "安徽省",
				"pc": "86"
			}, {
				"c": "340100",
				"n": "合肥市",
				"pc": "340000"
			}, {
				"c": "340101",
				"n": "市辖区",
				"pc": "340100"
			}, {
				"c": "340102",
				"n": "瑶海区",
				"pc": "340100"
			}, {
				"c": "340103",
				"n": "庐阳区",
				"pc": "340100"
			}, {
				"c": "340104",
				"n": "蜀山区",
				"pc": "340100"
			}, {
				"c": "340111",
				"n": "包河区",
				"pc": "340100"
			}, {
				"c": "340121",
				"n": "长丰县",
				"pc": "340100"
			}, {
				"c": "340122",
				"n": "肥东县",
				"pc": "340100"
			}, {
				"c": "340123",
				"n": "肥西县",
				"pc": "340100"
			}, {
				"c": "340124",
				"n": "庐江县",
				"pc": "340100"
			}, {
				"c": "340181",
				"n": "巢湖市",
				"pc": "340100"
			}, {
				"c": "340200",
				"n": "芜湖市",
				"pc": "340000"
			}, {
				"c": "340201",
				"n": "市辖区",
				"pc": "340200"
			}, {
				"c": "340202",
				"n": "镜湖区",
				"pc": "340200"
			}, {
				"c": "340203",
				"n": "弋江区",
				"pc": "340200"
			}, {
				"c": "340207",
				"n": "鸠江区",
				"pc": "340200"
			}, {
				"c": "340208",
				"n": "三山区",
				"pc": "340200"
			}, {
				"c": "340221",
				"n": "芜湖县",
				"pc": "340200"
			}, {
				"c": "340222",
				"n": "繁昌县",
				"pc": "340200"
			}, {
				"c": "340223",
				"n": "南陵县",
				"pc": "340200"
			}, {
				"c": "340225",
				"n": "无为县",
				"pc": "340200"
			}, {
				"c": "340300",
				"n": "蚌埠市",
				"pc": "340000"
			}, {
				"c": "340301",
				"n": "市辖区",
				"pc": "340300"
			}, {
				"c": "340302",
				"n": "龙子湖区",
				"pc": "340300"
			}, {
				"c": "340303",
				"n": "蚌山区",
				"pc": "340300"
			}, {
				"c": "340304",
				"n": "禹会区",
				"pc": "340300"
			}, {
				"c": "340311",
				"n": "淮上区",
				"pc": "340300"
			}, {
				"c": "340321",
				"n": "怀远县",
				"pc": "340300"
			}, {
				"c": "340322",
				"n": "五河县",
				"pc": "340300"
			}, {
				"c": "340323",
				"n": "固镇县",
				"pc": "340300"
			}, {
				"c": "340400",
				"n": "淮南市",
				"pc": "340000"
			}, {
				"c": "340401",
				"n": "市辖区",
				"pc": "340400"
			}, {
				"c": "340402",
				"n": "大通区",
				"pc": "340400"
			}, {
				"c": "340403",
				"n": "田家庵区",
				"pc": "340400"
			}, {
				"c": "340404",
				"n": "谢家集区",
				"pc": "340400"
			}, {
				"c": "340405",
				"n": "八公山区",
				"pc": "340400"
			}, {
				"c": "340406",
				"n": "潘集区",
				"pc": "340400"
			}, {
				"c": "340421",
				"n": "凤台县",
				"pc": "340400"
			}, {
				"c": "340500",
				"n": "马鞍山市",
				"pc": "340000"
			}, {
				"c": "340501",
				"n": "市辖区",
				"pc": "340500"
			}, {
				"c": "340503",
				"n": "花山区",
				"pc": "340500"
			}, {
				"c": "340504",
				"n": "雨山区",
				"pc": "340500"
			}, {
				"c": "340506",
				"n": "博望区",
				"pc": "340500"
			}, {
				"c": "340521",
				"n": "当涂县",
				"pc": "340500"
			}, {
				"c": "340522",
				"n": "含山县",
				"pc": "340500"
			}, {
				"c": "340523",
				"n": "和县",
				"pc": "340500"
			}, {
				"c": "340600",
				"n": "淮北市",
				"pc": "340000"
			}, {
				"c": "340601",
				"n": "市辖区",
				"pc": "340600"
			}, {
				"c": "340602",
				"n": "杜集区",
				"pc": "340600"
			}, {
				"c": "340603",
				"n": "相山区",
				"pc": "340600"
			}, {
				"c": "340604",
				"n": "烈山区",
				"pc": "340600"
			}, {
				"c": "340621",
				"n": "濉溪县",
				"pc": "340600"
			}, {
				"c": "340700",
				"n": "铜陵市",
				"pc": "340000"
			}, {
				"c": "340701",
				"n": "市辖区",
				"pc": "340700"
			}, {
				"c": "340702",
				"n": "铜官山区",
				"pc": "340700"
			}, {
				"c": "340703",
				"n": "狮子山区",
				"pc": "340700"
			}, {
				"c": "340711",
				"n": "郊区",
				"pc": "340700"
			}, {
				"c": "340721",
				"n": "铜陵县",
				"pc": "340700"
			}, {
				"c": "340800",
				"n": "安庆市",
				"pc": "340000"
			}, {
				"c": "340801",
				"n": "市辖区",
				"pc": "340800"
			}, {
				"c": "340802",
				"n": "迎江区",
				"pc": "340800"
			}, {
				"c": "340803",
				"n": "大观区",
				"pc": "340800"
			}, {
				"c": "340811",
				"n": "宜秀区",
				"pc": "340800"
			}, {
				"c": "340822",
				"n": "怀宁县",
				"pc": "340800"
			}, {
				"c": "340823",
				"n": "枞阳县",
				"pc": "340800"
			}, {
				"c": "340824",
				"n": "潜山县",
				"pc": "340800"
			}, {
				"c": "340825",
				"n": "太湖县",
				"pc": "340800"
			}, {
				"c": "340826",
				"n": "宿松县",
				"pc": "340800"
			}, {
				"c": "340827",
				"n": "望江县",
				"pc": "340800"
			}, {
				"c": "340828",
				"n": "岳西县",
				"pc": "340800"
			}, {
				"c": "340881",
				"n": "桐城市",
				"pc": "340800"
			}, {
				"c": "341000",
				"n": "黄山市",
				"pc": "340000"
			}, {
				"c": "341001",
				"n": "市辖区",
				"pc": "341000"
			}, {
				"c": "341002",
				"n": "屯溪区",
				"pc": "341000"
			}, {
				"c": "341003",
				"n": "黄山区o:p>",
				"pc": "341000"
			}, {
				"c": "341004",
				"n": "徽州区",
				"pc": "341000"
			}, {
				"c": "341021",
				"n": "歙县",
				"pc": "341000"
			}, {
				"c": "341022",
				"n": "休宁县",
				"pc": "341000"
			}, {
				"c": "341023",
				"n": "黟县",
				"pc": "341000"
			}, {
				"c": "341024",
				"n": "祁门县",
				"pc": "341000"
			}, {
				"c": "341100",
				"n": "滁州市",
				"pc": "340000"
			}, {
				"c": "341101",
				"n": "市辖区",
				"pc": "341100"
			}, {
				"c": "341102",
				"n": "琅琊区",
				"pc": "341100"
			}, {
				"c": "341103",
				"n": "南谯区",
				"pc": "341100"
			}, {
				"c": "341122",
				"n": "来安县",
				"pc": "341100"
			}, {
				"c": "341124",
				"n": "全椒县",
				"pc": "341100"
			}, {
				"c": "341125",
				"n": "定远县",
				"pc": "341100"
			}, {
				"c": "341126",
				"n": "凤阳县",
				"pc": "341100"
			}, {
				"c": "341181",
				"n": "天长市",
				"pc": "341100"
			}, {
				"c": "341182",
				"n": "明光市",
				"pc": "341100"
			}, {
				"c": "341200",
				"n": "阜阳市",
				"pc": "340000"
			}, {
				"c": "341201",
				"n": "市辖区",
				"pc": "341200"
			}, {
				"c": "341202",
				"n": "颍州区",
				"pc": "341200"
			}, {
				"c": "341203",
				"n": "颍东区",
				"pc": "341200"
			}, {
				"c": "341204",
				"n": "颍泉区",
				"pc": "341200"
			}, {
				"c": "341221",
				"n": "临泉县",
				"pc": "341200"
			}, {
				"c": "341222",
				"n": "太和县",
				"pc": "341200"
			}, {
				"c": "341225",
				"n": "阜南县",
				"pc": "341200"
			}, {
				"c": "341226",
				"n": "颍上县",
				"pc": "341200"
			}, {
				"c": "341282",
				"n": "界首市",
				"pc": "341200"
			}, {
				"c": "341300",
				"n": "宿州市",
				"pc": "340000"
			}, {
				"c": "341301",
				"n": "市辖区",
				"pc": "341300"
			}, {
				"c": "341302",
				"n": "埇桥区",
				"pc": "341300"
			}, {
				"c": "341321",
				"n": "砀山县",
				"pc": "341300"
			}, {
				"c": "341322",
				"n": "萧县",
				"pc": "341300"
			}, {
				"c": "341323",
				"n": "灵璧县",
				"pc": "341300"
			}, {
				"c": "341324",
				"n": "泗县",
				"pc": "341300"
			}, {
				"c": "341500",
				"n": "六安市",
				"pc": "340000"
			}, {
				"c": "341501",
				"n": "市辖区",
				"pc": "341500"
			}, {
				"c": "341502",
				"n": "金安区",
				"pc": "341500"
			}, {
				"c": "341503",
				"n": "裕安区",
				"pc": "341500"
			}, {
				"c": "341521",
				"n": "寿县",
				"pc": "341500"
			}, {
				"c": "341522",
				"n": "霍邱县",
				"pc": "341500"
			}, {
				"c": "341523",
				"n": "舒城县",
				"pc": "341500"
			}, {
				"c": "341524",
				"n": "金寨县",
				"pc": "341500"
			}, {
				"c": "341525",
				"n": "霍山县",
				"pc": "341500"
			}, {
				"c": "341600",
				"n": "亳州市",
				"pc": "340000"
			}, {
				"c": "341601",
				"n": "市辖区",
				"pc": "341600"
			}, {
				"c": "341602",
				"n": "谯城区",
				"pc": "341600"
			}, {
				"c": "341621",
				"n": "涡阳县",
				"pc": "341600"
			}, {
				"c": "341622",
				"n": "蒙城县",
				"pc": "341600"
			}, {
				"c": "341623",
				"n": "利辛县",
				"pc": "341600"
			}, {
				"c": "341700",
				"n": "池州市",
				"pc": "340000"
			}, {
				"c": "341701",
				"n": "市辖区",
				"pc": "341700"
			}, {
				"c": "341702",
				"n": "贵池区",
				"pc": "341700"
			}, {
				"c": "341721",
				"n": "东至县",
				"pc": "341700"
			}, {
				"c": "341722",
				"n": "石台县",
				"pc": "341700"
			}, {
				"c": "341723",
				"n": "青阳县",
				"pc": "341700"
			}, {
				"c": "341800",
				"n": "宣城市",
				"pc": "340000"
			}, {
				"c": "341801",
				"n": "市辖区",
				"pc": "341800"
			}, {
				"c": "341802",
				"n": "宣州区",
				"pc": "341800"
			}, {
				"c": "341821",
				"n": "郎溪县",
				"pc": "341800"
			}, {
				"c": "341822",
				"n": "广德县",
				"pc": "341800"
			}, {
				"c": "341823",
				"n": "泾县",
				"pc": "341800"
			}, {
				"c": "341824",
				"n": "绩溪县",
				"pc": "341800"
			}, {
				"c": "341825",
				"n": "旌德县",
				"pc": "341800"
			}, {
				"c": "341881",
				"n": "宁国市",
				"pc": "341800"
			}, {
				"c": "350000",
				"n": "福建省",
				"pc": "86"
			}, {
				"c": "350100",
				"n": "福州市",
				"pc": "350000"
			}, {
				"c": "350101",
				"n": "市辖区",
				"pc": "350100"
			}, {
				"c": "350102",
				"n": "鼓楼区",
				"pc": "350100"
			}, {
				"c": "350103",
				"n": "台江区",
				"pc": "350100"
			}, {
				"c": "350104",
				"n": "仓山区",
				"pc": "350100"
			}, {
				"c": "350105",
				"n": "马尾区",
				"pc": "350100"
			}, {
				"c": "350111",
				"n": "晋安区",
				"pc": "350100"
			}, {
				"c": "350121",
				"n": "闽侯县",
				"pc": "350100"
			}, {
				"c": "350122",
				"n": "连江县",
				"pc": "350100"
			}, {
				"c": "350123",
				"n": "罗源县",
				"pc": "350100"
			}, {
				"c": "350124",
				"n": "闽清县",
				"pc": "350100"
			}, {
				"c": "350125",
				"n": "永泰县",
				"pc": "350100"
			}, {
				"c": "350128",
				"n": "平潭县",
				"pc": "350100"
			}, {
				"c": "350181",
				"n": "福清市",
				"pc": "350100"
			}, {
				"c": "350182",
				"n": "长乐市",
				"pc": "350100"
			}, {
				"c": "350200",
				"n": "厦门市",
				"pc": "350000"
			}, {
				"c": "350201",
				"n": "市辖区",
				"pc": "350200"
			}, {
				"c": "350203",
				"n": "思明区",
				"pc": "350200"
			}, {
				"c": "350205",
				"n": "海沧区",
				"pc": "350200"
			}, {
				"c": "350206",
				"n": "湖里区",
				"pc": "350200"
			}, {
				"c": "350211",
				"n": "集美区",
				"pc": "350200"
			}, {
				"c": "350212",
				"n": "同安区",
				"pc": "350200"
			}, {
				"c": "350213",
				"n": "翔安区",
				"pc": "350200"
			}, {
				"c": "350300",
				"n": "莆田市",
				"pc": "350000"
			}, {
				"c": "350301",
				"n": "市辖区",
				"pc": "350300"
			}, {
				"c": "350302",
				"n": "城厢区",
				"pc": "350300"
			}, {
				"c": "350303",
				"n": "涵江区",
				"pc": "350300"
			}, {
				"c": "350304",
				"n": "荔城区",
				"pc": "350300"
			}, {
				"c": "350305",
				"n": "秀屿区",
				"pc": "350300"
			}, {
				"c": "350322",
				"n": "仙游县",
				"pc": "350300"
			}, {
				"c": "350400",
				"n": "三明市",
				"pc": "350000"
			}, {
				"c": "350401",
				"n": "市辖区",
				"pc": "350400"
			}, {
				"c": "350402",
				"n": "梅列区",
				"pc": "350400"
			}, {
				"c": "350403",
				"n": "三元区",
				"pc": "350400"
			}, {
				"c": "350421",
				"n": "明溪县",
				"pc": "350400"
			}, {
				"c": "350423",
				"n": "清流县",
				"pc": "350400"
			}, {
				"c": "350424",
				"n": "宁化县",
				"pc": "350400"
			}, {
				"c": "350425",
				"n": "大田县",
				"pc": "350400"
			}, {
				"c": "350426",
				"n": "尤溪县",
				"pc": "350400"
			}, {
				"c": "350427",
				"n": "沙县",
				"pc": "350400"
			}, {
				"c": "350428",
				"n": "将乐县",
				"pc": "350400"
			}, {
				"c": "350429",
				"n": "泰宁县",
				"pc": "350400"
			}, {
				"c": "350430",
				"n": "建宁县",
				"pc": "350400"
			}, {
				"c": "350481",
				"n": "永安市",
				"pc": "350400"
			}, {
				"c": "350500",
				"n": "泉州市",
				"pc": "350000"
			}, {
				"c": "350501",
				"n": "市辖区",
				"pc": "350500"
			}, {
				"c": "350502",
				"n": "鲤城区",
				"pc": "350500"
			}, {
				"c": "350503",
				"n": "丰泽区",
				"pc": "350500"
			}, {
				"c": "350504",
				"n": "洛江区",
				"pc": "350500"
			}, {
				"c": "350505",
				"n": "泉港区",
				"pc": "350500"
			}, {
				"c": "350521",
				"n": "惠安县",
				"pc": "350500"
			}, {
				"c": "350524",
				"n": "安溪县",
				"pc": "350500"
			}, {
				"c": "350525",
				"n": "永春县",
				"pc": "350500"
			}, {
				"c": "350526",
				"n": "德化县",
				"pc": "350500"
			}, {
				"c": "350527",
				"n": "金门县",
				"pc": "350500"
			}, {
				"c": "350581",
				"n": "石狮市",
				"pc": "350500"
			}, {
				"c": "350582",
				"n": "晋江市",
				"pc": "350500"
			}, {
				"c": "350583",
				"n": "南安市",
				"pc": "350500"
			}, {
				"c": "350600",
				"n": "漳州市",
				"pc": "350000"
			}, {
				"c": "350601",
				"n": "市辖区",
				"pc": "350600"
			}, {
				"c": "350602",
				"n": "芗城区",
				"pc": "350600"
			}, {
				"c": "350603",
				"n": "龙文区",
				"pc": "350600"
			}, {
				"c": "350622",
				"n": "云霄县",
				"pc": "350600"
			}, {
				"c": "350623",
				"n": "漳浦县",
				"pc": "350600"
			}, {
				"c": "350624",
				"n": "诏安县",
				"pc": "350600"
			}, {
				"c": "350625",
				"n": "长泰县",
				"pc": "350600"
			}, {
				"c": "350626",
				"n": "东山县",
				"pc": "350600"
			}, {
				"c": "350627",
				"n": "南靖县",
				"pc": "350600"
			}, {
				"c": "350628",
				"n": "平和县",
				"pc": "350600"
			}, {
				"c": "350629",
				"n": "华安县",
				"pc": "350600"
			}, {
				"c": "350681",
				"n": "龙海市",
				"pc": "350600"
			}, {
				"c": "350700",
				"n": "南平市",
				"pc": "350000"
			}, {
				"c": "350701",
				"n": "市辖区",
				"pc": "350700"
			}, {
				"c": "350702",
				"n": "延平区",
				"pc": "350700"
			}, {
				"c": "350721",
				"n": "顺昌县",
				"pc": "350700"
			}, {
				"c": "350722",
				"n": "浦城县",
				"pc": "350700"
			}, {
				"c": "350723",
				"n": "光泽县",
				"pc": "350700"
			}, {
				"c": "350724",
				"n": "松溪县",
				"pc": "350700"
			}, {
				"c": "350725",
				"n": "政和县",
				"pc": "350700"
			}, {
				"c": "350781",
				"n": "邵武市",
				"pc": "350700"
			}, {
				"c": "350782",
				"n": "武夷山市",
				"pc": "350700"
			}, {
				"c": "350783",
				"n": "建瓯市",
				"pc": "350700"
			}, {
				"c": "350784",
				"n": "建阳市",
				"pc": "350700"
			}, {
				"c": "350800",
				"n": "龙岩市",
				"pc": "350000"
			}, {
				"c": "350801",
				"n": "市辖区",
				"pc": "350800"
			}, {
				"c": "350802",
				"n": "新罗区",
				"pc": "350800"
			}, {
				"c": "350821",
				"n": "长汀县",
				"pc": "350800"
			}, {
				"c": "350822",
				"n": "永定县",
				"pc": "350800"
			}, {
				"c": "350823",
				"n": "上杭县",
				"pc": "350800"
			}, {
				"c": "350824",
				"n": "武平县",
				"pc": "350800"
			}, {
				"c": "350825",
				"n": "连城县",
				"pc": "350800"
			}, {
				"c": "350881",
				"n": "漳平市",
				"pc": "350800"
			}, {
				"c": "350900",
				"n": "宁德市",
				"pc": "350000"
			}, {
				"c": "350901",
				"n": "市辖区",
				"pc": "350900"
			}, {
				"c": "350902",
				"n": "蕉城区",
				"pc": "350900"
			}, {
				"c": "350921",
				"n": "霞浦县",
				"pc": "350900"
			}, {
				"c": "350922",
				"n": "古田县",
				"pc": "350900"
			}, {
				"c": "350923",
				"n": "屏南县",
				"pc": "350900"
			}, {
				"c": "350924",
				"n": "寿宁县",
				"pc": "350900"
			}, {
				"c": "350925",
				"n": "周宁县",
				"pc": "350900"
			}, {
				"c": "350926",
				"n": "柘荣县",
				"pc": "350900"
			}, {
				"c": "350981",
				"n": "福安市",
				"pc": "350900"
			}, {
				"c": "350982",
				"n": "福鼎市",
				"pc": "350900"
			}, {
				"c": "360000",
				"n": "江西省",
				"pc": "86"
			}, {
				"c": "360100",
				"n": "南昌市",
				"pc": "360000"
			}, {
				"c": "360101",
				"n": "市辖区",
				"pc": "360100"
			}, {
				"c": "360102",
				"n": "东湖区",
				"pc": "360100"
			}, {
				"c": "360103",
				"n": "西湖区",
				"pc": "360100"
			}, {
				"c": "360104",
				"n": "青云谱区",
				"pc": "360100"
			}, {
				"c": "360105",
				"n": "湾里区",
				"pc": "360100"
			}, {
				"c": "360111",
				"n": "青山湖区",
				"pc": "360100"
			}, {
				"c": "360121",
				"n": "南昌县",
				"pc": "360100"
			}, {
				"c": "360122",
				"n": "新建县",
				"pc": "360100"
			}, {
				"c": "360123",
				"n": "安义县",
				"pc": "360100"
			}, {
				"c": "360124",
				"n": "进贤县",
				"pc": "360100"
			}, {
				"c": "360200",
				"n": "景德镇市",
				"pc": "360000"
			}, {
				"c": "360201",
				"n": "市辖区",
				"pc": "360200"
			}, {
				"c": "360202",
				"n": "昌江区",
				"pc": "360200"
			}, {
				"c": "360203",
				"n": "珠山区",
				"pc": "360200"
			}, {
				"c": "360222",
				"n": "浮梁县",
				"pc": "360200"
			}, {
				"c": "360281",
				"n": "乐平市",
				"pc": "360200"
			}, {
				"c": "360300",
				"n": "萍乡市",
				"pc": "360000"
			}, {
				"c": "360301",
				"n": "市辖区",
				"pc": "360300"
			}, {
				"c": "360302",
				"n": "安源区",
				"pc": "360300"
			}, {
				"c": "360313",
				"n": "湘东区",
				"pc": "360300"
			}, {
				"c": "360321",
				"n": "莲花县",
				"pc": "360300"
			}, {
				"c": "360322",
				"n": "上栗县",
				"pc": "360300"
			}, {
				"c": "360323",
				"n": "芦溪县",
				"pc": "360300"
			}, {
				"c": "360400",
				"n": "九江市",
				"pc": "360000"
			}, {
				"c": "360401",
				"n": "市辖区",
				"pc": "360400"
			}, {
				"c": "360402",
				"n": "庐山区",
				"pc": "360400"
			}, {
				"c": "360403",
				"n": "浔阳区",
				"pc": "360400"
			}, {
				"c": "360421",
				"n": "九江县",
				"pc": "360400"
			}, {
				"c": "360423",
				"n": "武宁县",
				"pc": "360400"
			}, {
				"c": "360424",
				"n": "修水县",
				"pc": "360400"
			}, {
				"c": "360425",
				"n": "永修县",
				"pc": "360400"
			}, {
				"c": "360426",
				"n": "德安县",
				"pc": "360400"
			}, {
				"c": "360427",
				"n": "星子县",
				"pc": "360400"
			}, {
				"c": "360428",
				"n": "都昌县",
				"pc": "360400"
			}, {
				"c": "360429",
				"n": "湖口县",
				"pc": "360400"
			}, {
				"c": "360430",
				"n": "彭泽县",
				"pc": "360400"
			}, {
				"c": "360481",
				"n": "瑞昌市",
				"pc": "360400"
			}, {
				"c": "360482",
				"n": "共青城市",
				"pc": "360400"
			}, {
				"c": "360500",
				"n": "新余市",
				"pc": "360000"
			}, {
				"c": "360501",
				"n": "市辖区",
				"pc": "360500"
			}, {
				"c": "360502",
				"n": "渝水区",
				"pc": "360500"
			}, {
				"c": "360521",
				"n": "分宜县",
				"pc": "360500"
			}, {
				"c": "360600",
				"n": "鹰潭市",
				"pc": "360000"
			}, {
				"c": "360601",
				"n": "市辖区",
				"pc": "360600"
			}, {
				"c": "360602",
				"n": "月湖区",
				"pc": "360600"
			}, {
				"c": "360622",
				"n": "余江县",
				"pc": "360600"
			}, {
				"c": "360681",
				"n": "贵溪市",
				"pc": "360600"
			}, {
				"c": "360700",
				"n": "赣州市",
				"pc": "360000"
			}, {
				"c": "360701",
				"n": "市辖区",
				"pc": "360700"
			}, {
				"c": "360702",
				"n": "章贡区",
				"pc": "360700"
			}, {
				"c": "360721",
				"n": "赣县",
				"pc": "360700"
			}, {
				"c": "360722",
				"n": "信丰县",
				"pc": "360700"
			}, {
				"c": "360723",
				"n": "大余县",
				"pc": "360700"
			}, {
				"c": "360724",
				"n": "上犹县",
				"pc": "360700"
			}, {
				"c": "360725",
				"n": "崇义县",
				"pc": "360700"
			}, {
				"c": "360726",
				"n": "安远县",
				"pc": "360700"
			}, {
				"c": "360727",
				"n": "龙南县",
				"pc": "360700"
			}, {
				"c": "360728",
				"n": "定南县",
				"pc": "360700"
			}, {
				"c": "360729",
				"n": "全南县",
				"pc": "360700"
			}, {
				"c": "360730",
				"n": "宁都县",
				"pc": "360700"
			}, {
				"c": "360731",
				"n": "于都县",
				"pc": "360700"
			}, {
				"c": "360732",
				"n": "兴国县",
				"pc": "360700"
			}, {
				"c": "360733",
				"n": "会昌县",
				"pc": "360700"
			}, {
				"c": "360734",
				"n": "寻乌县",
				"pc": "360700"
			}, {
				"c": "360735",
				"n": "石城县",
				"pc": "360700"
			}, {
				"c": "360781",
				"n": "瑞金市",
				"pc": "360700"
			}, {
				"c": "360782",
				"n": "南康市",
				"pc": "360700"
			}, {
				"c": "360800",
				"n": "吉安市",
				"pc": "360000"
			}, {
				"c": "360801",
				"n": "市辖区",
				"pc": "360800"
			}, {
				"c": "360802",
				"n": "吉州区",
				"pc": "360800"
			}, {
				"c": "360803",
				"n": "青原区",
				"pc": "360800"
			}, {
				"c": "360821",
				"n": "吉安县",
				"pc": "360800"
			}, {
				"c": "360822",
				"n": "吉水县",
				"pc": "360800"
			}, {
				"c": "360823",
				"n": "峡江县",
				"pc": "360800"
			}, {
				"c": "360824",
				"n": "新干县",
				"pc": "360800"
			}, {
				"c": "360825",
				"n": "永丰县",
				"pc": "360800"
			}, {
				"c": "360826",
				"n": "泰和县",
				"pc": "360800"
			}, {
				"c": "360827",
				"n": "遂川县",
				"pc": "360800"
			}, {
				"c": "360828",
				"n": "万安县",
				"pc": "360800"
			}, {
				"c": "360829",
				"n": "安福县",
				"pc": "360800"
			}, {
				"c": "360830",
				"n": "永新县",
				"pc": "360800"
			}, {
				"c": "360881",
				"n": "井冈山市",
				"pc": "360800"
			}, {
				"c": "360900",
				"n": "宜春市",
				"pc": "360000"
			}, {
				"c": "360901",
				"n": "市辖区",
				"pc": "360900"
			}, {
				"c": "360902",
				"n": "袁州区",
				"pc": "360900"
			}, {
				"c": "360921",
				"n": "奉新县",
				"pc": "360900"
			}, {
				"c": "360922",
				"n": "万载县",
				"pc": "360900"
			}, {
				"c": "360923",
				"n": "上高县",
				"pc": "360900"
			}, {
				"c": "360924",
				"n": "宜丰县",
				"pc": "360900"
			}, {
				"c": "360925",
				"n": "靖安县",
				"pc": "360900"
			}, {
				"c": "360926",
				"n": "铜鼓县",
				"pc": "360900"
			}, {
				"c": "360981",
				"n": "丰城市",
				"pc": "360900"
			}, {
				"c": "360982",
				"n": "樟树市",
				"pc": "360900"
			}, {
				"c": "360983",
				"n": "高安市",
				"pc": "360900"
			}, {
				"c": "361000",
				"n": "抚州市",
				"pc": "360000"
			}, {
				"c": "361001",
				"n": "市辖区",
				"pc": "361000"
			}, {
				"c": "361002",
				"n": "临川区",
				"pc": "361000"
			}, {
				"c": "361021",
				"n": "南城县",
				"pc": "361000"
			}, {
				"c": "361022",
				"n": "黎川县",
				"pc": "361000"
			}, {
				"c": "361023",
				"n": "南丰县",
				"pc": "361000"
			}, {
				"c": "361024",
				"n": "崇仁县",
				"pc": "361000"
			}, {
				"c": "361025",
				"n": "乐安县",
				"pc": "361000"
			}, {
				"c": "361026",
				"n": "宜黄县",
				"pc": "361000"
			}, {
				"c": "361027",
				"n": "金溪县",
				"pc": "361000"
			}, {
				"c": "361028",
				"n": "资溪县",
				"pc": "361000"
			}, {
				"c": "361029",
				"n": "东乡县",
				"pc": "361000"
			}, {
				"c": "361030",
				"n": "广昌县",
				"pc": "361000"
			}, {
				"c": "361100",
				"n": "上饶市",
				"pc": "360000"
			}, {
				"c": "361101",
				"n": "市辖区",
				"pc": "361100"
			}, {
				"c": "361102",
				"n": "信州区",
				"pc": "361100"
			}, {
				"c": "361121",
				"n": "上饶县",
				"pc": "361100"
			}, {
				"c": "361122",
				"n": "广丰县",
				"pc": "361100"
			}, {
				"c": "361123",
				"n": "玉山县",
				"pc": "361100"
			}, {
				"c": "361124",
				"n": "铅山县",
				"pc": "361100"
			}, {
				"c": "361125",
				"n": "横峰县",
				"pc": "361100"
			}, {
				"c": "361126",
				"n": "弋阳县",
				"pc": "361100"
			}, {
				"c": "361127",
				"n": "余干县",
				"pc": "361100"
			}, {
				"c": "361128",
				"n": "鄱阳县",
				"pc": "361100"
			}, {
				"c": "361129",
				"n": "万年县",
				"pc": "361100"
			}, {
				"c": "361130",
				"n": "婺源县",
				"pc": "361100"
			}, {
				"c": "361181",
				"n": "德兴市",
				"pc": "361100"
			}, {
				"c": "370000",
				"n": "山东省",
				"pc": "86"
			}, {
				"c": "370100",
				"n": "济南市",
				"pc": "370000"
			}, {
				"c": "370101",
				"n": "市辖区",
				"pc": "370100"
			}, {
				"c": "370102",
				"n": "历下区",
				"pc": "370100"
			}, {
				"c": "370103",
				"n": "市中区",
				"pc": "370100"
			}, {
				"c": "370104",
				"n": "槐荫区",
				"pc": "370100"
			}, {
				"c": "370105",
				"n": "天桥区",
				"pc": "370100"
			}, {
				"c": "370112",
				"n": "历城区",
				"pc": "370100"
			}, {
				"c": "370113",
				"n": "长清区",
				"pc": "370100"
			}, {
				"c": "370124",
				"n": "平阴县",
				"pc": "370100"
			}, {
				"c": "370125",
				"n": "济阳县",
				"pc": "370100"
			}, {
				"c": "370126",
				"n": "商河县",
				"pc": "370100"
			}, {
				"c": "370181",
				"n": "章丘市",
				"pc": "370100"
			}, {
				"c": "370200",
				"n": "青岛市",
				"pc": "370000"
			}, {
				"c": "370201",
				"n": "市辖区",
				"pc": "370200"
			}, {
				"c": "370202",
				"n": "市南区",
				"pc": "370200"
			}, {
				"c": "370203",
				"n": "市北区",
				"pc": "370200"
			}, {
				"c": "370205",
				"n": "四方区",
				"pc": "370200"
			}, {
				"c": "370211",
				"n": "黄岛区",
				"pc": "370200"
			}, {
				"c": "370212",
				"n": "崂山区",
				"pc": "370200"
			}, {
				"c": "370213",
				"n": "李沧区",
				"pc": "370200"
			}, {
				"c": "370214",
				"n": "城阳区",
				"pc": "370200"
			}, {
				"c": "370281",
				"n": "胶州市",
				"pc": "370200"
			}, {
				"c": "370282",
				"n": "即墨市",
				"pc": "370200"
			}, {
				"c": "370283",
				"n": "平度市",
				"pc": "370200"
			}, {
				"c": "370284",
				"n": "胶南市",
				"pc": "370200"
			}, {
				"c": "370285",
				"n": "莱西市",
				"pc": "370200"
			}, {
				"c": "370300",
				"n": "淄博市",
				"pc": "370000"
			}, {
				"c": "370301",
				"n": "市辖区",
				"pc": "370300"
			}, {
				"c": "370302",
				"n": "淄川区",
				"pc": "370300"
			}, {
				"c": "370303",
				"n": "张店区",
				"pc": "370300"
			}, {
				"c": "370304",
				"n": "博山区",
				"pc": "370300"
			}, {
				"c": "370305",
				"n": "临淄区",
				"pc": "370300"
			}, {
				"c": "370306",
				"n": "周村区",
				"pc": "370300"
			}, {
				"c": "370321",
				"n": "桓台县",
				"pc": "370300"
			}, {
				"c": "370322",
				"n": "高青县",
				"pc": "370300"
			}, {
				"c": "370323",
				"n": "沂源县",
				"pc": "370300"
			}, {
				"c": "370400",
				"n": "枣庄市",
				"pc": "370000"
			}, {
				"c": "370401",
				"n": "市辖区",
				"pc": "370400"
			}, {
				"c": "370402",
				"n": "市中区",
				"pc": "370400"
			}, {
				"c": "370403",
				"n": "薛城区",
				"pc": "370400"
			}, {
				"c": "370404",
				"n": "峄城区",
				"pc": "370400"
			}, {
				"c": "370405",
				"n": "台儿庄区",
				"pc": "370400"
			}, {
				"c": "370406",
				"n": "山亭区",
				"pc": "370400"
			}, {
				"c": "370481",
				"n": "滕州市",
				"pc": "370400"
			}, {
				"c": "370500",
				"n": "东营市",
				"pc": "370000"
			}, {
				"c": "370501",
				"n": "市辖区",
				"pc": "370500"
			}, {
				"c": "370502",
				"n": "东营区",
				"pc": "370500"
			}, {
				"c": "370503",
				"n": "河口区",
				"pc": "370500"
			}, {
				"c": "370521",
				"n": "垦利县",
				"pc": "370500"
			}, {
				"c": "370522",
				"n": "利津县",
				"pc": "370500"
			}, {
				"c": "370523",
				"n": "广饶县",
				"pc": "370500"
			}, {
				"c": "370600",
				"n": "烟台市",
				"pc": "370000"
			}, {
				"c": "370601",
				"n": "市辖区",
				"pc": "370600"
			}, {
				"c": "370602",
				"n": "芝罘区",
				"pc": "370600"
			}, {
				"c": "370611",
				"n": "福山区",
				"pc": "370600"
			}, {
				"c": "370612",
				"n": "牟平区",
				"pc": "370600"
			}, {
				"c": "370613",
				"n": "莱山区",
				"pc": "370600"
			}, {
				"c": "370634",
				"n": "长岛县",
				"pc": "370600"
			}, {
				"c": "370681",
				"n": "龙口市",
				"pc": "370600"
			}, {
				"c": "370682",
				"n": "莱阳市",
				"pc": "370600"
			}, {
				"c": "370683",
				"n": "莱州市",
				"pc": "370600"
			}, {
				"c": "370684",
				"n": "蓬莱市",
				"pc": "370600"
			}, {
				"c": "370685",
				"n": "招远市",
				"pc": "370600"
			}, {
				"c": "3706",
				"n": "栖霞市",
				"pc": "370600"
			}, {
				"c": "370687",
				"n": "海阳市",
				"pc": "370600"
			}, {
				"c": "370700",
				"n": "潍坊市",
				"pc": "370000"
			}, {
				"c": "370701",
				"n": "市辖区",
				"pc": "370700"
			}, {
				"c": "370702",
				"n": "潍城区",
				"pc": "370700"
			}, {
				"c": "370703",
				"n": "寒亭区",
				"pc": "370700"
			}, {
				"c": "370704",
				"n": "坊子区",
				"pc": "370700"
			}, {
				"c": "370705",
				"n": "奎文区",
				"pc": "370700"
			}, {
				"c": "370724",
				"n": "临朐县",
				"pc": "370700"
			}, {
				"c": "370725",
				"n": "昌乐县",
				"pc": "370700"
			}, {
				"c": "370781",
				"n": "青州市",
				"pc": "370700"
			}, {
				"c": "370782",
				"n": "诸城市",
				"pc": "370700"
			}, {
				"c": "370783",
				"n": "寿光市",
				"pc": "370700"
			}, {
				"c": "370784",
				"n": "安丘市",
				"pc": "370700"
			}, {
				"c": "370785",
				"n": "高密市",
				"pc": "370700"
			}, {
				"c": "3707",
				"n": "昌邑市",
				"pc": "370700"
			}, {
				"c": "370800",
				"n": "济宁市",
				"pc": "370000"
			}, {
				"c": "370801",
				"n": "市辖区",
				"pc": "370800"
			}, {
				"c": "370802",
				"n": "市中区",
				"pc": "370800"
			}, {
				"c": "370811",
				"n": "任城区",
				"pc": "370800"
			}, {
				"c": "370826",
				"n": "微山县",
				"pc": "370800"
			}, {
				"c": "370827",
				"n": "鱼台县",
				"pc": "370800"
			}, {
				"c": "370828",
				"n": "金乡县",
				"pc": "370800"
			}, {
				"c": "370829",
				"n": "嘉祥县",
				"pc": "370800"
			}, {
				"c": "370830",
				"n": "汶上县",
				"pc": "370800"
			}, {
				"c": "370831",
				"n": "泗水县",
				"pc": "370800"
			}, {
				"c": "370832",
				"n": "梁山县",
				"pc": "370800"
			}, {
				"c": "370881",
				"n": "曲阜市",
				"pc": "370800"
			}, {
				"c": "370882",
				"n": "兖州市",
				"pc": "370800"
			}, {
				"c": "370883",
				"n": "邹城市",
				"pc": "370800"
			}, {
				"c": "370900",
				"n": "泰安市",
				"pc": "370000"
			}, {
				"c": "370901",
				"n": "市辖区",
				"pc": "370900"
			}, {
				"c": "370902",
				"n": "泰山区",
				"pc": "370900"
			}, {
				"c": "370911",
				"n": "岱岳区",
				"pc": "370900"
			}, {
				"c": "370921",
				"n": "宁阳县",
				"pc": "370900"
			}, {
				"c": "370923",
				"n": "东平县",
				"pc": "370900"
			}, {
				"c": "370982",
				"n": "新泰市",
				"pc": "370900"
			}, {
				"c": "370983",
				"n": "肥城市",
				"pc": "370900"
			}, {
				"c": "371000",
				"n": "威海市",
				"pc": "370000"
			}, {
				"c": "371001",
				"n": "市辖区",
				"pc": "371000"
			}, {
				"c": "371002",
				"n": "环翠区",
				"pc": "371000"
			}, {
				"c": "371081",
				"n": "文登市",
				"pc": "371000"
			}, {
				"c": "371082",
				"n": "荣成市",
				"pc": "371000"
			}, {
				"c": "371083",
				"n": "乳山市",
				"pc": "371000"
			}, {
				"c": "371100",
				"n": "日照市",
				"pc": "370000"
			}, {
				"c": "371101",
				"n": "市辖区",
				"pc": "371100"
			}, {
				"c": "371102",
				"n": "东港区",
				"pc": "371100"
			}, {
				"c": "371103",
				"n": "岚山区",
				"pc": "371100"
			}, {
				"c": "371121",
				"n": "五莲县",
				"pc": "371100"
			}, {
				"c": "371122",
				"n": "莒县",
				"pc": "371100"
			}, {
				"c": "371200",
				"n": "莱芜市",
				"pc": "370000"
			}, {
				"c": "371201",
				"n": "市辖区",
				"pc": "371200"
			}, {
				"c": "371202",
				"n": "莱城区",
				"pc": "371200"
			}, {
				"c": "371203",
				"n": "钢城区",
				"pc": "371200"
			}, {
				"c": "371300",
				"n": "临沂市",
				"pc": "370000"
			}, {
				"c": "371301",
				"n": "市辖区",
				"pc": "371300"
			}, {
				"c": "371302",
				"n": "兰山区",
				"pc": "371300"
			}, {
				"c": "371311",
				"n": "罗庄区",
				"pc": "371300"
			}, {
				"c": "371312",
				"n": "河东区",
				"pc": "371300"
			}, {
				"c": "371321",
				"n": "沂南县",
				"pc": "371300"
			}, {
				"c": "371322",
				"n": "郯城县",
				"pc": "371300"
			}, {
				"c": "371323",
				"n": "沂水县",
				"pc": "371300"
			}, {
				"c": "371324",
				"n": "苍山县",
				"pc": "371300"
			}, {
				"c": "371325",
				"n": "费县",
				"pc": "371300"
			}, {
				"c": "371326",
				"n": "平邑县",
				"pc": "371300"
			}, {
				"c": "371327",
				"n": "莒南县",
				"pc": "371300"
			}, {
				"c": "371328",
				"n": "蒙阴县",
				"pc": "371300"
			}, {
				"c": "371329",
				"n": "临沭县",
				"pc": "371300"
			}, {
				"c": "371400",
				"n": "德州市",
				"pc": "370000"
			}, {
				"c": "371401",
				"n": "市辖区",
				"pc": "371400"
			}, {
				"c": "371402",
				"n": "德城区",
				"pc": "371400"
			}, {
				"c": "371421",
				"n": "陵县",
				"pc": "371400"
			}, {
				"c": "371422",
				"n": "宁津县",
				"pc": "371400"
			}, {
				"c": "371423",
				"n": "庆云县",
				"pc": "371400"
			}, {
				"c": "371424",
				"n": "临邑县",
				"pc": "371400"
			}, {
				"c": "371425",
				"n": "齐河县",
				"pc": "371400"
			}, {
				"c": "371426",
				"n": "平原县",
				"pc": "371400"
			}, {
				"c": "371427",
				"n": "夏津县",
				"pc": "371400"
			}, {
				"c": "371428",
				"n": "武城县",
				"pc": "371400"
			}, {
				"c": "371481",
				"n": "乐陵市",
				"pc": "371400"
			}, {
				"c": "371482",
				"n": "禹城市",
				"pc": "371400"
			}, {
				"c": "371500",
				"n": "聊城市",
				"pc": "370000"
			}, {
				"c": "371501",
				"n": "市辖区",
				"pc": "371500"
			}, {
				"c": "371502",
				"n": "东昌府区",
				"pc": "371500"
			}, {
				"c": "371521",
				"n": "阳谷县",
				"pc": "371500"
			}, {
				"c": "371522",
				"n": "莘县",
				"pc": "371500"
			}, {
				"c": "371523",
				"n": "茌平县",
				"pc": "371500"
			}, {
				"c": "371524",
				"n": "东阿县",
				"pc": "371500"
			}, {
				"c": "371525",
				"n": "冠县",
				"pc": "371500"
			}, {
				"c": "371526",
				"n": "高唐县",
				"pc": "371500"
			}, {
				"c": "371581",
				"n": "临清市",
				"pc": "371500"
			}, {
				"c": "371600",
				"n": "滨州市",
				"pc": "370000"
			}, {
				"c": "371601",
				"n": "市辖区",
				"pc": "371600"
			}, {
				"c": "371602",
				"n": "滨城区",
				"pc": "371600"
			}, {
				"c": "371621",
				"n": "惠民县",
				"pc": "371600"
			}, {
				"c": "371622",
				"n": "阳信县",
				"pc": "371600"
			}, {
				"c": "371623",
				"n": "无棣县",
				"pc": "371600"
			}, {
				"c": "371624",
				"n": "沾化县",
				"pc": "371600"
			}, {
				"c": "371625",
				"n": "博兴县",
				"pc": "371600"
			}, {
				"c": "371626",
				"n": "邹平县",
				"pc": "371600"
			}, {
				"c": "371700",
				"n": "菏泽市",
				"pc": "370000"
			}, {
				"c": "371701",
				"n": "市辖区",
				"pc": "371700"
			}, {
				"c": "371702",
				"n": "牡丹区",
				"pc": "371700"
			}, {
				"c": "371721",
				"n": "曹县",
				"pc": "371700"
			}, {
				"c": "371722",
				"n": "单县",
				"pc": "371700"
			}, {
				"c": "371723",
				"n": "成武县",
				"pc": "371700"
			}, {
				"c": "371724",
				"n": "巨野县",
				"pc": "371700"
			}, {
				"c": "371725",
				"n": "郓城县",
				"pc": "371700"
			}, {
				"c": "371726",
				"n": "鄄城县",
				"pc": "371700"
			}, {
				"c": "371727",
				"n": "定陶县",
				"pc": "371700"
			}, {
				"c": "371728",
				"n": "东明县",
				"pc": "371700"
			}, {
				"c": "410000",
				"n": "河南省",
				"pc": "86"
			}, {
				"c": "410100",
				"n": "郑州市",
				"pc": "410000"
			}, {
				"c": "410101",
				"n": "市辖区",
				"pc": "410100"
			}, {
				"c": "410102",
				"n": "中原区",
				"pc": "410100"
			}, {
				"c": "410103",
				"n": "二七区",
				"pc": "410100"
			}, {
				"c": "410104",
				"n": "管城回族区",
				"pc": "410100"
			}, {
				"c": "410105",
				"n": "金水区",
				"pc": "410100"
			}, {
				"c": "410106",
				"n": "上街区",
				"pc": "410100"
			}, {
				"c": "410108",
				"n": "惠济区",
				"pc": "410100"
			}, {
				"c": "410122",
				"n": "中牟县",
				"pc": "410100"
			}, {
				"c": "410181",
				"n": "巩义市",
				"pc": "410100"
			}, {
				"c": "410182",
				"n": "荥阳市",
				"pc": "410100"
			}, {
				"c": "410183",
				"n": "新密市",
				"pc": "410100"
			}, {
				"c": "410184",
				"n": "新郑市",
				"pc": "410100"
			}, {
				"c": "410185",
				"n": "登封市",
				"pc": "410100"
			}, {
				"c": "410200",
				"n": "开封市",
				"pc": "410000"
			}, {
				"c": "410201",
				"n": "市辖区",
				"pc": "410200"
			}, {
				"c": "410202",
				"n": "龙亭区",
				"pc": "410200"
			}, {
				"c": "410203",
				"n": "顺河回族区",
				"pc": "410200"
			}, {
				"c": "410204",
				"n": "鼓楼区",
				"pc": "410200"
			}, {
				"c": "410205",
				"n": "禹王台区",
				"pc": "410200"
			}, {
				"c": "410211",
				"n": "金明区",
				"pc": "410200"
			}, {
				"c": "410221",
				"n": "杞县",
				"pc": "410200"
			}, {
				"c": "410222",
				"n": "通许县",
				"pc": "410200"
			}, {
				"c": "410223",
				"n": "尉氏县",
				"pc": "410200"
			}, {
				"c": "410224",
				"n": "开封县",
				"pc": "410200"
			}, {
				"c": "410225",
				"n": "兰考县",
				"pc": "410200"
			}, {
				"c": "410300",
				"n": "洛阳市",
				"pc": "410000"
			}, {
				"c": "410301",
				"n": "市辖区",
				"pc": "410300"
			}, {
				"c": "410302",
				"n": "老城区",
				"pc": "410300"
			}, {
				"c": "410303",
				"n": "西工区",
				"pc": "410300"
			}, {
				"c": "410304",
				"n": "瀍河回族区",
				"pc": "410300"
			}, {
				"c": "410305",
				"n": "涧西区",
				"pc": "410300"
			}, {
				"c": "410306",
				"n": "吉利区",
				"pc": "410300"
			}, {
				"c": "410311",
				"n": "洛龙区",
				"pc": "410300"
			}, {
				"c": "410322",
				"n": "孟津县",
				"pc": "410300"
			}, {
				"c": "410323",
				"n": "新安县",
				"pc": "410300"
			}, {
				"c": "410324",
				"n": "栾川县",
				"pc": "410300"
			}, {
				"c": "410325",
				"n": "嵩县",
				"pc": "410300"
			}, {
				"c": "410326",
				"n": "汝阳县",
				"pc": "410300"
			}, {
				"c": "410327",
				"n": "宜阳县",
				"pc": "410300"
			}, {
				"c": "410328",
				"n": "洛宁县",
				"pc": "410300"
			}, {
				"c": "410329",
				"n": "伊川县",
				"pc": "410300"
			}, {
				"c": "410381",
				"n": "偃师市",
				"pc": "410300"
			}, {
				"c": "410400",
				"n": "平顶山市",
				"pc": "410000"
			}, {
				"c": "410401",
				"n": "市辖区",
				"pc": "410400"
			}, {
				"c": "410402",
				"n": "新华区",
				"pc": "410400"
			}, {
				"c": "410403",
				"n": "卫东区",
				"pc": "410400"
			}, {
				"c": "410404",
				"n": "石龙区",
				"pc": "410400"
			}, {
				"c": "410411",
				"n": "湛河区",
				"pc": "410400"
			}, {
				"c": "410421",
				"n": "宝丰县",
				"pc": "410400"
			}, {
				"c": "410422",
				"n": "叶县",
				"pc": "410400"
			}, {
				"c": "410423",
				"n": "鲁山县",
				"pc": "410400"
			}, {
				"c": "410425",
				"n": "郏县",
				"pc": "410400"
			}, {
				"c": "410481",
				"n": "舞钢市",
				"pc": "410400"
			}, {
				"c": "410482",
				"n": "汝州市",
				"pc": "410400"
			}, {
				"c": "410500",
				"n": "安阳市",
				"pc": "410000"
			}, {
				"c": "410501",
				"n": "市辖区",
				"pc": "410500"
			}, {
				"c": "410502",
				"n": "文峰区",
				"pc": "410500"
			}, {
				"c": "410503",
				"n": "北关区",
				"pc": "410500"
			}, {
				"c": "410505",
				"n": "殷都区",
				"pc": "410500"
			}, {
				"c": "410506",
				"n": "龙安区",
				"pc": "410500"
			}, {
				"c": "410522",
				"n": "安阳县",
				"pc": "410500"
			}, {
				"c": "410523",
				"n": "汤阴县",
				"pc": "410500"
			}, {
				"c": "410526",
				"n": "滑县",
				"pc": "410500"
			}, {
				"c": "410527",
				"n": "内黄县",
				"pc": "410500"
			}, {
				"c": "410581",
				"n": "林州市",
				"pc": "410500"
			}, {
				"c": "410600",
				"n": "鹤壁市",
				"pc": "410000"
			}, {
				"c": "410601",
				"n": "市辖区",
				"pc": "410600"
			}, {
				"c": "410602",
				"n": "鹤山区",
				"pc": "410600"
			}, {
				"c": "410603",
				"n": "山城区",
				"pc": "410600"
			}, {
				"c": "410611",
				"n": "淇滨区",
				"pc": "410600"
			}, {
				"c": "410621",
				"n": "浚县",
				"pc": "410600"
			}, {
				"c": "410622",
				"n": "淇县",
				"pc": "410600"
			}, {
				"c": "410700",
				"n": "新乡市",
				"pc": "410000"
			}, {
				"c": "410701",
				"n": "市辖区",
				"pc": "410700"
			}, {
				"c": "410702",
				"n": "红旗区",
				"pc": "410700"
			}, {
				"c": "410703",
				"n": "卫滨区",
				"pc": "410700"
			}, {
				"c": "410704",
				"n": "凤泉区",
				"pc": "410700"
			}, {
				"c": "410711",
				"n": "牧野区",
				"pc": "410700"
			}, {
				"c": "410721",
				"n": "新乡县",
				"pc": "410700"
			}, {
				"c": "410724",
				"n": "获嘉县",
				"pc": "410700"
			}, {
				"c": "410725",
				"n": "原阳县",
				"pc": "410700"
			}, {
				"c": "410726",
				"n": "延津县",
				"pc": "410700"
			}, {
				"c": "410727",
				"n": "封丘县",
				"pc": "410700"
			}, {
				"c": "410728",
				"n": "长垣县",
				"pc": "410700"
			}, {
				"c": "410781",
				"n": "卫辉市",
				"pc": "410700"
			}, {
				"c": "410782",
				"n": "辉县市",
				"pc": "410700"
			}, {
				"c": "410800",
				"n": "焦作市",
				"pc": "410000"
			}, {
				"c": "410801",
				"n": "市辖区",
				"pc": "410800"
			}, {
				"c": "410802",
				"n": "解放区",
				"pc": "410800"
			}, {
				"c": "410803",
				"n": "中站区",
				"pc": "410800"
			}, {
				"c": "410804",
				"n": "马村区",
				"pc": "410800"
			}, {
				"c": "410811",
				"n": "山阳区",
				"pc": "410800"
			}, {
				"c": "410821",
				"n": "修武县",
				"pc": "410800"
			}, {
				"c": "410822",
				"n": "博爱县",
				"pc": "410800"
			}, {
				"c": "410823",
				"n": "武陟县",
				"pc": "410800"
			}, {
				"c": "410825",
				"n": "温县",
				"pc": "410800"
			}, {
				"c": "410882",
				"n": "沁阳市",
				"pc": "410800"
			}, {
				"c": "410883",
				"n": "孟州市",
				"pc": "410800"
			}, {
				"c": "410900",
				"n": "濮阳市",
				"pc": "410000"
			}, {
				"c": "410901",
				"n": "市辖区",
				"pc": "410900"
			}, {
				"c": "410902",
				"n": "华龙区",
				"pc": "410900"
			}, {
				"c": "410922",
				"n": "清丰县",
				"pc": "410900"
			}, {
				"c": "410923",
				"n": "南乐县",
				"pc": "410900"
			}, {
				"c": "410926",
				"n": "范县",
				"pc": "410900"
			}, {
				"c": "410927",
				"n": "台前县",
				"pc": "410900"
			}, {
				"c": "410928",
				"n": "濮阳县",
				"pc": "410900"
			}, {
				"c": "411000",
				"n": "许昌市",
				"pc": "410000"
			}, {
				"c": "411001",
				"n": "市辖区",
				"pc": "411000"
			}, {
				"c": "411002",
				"n": "魏都区",
				"pc": "411000"
			}, {
				"c": "411023",
				"n": "许昌县",
				"pc": "411000"
			}, {
				"c": "411024",
				"n": "鄢陵县",
				"pc": "411000"
			}, {
				"c": "411025",
				"n": "襄城县",
				"pc": "411000"
			}, {
				"c": "411081",
				"n": "禹州市",
				"pc": "411000"
			}, {
				"c": "411082",
				"n": "长葛市",
				"pc": "411000"
			}, {
				"c": "411100",
				"n": "漯河市",
				"pc": "410000"
			}, {
				"c": "411101",
				"n": "市辖区",
				"pc": "411100"
			}, {
				"c": "411102",
				"n": "源汇区",
				"pc": "411100"
			}, {
				"c": "411103",
				"n": "郾城区",
				"pc": "411100"
			}, {
				"c": "411104",
				"n": "召陵区",
				"pc": "411100"
			}, {
				"c": "411121",
				"n": "舞阳县",
				"pc": "411100"
			}, {
				"c": "411122",
				"n": "临颍县",
				"pc": "411100"
			}, {
				"c": "411200",
				"n": "三门峡市",
				"pc": "410000"
			}, {
				"c": "411201",
				"n": "市辖区",
				"pc": "411200"
			}, {
				"c": "411202",
				"n": "湖滨区",
				"pc": "411200"
			}, {
				"c": "411221",
				"n": "渑池县",
				"pc": "411200"
			}, {
				"c": "411222",
				"n": "陕县",
				"pc": "411200"
			}, {
				"c": "411224",
				"n": "卢氏县",
				"pc": "411200"
			}, {
				"c": "411281",
				"n": "义马市",
				"pc": "411200"
			}, {
				"c": "411282",
				"n": "灵宝市",
				"pc": "411200"
			}, {
				"c": "411300",
				"n": "南阳市",
				"pc": "410000"
			}, {
				"c": "411301",
				"n": "市辖区",
				"pc": "411300"
			}, {
				"c": "411302",
				"n": "宛城区",
				"pc": "411300"
			}, {
				"c": "411303",
				"n": "卧龙区",
				"pc": "411300"
			}, {
				"c": "411321",
				"n": "南召县",
				"pc": "411300"
			}, {
				"c": "411322",
				"n": "方城县",
				"pc": "411300"
			}, {
				"c": "411323",
				"n": "西峡县",
				"pc": "411300"
			}, {
				"c": "411324",
				"n": "镇平县",
				"pc": "411300"
			}, {
				"c": "411325",
				"n": "内乡县",
				"pc": "411300"
			}, {
				"c": "411326",
				"n": "淅川县",
				"pc": "411300"
			}, {
				"c": "411327",
				"n": "社旗县",
				"pc": "411300"
			}, {
				"c": "411328",
				"n": "唐河县",
				"pc": "411300"
			}, {
				"c": "411329",
				"n": "新野县",
				"pc": "411300"
			}, {
				"c": "411330",
				"n": "桐柏县",
				"pc": "411300"
			}, {
				"c": "411381",
				"n": "邓州市",
				"pc": "411300"
			}, {
				"c": "411400",
				"n": "商丘市",
				"pc": "410000"
			}, {
				"c": "411401",
				"n": "市辖区",
				"pc": "411400"
			}, {
				"c": "411402",
				"n": "梁园区",
				"pc": "411400"
			}, {
				"c": "411403",
				"n": "睢阳区",
				"pc": "411400"
			}, {
				"c": "411421",
				"n": "民权县",
				"pc": "411400"
			}, {
				"c": "411422",
				"n": "睢县",
				"pc": "411400"
			}, {
				"c": "411423",
				"n": "宁陵县",
				"pc": "411400"
			}, {
				"c": "411424",
				"n": "柘城县",
				"pc": "411400"
			}, {
				"c": "411425",
				"n": "虞城县",
				"pc": "411400"
			}, {
				"c": "411426",
				"n": "夏邑县",
				"pc": "411400"
			}, {
				"c": "411481",
				"n": "永城市",
				"pc": "411400"
			}, {
				"c": "411500",
				"n": "信阳市",
				"pc": "410000"
			}, {
				"c": "411501",
				"n": "市辖区",
				"pc": "411500"
			}, {
				"c": "411502",
				"n": "浉河区",
				"pc": "411500"
			}, {
				"c": "411503",
				"n": "平桥区",
				"pc": "411500"
			}, {
				"c": "411521",
				"n": "罗山县",
				"pc": "411500"
			}, {
				"c": "411522",
				"n": "光山县",
				"pc": "411500"
			}, {
				"c": "411523",
				"n": "新县",
				"pc": "411500"
			}, {
				"c": "411524",
				"n": "商城县",
				"pc": "411500"
			}, {
				"c": "411525",
				"n": "固始县",
				"pc": "411500"
			}, {
				"c": "411526",
				"n": "潢川县",
				"pc": "411500"
			}, {
				"c": "411527",
				"n": "淮滨县",
				"pc": "411500"
			}, {
				"c": "411528",
				"n": "息县",
				"pc": "411500"
			}, {
				"c": "411600",
				"n": "周口市",
				"pc": "410000"
			}, {
				"c": "411601",
				"n": "市辖区",
				"pc": "411600"
			}, {
				"c": "411602",
				"n": "川汇区",
				"pc": "411600"
			}, {
				"c": "411621",
				"n": "扶沟县",
				"pc": "411600"
			}, {
				"c": "411622",
				"n": "西华县",
				"pc": "411600"
			}, {
				"c": "411623",
				"n": "商水县",
				"pc": "411600"
			}, {
				"c": "411624",
				"n": "沈丘县",
				"pc": "411600"
			}, {
				"c": "411625",
				"n": "郸城县",
				"pc": "411600"
			}, {
				"c": "411626",
				"n": "淮阳县",
				"pc": "411600"
			}, {
				"c": "411627",
				"n": "太康县",
				"pc": "411600"
			}, {
				"c": "411628",
				"n": "鹿邑县",
				"pc": "411600"
			}, {
				"c": "411681",
				"n": "项城市",
				"pc": "411600"
			}, {
				"c": "411700",
				"n": "驻马店市",
				"pc": "410000"
			}, {
				"c": "411701",
				"n": "市辖区",
				"pc": "411700"
			}, {
				"c": "411702",
				"n": "驿城区",
				"pc": "411700"
			}, {
				"c": "411721",
				"n": "西平县",
				"pc": "411700"
			}, {
				"c": "411722",
				"n": "上蔡县",
				"pc": "411700"
			}, {
				"c": "411723",
				"n": "平舆县",
				"pc": "411700"
			}, {
				"c": "411724",
				"n": "正阳县",
				"pc": "411700"
			}, {
				"c": "411725",
				"n": "确山县",
				"pc": "411700"
			}, {
				"c": "411726",
				"n": "泌阳县",
				"pc": "411700"
			}, {
				"c": "411727",
				"n": "汝南县",
				"pc": "411700"
			}, {
				"c": "411728",
				"n": "遂平县",
				"pc": "411700"
			}, {
				"c": "411729",
				"n": "新蔡县",
				"pc": "411700"
			}, {
				"c": "419000",
				"n": "省直辖县级行政区划",
				"pc": "410000"
			}, {
				"c": "419001",
				"n": "济源市",
				"pc": "419000"
			}, {
				"c": "420000",
				"n": "湖北省",
				"pc": "86"
			}, {
				"c": "420100",
				"n": "武汉市",
				"pc": "420000"
			}, {
				"c": "420101",
				"n": "市辖区",
				"pc": "420100"
			}, {
				"c": "420102",
				"n": "江岸区",
				"pc": "420100"
			}, {
				"c": "420103",
				"n": "江汉区",
				"pc": "420100"
			}, {
				"c": "420104",
				"n": "硚口区",
				"pc": "420100"
			}, {
				"c": "420105",
				"n": "汉阳区",
				"pc": "420100"
			}, {
				"c": "420106",
				"n": "武昌区",
				"pc": "420100"
			}, {
				"c": "420107",
				"n": "青山区",
				"pc": "420100"
			}, {
				"c": "420111",
				"n": "洪山区",
				"pc": "420100"
			}, {
				"c": "420112",
				"n": "东西湖区",
				"pc": "420100"
			}, {
				"c": "420113",
				"n": "汉南区",
				"pc": "420100"
			}, {
				"c": "420114",
				"n": "蔡甸区",
				"pc": "420100"
			}, {
				"c": "420115",
				"n": "江夏区",
				"pc": "420100"
			}, {
				"c": "420116",
				"n": "黄陂区",
				"pc": "420100"
			}, {
				"c": "420117",
				"n": "新洲区",
				"pc": "420100"
			}, {
				"c": "420200",
				"n": "黄石市",
				"pc": "420000"
			}, {
				"c": "420201",
				"n": "市辖区",
				"pc": "420200"
			}, {
				"c": "420202",
				"n": "黄石港区",
				"pc": "420200"
			}, {
				"c": "420203",
				"n": "西塞山区",
				"pc": "420200"
			}, {
				"c": "420204",
				"n": "下陆区",
				"pc": "420200"
			}, {
				"c": "420205",
				"n": "铁山区",
				"pc": "420200"
			}, {
				"c": "420222",
				"n": "阳新县",
				"pc": "420200"
			}, {
				"c": "420281",
				"n": "大冶市",
				"pc": "420200"
			}, {
				"c": "420300",
				"n": "十堰市",
				"pc": "420000"
			}, {
				"c": "420301",
				"n": "市辖区",
				"pc": "420300"
			}, {
				"c": "420302",
				"n": "茅箭区",
				"pc": "420300"
			}, {
				"c": "420303",
				"n": "张湾区",
				"pc": "420300"
			}, {
				"c": "420321",
				"n": "郧县",
				"pc": "420300"
			}, {
				"c": "420322",
				"n": "郧西县",
				"pc": "420300"
			}, {
				"c": "420323",
				"n": "竹山县",
				"pc": "420300"
			}, {
				"c": "420324",
				"n": "竹溪县",
				"pc": "420300"
			}, {
				"c": "420325",
				"n": "房县",
				"pc": "420300"
			}, {
				"c": "420381",
				"n": "丹江口市",
				"pc": "420300"
			}, {
				"c": "420500",
				"n": "宜昌市",
				"pc": "420000"
			}, {
				"c": "420501",
				"n": "市辖区",
				"pc": "420500"
			}, {
				"c": "420502",
				"n": "西陵区",
				"pc": "420500"
			}, {
				"c": "420503",
				"n": "伍家岗区",
				"pc": "420500"
			}, {
				"c": "420504",
				"n": "点军区",
				"pc": "420500"
			}, {
				"c": "420505",
				"n": "猇亭区",
				"pc": "420500"
			}, {
				"c": "420506",
				"n": "夷陵区",
				"pc": "420500"
			}, {
				"c": "420525",
				"n": "远安县",
				"pc": "420500"
			}, {
				"c": "420526",
				"n": "兴山县",
				"pc": "420500"
			}, {
				"c": "420527",
				"n": "秭归县",
				"pc": "420500"
			}, {
				"c": "420528",
				"n": "长阳土家族自治县",
				"pc": "420500"
			}, {
				"c": "420529",
				"n": "五峰土家族自治县",
				"pc": "420500"
			}, {
				"c": "420581",
				"n": "宜都市",
				"pc": "420500"
			}, {
				"c": "420582",
				"n": "当阳市",
				"pc": "420500"
			}, {
				"c": "420583",
				"n": "枝江市",
				"pc": "420500"
			}, {
				"c": "420600",
				"n": "襄阳市",
				"pc": "420000"
			}, {
				"c": "420601",
				"n": "市辖区",
				"pc": "420600"
			}, {
				"c": "420602",
				"n": "襄城区",
				"pc": "420600"
			}, {
				"c": "420606",
				"n": "樊城区",
				"pc": "420600"
			}, {
				"c": "420607",
				"n": "襄州区",
				"pc": "420600"
			}, {
				"c": "420624",
				"n": "南漳县",
				"pc": "420600"
			}, {
				"c": "420625",
				"n": "谷城县",
				"pc": "420600"
			}, {
				"c": "420626",
				"n": "保康县",
				"pc": "420600"
			}, {
				"c": "420682",
				"n": "老河口市",
				"pc": "420600"
			}, {
				"c": "420683",
				"n": "枣阳市",
				"pc": "420600"
			}, {
				"c": "420684",
				"n": "宜城市",
				"pc": "420600"
			}, {
				"c": "420700",
				"n": "鄂州市",
				"pc": "420000"
			}, {
				"c": "420701",
				"n": "市辖区",
				"pc": "420700"
			}, {
				"c": "420702",
				"n": "梁子湖区",
				"pc": "420700"
			}, {
				"c": "420703",
				"n": "华容区",
				"pc": "420700"
			}, {
				"c": "420704",
				"n": "鄂城区",
				"pc": "420700"
			}, {
				"c": "420800",
				"n": "荆门市",
				"pc": "420000"
			}, {
				"c": "420801",
				"n": "市辖区",
				"pc": "420800"
			}, {
				"c": "420802",
				"n": "东宝区",
				"pc": "420800"
			}, {
				"c": "420804",
				"n": "掇刀区",
				"pc": "420800"
			}, {
				"c": "420821",
				"n": "京山县",
				"pc": "420800"
			}, {
				"c": "420822",
				"n": "沙洋县",
				"pc": "420800"
			}, {
				"c": "420881",
				"n": "钟祥市",
				"pc": "420800"
			}, {
				"c": "420900",
				"n": "孝感市",
				"pc": "420000"
			}, {
				"c": "420901",
				"n": "市辖区",
				"pc": "420900"
			}, {
				"c": "420902",
				"n": "孝南区",
				"pc": "420900"
			}, {
				"c": "420921",
				"n": "孝昌县",
				"pc": "420900"
			}, {
				"c": "420922",
				"n": "大悟县",
				"pc": "420900"
			}, {
				"c": "420923",
				"n": "云梦县",
				"pc": "420900"
			}, {
				"c": "420981",
				"n": "应城市",
				"pc": "420900"
			}, {
				"c": "420982",
				"n": "安陆市",
				"pc": "420900"
			}, {
				"c": "420984",
				"n": "汉川市",
				"pc": "420900"
			}, {
				"c": "421000",
				"n": "荆州市",
				"pc": "420000"
			}, {
				"c": "421001",
				"n": "市辖区",
				"pc": "421000"
			}, {
				"c": "421002",
				"n": "沙市区",
				"pc": "421000"
			}, {
				"c": "421003",
				"n": "荆州区",
				"pc": "421000"
			}, {
				"c": "421022",
				"n": "公安县",
				"pc": "421000"
			}, {
				"c": "421023",
				"n": "监利县",
				"pc": "421000"
			}, {
				"c": "421024",
				"n": "江陵县",
				"pc": "421000"
			}, {
				"c": "421081",
				"n": "石首市",
				"pc": "421000"
			}, {
				"c": "421083",
				"n": "洪湖市",
				"pc": "421000"
			}, {
				"c": "421087",
				"n": "松滋市",
				"pc": "421000"
			}, {
				"c": "421100",
				"n": "黄冈市",
				"pc": "420000"
			}, {
				"c": "421101",
				"n": "市辖区",
				"pc": "421100"
			}, {
				"c": "421102",
				"n": "黄州区",
				"pc": "421100"
			}, {
				"c": "421121",
				"n": "团风县",
				"pc": "421100"
			}, {
				"c": "421122",
				"n": "红安县",
				"pc": "421100"
			}, {
				"c": "421123",
				"n": "罗田县",
				"pc": "421100"
			}, {
				"c": "421124",
				"n": "英山县",
				"pc": "421100"
			}, {
				"c": "421125",
				"n": "浠水县",
				"pc": "421100"
			}, {
				"c": "421126",
				"n": "蕲春县",
				"pc": "421100"
			}, {
				"c": "421127",
				"n": "黄梅县",
				"pc": "421100"
			}, {
				"c": "421181",
				"n": "麻城市",
				"pc": "421100"
			}, {
				"c": "421182",
				"n": "武穴市",
				"pc": "421100"
			}, {
				"c": "421200",
				"n": "咸宁市",
				"pc": "420000"
			}, {
				"c": "421201",
				"n": "市辖区",
				"pc": "421200"
			}, {
				"c": "421202",
				"n": "咸安区",
				"pc": "421200"
			}, {
				"c": "421221",
				"n": "嘉鱼县",
				"pc": "421200"
			}, {
				"c": "421222",
				"n": "通城县",
				"pc": "421200"
			}, {
				"c": "421223",
				"n": "崇阳县",
				"pc": "421200"
			}, {
				"c": "421224",
				"n": "通山县",
				"pc": "421200"
			}, {
				"c": "421281",
				"n": "赤壁市",
				"pc": "421200"
			}, {
				"c": "421300",
				"n": "随州市",
				"pc": "420000"
			}, {
				"c": "421301",
				"n": "市辖区",
				"pc": "421300"
			}, {
				"c": "421303",
				"n": "曾都区",
				"pc": "421300"
			}, {
				"c": "421321",
				"n": "随县",
				"pc": "421300"
			}, {
				"c": "421381",
				"n": "广水市",
				"pc": "421300"
			}, {
				"c": "422800",
				"n": "恩施土家族苗族自治州",
				"pc": "420000"
			}, {
				"c": "422801",
				"n": "恩施市",
				"pc": "422800"
			}, {
				"c": "422802",
				"n": "利川市",
				"pc": "422800"
			}, {
				"c": "422822",
				"n": "建始县",
				"pc": "422800"
			}, {
				"c": "422823",
				"n": "巴东县",
				"pc": "422800"
			}, {
				"c": "422825",
				"n": "宣恩县",
				"pc": "422800"
			}, {
				"c": "422826",
				"n": "咸丰县",
				"pc": "422800"
			}, {
				"c": "422827",
				"n": "来凤县",
				"pc": "422800"
			}, {
				"c": "422828",
				"n": "鹤峰县",
				"pc": "422800"
			}, {
				"c": "429000",
				"n": "省直辖县级行政区划",
				"pc": "420000"
			}, {
				"c": "429004",
				"n": "仙桃市",
				"pc": "429000"
			}, {
				"c": "429005",
				"n": "潜江市",
				"pc": "429000"
			}, {
				"c": "429006",
				"n": "天门市",
				"pc": "429000"
			}, {
				"c": "429021",
				"n": "神农架林区",
				"pc": "429000"
			}, {
				"c": "430000",
				"n": "湖南省",
				"pc": "86"
			}, {
				"c": "430100",
				"n": "长沙市",
				"pc": "430000"
			}, {
				"c": "430101",
				"n": "市辖区",
				"pc": "430100"
			}, {
				"c": "430102",
				"n": "芙蓉区",
				"pc": "430100"
			}, {
				"c": "430103",
				"n": "天心区",
				"pc": "430100"
			}, {
				"c": "430104",
				"n": "岳麓区",
				"pc": "430100"
			}, {
				"c": "430105",
				"n": "开福区",
				"pc": "430100"
			}, {
				"c": "430111",
				"n": "雨花区",
				"pc": "430100"
			}, {
				"c": "430112",
				"n": "望城区",
				"pc": "430100"
			}, {
				"c": "430121",
				"n": "长沙县",
				"pc": "430100"
			}, {
				"c": "430124",
				"n": "宁乡县",
				"pc": "430100"
			}, {
				"c": "430181",
				"n": "浏阳市",
				"pc": "430100"
			}, {
				"c": "430200",
				"n": "株洲市",
				"pc": "430000"
			}, {
				"c": "430201",
				"n": "市辖区",
				"pc": "430200"
			}, {
				"c": "430202",
				"n": "荷塘区",
				"pc": "430200"
			}, {
				"c": "430203",
				"n": "芦淞区",
				"pc": "430200"
			}, {
				"c": "430204",
				"n": "石峰区",
				"pc": "430200"
			}, {
				"c": "430211",
				"n": "天元区",
				"pc": "430200"
			}, {
				"c": "430221",
				"n": "株洲县",
				"pc": "430200"
			}, {
				"c": "430223",
				"n": "攸县",
				"pc": "430200"
			}, {
				"c": "430224",
				"n": "茶陵县",
				"pc": "430200"
			}, {
				"c": "430225",
				"n": "炎陵县",
				"pc": "430200"
			}, {
				"c": "430281",
				"n": "醴陵市",
				"pc": "430200"
			}, {
				"c": "430300",
				"n": "湘潭市",
				"pc": "430000"
			}, {
				"c": "430301",
				"n": "市辖区",
				"pc": "430300"
			}, {
				"c": "430302",
				"n": "雨湖区",
				"pc": "430300"
			}, {
				"c": "430304",
				"n": "岳塘区",
				"pc": "430300"
			}, {
				"c": "430321",
				"n": "湘潭县",
				"pc": "430300"
			}, {
				"c": "430381",
				"n": "湘乡市",
				"pc": "430300"
			}, {
				"c": "430382",
				"n": "韶山市",
				"pc": "430300"
			}, {
				"c": "430400",
				"n": "衡阳市",
				"pc": "430000"
			}, {
				"c": "430401",
				"n": "市辖区",
				"pc": "430400"
			}, {
				"c": "430405",
				"n": "珠晖区",
				"pc": "430400"
			}, {
				"c": "430406",
				"n": "雁峰区",
				"pc": "430400"
			}, {
				"c": "430407",
				"n": "石鼓区",
				"pc": "430400"
			}, {
				"c": "430408",
				"n": "蒸湘区",
				"pc": "430400"
			}, {
				"c": "430412",
				"n": "南岳区",
				"pc": "430400"
			}, {
				"c": "430421",
				"n": "衡阳县",
				"pc": "430400"
			}, {
				"c": "430422",
				"n": "衡南县",
				"pc": "430400"
			}, {
				"c": "430423",
				"n": "衡山县",
				"pc": "430400"
			}, {
				"c": "430424",
				"n": "衡东县",
				"pc": "430400"
			}, {
				"c": "430426",
				"n": "祁东县",
				"pc": "430400"
			}, {
				"c": "430481",
				"n": "耒阳市",
				"pc": "430400"
			}, {
				"c": "430482",
				"n": "常宁市",
				"pc": "430400"
			}, {
				"c": "430500",
				"n": "邵阳市",
				"pc": "430000"
			}, {
				"c": "430501",
				"n": "市辖区",
				"pc": "430500"
			}, {
				"c": "430502",
				"n": "双清区",
				"pc": "430500"
			}, {
				"c": "430503",
				"n": "大祥区",
				"pc": "430500"
			}, {
				"c": "430511",
				"n": "北塔区",
				"pc": "430500"
			}, {
				"c": "430521",
				"n": "邵东县",
				"pc": "430500"
			}, {
				"c": "430522",
				"n": "新邵县",
				"pc": "430500"
			}, {
				"c": "430523",
				"n": "邵阳县",
				"pc": "430500"
			}, {
				"c": "430524",
				"n": "隆回县",
				"pc": "430500"
			}, {
				"c": "430525",
				"n": "洞口县",
				"pc": "430500"
			}, {
				"c": "430527",
				"n": "绥宁县",
				"pc": "430500"
			}, {
				"c": "430528",
				"n": "新宁县",
				"pc": "430500"
			}, {
				"c": "430529",
				"n": "城步苗族自治县",
				"pc": "430500"
			}, {
				"c": "430581",
				"n": "武冈市",
				"pc": "430500"
			}, {
				"c": "430600",
				"n": "岳阳市",
				"pc": "430000"
			}, {
				"c": "430601",
				"n": "市辖区",
				"pc": "430600"
			}, {
				"c": "430602",
				"n": "岳阳楼区",
				"pc": "430600"
			}, {
				"c": "430603",
				"n": "云溪区",
				"pc": "430600"
			}, {
				"c": "430611",
				"n": "君山区",
				"pc": "430600"
			}, {
				"c": "430621",
				"n": "岳阳县",
				"pc": "430600"
			}, {
				"c": "430623",
				"n": "华容县",
				"pc": "430600"
			}, {
				"c": "430624",
				"n": "湘阴县",
				"pc": "430600"
			}, {
				"c": "430626",
				"n": "平江县",
				"pc": "430600"
			}, {
				"c": "430681",
				"n": "汨罗市",
				"pc": "430600"
			}, {
				"c": "430682",
				"n": "临湘市",
				"pc": "430600"
			}, {
				"c": "430700",
				"n": "常德市",
				"pc": "430000"
			}, {
				"c": "430701",
				"n": "市辖区",
				"pc": "430700"
			}, {
				"c": "430702",
				"n": "武陵区",
				"pc": "430700"
			}, {
				"c": "430703",
				"n": "鼎城区",
				"pc": "430700"
			}, {
				"c": "430721",
				"n": "安乡县",
				"pc": "430700"
			}, {
				"c": "430722",
				"n": "汉寿县",
				"pc": "430700"
			}, {
				"c": "430723",
				"n": "澧县",
				"pc": "430700"
			}, {
				"c": "430724",
				"n": "临澧县",
				"pc": "430700"
			}, {
				"c": "430725",
				"n": "桃源县",
				"pc": "430700"
			}, {
				"c": "430726",
				"n": "石门县",
				"pc": "430700"
			}, {
				"c": "430781",
				"n": "津市市",
				"pc": "430700"
			}, {
				"c": "430800",
				"n": "张家界市",
				"pc": "430000"
			}, {
				"c": "430801",
				"n": "市辖区",
				"pc": "430800"
			}, {
				"c": "430802",
				"n": "永定区",
				"pc": "430800"
			}, {
				"c": "430811",
				"n": "武陵源区",
				"pc": "430800"
			}, {
				"c": "430821",
				"n": "慈利县",
				"pc": "430800"
			}, {
				"c": "430822",
				"n": "桑植县",
				"pc": "430800"
			}, {
				"c": "430900",
				"n": "益阳市",
				"pc": "430000"
			}, {
				"c": "430901",
				"n": "市辖区",
				"pc": "430900"
			}, {
				"c": "430902",
				"n": "资阳区",
				"pc": "430900"
			}, {
				"c": "430903",
				"n": "赫山区",
				"pc": "430900"
			}, {
				"c": "430921",
				"n": "南县",
				"pc": "430900"
			}, {
				"c": "430922",
				"n": "桃江县",
				"pc": "430900"
			}, {
				"c": "430923",
				"n": "安化县",
				"pc": "430900"
			}, {
				"c": "430981",
				"n": "沅江市",
				"pc": "430900"
			}, {
				"c": "431000",
				"n": "郴州市",
				"pc": "430000"
			}, {
				"c": "431001",
				"n": "市辖区",
				"pc": "431000"
			}, {
				"c": "431002",
				"n": "北湖区",
				"pc": "431000"
			}, {
				"c": "431003",
				"n": "苏仙区",
				"pc": "431000"
			}, {
				"c": "431021",
				"n": "桂阳县",
				"pc": "431000"
			}, {
				"c": "431022",
				"n": "宜章县",
				"pc": "431000"
			}, {
				"c": "431023",
				"n": "永兴县",
				"pc": "431000"
			}, {
				"c": "431024",
				"n": "嘉禾县",
				"pc": "431000"
			}, {
				"c": "431025",
				"n": "临武县",
				"pc": "431000"
			}, {
				"c": "431026",
				"n": "汝城县",
				"pc": "431000"
			}, {
				"c": "431027",
				"n": "桂东县",
				"pc": "431000"
			}, {
				"c": "431028",
				"n": "安仁县",
				"pc": "431000"
			}, {
				"c": "431081",
				"n": "资兴市",
				"pc": "431000"
			}, {
				"c": "431100",
				"n": "永州市",
				"pc": "430000"
			}, {
				"c": "431101",
				"n": "市辖区",
				"pc": "431100"
			}, {
				"c": "431102",
				"n": "零陵区",
				"pc": "431100"
			}, {
				"c": "431103",
				"n": "冷水滩区",
				"pc": "431100"
			}, {
				"c": "431121",
				"n": "祁阳县",
				"pc": "431100"
			}, {
				"c": "431122",
				"n": "东安县",
				"pc": "431100"
			}, {
				"c": "431123",
				"n": "双牌县",
				"pc": "431100"
			}, {
				"c": "431124",
				"n": "道县",
				"pc": "431100"
			}, {
				"c": "431125",
				"n": "江永县",
				"pc": "431100"
			}, {
				"c": "431126",
				"n": "宁远县",
				"pc": "431100"
			}, {
				"c": "431127",
				"n": "蓝山县",
				"pc": "431100"
			}, {
				"c": "431128",
				"n": "新田县",
				"pc": "431100"
			}, {
				"c": "431129",
				"n": "江华瑶族自治县",
				"pc": "431100"
			}, {
				"c": "431200",
				"n": "怀化市",
				"pc": "430000"
			}, {
				"c": "431201",
				"n": "市辖区",
				"pc": "431200"
			}, {
				"c": "431202",
				"n": "鹤城区",
				"pc": "431200"
			}, {
				"c": "431221",
				"n": "中方县",
				"pc": "431200"
			}, {
				"c": "431222",
				"n": "沅陵县",
				"pc": "431200"
			}, {
				"c": "431223",
				"n": "辰溪县",
				"pc": "431200"
			}, {
				"c": "431224",
				"n": "溆浦县",
				"pc": "431200"
			}, {
				"c": "431225",
				"n": "会同县",
				"pc": "431200"
			}, {
				"c": "431226",
				"n": "麻阳苗族自治县",
				"pc": "431200"
			}, {
				"c": "431227",
				"n": "新晃侗族自治县",
				"pc": "431200"
			}, {
				"c": "431228",
				"n": "芷江侗族自治县",
				"pc": "431200"
			}, {
				"c": "431229",
				"n": "靖州苗族侗族自治县",
				"pc": "431200"
			}, {
				"c": "431230",
				"n": "通道侗族自治县",
				"pc": "431200"
			}, {
				"c": "431281",
				"n": "洪江市",
				"pc": "431200"
			}, {
				"c": "431300",
				"n": "娄底市",
				"pc": "430000"
			}, {
				"c": "431301",
				"n": "市辖区",
				"pc": "431300"
			}, {
				"c": "431302",
				"n": "娄星区",
				"pc": "431300"
			}, {
				"c": "431321",
				"n": "双峰县",
				"pc": "431300"
			}, {
				"c": "431322",
				"n": "新化县",
				"pc": "431300"
			}, {
				"c": "431381",
				"n": "冷水江市",
				"pc": "431300"
			}, {
				"c": "431382",
				"n": "涟源市",
				"pc": "431300"
			}, {
				"c": "433100",
				"n": "湘西土家族苗族自治州",
				"pc": "430000"
			}, {
				"c": "433101",
				"n": "吉首市",
				"pc": "433100"
			}, {
				"c": "433122",
				"n": "泸溪县",
				"pc": "433100"
			}, {
				"c": "433123",
				"n": "凤凰县",
				"pc": "433100"
			}, {
				"c": "433124",
				"n": "花垣县",
				"pc": "433100"
			}, {
				"c": "433125",
				"n": "保靖县",
				"pc": "433100"
			}, {
				"c": "433126",
				"n": "古丈县",
				"pc": "433100"
			}, {
				"c": "433127",
				"n": "永顺县",
				"pc": "433100"
			}, {
				"c": "433130",
				"n": "龙山县",
				"pc": "433100"
			}, {
				"c": "440000",
				"n": "广东省",
				"pc": "86"
			}, {
				"c": "440100",
				"n": "广州市",
				"pc": "440000"
			}, {
				"c": "440101",
				"n": "市辖区",
				"pc": "440100"
			}, {
				"c": "440103",
				"n": "荔湾区",
				"pc": "440100"
			}, {
				"c": "440104",
				"n": "越秀区",
				"pc": "440100"
			}, {
				"c": "440105",
				"n": "海珠区",
				"pc": "440100"
			}, {
				"c": "440106",
				"n": "天河区",
				"pc": "440100"
			}, {
				"c": "440111",
				"n": "白云区",
				"pc": "440100"
			}, {
				"c": "440112",
				"n": "黄埔区",
				"pc": "440100"
			}, {
				"c": "440113",
				"n": "番禺区",
				"pc": "440100"
			}, {
				"c": "440114",
				"n": "花都区",
				"pc": "440100"
			}, {
				"c": "440115",
				"n": "南沙区",
				"pc": "440100"
			}, {
				"c": "440116",
				"n": "萝岗区",
				"pc": "440100"
			}, {
				"c": "440183",
				"n": "增城市",
				"pc": "440100"
			}, {
				"c": "440184",
				"n": "从化市",
				"pc": "440100"
			}, {
				"c": "440200",
				"n": "韶关市",
				"pc": "440000"
			}, {
				"c": "440201",
				"n": "市辖区",
				"pc": "440200"
			}, {
				"c": "440203",
				"n": "武江区",
				"pc": "440200"
			}, {
				"c": "440204",
				"n": "浈江区",
				"pc": "440200"
			}, {
				"c": "440205",
				"n": "曲江区",
				"pc": "440200"
			}, {
				"c": "440222",
				"n": "始兴县",
				"pc": "440200"
			}, {
				"c": "440224",
				"n": "仁化县",
				"pc": "440200"
			}, {
				"c": "440229",
				"n": "翁源县",
				"pc": "440200"
			}, {
				"c": "440232",
				"n": "乳源瑶族自治县",
				"pc": "440200"
			}, {
				"c": "440233",
				"n": "新丰县",
				"pc": "440200"
			}, {
				"c": "440281",
				"n": "乐昌市",
				"pc": "440200"
			}, {
				"c": "440282",
				"n": "南雄市",
				"pc": "440200"
			}, {
				"c": "440300",
				"n": "深圳市",
				"pc": "440000"
			}, {
				"c": "440301",
				"n": "市辖区",
				"pc": "440300"
			}, {
				"c": "440303",
				"n": "罗湖区",
				"pc": "440300"
			}, {
				"c": "440304",
				"n": "福田区",
				"pc": "440300"
			}, {
				"c": "440305",
				"n": "南山区",
				"pc": "440300"
			}, {
				"c": "440306",
				"n": "宝安区",
				"pc": "440300"
			}, {
				"c": "440307",
				"n": "龙岗区",
				"pc": "440300"
			}, {
				"c": "440308",
				"n": "盐田区",
				"pc": "440300"
			}, {
				"c": "440400",
				"n": "珠海市",
				"pc": "440000"
			}, {
				"c": "440401",
				"n": "市辖区",
				"pc": "440400"
			}, {
				"c": "440402",
				"n": "香洲区",
				"pc": "440400"
			}, {
				"c": "440403",
				"n": "斗门区",
				"pc": "440400"
			}, {
				"c": "440404",
				"n": "金湾区",
				"pc": "440400"
			}, {
				"c": "440500",
				"n": "汕头市",
				"pc": "440000"
			}, {
				"c": "440501",
				"n": "市辖区",
				"pc": "440500"
			}, {
				"c": "440507",
				"n": "龙湖区",
				"pc": "440500"
			}, {
				"c": "440511",
				"n": "金平区",
				"pc": "440500"
			}, {
				"c": "440512",
				"n": "濠江区",
				"pc": "440500"
			}, {
				"c": "440513",
				"n": "潮阳区",
				"pc": "440500"
			}, {
				"c": "440514",
				"n": "潮南区",
				"pc": "440500"
			}, {
				"c": "440515",
				"n": "澄海区",
				"pc": "440500"
			}, {
				"c": "440523",
				"n": "南澳县",
				"pc": "440500"
			}, {
				"c": "440600",
				"n": "佛山市",
				"pc": "440000"
			}, {
				"c": "440601",
				"n": "市辖区",
				"pc": "440600"
			}, {
				"c": "440604",
				"n": "禅城区",
				"pc": "440600"
			}, {
				"c": "440605",
				"n": "南海区",
				"pc": "440600"
			}, {
				"c": "440606",
				"n": "顺德区",
				"pc": "440600"
			}, {
				"c": "440607",
				"n": "三水区",
				"pc": "440600"
			}, {
				"c": "440608",
				"n": "高明区",
				"pc": "440600"
			}, {
				"c": "440700",
				"n": "江门市",
				"pc": "440000"
			}, {
				"c": "440701",
				"n": "市辖区",
				"pc": "440700"
			}, {
				"c": "440703",
				"n": "蓬江区",
				"pc": "440700"
			}, {
				"c": "440704",
				"n": "江海区",
				"pc": "440700"
			}, {
				"c": "440705",
				"n": "新会区",
				"pc": "440700"
			}, {
				"c": "440781",
				"n": "台山市",
				"pc": "440700"
			}, {
				"c": "440783",
				"n": "开平市",
				"pc": "440700"
			}, {
				"c": "440784",
				"n": "鹤山市",
				"pc": "440700"
			}, {
				"c": "440785",
				"n": "恩平市",
				"pc": "440700"
			}, {
				"c": "440800",
				"n": "湛江市",
				"pc": "440000"
			}, {
				"c": "440801",
				"n": "市辖区",
				"pc": "440800"
			}, {
				"c": "440802",
				"n": "赤坎区",
				"pc": "440800"
			}, {
				"c": "440803",
				"n": "霞山区",
				"pc": "440800"
			}, {
				"c": "440804",
				"n": "坡头区",
				"pc": "440800"
			}, {
				"c": "440811",
				"n": "麻章区",
				"pc": "440800"
			}, {
				"c": "440823",
				"n": "遂溪县",
				"pc": "440800"
			}, {
				"c": "440825",
				"n": "徐闻县",
				"pc": "440800"
			}, {
				"c": "440881",
				"n": "廉江市",
				"pc": "440800"
			}, {
				"c": "440882",
				"n": "雷州市",
				"pc": "440800"
			}, {
				"c": "440883",
				"n": "吴川市",
				"pc": "440800"
			}, {
				"c": "440900",
				"n": "茂名市",
				"pc": "440000"
			}, {
				"c": "440901",
				"n": "市辖区",
				"pc": "440900"
			}, {
				"c": "440902",
				"n": "茂南区",
				"pc": "440900"
			}, {
				"c": "440903",
				"n": "茂港区",
				"pc": "440900"
			}, {
				"c": "440923",
				"n": "电白县",
				"pc": "440900"
			}, {
				"c": "440981",
				"n": "高州市",
				"pc": "440900"
			}, {
				"c": "440982",
				"n": "化州市",
				"pc": "440900"
			}, {
				"c": "440983",
				"n": "信宜市",
				"pc": "440900"
			}, {
				"c": "441200",
				"n": "肇庆市",
				"pc": "440000"
			}, {
				"c": "441201",
				"n": "市辖区",
				"pc": "441200"
			}, {
				"c": "441202",
				"n": "端州区",
				"pc": "441200"
			}, {
				"c": "441203",
				"n": "鼎湖区",
				"pc": "441200"
			}, {
				"c": "441223",
				"n": "广宁县",
				"pc": "441200"
			}, {
				"c": "441224",
				"n": "怀集县",
				"pc": "441200"
			}, {
				"c": "441225",
				"n": "封开县",
				"pc": "441200"
			}, {
				"c": "441226",
				"n": "德庆县",
				"pc": "441200"
			}, {
				"c": "441283",
				"n": "高要市",
				"pc": "441200"
			}, {
				"c": "441284",
				"n": "四会市",
				"pc": "441200"
			}, {
				"c": "441300",
				"n": "惠州市",
				"pc": "440000"
			}, {
				"c": "441301",
				"n": "市辖区",
				"pc": "441300"
			}, {
				"c": "441302",
				"n": "惠城区",
				"pc": "441300"
			}, {
				"c": "441303",
				"n": "惠阳区",
				"pc": "441300"
			}, {
				"c": "441322",
				"n": "博罗县",
				"pc": "441300"
			}, {
				"c": "441323",
				"n": "惠东县",
				"pc": "441300"
			}, {
				"c": "441324",
				"n": "龙门县",
				"pc": "441300"
			}, {
				"c": "441400",
				"n": "梅州市",
				"pc": "440000"
			}, {
				"c": "441401",
				"n": "市辖区",
				"pc": "441400"
			}, {
				"c": "441402",
				"n": "梅江区",
				"pc": "441400"
			}, {
				"c": "441421",
				"n": "梅县",
				"pc": "441400"
			}, {
				"c": "441422",
				"n": "大埔县",
				"pc": "441400"
			}, {
				"c": "441423",
				"n": "丰顺县",
				"pc": "441400"
			}, {
				"c": "441424",
				"n": "五华县",
				"pc": "441400"
			}, {
				"c": "441426",
				"n": "平远县",
				"pc": "441400"
			}, {
				"c": "441427",
				"n": "蕉岭县",
				"pc": "441400"
			}, {
				"c": "441481",
				"n": "兴宁市",
				"pc": "441400"
			}, {
				"c": "441500",
				"n": "汕尾市",
				"pc": "440000"
			}, {
				"c": "441501",
				"n": "市辖区",
				"pc": "441500"
			}, {
				"c": "441502",
				"n": "城区",
				"pc": "441500"
			}, {
				"c": "441521",
				"n": "海丰县",
				"pc": "441500"
			}, {
				"c": "441523",
				"n": "陆河县",
				"pc": "441500"
			}, {
				"c": "441581",
				"n": "陆丰市",
				"pc": "441500"
			}, {
				"c": "441600",
				"n": "河源市",
				"pc": "440000"
			}, {
				"c": "441601",
				"n": "市辖区",
				"pc": "441600"
			}, {
				"c": "441602",
				"n": "源城区",
				"pc": "441600"
			}, {
				"c": "441621",
				"n": "紫金县",
				"pc": "441600"
			}, {
				"c": "441622",
				"n": "龙川县",
				"pc": "441600"
			}, {
				"c": "441623",
				"n": "连平县",
				"pc": "441600"
			}, {
				"c": "441624",
				"n": "和平县",
				"pc": "441600"
			}, {
				"c": "441625",
				"n": "东源县",
				"pc": "441600"
			}, {
				"c": "441700",
				"n": "阳江市",
				"pc": "440000"
			}, {
				"c": "441701",
				"n": "市辖区",
				"pc": "441700"
			}, {
				"c": "441702",
				"n": "江城区",
				"pc": "441700"
			}, {
				"c": "441721",
				"n": "阳西县",
				"pc": "441700"
			}, {
				"c": "441723",
				"n": "阳东县",
				"pc": "441700"
			}, {
				"c": "441781",
				"n": "阳春市",
				"pc": "441700"
			}, {
				"c": "441800",
				"n": "清远市",
				"pc": "440000"
			}, {
				"c": "441801",
				"n": "市辖区",
				"pc": "441800"
			}, {
				"c": "441802",
				"n": "清城区",
				"pc": "441800"
			}, {
				"c": "441821",
				"n": "佛冈县",
				"pc": "441800"
			}, {
				"c": "441823",
				"n": "阳山县",
				"pc": "441800"
			}, {
				"c": "441825",
				"n": "连山壮族瑶族自治县",
				"pc": "441800"
			}, {
				"c": "441826",
				"n": "连南瑶族自治县",
				"pc": "441800"
			}, {
				"c": "441827",
				"n": "清新县",
				"pc": "441800"
			}, {
				"c": "441881",
				"n": "英德市",
				"pc": "441800"
			}, {
				"c": "441882",
				"n": "连州市",
				"pc": "441800"
			}, {
				"c": "441900",
				"n": "东莞市",
				"pc": "440000"
			}, {
				"c": "442000",
				"n": "中山市",
				"pc": "440000"
			}, {
				"c": "445100",
				"n": "潮州市",
				"pc": "440000"
			}, {
				"c": "445101",
				"n": "市辖区",
				"pc": "445100"
			}, {
				"c": "445102",
				"n": "湘桥区",
				"pc": "445100"
			}, {
				"c": "445121",
				"n": "潮安县",
				"pc": "445100"
			}, {
				"c": "445122",
				"n": "饶平县",
				"pc": "445100"
			}, {
				"c": "445200",
				"n": "揭阳市",
				"pc": "440000"
			}, {
				"c": "445201",
				"n": "市辖区",
				"pc": "445200"
			}, {
				"c": "445202",
				"n": "榕城区",
				"pc": "445200"
			}, {
				"c": "445221",
				"n": "揭东县",
				"pc": "445200"
			}, {
				"c": "445222",
				"n": "揭西县",
				"pc": "445200"
			}, {
				"c": "445224",
				"n": "惠来县",
				"pc": "445200"
			}, {
				"c": "445281",
				"n": "普宁市",
				"pc": "445200"
			}, {
				"c": "445300",
				"n": "云浮市",
				"pc": "440000"
			}, {
				"c": "445301",
				"n": "市辖区",
				"pc": "445300"
			}, {
				"c": "445302",
				"n": "云城区",
				"pc": "445300"
			}, {
				"c": "445321",
				"n": "新兴县",
				"pc": "445300"
			}, {
				"c": "445322",
				"n": "郁南县",
				"pc": "445300"
			}, {
				"c": "445323",
				"n": "云安县",
				"pc": "445300"
			}, {
				"c": "445381",
				"n": "罗定市",
				"pc": "445300"
			}, {
				"c": "450000",
				"n": "广西壮族自治区",
				"pc": "86"
			}, {
				"c": "450100",
				"n": "南宁市",
				"pc": "450000"
			}, {
				"c": "450101",
				"n": "市辖区",
				"pc": "450100"
			}, {
				"c": "450102",
				"n": "兴宁区",
				"pc": "450100"
			}, {
				"c": "450103",
				"n": "青秀区",
				"pc": "450100"
			}, {
				"c": "450105",
				"n": "江南区",
				"pc": "450100"
			}, {
				"c": "450107",
				"n": "西乡塘区",
				"pc": "450100"
			}, {
				"c": "450108",
				"n": "良庆区",
				"pc": "450100"
			}, {
				"c": "450109",
				"n": "邕宁区",
				"pc": "450100"
			}, {
				"c": "450122",
				"n": "武鸣县",
				"pc": "450100"
			}, {
				"c": "450123",
				"n": "隆安县",
				"pc": "450100"
			}, {
				"c": "450124",
				"n": "马山县",
				"pc": "450100"
			}, {
				"c": "450125",
				"n": "上林县",
				"pc": "450100"
			}, {
				"c": "450126",
				"n": "宾阳县",
				"pc": "450100"
			}, {
				"c": "450127",
				"n": "横县",
				"pc": "450100"
			}, {
				"c": "450200",
				"n": "柳州市",
				"pc": "450000"
			}, {
				"c": "450201",
				"n": "市辖区",
				"pc": "450200"
			}, {
				"c": "450202",
				"n": "城中区",
				"pc": "450200"
			}, {
				"c": "450203",
				"n": "鱼峰区",
				"pc": "450200"
			}, {
				"c": "450204",
				"n": "柳南区",
				"pc": "450200"
			}, {
				"c": "450205",
				"n": "柳北区",
				"pc": "450200"
			}, {
				"c": "450221",
				"n": "柳江县",
				"pc": "450200"
			}, {
				"c": "450222",
				"n": "柳城县",
				"pc": "450200"
			}, {
				"c": "450223",
				"n": "鹿寨县",
				"pc": "450200"
			}, {
				"c": "450224",
				"n": "融安县",
				"pc": "450200"
			}, {
				"c": "450225",
				"n": "融水苗族自治县",
				"pc": "450200"
			}, {
				"c": "450226",
				"n": "三江侗族自治县",
				"pc": "450200"
			}, {
				"c": "450300",
				"n": "桂林市",
				"pc": "450000"
			}, {
				"c": "450301",
				"n": "市辖区",
				"pc": "450300"
			}, {
				"c": "450302",
				"n": "秀峰区",
				"pc": "450300"
			}, {
				"c": "450303",
				"n": "叠彩区",
				"pc": "450300"
			}, {
				"c": "450304",
				"n": "象山区",
				"pc": "450300"
			}, {
				"c": "450305",
				"n": "七星区",
				"pc": "450300"
			}, {
				"c": "450311",
				"n": "雁山区",
				"pc": "450300"
			}, {
				"c": "450321",
				"n": "阳朔县",
				"pc": "450300"
			}, {
				"c": "450322",
				"n": "临桂县",
				"pc": "450300"
			}, {
				"c": "450323",
				"n": "灵川县",
				"pc": "450300"
			}, {
				"c": "450324",
				"n": "全州县",
				"pc": "450300"
			}, {
				"c": "450325",
				"n": "兴安县",
				"pc": "450300"
			}, {
				"c": "450326",
				"n": "永福县",
				"pc": "450300"
			}, {
				"c": "450327",
				"n": "灌阳县",
				"pc": "450300"
			}, {
				"c": "450328",
				"n": "龙胜各族自治县",
				"pc": "450300"
			}, {
				"c": "450329",
				"n": "资源县",
				"pc": "450300"
			}, {
				"c": "450330",
				"n": "平乐县",
				"pc": "450300"
			}, {
				"c": "450331",
				"n": "荔浦县",
				"pc": "450300"
			}, {
				"c": "450332",
				"n": "恭城瑶族自治县",
				"pc": "450300"
			}, {
				"c": "450400",
				"n": "梧州市",
				"pc": "450000"
			}, {
				"c": "450401",
				"n": "市辖区",
				"pc": "450400"
			}, {
				"c": "450403",
				"n": "万秀区",
				"pc": "450400"
			}, {
				"c": "450404",
				"n": "蝶山区",
				"pc": "450400"
			}, {
				"c": "450405",
				"n": "长洲区",
				"pc": "450400"
			}, {
				"c": "450421",
				"n": "苍梧县",
				"pc": "450400"
			}, {
				"c": "450422",
				"n": "藤县",
				"pc": "450400"
			}, {
				"c": "450423",
				"n": "蒙山县",
				"pc": "450400"
			}, {
				"c": "450481",
				"n": "岑溪市",
				"pc": "450400"
			}, {
				"c": "450500",
				"n": "北海市",
				"pc": "450000"
			}, {
				"c": "450501",
				"n": "市辖区",
				"pc": "450500"
			}, {
				"c": "450502",
				"n": "海城区",
				"pc": "450500"
			}, {
				"c": "450503",
				"n": "银海区",
				"pc": "450500"
			}, {
				"c": "450512",
				"n": "铁山港区",
				"pc": "450500"
			}, {
				"c": "450521",
				"n": "合浦县",
				"pc": "450500"
			}, {
				"c": "450600",
				"n": "防城港市",
				"pc": "450000"
			}, {
				"c": "450601",
				"n": "市辖区",
				"pc": "450600"
			}, {
				"c": "450602",
				"n": "港口区",
				"pc": "450600"
			}, {
				"c": "450603",
				"n": "防城区",
				"pc": "450600"
			}, {
				"c": "450621",
				"n": "上思县",
				"pc": "450600"
			}, {
				"c": "450681",
				"n": "东兴市",
				"pc": "450600"
			}, {
				"c": "450700",
				"n": "钦州市",
				"pc": "450000"
			}, {
				"c": "450701",
				"n": "市辖区",
				"pc": "450700"
			}, {
				"c": "450702",
				"n": "钦南区",
				"pc": "450700"
			}, {
				"c": "450703",
				"n": "钦北区",
				"pc": "450700"
			}, {
				"c": "450721",
				"n": "灵山县",
				"pc": "450700"
			}, {
				"c": "450722",
				"n": "浦北县",
				"pc": "450700"
			}, {
				"c": "450800",
				"n": "贵港市",
				"pc": "450000"
			}, {
				"c": "450801",
				"n": "市辖区",
				"pc": "450800"
			}, {
				"c": "450802",
				"n": "港北区",
				"pc": "450800"
			}, {
				"c": "450803",
				"n": "港南区",
				"pc": "450800"
			}, {
				"c": "450804",
				"n": "覃塘区",
				"pc": "450800"
			}, {
				"c": "450821",
				"n": "平南县",
				"pc": "450800"
			}, {
				"c": "450881",
				"n": "桂平市",
				"pc": "450800"
			}, {
				"c": "450900",
				"n": "玉林市",
				"pc": "450000"
			}, {
				"c": "450901",
				"n": "市辖区",
				"pc": "450900"
			}, {
				"c": "450902",
				"n": "玉州区",
				"pc": "450900"
			}, {
				"c": "450921",
				"n": "容县",
				"pc": "450900"
			}, {
				"c": "450922",
				"n": "陆川县",
				"pc": "450900"
			}, {
				"c": "450923",
				"n": "博白县",
				"pc": "450900"
			}, {
				"c": "450924",
				"n": "兴业县",
				"pc": "450900"
			}, {
				"c": "450981",
				"n": "北流市",
				"pc": "450900"
			}, {
				"c": "451000",
				"n": "百色市",
				"pc": "450000"
			}, {
				"c": "451001",
				"n": "市辖区",
				"pc": "451000"
			}, {
				"c": "451002",
				"n": "右江区",
				"pc": "451000"
			}, {
				"c": "451021",
				"n": "田阳县",
				"pc": "451000"
			}, {
				"c": "451022",
				"n": "田东县",
				"pc": "451000"
			}, {
				"c": "451023",
				"n": "平果县",
				"pc": "451000"
			}, {
				"c": "451024",
				"n": "德保县",
				"pc": "451000"
			}, {
				"c": "451025",
				"n": "靖西县",
				"pc": "451000"
			}, {
				"c": "451026",
				"n": "那坡县",
				"pc": "451000"
			}, {
				"c": "451027",
				"n": "凌云县",
				"pc": "451000"
			}, {
				"c": "451028",
				"n": "乐业县",
				"pc": "451000"
			}, {
				"c": "451029",
				"n": "田林县",
				"pc": "451000"
			}, {
				"c": "451030",
				"n": "西林县",
				"pc": "451000"
			}, {
				"c": "451031",
				"n": "隆林各族自治县",
				"pc": "451000"
			}, {
				"c": "451100",
				"n": "贺州市",
				"pc": "450000"
			}, {
				"c": "451101",
				"n": "市辖区",
				"pc": "451100"
			}, {
				"c": "451102",
				"n": "八步区",
				"pc": "451100"
			}, {
				"c": "451121",
				"n": "昭平县",
				"pc": "451100"
			}, {
				"c": "451122",
				"n": "钟山县",
				"pc": "451100"
			}, {
				"c": "451123",
				"n": "富川瑶族自治县",
				"pc": "451100"
			}, {
				"c": "451200",
				"n": "河池市",
				"pc": "450000"
			}, {
				"c": "451201",
				"n": "市辖区",
				"pc": "451200"
			}, {
				"c": "451202",
				"n": "金城江区",
				"pc": "451200"
			}, {
				"c": "451221",
				"n": "南丹县",
				"pc": "451200"
			}, {
				"c": "451222",
				"n": "天峨县",
				"pc": "451200"
			}, {
				"c": "451223",
				"n": "凤山县",
				"pc": "451200"
			}, {
				"c": "451224",
				"n": "东兰县",
				"pc": "451200"
			}, {
				"c": "451225",
				"n": "罗城仫佬族自治县",
				"pc": "451200"
			}, {
				"c": "451226",
				"n": "环江毛南族自治县",
				"pc": "451200"
			}, {
				"c": "451227",
				"n": "巴马瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451228",
				"n": "都安瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451229",
				"n": "大化瑶族自治县",
				"pc": "451200"
			}, {
				"c": "451281",
				"n": "宜州市",
				"pc": "451200"
			}, {
				"c": "451300",
				"n": "来宾市",
				"pc": "450000"
			}, {
				"c": "451301",
				"n": "市辖区",
				"pc": "451300"
			}, {
				"c": "451302",
				"n": "兴宾区",
				"pc": "451300"
			}, {
				"c": "451321",
				"n": "忻城县",
				"pc": "451300"
			}, {
				"c": "451322",
				"n": "象州县",
				"pc": "451300"
			}, {
				"c": "451323",
				"n": "武宣县",
				"pc": "451300"
			}, {
				"c": "451324",
				"n": "金秀瑶族自治县",
				"pc": "451300"
			}, {
				"c": "451381",
				"n": "合山市",
				"pc": "451300"
			}, {
				"c": "451400",
				"n": "崇左市",
				"pc": "450000"
			}, {
				"c": "451401",
				"n": "市辖区",
				"pc": "451400"
			}, {
				"c": "451402",
				"n": "江洲区",
				"pc": "451400"
			}, {
				"c": "451421",
				"n": "扶绥县",
				"pc": "451400"
			}, {
				"c": "451422",
				"n": "宁明县",
				"pc": "451400"
			}, {
				"c": "451423",
				"n": "龙州县",
				"pc": "451400"
			}, {
				"c": "451424",
				"n": "大新县",
				"pc": "451400"
			}, {
				"c": "451425",
				"n": "天等县",
				"pc": "451400"
			}, {
				"c": "451481",
				"n": "凭祥市",
				"pc": "451400"
			}, {
				"c": "460000",
				"n": "海南省",
				"pc": "86"
			}, {
				"c": "460100",
				"n": "海口市",
				"pc": "460000"
			}, {
				"c": "460101",
				"n": "市辖区",
				"pc": "460100"
			}, {
				"c": "460105",
				"n": "秀英区",
				"pc": "460100"
			}, {
				"c": "460106",
				"n": "龙华区",
				"pc": "460100"
			}, {
				"c": "460107",
				"n": "琼山区",
				"pc": "460100"
			}, {
				"c": "460108",
				"n": "美兰区",
				"pc": "460100"
			}, {
				"c": "460200",
				"n": "三亚市",
				"pc": "460000"
			}, {
				"c": "460201",
				"n": "市辖区",
				"pc": "460200"
			}, {
				"c": "460300",
				"n": "三沙市",
				"pc": "460000"
			}, {
				"c": "460321",
				"n": "西沙群岛",
				"pc": "460300"
			}, {
				"c": "460322",
				"n": "南沙群岛",
				"pc": "460300"
			}, {
				"c": "460323",
				"n": "中沙群岛的岛礁及其海域",
				"pc": "460300"
			}, {
				"c": "469000",
				"n": "省直辖县级行政区划",
				"pc": "460000"
			}, {
				"c": "469001",
				"n": "五指山市",
				"pc": "469000"
			}, {
				"c": "469002",
				"n": "琼海市",
				"pc": "469000"
			}, {
				"c": "469003",
				"n": "儋州市",
				"pc": "469000"
			}, {
				"c": "469005",
				"n": "文昌市",
				"pc": "469000"
			}, {
				"c": "469006",
				"n": "万宁市",
				"pc": "469000"
			}, {
				"c": "469007",
				"n": "东方市",
				"pc": "469000"
			}, {
				"c": "469021",
				"n": "定安县",
				"pc": "469000"
			}, {
				"c": "469022",
				"n": "屯昌县",
				"pc": "469000"
			}, {
				"c": "469023",
				"n": "澄迈县",
				"pc": "469000"
			}, {
				"c": "469024",
				"n": "临高县",
				"pc": "469000"
			}, {
				"c": "469025",
				"n": "白沙黎族自治县",
				"pc": "469000"
			}, {
				"c": "469026",
				"n": "昌江黎族自治县",
				"pc": "469000"
			}, {
				"c": "469027",
				"n": "乐东黎族自治县",
				"pc": "469000"
			}, {
				"c": "469028",
				"n": "陵水黎族自治县",
				"pc": "469000"
			}, {
				"c": "469029",
				"n": "保亭黎族苗族自治县",
				"pc": "469000"
			}, {
				"c": "469030",
				"n": "琼中黎族苗族自治县",
				"pc": "469000"
			}, {
				"c": "500000",
				"n": "重庆市",
				"pc": "86"
			}, {
				"c": "500100",
				"n": "重庆市",
				"pc": "500000"
			}, {
				"c": "500101",
				"n": "万州区",
				"pc": "500100"
			}, {
				"c": "500102",
				"n": "涪陵区",
				"pc": "500100"
			}, {
				"c": "500103",
				"n": "渝中区",
				"pc": "500100"
			}, {
				"c": "500104",
				"n": "大渡口区",
				"pc": "500100"
			}, {
				"c": "500105",
				"n": "江北区",
				"pc": "500100"
			}, {
				"c": "500106",
				"n": "沙坪坝区",
				"pc": "500100"
			}, {
				"c": "500107",
				"n": "九龙坡区",
				"pc": "500100"
			}, {
				"c": "500108",
				"n": "南岸区",
				"pc": "500100"
			}, {
				"c": "500109",
				"n": "北碚区",
				"pc": "500100"
			}, {
				"c": "500110",
				"n": "綦江区",
				"pc": "500100"
			}, {
				"c": "500111",
				"n": "大足区",
				"pc": "500100"
			}, {
				"c": "500112",
				"n": "渝北区",
				"pc": "500100"
			}, {
				"c": "500113",
				"n": "巴南区",
				"pc": "500100"
			}, {
				"c": "500114",
				"n": "黔江区",
				"pc": "500100"
			}, {
				"c": "500115",
				"n": "长寿区",
				"pc": "500100"
			}, {
				"c": "500116",
				"n": "江津区",
				"pc": "500100"
			}, {
				"c": "500117",
				"n": "合川区",
				"pc": "500100"
			}, {
				"c": "500118",
				"n": "永川区",
				"pc": "500100"
			}, {
				"c": "500119",
				"n": "南川区",
				"pc": "500100"
			}, {
				"c": "500100",
				"n": "县",
				"pc": "500000"
			}, {
				"c": "500223",
				"n": "潼南县",
				"pc": "500100"
			}, {
				"c": "500224",
				"n": "铜梁县",
				"pc": "500100"
			}, {
				"c": "500226",
				"n": "荣昌县",
				"pc": "500100"
			}, {
				"c": "500227",
				"n": "璧山县",
				"pc": "500100"
			}, {
				"c": "500228",
				"n": "梁平县",
				"pc": "500100"
			}, {
				"c": "500229",
				"n": "城口县",
				"pc": "500100"
			}, {
				"c": "500230",
				"n": "丰都县",
				"pc": "500100"
			}, {
				"c": "500231",
				"n": "垫江县",
				"pc": "500100"
			}, {
				"c": "500232",
				"n": "武隆县",
				"pc": "500100"
			}, {
				"c": "500233",
				"n": "忠县",
				"pc": "500100"
			}, {
				"c": "500234",
				"n": "开县",
				"pc": "500100"
			}, {
				"c": "500235",
				"n": "云阳县",
				"pc": "500100"
			}, {
				"c": "500236",
				"n": "奉节县",
				"pc": "500100"
			}, {
				"c": "500237",
				"n": "巫山县",
				"pc": "500100"
			}, {
				"c": "500238",
				"n": "巫溪县",
				"pc": "500100"
			}, {
				"c": "500240",
				"n": "石柱土家族自治县",
				"pc": "500100"
			}, {
				"c": "500241",
				"n": "秀山土家族苗族自治县",
				"pc": "500100"
			}, {
				"c": "500242",
				"n": "酉阳土家族苗族自治县",
				"pc": "500100"
			}, {
				"c": "500243",
				"n": "彭水苗族土家族自治县",
				"pc": "500100"
			}, {
				"c": "510000",
				"n": "四川省",
				"pc": "86"
			}, {
				"c": "510100",
				"n": "成都市",
				"pc": "510000"
			}, {
				"c": "510101",
				"n": "市辖区",
				"pc": "510100"
			}, {
				"c": "510104",
				"n": "锦江区",
				"pc": "510100"
			}, {
				"c": "510105",
				"n": "青羊区",
				"pc": "510100"
			}, {
				"c": "510106",
				"n": "金牛区",
				"pc": "510100"
			}, {
				"c": "510107",
				"n": "武侯区",
				"pc": "510100"
			}, {
				"c": "510108",
				"n": "成华区",
				"pc": "510100"
			}, {
				"c": "510112",
				"n": "龙泉驿区",
				"pc": "510100"
			}, {
				"c": "510113",
				"n": "青白江区",
				"pc": "510100"
			}, {
				"c": "510114",
				"n": "新都区",
				"pc": "510100"
			}, {
				"c": "510115",
				"n": "温江区",
				"pc": "510100"
			}, {
				"c": "510121",
				"n": "金堂县",
				"pc": "510100"
			}, {
				"c": "510122",
				"n": "双流县",
				"pc": "510100"
			}, {
				"c": "510124",
				"n": "郫县",
				"pc": "510100"
			}, {
				"c": "510129",
				"n": "大邑县",
				"pc": "510100"
			}, {
				"c": "510131",
				"n": "蒲江县",
				"pc": "510100"
			}, {
				"c": "510132",
				"n": "新津县",
				"pc": "510100"
			}, {
				"c": "510181",
				"n": "都江堰市",
				"pc": "510100"
			}, {
				"c": "510182",
				"n": "彭州市",
				"pc": "510100"
			}, {
				"c": "510183",
				"n": "邛崃市",
				"pc": "510100"
			}, {
				"c": "510184",
				"n": "崇州市",
				"pc": "510100"
			}, {
				"c": "510300",
				"n": "自贡市",
				"pc": "510000"
			}, {
				"c": "510301",
				"n": "市辖区",
				"pc": "510300"
			}, {
				"c": "510302",
				"n": "自流井区",
				"pc": "510300"
			}, {
				"c": "510303",
				"n": "贡井区",
				"pc": "510300"
			}, {
				"c": "510304",
				"n": "大安区",
				"pc": "510300"
			}, {
				"c": "510311",
				"n": "沿滩区",
				"pc": "510300"
			}, {
				"c": "510321",
				"n": "荣县",
				"pc": "510300"
			}, {
				"c": "510322",
				"n": "富顺县",
				"pc": "510300"
			}, {
				"c": "510400",
				"n": "攀枝花市",
				"pc": "510000"
			}, {
				"c": "510401",
				"n": "市辖区",
				"pc": "510400"
			}, {
				"c": "510402",
				"n": "东区",
				"pc": "510400"
			}, {
				"c": "510403",
				"n": "西区",
				"pc": "510400"
			}, {
				"c": "510411",
				"n": "仁和区",
				"pc": "510400"
			}, {
				"c": "510421",
				"n": "米易县",
				"pc": "510400"
			}, {
				"c": "510422",
				"n": "盐边县",
				"pc": "510400"
			}, {
				"c": "510500",
				"n": "泸州市",
				"pc": "510000"
			}, {
				"c": "510501",
				"n": "市辖区",
				"pc": "510500"
			}, {
				"c": "510502",
				"n": "江阳区",
				"pc": "510500"
			}, {
				"c": "510503",
				"n": "纳溪区",
				"pc": "510500"
			}, {
				"c": "510504",
				"n": "龙马潭区",
				"pc": "510500"
			}, {
				"c": "510521",
				"n": "泸县",
				"pc": "510500"
			}, {
				"c": "510522",
				"n": "合江县",
				"pc": "510500"
			}, {
				"c": "510524",
				"n": "叙永县",
				"pc": "510500"
			}, {
				"c": "510525",
				"n": "古蔺县",
				"pc": "510500"
			}, {
				"c": "510600",
				"n": "德阳市",
				"pc": "510000"
			}, {
				"c": "510601",
				"n": "市辖区",
				"pc": "510600"
			}, {
				"c": "510603",
				"n": "旌阳区",
				"pc": "510600"
			}, {
				"c": "510623",
				"n": "中江县",
				"pc": "510600"
			}, {
				"c": "510626",
				"n": "罗江县",
				"pc": "510600"
			}, {
				"c": "510681",
				"n": "广汉市",
				"pc": "510600"
			}, {
				"c": "510682",
				"n": "什邡市",
				"pc": "510600"
			}, {
				"c": "510683",
				"n": "绵竹市",
				"pc": "510600"
			}, {
				"c": "510700",
				"n": "绵阳市",
				"pc": "510000"
			}, {
				"c": "510701",
				"n": "市辖区",
				"pc": "510700"
			}, {
				"c": "510703",
				"n": "涪城区",
				"pc": "510700"
			}, {
				"c": "510704",
				"n": "游仙区",
				"pc": "510700"
			}, {
				"c": "510722",
				"n": "三台县",
				"pc": "510700"
			}, {
				"c": "510723",
				"n": "盐亭县",
				"pc": "510700"
			}, {
				"c": "510724",
				"n": "安县",
				"pc": "510700"
			}, {
				"c": "510725",
				"n": "梓潼县",
				"pc": "510700"
			}, {
				"c": "510726",
				"n": "北川羌族自治县",
				"pc": "510700"
			}, {
				"c": "510727",
				"n": "平武县",
				"pc": "510700"
			}, {
				"c": "510781",
				"n": "江油市",
				"pc": "510700"
			}, {
				"c": "510800",
				"n": "广元市",
				"pc": "510000"
			}, {
				"c": "510801",
				"n": "市辖区",
				"pc": "510800"
			}, {
				"c": "510802",
				"n": "利州区",
				"pc": "510800"
			}, {
				"c": "510811",
				"n": "元坝区",
				"pc": "510800"
			}, {
				"c": "510812",
				"n": "朝天区",
				"pc": "510800"
			}, {
				"c": "510821",
				"n": "旺苍县",
				"pc": "510800"
			}, {
				"c": "510822",
				"n": "青川县",
				"pc": "510800"
			}, {
				"c": "510823",
				"n": "剑阁县",
				"pc": "510800"
			}, {
				"c": "510824",
				"n": "苍溪县",
				"pc": "510800"
			}, {
				"c": "510900",
				"n": "遂宁市",
				"pc": "510000"
			}, {
				"c": "510901",
				"n": "市辖区",
				"pc": "510900"
			}, {
				"c": "510903",
				"n": "船山区",
				"pc": "510900"
			}, {
				"c": "510904",
				"n": "安居区",
				"pc": "510900"
			}, {
				"c": "510921",
				"n": "蓬溪县",
				"pc": "510900"
			}, {
				"c": "510922",
				"n": "射洪县",
				"pc": "510900"
			}, {
				"c": "510923",
				"n": "大英县",
				"pc": "510900"
			}, {
				"c": "511000",
				"n": "内江市",
				"pc": "510000"
			}, {
				"c": "511001",
				"n": "市辖区",
				"pc": "511000"
			}, {
				"c": "511002",
				"n": "市中区",
				"pc": "511000"
			}, {
				"c": "511011",
				"n": "东兴区",
				"pc": "511000"
			}, {
				"c": "511024",
				"n": "威远县",
				"pc": "511000"
			}, {
				"c": "511025",
				"n": "资中县",
				"pc": "511000"
			}, {
				"c": "511028",
				"n": "隆昌县",
				"pc": "511000"
			}, {
				"c": "511100",
				"n": "乐山市",
				"pc": "510000"
			}, {
				"c": "511101",
				"n": "市辖区",
				"pc": "511100"
			}, {
				"c": "511102",
				"n": "市中区",
				"pc": "511100"
			}, {
				"c": "511111",
				"n": "沙湾区",
				"pc": "511100"
			}, {
				"c": "511112",
				"n": "五通桥区",
				"pc": "511100"
			}, {
				"c": "511113",
				"n": "金口河区",
				"pc": "511100"
			}, {
				"c": "511123",
				"n": "犍为县",
				"pc": "511100"
			}, {
				"c": "511124",
				"n": "井研县",
				"pc": "511100"
			}, {
				"c": "511126",
				"n": "夹江县",
				"pc": "511100"
			}, {
				"c": "511129",
				"n": "沐川县",
				"pc": "511100"
			}, {
				"c": "511132",
				"n": "峨边彝族自治县",
				"pc": "511100"
			}, {
				"c": "511133",
				"n": "马边彝族自治县",
				"pc": "511100"
			}, {
				"c": "511181",
				"n": "峨眉山市",
				"pc": "511100"
			}, {
				"c": "511300",
				"n": "南充市",
				"pc": "510000"
			}, {
				"c": "511301",
				"n": "市辖区",
				"pc": "511300"
			}, {
				"c": "511302",
				"n": "顺庆区",
				"pc": "511300"
			}, {
				"c": "511303",
				"n": "高坪区",
				"pc": "511300"
			}, {
				"c": "511304",
				"n": "嘉陵区",
				"pc": "511300"
			}, {
				"c": "511321",
				"n": "南部县",
				"pc": "511300"
			}, {
				"c": "511322",
				"n": "营山县",
				"pc": "511300"
			}, {
				"c": "511323",
				"n": "蓬安县",
				"pc": "511300"
			}, {
				"c": "511324",
				"n": "仪陇县",
				"pc": "511300"
			}, {
				"c": "511325",
				"n": "西充县",
				"pc": "511300"
			}, {
				"c": "511381",
				"n": "阆中市",
				"pc": "511300"
			}, {
				"c": "511400",
				"n": "眉山市",
				"pc": "510000"
			}, {
				"c": "511401",
				"n": "市辖区",
				"pc": "511400"
			}, {
				"c": "511402",
				"n": "东坡区",
				"pc": "511400"
			}, {
				"c": "511421",
				"n": "仁寿县",
				"pc": "511400"
			}, {
				"c": "511422",
				"n": "彭山县",
				"pc": "511400"
			}, {
				"c": "511423",
				"n": "洪雅县",
				"pc": "511400"
			}, {
				"c": "511424",
				"n": "丹棱县",
				"pc": "511400"
			}, {
				"c": "511425",
				"n": "青神县",
				"pc": "511400"
			}, {
				"c": "511500",
				"n": "宜宾市",
				"pc": "510000"
			}, {
				"c": "511501",
				"n": "市辖区",
				"pc": "511500"
			}, {
				"c": "511502",
				"n": "翠屏区",
				"pc": "511500"
			}, {
				"c": "511503",
				"n": "南溪区",
				"pc": "511500"
			}, {
				"c": "511521",
				"n": "宜宾县",
				"pc": "511500"
			}, {
				"c": "511523",
				"n": "江安县",
				"pc": "511500"
			}, {
				"c": "511524",
				"n": "长宁县",
				"pc": "511500"
			}, {
				"c": "511525",
				"n": "高县",
				"pc": "511500"
			}, {
				"c": "511526",
				"n": "珙县",
				"pc": "511500"
			}, {
				"c": "511527",
				"n": "筠连县",
				"pc": "511500"
			}, {
				"c": "511528",
				"n": "兴文县",
				"pc": "511500"
			}, {
				"c": "511529",
				"n": "屏山县",
				"pc": "511500"
			}, {
				"c": "511600",
				"n": "广安市",
				"pc": "510000"
			}, {
				"c": "511601",
				"n": "市辖区",
				"pc": "511600"
			}, {
				"c": "511602",
				"n": "广安区",
				"pc": "511600"
			}, {
				"c": "511621",
				"n": "岳池县",
				"pc": "511600"
			}, {
				"c": "511622",
				"n": "武胜县",
				"pc": "511600"
			}, {
				"c": "511623",
				"n": "邻水县",
				"pc": "511600"
			}, {
				"c": "511681",
				"n": "华蓥市",
				"pc": "511600"
			}, {
				"c": "511700",
				"n": "达州市",
				"pc": "510000"
			}, {
				"c": "511701",
				"n": "市辖区",
				"pc": "511700"
			}, {
				"c": "511702",
				"n": "通川区",
				"pc": "511700"
			}, {
				"c": "511721",
				"n": "达县",
				"pc": "511700"
			}, {
				"c": "511722",
				"n": "宣汉县",
				"pc": "511700"
			}, {
				"c": "511723",
				"n": "开江县",
				"pc": "511700"
			}, {
				"c": "511724",
				"n": "大竹县",
				"pc": "511700"
			}, {
				"c": "511725",
				"n": "渠县",
				"pc": "511700"
			}, {
				"c": "511781",
				"n": "万源市",
				"pc": "511700"
			}, {
				"c": "511800",
				"n": "雅安市",
				"pc": "510000"
			}, {
				"c": "511801",
				"n": "市辖区",
				"pc": "511800"
			}, {
				"c": "511802",
				"n": "雨城区",
				"pc": "511800"
			}, {
				"c": "511803",
				"n": "名山区",
				"pc": "511800"
			}, {
				"c": "511822",
				"n": "荥经县",
				"pc": "511800"
			}, {
				"c": "511823",
				"n": "汉源县",
				"pc": "511800"
			}, {
				"c": "511824",
				"n": "石棉县",
				"pc": "511800"
			}, {
				"c": "511825",
				"n": "天全县",
				"pc": "511800"
			}, {
				"c": "511826",
				"n": "芦山县",
				"pc": "511800"
			}, {
				"c": "511827",
				"n": "宝兴县",
				"pc": "511800"
			}, {
				"c": "511900",
				"n": "巴中市",
				"pc": "510000"
			}, {
				"c": "511901",
				"n": "市辖区",
				"pc": "511900"
			}, {
				"c": "511902",
				"n": "巴州区",
				"pc": "511900"
			}, {
				"c": "511921",
				"n": "通江县",
				"pc": "511900"
			}, {
				"c": "511922",
				"n": "南江县",
				"pc": "511900"
			}, {
				"c": "511923",
				"n": "平昌县",
				"pc": "511900"
			}, {
				"c": "512000",
				"n": "资阳市",
				"pc": "510000"
			}, {
				"c": "512001",
				"n": "市辖区",
				"pc": "512000"
			}, {
				"c": "512002",
				"n": "雁江区",
				"pc": "512000"
			}, {
				"c": "512021",
				"n": "安岳县",
				"pc": "512000"
			}, {
				"c": "512022",
				"n": "乐至县",
				"pc": "512000"
			}, {
				"c": "512081",
				"n": "简阳市",
				"pc": "512000"
			}, {
				"c": "513200",
				"n": "阿坝藏族羌族自治州",
				"pc": "510000"
			}, {
				"c": "513221",
				"n": "汶川县",
				"pc": "513200"
			}, {
				"c": "513222",
				"n": "理县",
				"pc": "513200"
			}, {
				"c": "513223",
				"n": "茂县",
				"pc": "513200"
			}, {
				"c": "513224",
				"n": "松潘县",
				"pc": "513200"
			}, {
				"c": "513225",
				"n": "九寨沟县",
				"pc": "513200"
			}, {
				"c": "513226",
				"n": "金川县",
				"pc": "513200"
			}, {
				"c": "513227",
				"n": "小金县",
				"pc": "513200"
			}, {
				"c": "513228",
				"n": "黑水县",
				"pc": "513200"
			}, {
				"c": "513229",
				"n": "马尔康县",
				"pc": "513200"
			}, {
				"c": "513230",
				"n": "壤塘县",
				"pc": "513200"
			}, {
				"c": "513231",
				"n": "阿坝县",
				"pc": "513200"
			}, {
				"c": "513232",
				"n": "若尔盖县",
				"pc": "513200"
			}, {
				"c": "513233",
				"n": "红原县",
				"pc": "513200"
			}, {
				"c": "513300",
				"n": "甘孜藏族自治州",
				"pc": "510000"
			}, {
				"c": "513321",
				"n": "康定县",
				"pc": "513300"
			}, {
				"c": "513322",
				"n": "泸定县",
				"pc": "513300"
			}, {
				"c": "513323",
				"n": "丹巴县",
				"pc": "513300"
			}, {
				"c": "513324",
				"n": "九龙县",
				"pc": "513300"
			}, {
				"c": "513325",
				"n": "雅江县",
				"pc": "513300"
			}, {
				"c": "513326",
				"n": "道孚县",
				"pc": "513300"
			}, {
				"c": "513327",
				"n": "炉霍县",
				"pc": "513300"
			}, {
				"c": "513328",
				"n": "甘孜县",
				"pc": "513300"
			}, {
				"c": "513329",
				"n": "新龙县",
				"pc": "513300"
			}, {
				"c": "513330",
				"n": "德格县",
				"pc": "513300"
			}, {
				"c": "513331",
				"n": "白玉县",
				"pc": "513300"
			}, {
				"c": "513332",
				"n": "石渠县",
				"pc": "513300"
			}, {
				"c": "513333",
				"n": "色达县",
				"pc": "513300"
			}, {
				"c": "513334",
				"n": "理塘县",
				"pc": "513300"
			}, {
				"c": "513335",
				"n": "巴塘县",
				"pc": "513300"
			}, {
				"c": "513336",
				"n": "乡城县",
				"pc": "513300"
			}, {
				"c": "513337",
				"n": "稻城县",
				"pc": "513300"
			}, {
				"c": "513338",
				"n": "得荣县",
				"pc": "513300"
			}, {
				"c": "513400",
				"n": "凉山彝族自治州",
				"pc": "510000"
			}, {
				"c": "513401",
				"n": "西昌市",
				"pc": "513400"
			}, {
				"c": "513422",
				"n": "木里藏族自治县",
				"pc": "513400"
			}, {
				"c": "513423",
				"n": "盐源县",
				"pc": "513400"
			}, {
				"c": "513424",
				"n": "德昌县",
				"pc": "513400"
			}, {
				"c": "513425",
				"n": "会理县",
				"pc": "513400"
			}, {
				"c": "513426",
				"n": "会东县",
				"pc": "513400"
			}, {
				"c": "513427",
				"n": "宁南县",
				"pc": "513400"
			}, {
				"c": "513428",
				"n": "普格县",
				"pc": "513400"
			}, {
				"c": "513429",
				"n": "布拖县",
				"pc": "513400"
			}, {
				"c": "513430",
				"n": "金阳县",
				"pc": "513400"
			}, {
				"c": "513431",
				"n": "昭觉县",
				"pc": "513400"
			}, {
				"c": "513432",
				"n": "喜德县",
				"pc": "513400"
			}, {
				"c": "513433",
				"n": "冕宁县",
				"pc": "513400"
			}, {
				"c": "513434",
				"n": "越西县",
				"pc": "513400"
			}, {
				"c": "513435",
				"n": "甘洛县",
				"pc": "513400"
			}, {
				"c": "513436",
				"n": "美姑县",
				"pc": "513400"
			}, {
				"c": "513437",
				"n": "雷波县",
				"pc": "513400"
			}, {
				"c": "520000",
				"n": "贵州省",
				"pc": "86"
			}, {
				"c": "520100",
				"n": "贵阳市",
				"pc": "520000"
			}, {
				"c": "520101",
				"n": "市辖区",
				"pc": "520100"
			}, {
				"c": "520102",
				"n": "南明区",
				"pc": "520100"
			}, {
				"c": "520103",
				"n": "云岩区",
				"pc": "520100"
			}, {
				"c": "520111",
				"n": "花溪区",
				"pc": "520100"
			}, {
				"c": "520112",
				"n": "乌当区",
				"pc": "520100"
			}, {
				"c": "520113",
				"n": "白云区",
				"pc": "520100"
			}, {
				"c": "520114",
				"n": "小河区",
				"pc": "520100"
			}, {
				"c": "520121",
				"n": "开阳县",
				"pc": "520100"
			}, {
				"c": "520122",
				"n": "息烽县",
				"pc": "520100"
			}, {
				"c": "520123",
				"n": "修文县",
				"pc": "520100"
			}, {
				"c": "520181",
				"n": "清镇市",
				"pc": "520100"
			}, {
				"c": "520200",
				"n": "六盘水市",
				"pc": "520000"
			}, {
				"c": "520201",
				"n": "钟山区",
				"pc": "520200"
			}, {
				"c": "520203",
				"n": "六枝特区",
				"pc": "520200"
			}, {
				"c": "520221",
				"n": "水城县",
				"pc": "520200"
			}, {
				"c": "520222",
				"n": "盘县",
				"pc": "520200"
			}, {
				"c": "520300",
				"n": "遵义市",
				"pc": "520000"
			}, {
				"c": "520301",
				"n": "市辖区",
				"pc": "520300"
			}, {
				"c": "520302",
				"n": "红花岗区",
				"pc": "520300"
			}, {
				"c": "520303",
				"n": "汇川区",
				"pc": "520300"
			}, {
				"c": "520321",
				"n": "遵义县",
				"pc": "520300"
			}, {
				"c": "520322",
				"n": "桐梓县",
				"pc": "520300"
			}, {
				"c": "520323",
				"n": "绥阳县",
				"pc": "520300"
			}, {
				"c": "520324",
				"n": "正安县",
				"pc": "520300"
			}, {
				"c": "520325",
				"n": "道真仡佬族苗族自治县",
				"pc": "520300"
			}, {
				"c": "520326",
				"n": "务川仡佬族苗族自治县",
				"pc": "520300"
			}, {
				"c": "520327",
				"n": "凤冈县",
				"pc": "520300"
			}, {
				"c": "520328",
				"n": "湄潭县",
				"pc": "520300"
			}, {
				"c": "520329",
				"n": "余庆县",
				"pc": "520300"
			}, {
				"c": "520330",
				"n": "习水县",
				"pc": "520300"
			}, {
				"c": "520381",
				"n": "赤水市",
				"pc": "520300"
			}, {
				"c": "520382",
				"n": "仁怀市",
				"pc": "520300"
			}, {
				"c": "520400",
				"n": "安顺市",
				"pc": "520000"
			}, {
				"c": "520401",
				"n": "市辖区",
				"pc": "520400"
			}, {
				"c": "520402",
				"n": "西秀区",
				"pc": "520400"
			}, {
				"c": "520421",
				"n": "平坝县",
				"pc": "520400"
			}, {
				"c": "520422",
				"n": "普定县",
				"pc": "520400"
			}, {
				"c": "520423",
				"n": "镇宁布依族苗族自治县",
				"pc": "520400"
			}, {
				"c": "520424",
				"n": "关岭布依族苗族自治县",
				"pc": "520400"
			}, {
				"c": "520425",
				"n": "紫云苗族布依族自治县",
				"pc": "520400"
			}, {
				"c": "520500",
				"n": "毕节市",
				"pc": "520000"
			}, {
				"c": "520502",
				"n": "七星关区",
				"pc": "520500"
			}, {
				"c": "520521",
				"n": "大方县",
				"pc": "520500"
			}, {
				"c": "520522",
				"n": "黔西县",
				"pc": "520500"
			}, {
				"c": "520523",
				"n": "金沙县",
				"pc": "520500"
			}, {
				"c": "520524",
				"n": "织金县",
				"pc": "520500"
			}, {
				"c": "520525",
				"n": "纳雍县",
				"pc": "520500"
			}, {
				"c": "520526",
				"n": "威宁彝族回族苗族自治县",
				"pc": "520500"
			}, {
				"c": "520527",
				"n": "赫章县",
				"pc": "520500"
			}, {
				"c": "520600",
				"n": "铜仁市",
				"pc": "520000"
			}, {
				"c": "520602",
				"n": "碧江区",
				"pc": "520600"
			}, {
				"c": "520603",
				"n": "万山区",
				"pc": "520600"
			}, {
				"c": "520621",
				"n": "江口县",
				"pc": "520600"
			}, {
				"c": "520622",
				"n": "玉屏侗族自治县",
				"pc": "520600"
			}, {
				"c": "520623",
				"n": "石阡县",
				"pc": "520600"
			}, {
				"c": "520624",
				"n": "思南县",
				"pc": "520600"
			}, {
				"c": "520625",
				"n": "印江土家族苗族自治县",
				"pc": "520600"
			}, {
				"c": "520626",
				"n": "德江县",
				"pc": "520600"
			}, {
				"c": "520627",
				"n": "沿河土家族自治县",
				"pc": "520600"
			}, {
				"c": "520628",
				"n": "松桃苗族自治县",
				"pc": "520600"
			}, {
				"c": "522300",
				"n": "黔西南布依族苗族自治州",
				"pc": "520000"
			}, {
				"c": "522301",
				"n": "兴义市",
				"pc": "522300"
			}, {
				"c": "522322",
				"n": "兴仁县",
				"pc": "522300"
			}, {
				"c": "522323",
				"n": "普安县",
				"pc": "522300"
			}, {
				"c": "522324",
				"n": "晴隆县",
				"pc": "522300"
			}, {
				"c": "522325",
				"n": "贞丰县",
				"pc": "522300"
			}, {
				"c": "522326",
				"n": "望谟县",
				"pc": "522300"
			}, {
				"c": "522327",
				"n": "册亨县",
				"pc": "522300"
			}, {
				"c": "522328",
				"n": "安龙县",
				"pc": "522300"
			}, {
				"c": "522600",
				"n": "黔东南苗族侗族自治州",
				"pc": "520000"
			}, {
				"c": "522601",
				"n": "凯里市",
				"pc": "522600"
			}, {
				"c": "522622",
				"n": "黄平县",
				"pc": "522600"
			}, {
				"c": "522623",
				"n": "施秉县",
				"pc": "522600"
			}, {
				"c": "522624",
				"n": "三穗县",
				"pc": "522600"
			}, {
				"c": "522625",
				"n": "镇远县",
				"pc": "522600"
			}, {
				"c": "522626",
				"n": "岑巩县",
				"pc": "522600"
			}, {
				"c": "522627",
				"n": "天柱县",
				"pc": "522600"
			}, {
				"c": "522628",
				"n": "锦屏县",
				"pc": "522600"
			}, {
				"c": "522629",
				"n": "剑河县",
				"pc": "522600"
			}, {
				"c": "522630",
				"n": "台江县",
				"pc": "522600"
			}, {
				"c": "522631",
				"n": "黎平县",
				"pc": "522600"
			}, {
				"c": "522632",
				"n": "榕江县",
				"pc": "522600"
			}, {
				"c": "522633",
				"n": "从江县",
				"pc": "522600"
			}, {
				"c": "522634",
				"n": "雷山县",
				"pc": "522600"
			}, {
				"c": "522635",
				"n": "麻江县",
				"pc": "522600"
			}, {
				"c": "522636",
				"n": "丹寨县",
				"pc": "522600"
			}, {
				"c": "522700",
				"n": "黔南布依族苗族自治州",
				"pc": "520000"
			}, {
				"c": "522701",
				"n": "都匀市",
				"pc": "522700"
			}, {
				"c": "522702",
				"n": "福泉市",
				"pc": "522700"
			}, {
				"c": "522722",
				"n": "荔波县",
				"pc": "522700"
			}, {
				"c": "522723",
				"n": "贵定县",
				"pc": "522700"
			}, {
				"c": "522725",
				"n": "瓮安县",
				"pc": "522700"
			}, {
				"c": "522726",
				"n": "独山县",
				"pc": "522700"
			}, {
				"c": "522727",
				"n": "平塘县",
				"pc": "522700"
			}, {
				"c": "522728",
				"n": "罗甸县",
				"pc": "522700"
			}, {
				"c": "522729",
				"n": "长顺县",
				"pc": "522700"
			}, {
				"c": "522730",
				"n": "龙里县",
				"pc": "522700"
			}, {
				"c": "522731",
				"n": "惠水县",
				"pc": "522700"
			}, {
				"c": "522732",
				"n": "三都水族自治县",
				"pc": "522700"
			}, {
				"c": "530000",
				"n": "云南省",
				"pc": "86"
			}, {
				"c": "530100",
				"n": "昆明市",
				"pc": "530000"
			}, {
				"c": "530101",
				"n": "市辖区",
				"pc": "530100"
			}, {
				"c": "530102",
				"n": "五华区",
				"pc": "530100"
			}, {
				"c": "530103",
				"n": "盘龙区",
				"pc": "530100"
			}, {
				"c": "530111",
				"n": "官渡区",
				"pc": "530100"
			}, {
				"c": "530112",
				"n": "西山区",
				"pc": "530100"
			}, {
				"c": "530113",
				"n": "东川区",
				"pc": "530100"
			}, {
				"c": "530114",
				"n": "呈贡区",
				"pc": "530100"
			}, {
				"c": "530122",
				"n": "晋宁县",
				"pc": "530100"
			}, {
				"c": "530124",
				"n": "富民县",
				"pc": "530100"
			}, {
				"c": "530125",
				"n": "宜良县",
				"pc": "530100"
			}, {
				"c": "530126",
				"n": "石林彝族自治县",
				"pc": "530100"
			}, {
				"c": "530127",
				"n": "嵩明县",
				"pc": "530100"
			}, {
				"c": "530128",
				"n": "禄劝彝族苗族自治县",
				"pc": "530100"
			}, {
				"c": "530129",
				"n": "寻甸回族彝族自治县",
				"pc": "530100"
			}, {
				"c": "530181",
				"n": "安宁市",
				"pc": "530100"
			}, {
				"c": "530300",
				"n": "曲靖市",
				"pc": "530000"
			}, {
				"c": "530301",
				"n": "市辖区",
				"pc": "530300"
			}, {
				"c": "530302",
				"n": "麒麟区",
				"pc": "530300"
			}, {
				"c": "530321",
				"n": "马龙县",
				"pc": "530300"
			}, {
				"c": "530322",
				"n": "陆良县",
				"pc": "530300"
			}, {
				"c": "530323",
				"n": "师宗县",
				"pc": "530300"
			}, {
				"c": "530324",
				"n": "罗平县",
				"pc": "530300"
			}, {
				"c": "530325",
				"n": "富源县",
				"pc": "530300"
			}, {
				"c": "530326",
				"n": "会泽县",
				"pc": "530300"
			}, {
				"c": "530328",
				"n": "沾益县",
				"pc": "530300"
			}, {
				"c": "530381",
				"n": "宣威市",
				"pc": "530300"
			}, {
				"c": "530400",
				"n": "玉溪市",
				"pc": "530000"
			}, {
				"c": "530402",
				"n": "红塔区",
				"pc": "530400"
			}, {
				"c": "530421",
				"n": "江川县",
				"pc": "530400"
			}, {
				"c": "530422",
				"n": "澄江县",
				"pc": "530400"
			}, {
				"c": "530423",
				"n": "通海县",
				"pc": "530400"
			}, {
				"c": "530424",
				"n": "华宁县",
				"pc": "530400"
			}, {
				"c": "530425",
				"n": "易门县",
				"pc": "530400"
			}, {
				"c": "530426",
				"n": "峨山彝族自治县",
				"pc": "530400"
			}, {
				"c": "530427",
				"n": "新平彝族傣族自治县",
				"pc": "530400"
			}, {
				"c": "530428",
				"n": "元江哈尼族彝族傣族自治县",
				"pc": "530400"
			}, {
				"c": "530500",
				"n": "保山市",
				"pc": "530000"
			}, {
				"c": "530501",
				"n": "市辖区",
				"pc": "530500"
			}, {
				"c": "530502",
				"n": "隆阳区",
				"pc": "530500"
			}, {
				"c": "530521",
				"n": "施甸县",
				"pc": "530500"
			}, {
				"c": "530522",
				"n": "腾冲县",
				"pc": "530500"
			}, {
				"c": "530523",
				"n": "龙陵县",
				"pc": "530500"
			}, {
				"c": "530524",
				"n": "昌宁县",
				"pc": "530500"
			}, {
				"c": "530600",
				"n": "昭通市",
				"pc": "530000"
			}, {
				"c": "530601",
				"n": "市辖区",
				"pc": "530600"
			}, {
				"c": "530602",
				"n": "昭阳区",
				"pc": "530600"
			}, {
				"c": "530621",
				"n": "鲁甸县",
				"pc": "530600"
			}, {
				"c": "530622",
				"n": "巧家县",
				"pc": "530600"
			}, {
				"c": "530623",
				"n": "盐津县",
				"pc": "530600"
			}, {
				"c": "530624",
				"n": "大关县",
				"pc": "530600"
			}, {
				"c": "530625",
				"n": "永善县",
				"pc": "530600"
			}, {
				"c": "530626",
				"n": "绥江县",
				"pc": "530600"
			}, {
				"c": "530627",
				"n": "镇雄县",
				"pc": "530600"
			}, {
				"c": "530628",
				"n": "彝良县",
				"pc": "530600"
			}, {
				"c": "530629",
				"n": "威信县",
				"pc": "530600"
			}, {
				"c": "530630",
				"n": "水富县",
				"pc": "530600"
			}, {
				"c": "530700",
				"n": "丽江市",
				"pc": "530000"
			}, {
				"c": "530701",
				"n": "市辖区",
				"pc": "530700"
			}, {
				"c": "530702",
				"n": "古城区",
				"pc": "530700"
			}, {
				"c": "530721",
				"n": "玉龙纳西族自治县",
				"pc": "530700"
			}, {
				"c": "530722",
				"n": "永胜县",
				"pc": "530700"
			}, {
				"c": "530723",
				"n": "华坪县",
				"pc": "530700"
			}, {
				"c": "530724",
				"n": "宁蒗彝族自治县",
				"pc": "530700"
			}, {
				"c": "530800",
				"n": "普洱市",
				"pc": "530000"
			}, {
				"c": "530801",
				"n": "市辖区",
				"pc": "530800"
			}, {
				"c": "530802",
				"n": "思茅区",
				"pc": "530800"
			}, {
				"c": "530821",
				"n": "宁洱哈尼族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530822",
				"n": "墨江哈尼族自治县",
				"pc": "530800"
			}, {
				"c": "530823",
				"n": "景东彝族自治县",
				"pc": "530800"
			}, {
				"c": "530824",
				"n": "景谷傣族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530825",
				"n": "镇沅彝族哈尼族拉祜族自治县",
				"pc": "530800"
			}, {
				"c": "530826",
				"n": "江城哈尼族彝族自治县",
				"pc": "530800"
			}, {
				"c": "530827",
				"n": "孟连傣族拉祜族佤族自治县",
				"pc": "530800"
			}, {
				"c": "530828",
				"n": "澜沧拉祜族自治县",
				"pc": "530800"
			}, {
				"c": "530829",
				"n": "西盟佤族自治县",
				"pc": "530800"
			}, {
				"c": "530900",
				"n": "临沧市",
				"pc": "530000"
			}, {
				"c": "530901",
				"n": "市辖区",
				"pc": "530900"
			}, {
				"c": "530902",
				"n": "临翔区",
				"pc": "530900"
			}, {
				"c": "530921",
				"n": "凤庆县",
				"pc": "530900"
			}, {
				"c": "530922",
				"n": "云县",
				"pc": "530900"
			}, {
				"c": "530923",
				"n": "永德县",
				"pc": "530900"
			}, {
				"c": "530924",
				"n": "镇康县",
				"pc": "530900"
			}, {
				"c": "530925",
				"n": "双江拉祜族佤族布朗族傣族自治县",
				"pc": "530900"
			}, {
				"c": "530926",
				"n": "耿马傣族佤族自治县",
				"pc": "530900"
			}, {
				"c": "530927",
				"n": "沧源佤族自治县",
				"pc": "530900"
			}, {
				"c": "532300",
				"n": "楚雄彝族自治州",
				"pc": "530000"
			}, {
				"c": "532301",
				"n": "楚雄市",
				"pc": "532300"
			}, {
				"c": "532322",
				"n": "双柏县",
				"pc": "532300"
			}, {
				"c": "532323",
				"n": "牟定县",
				"pc": "532300"
			}, {
				"c": "532324",
				"n": "南华县",
				"pc": "532300"
			}, {
				"c": "532325",
				"n": "姚安县",
				"pc": "532300"
			}, {
				"c": "532326",
				"n": "大姚县",
				"pc": "532300"
			}, {
				"c": "532327",
				"n": "永仁县",
				"pc": "532300"
			}, {
				"c": "532328",
				"n": "元谋县",
				"pc": "532300"
			}, {
				"c": "532329",
				"n": "武定县",
				"pc": "532300"
			}, {
				"c": "532331",
				"n": "禄丰县",
				"pc": "532300"
			}, {
				"c": "532500",
				"n": "红河哈尼族彝族自治州",
				"pc": "530000"
			}, {
				"c": "532501",
				"n": "个旧市",
				"pc": "532500"
			}, {
				"c": "532502",
				"n": "开远市",
				"pc": "532500"
			}, {
				"c": "532503",
				"n": "蒙自市",
				"pc": "532500"
			}, {
				"c": "532523",
				"n": "屏边苗族自治县",
				"pc": "532500"
			}, {
				"c": "532524",
				"n": "建水县",
				"pc": "532500"
			}, {
				"c": "532525",
				"n": "石屏县",
				"pc": "532500"
			}, {
				"c": "532526",
				"n": "弥勒县",
				"pc": "532500"
			}, {
				"c": "532527",
				"n": "泸西县",
				"pc": "532500"
			}, {
				"c": "532528",
				"n": "元阳县",
				"pc": "532500"
			}, {
				"c": "532529",
				"n": "红河县",
				"pc": "532500"
			}, {
				"c": "532530",
				"n": "金平苗族瑶族傣族自治县",
				"pc": "532500"
			}, {
				"c": "532531",
				"n": "绿春县",
				"pc": "532500"
			}, {
				"c": "532532",
				"n": "河口瑶族自治县",
				"pc": "532500"
			}, {
				"c": "532600",
				"n": "文山壮族苗族自治州",
				"pc": "530000"
			}, {
				"c": "532601",
				"n": "文山市",
				"pc": "532600"
			}, {
				"c": "532622",
				"n": "砚山县",
				"pc": "532600"
			}, {
				"c": "532623",
				"n": "西畴县",
				"pc": "532600"
			}, {
				"c": "532624",
				"n": "麻栗坡县",
				"pc": "532600"
			}, {
				"c": "532625",
				"n": "马关县",
				"pc": "532600"
			}, {
				"c": "532626",
				"n": "丘北县",
				"pc": "532600"
			}, {
				"c": "532627",
				"n": "广南县",
				"pc": "532600"
			}, {
				"c": "532628",
				"n": "富宁县",
				"pc": "532600"
			}, {
				"c": "532800",
				"n": "西双版纳傣族自治州",
				"pc": "530000"
			}, {
				"c": "532801",
				"n": "景洪市",
				"pc": "532800"
			}, {
				"c": "532822",
				"n": "勐海县",
				"pc": "532800"
			}, {
				"c": "532823",
				"n": "勐腊县",
				"pc": "532800"
			}, {
				"c": "532900",
				"n": "大理白族自治州",
				"pc": "530000"
			}, {
				"c": "532901",
				"n": "大理市",
				"pc": "532900"
			}, {
				"c": "532922",
				"n": "漾濞彝族自治县",
				"pc": "532900"
			}, {
				"c": "532923",
				"n": "祥云县",
				"pc": "532900"
			}, {
				"c": "532924",
				"n": "宾川县",
				"pc": "532900"
			}, {
				"c": "532925",
				"n": "弥渡县",
				"pc": "532900"
			}, {
				"c": "532926",
				"n": "南涧彝族自治县",
				"pc": "532900"
			}, {
				"c": "532927",
				"n": "巍山彝族回族自治县",
				"pc": "532900"
			}, {
				"c": "532928",
				"n": "永平县",
				"pc": "532900"
			}, {
				"c": "532929",
				"n": "云龙县",
				"pc": "532900"
			}, {
				"c": "532930",
				"n": "洱源县",
				"pc": "532900"
			}, {
				"c": "532931",
				"n": "剑川县",
				"pc": "532900"
			}, {
				"c": "532932",
				"n": "鹤庆县",
				"pc": "532900"
			}, {
				"c": "533100",
				"n": "德宏傣族景颇族自治州",
				"pc": "530000"
			}, {
				"c": "533102",
				"n": "瑞丽市",
				"pc": "533100"
			}, {
				"c": "533103",
				"n": "芒市",
				"pc": "533100"
			}, {
				"c": "533122",
				"n": "梁河县",
				"pc": "533100"
			}, {
				"c": "533123",
				"n": "盈江县",
				"pc": "533100"
			}, {
				"c": "533124",
				"n": "陇川县",
				"pc": "533100"
			}, {
				"c": "533300",
				"n": "怒江傈僳族自治州",
				"pc": "530000"
			}, {
				"c": "533321",
				"n": "泸水县",
				"pc": "533300"
			}, {
				"c": "533323",
				"n": "福贡县",
				"pc": "533300"
			}, {
				"c": "533324",
				"n": "贡山独龙族怒族自治县",
				"pc": "533300"
			}, {
				"c": "533325",
				"n": "兰坪白族普米族自治县",
				"pc": "533300"
			}, {
				"c": "533400",
				"n": "迪庆藏族自治州",
				"pc": "530000"
			}, {
				"c": "533421",
				"n": "香格里拉县",
				"pc": "533400"
			}, {
				"c": "533422",
				"n": "德钦县",
				"pc": "533400"
			}, {
				"c": "533423",
				"n": "维西傈僳族自治县",
				"pc": "533400"
			}, {
				"c": "540000",
				"n": "西藏自治区",
				"pc": "86"
			}, {
				"c": "540100",
				"n": "拉萨市",
				"pc": "540000"
			}, {
				"c": "540101",
				"n": "市辖区",
				"pc": "540100"
			}, {
				"c": "540102",
				"n": "城关区",
				"pc": "540100"
			}, {
				"c": "540121",
				"n": "林周县",
				"pc": "540100"
			}, {
				"c": "540122",
				"n": "当雄县",
				"pc": "540100"
			}, {
				"c": "540123",
				"n": "尼木县",
				"pc": "540100"
			}, {
				"c": "540124",
				"n": "曲水县",
				"pc": "540100"
			}, {
				"c": "540125",
				"n": "堆龙德庆县",
				"pc": "540100"
			}, {
				"c": "540126",
				"n": "达孜县",
				"pc": "540100"
			}, {
				"c": "540127",
				"n": "墨竹工卡县",
				"pc": "540100"
			}, {
				"c": "542100",
				"n": "昌都地区",
				"pc": "540000"
			}, {
				"c": "542121",
				"n": "昌都县",
				"pc": "542100"
			}, {
				"c": "542122",
				"n": "江达县",
				"pc": "542100"
			}, {
				"c": "542123",
				"n": "贡觉县",
				"pc": "542100"
			}, {
				"c": "542124",
				"n": "类乌齐县",
				"pc": "542100"
			}, {
				"c": "542125",
				"n": "丁青县",
				"pc": "542100"
			}, {
				"c": "542126",
				"n": "察雅县",
				"pc": "542100"
			}, {
				"c": "542127",
				"n": "八宿县",
				"pc": "542100"
			}, {
				"c": "542128",
				"n": "左贡县",
				"pc": "542100"
			}, {
				"c": "542129",
				"n": "芒康县",
				"pc": "542100"
			}, {
				"c": "542132",
				"n": "洛隆县",
				"pc": "542100"
			}, {
				"c": "542133",
				"n": "边坝县",
				"pc": "542100"
			}, {
				"c": "542200",
				"n": "山南地区",
				"pc": "540000"
			}, {
				"c": "542221",
				"n": "乃东县",
				"pc": "542200"
			}, {
				"c": "542222",
				"n": "扎囊县",
				"pc": "542200"
			}, {
				"c": "542223",
				"n": "贡嘎县",
				"pc": "542200"
			}, {
				"c": "542224",
				"n": "桑日县",
				"pc": "542200"
			}, {
				"c": "542225",
				"n": "琼结县",
				"pc": "542200"
			}, {
				"c": "542226",
				"n": "曲松县",
				"pc": "542200"
			}, {
				"c": "542227",
				"n": "措美县",
				"pc": "542200"
			}, {
				"c": "542228",
				"n": "洛扎县",
				"pc": "542200"
			}, {
				"c": "542229",
				"n": "加查县",
				"pc": "542200"
			}, {
				"c": "542231",
				"n": "隆子县",
				"pc": "542200"
			}, {
				"c": "542232",
				"n": "错那县",
				"pc": "542200"
			}, {
				"c": "542233",
				"n": "浪卡子县",
				"pc": "542200"
			}, {
				"c": "542300",
				"n": "日喀则地区",
				"pc": "540000"
			}, {
				"c": "542301",
				"n": "日喀则市",
				"pc": "542300"
			}, {
				"c": "542322",
				"n": "南木林县",
				"pc": "542300"
			}, {
				"c": "542323",
				"n": "江孜县",
				"pc": "542300"
			}, {
				"c": "542324",
				"n": "定日县",
				"pc": "542300"
			}, {
				"c": "542325",
				"n": "萨迦县",
				"pc": "542300"
			}, {
				"c": "542326",
				"n": "拉孜县",
				"pc": "542300"
			}, {
				"c": "542327",
				"n": "昂仁县",
				"pc": "542300"
			}, {
				"c": "542328",
				"n": "谢通门县",
				"pc": "542300"
			}, {
				"c": "542329",
				"n": "白朗县",
				"pc": "542300"
			}, {
				"c": "542330",
				"n": "仁布县",
				"pc": "542300"
			}, {
				"c": "542331",
				"n": "康马县",
				"pc": "542300"
			}, {
				"c": "542332",
				"n": "定结县",
				"pc": "542300"
			}, {
				"c": "542333",
				"n": "仲巴县",
				"pc": "542300"
			}, {
				"c": "542334",
				"n": "亚东县",
				"pc": "542300"
			}, {
				"c": "542335",
				"n": "吉隆县",
				"pc": "542300"
			}, {
				"c": "542336",
				"n": "聂拉木县",
				"pc": "542300"
			}, {
				"c": "542337",
				"n": "萨嘎县",
				"pc": "542300"
			}, {
				"c": "542338",
				"n": "岗巴县",
				"pc": "542300"
			}, {
				"c": "542400",
				"n": "那曲地区",
				"pc": "540000"
			}, {
				"c": "542421",
				"n": "那曲县",
				"pc": "542400"
			}, {
				"c": "542422",
				"n": "嘉黎县",
				"pc": "542400"
			}, {
				"c": "542423",
				"n": "比如县",
				"pc": "542400"
			}, {
				"c": "542424",
				"n": "聂荣县",
				"pc": "542400"
			}, {
				"c": "542425",
				"n": "安多县",
				"pc": "542400"
			}, {
				"c": "542426",
				"n": "申扎县",
				"pc": "542400"
			}, {
				"c": "542427",
				"n": "索县",
				"pc": "542400"
			}, {
				"c": "542428",
				"n": "班戈县",
				"pc": "542400"
			}, {
				"c": "542429",
				"n": "巴青县",
				"pc": "542400"
			}, {
				"c": "542430",
				"n": "尼玛县",
				"pc": "542400"
			}, {
				"c": "542500",
				"n": "阿里地区",
				"pc": "540000"
			}, {
				"c": "542521",
				"n": "普兰县",
				"pc": "542500"
			}, {
				"c": "542522",
				"n": "札达县",
				"pc": "542500"
			}, {
				"c": "542523",
				"n": "噶尔县",
				"pc": "542500"
			}, {
				"c": "542524",
				"n": "日土县",
				"pc": "542500"
			}, {
				"c": "542525",
				"n": "革吉县",
				"pc": "542500"
			}, {
				"c": "542526",
				"n": "改则县",
				"pc": "542500"
			}, {
				"c": "542527",
				"n": "措勤县",
				"pc": "542500"
			}, {
				"c": "542600",
				"n": "林芝地区",
				"pc": "540000"
			}, {
				"c": "542621",
				"n": "林芝县",
				"pc": "542600"
			}, {
				"c": "542622",
				"n": "工布江达县",
				"pc": "542600"
			}, {
				"c": "542623",
				"n": "米林县",
				"pc": "542600"
			}, {
				"c": "542624",
				"n": "墨脱县",
				"pc": "542600"
			}, {
				"c": "542625",
				"n": "波密县",
				"pc": "542600"
			}, {
				"c": "542626",
				"n": "察隅县",
				"pc": "542600"
			}, {
				"c": "542627",
				"n": "朗县",
				"pc": "542600"
			}, {
				"c": "610000",
				"n": "陕西省",
				"pc": "86"
			}, {
				"c": "610100",
				"n": "西安市",
				"pc": "610000"
			}, {
				"c": "610101",
				"n": "市辖区",
				"pc": "610100"
			}, {
				"c": "610102",
				"n": "新城区",
				"pc": "610100"
			}, {
				"c": "610103",
				"n": "碑林区",
				"pc": "610100"
			}, {
				"c": "610104",
				"n": "莲湖区",
				"pc": "610100"
			}, {
				"c": "610111",
				"n": "灞桥区",
				"pc": "610100"
			}, {
				"c": "610112",
				"n": "未央区",
				"pc": "610100"
			}, {
				"c": "610113",
				"n": "雁塔区",
				"pc": "610100"
			}, {
				"c": "610114",
				"n": "阎良区",
				"pc": "610100"
			}, {
				"c": "610115",
				"n": "临潼区",
				"pc": "610100"
			}, {
				"c": "610116",
				"n": "长安区",
				"pc": "610100"
			}, {
				"c": "610122",
				"n": "蓝田县",
				"pc": "610100"
			}, {
				"c": "610124",
				"n": "周至县",
				"pc": "610100"
			}, {
				"c": "610125",
				"n": "户县",
				"pc": "610100"
			}, {
				"c": "610126",
				"n": "高陵县",
				"pc": "610100"
			}, {
				"c": "610200",
				"n": "铜川市",
				"pc": "610000"
			}, {
				"c": "610201",
				"n": "市辖区",
				"pc": "610200"
			}, {
				"c": "610202",
				"n": "王益区",
				"pc": "610200"
			}, {
				"c": "610203",
				"n": "印台区",
				"pc": "610200"
			}, {
				"c": "610204",
				"n": "耀州区",
				"pc": "610200"
			}, {
				"c": "610222",
				"n": "宜君县",
				"pc": "610200"
			}, {
				"c": "610300",
				"n": "宝鸡市",
				"pc": "610000"
			}, {
				"c": "610301",
				"n": "市辖区",
				"pc": "610300"
			}, {
				"c": "610302",
				"n": "渭滨区",
				"pc": "610300"
			}, {
				"c": "610303",
				"n": "金台区",
				"pc": "610300"
			}, {
				"c": "610304",
				"n": "陈仓区",
				"pc": "610300"
			}, {
				"c": "610322",
				"n": "凤翔县",
				"pc": "610300"
			}, {
				"c": "610323",
				"n": "岐山县",
				"pc": "610300"
			}, {
				"c": "610324",
				"n": "扶风县",
				"pc": "610300"
			}, {
				"c": "610326",
				"n": "眉县",
				"pc": "610300"
			}, {
				"c": "610327",
				"n": "陇县",
				"pc": "610300"
			}, {
				"c": "610328",
				"n": "千阳县",
				"pc": "610300"
			}, {
				"c": "610329",
				"n": "麟游县",
				"pc": "610300"
			}, {
				"c": "610330",
				"n": "凤县",
				"pc": "610300"
			}, {
				"c": "610331",
				"n": "太白县",
				"pc": "610300"
			}, {
				"c": "610400",
				"n": "咸阳市",
				"pc": "610000"
			}, {
				"c": "610401",
				"n": "市辖区",
				"pc": "610400"
			}, {
				"c": "610402",
				"n": "秦都区",
				"pc": "610400"
			}, {
				"c": "610403",
				"n": "杨陵区",
				"pc": "610400"
			}, {
				"c": "610404",
				"n": "渭城区",
				"pc": "610400"
			}, {
				"c": "610422",
				"n": "三原县",
				"pc": "610400"
			}, {
				"c": "610423",
				"n": "泾阳县",
				"pc": "610400"
			}, {
				"c": "610424",
				"n": "乾县",
				"pc": "610400"
			}, {
				"c": "610425",
				"n": "礼泉县",
				"pc": "610400"
			}, {
				"c": "610426",
				"n": "永寿县",
				"pc": "610400"
			}, {
				"c": "610427",
				"n": "彬县",
				"pc": "610400"
			}, {
				"c": "610428",
				"n": "长武县",
				"pc": "610400"
			}, {
				"c": "610429",
				"n": "旬邑县",
				"pc": "610400"
			}, {
				"c": "610430",
				"n": "淳化县",
				"pc": "610400"
			}, {
				"c": "610431",
				"n": "武功县",
				"pc": "610400"
			}, {
				"c": "610481",
				"n": "兴平市",
				"pc": "610400"
			}, {
				"c": "610500",
				"n": "渭南市",
				"pc": "610000"
			}, {
				"c": "610501",
				"n": "市辖区",
				"pc": "610500"
			}, {
				"c": "610502",
				"n": "临渭区",
				"pc": "610500"
			}, {
				"c": "610521",
				"n": "华县",
				"pc": "610500"
			}, {
				"c": "610522",
				"n": "潼关县",
				"pc": "610500"
			}, {
				"c": "610523",
				"n": "大荔县",
				"pc": "610500"
			}, {
				"c": "610524",
				"n": "合阳县",
				"pc": "610500"
			}, {
				"c": "610525",
				"n": "澄城县",
				"pc": "610500"
			}, {
				"c": "610526",
				"n": "蒲城县",
				"pc": "610500"
			}, {
				"c": "610527",
				"n": "白水县",
				"pc": "610500"
			}, {
				"c": "610528",
				"n": "富平县",
				"pc": "610500"
			}, {
				"c": "610581",
				"n": "韩城市",
				"pc": "610500"
			}, {
				"c": "610582",
				"n": "华阴市",
				"pc": "610500"
			}, {
				"c": "610600",
				"n": "延安市",
				"pc": "610000"
			}, {
				"c": "610601",
				"n": "市辖区",
				"pc": "610600"
			}, {
				"c": "610602",
				"n": "宝塔区",
				"pc": "610600"
			}, {
				"c": "610621",
				"n": "延长县",
				"pc": "610600"
			}, {
				"c": "610622",
				"n": "延川县",
				"pc": "610600"
			}, {
				"c": "610623",
				"n": "子长县",
				"pc": "610600"
			}, {
				"c": "610624",
				"n": "安塞县",
				"pc": "610600"
			}, {
				"c": "610625",
				"n": "志丹县",
				"pc": "610600"
			}, {
				"c": "610626",
				"n": "吴起县",
				"pc": "610600"
			}, {
				"c": "610627",
				"n": "甘泉县",
				"pc": "610600"
			}, {
				"c": "610628",
				"n": "富县",
				"pc": "610600"
			}, {
				"c": "610629",
				"n": "洛川县",
				"pc": "610600"
			}, {
				"c": "610630",
				"n": "宜川县",
				"pc": "610600"
			}, {
				"c": "610631",
				"n": "黄龙县",
				"pc": "610600"
			}, {
				"c": "610632",
				"n": "黄陵县",
				"pc": "610600"
			}, {
				"c": "610700",
				"n": "汉中市",
				"pc": "610000"
			}, {
				"c": "610701",
				"n": "市辖区",
				"pc": "610700"
			}, {
				"c": "610702",
				"n": "汉台区",
				"pc": "610700"
			}, {
				"c": "610721",
				"n": "南郑县",
				"pc": "610700"
			}, {
				"c": "610722",
				"n": "城固县",
				"pc": "610700"
			}, {
				"c": "610723",
				"n": "洋县",
				"pc": "610700"
			}, {
				"c": "610724",
				"n": "西乡县",
				"pc": "610700"
			}, {
				"c": "610725",
				"n": "勉县",
				"pc": "610700"
			}, {
				"c": "610726",
				"n": "宁强县",
				"pc": "610700"
			}, {
				"c": "610727",
				"n": "略阳县",
				"pc": "610700"
			}, {
				"c": "610728",
				"n": "镇巴县",
				"pc": "610700"
			}, {
				"c": "610729",
				"n": "留坝县",
				"pc": "610700"
			}, {
				"c": "610730",
				"n": "佛坪县",
				"pc": "610700"
			}, {
				"c": "610800",
				"n": "榆林市",
				"pc": "610000"
			}, {
				"c": "610801",
				"n": "市辖区",
				"pc": "610800"
			}, {
				"c": "610802",
				"n": "榆阳区",
				"pc": "610800"
			}, {
				"c": "610821",
				"n": "神木县",
				"pc": "610800"
			}, {
				"c": "610822",
				"n": "府谷县",
				"pc": "610800"
			}, {
				"c": "610823",
				"n": "横山县",
				"pc": "610800"
			}, {
				"c": "610824",
				"n": "靖边县",
				"pc": "610800"
			}, {
				"c": "610825",
				"n": "定边县",
				"pc": "610800"
			}, {
				"c": "610826",
				"n": "绥德县",
				"pc": "610800"
			}, {
				"c": "610827",
				"n": "米脂县",
				"pc": "610800"
			}, {
				"c": "610828",
				"n": "佳县",
				"pc": "610800"
			}, {
				"c": "610829",
				"n": "吴堡县",
				"pc": "610800"
			}, {
				"c": "610830",
				"n": "清涧县",
				"pc": "610800"
			}, {
				"c": "610831",
				"n": "子洲县",
				"pc": "610800"
			}, {
				"c": "610900",
				"n": "安康市",
				"pc": "610000"
			}, {
				"c": "610901",
				"n": "市辖区",
				"pc": "610900"
			}, {
				"c": "610902",
				"n": "汉滨区",
				"pc": "610900"
			}, {
				"c": "610921",
				"n": "汉阴县",
				"pc": "610900"
			}, {
				"c": "610922",
				"n": "石泉县",
				"pc": "610900"
			}, {
				"c": "610923",
				"n": "宁陕县",
				"pc": "610900"
			}, {
				"c": "610924",
				"n": "紫阳县",
				"pc": "610900"
			}, {
				"c": "610925",
				"n": "岚皋县",
				"pc": "610900"
			}, {
				"c": "610926",
				"n": "平利县",
				"pc": "610900"
			}, {
				"c": "610927",
				"n": "镇坪县",
				"pc": "610900"
			}, {
				"c": "610928",
				"n": "旬阳县",
				"pc": "610900"
			}, {
				"c": "610929",
				"n": "白河县",
				"pc": "610900"
			}, {
				"c": "611000",
				"n": "商洛市",
				"pc": "610000"
			}, {
				"c": "611001",
				"n": "市辖区",
				"pc": "611000"
			}, {
				"c": "611002",
				"n": "商州区",
				"pc": "611000"
			}, {
				"c": "611021",
				"n": "洛南县",
				"pc": "611000"
			}, {
				"c": "611022",
				"n": "丹凤县",
				"pc": "611000"
			}, {
				"c": "611023",
				"n": "商南县",
				"pc": "611000"
			}, {
				"c": "611024",
				"n": "山阳县",
				"pc": "611000"
			}, {
				"c": "611025",
				"n": "镇安县",
				"pc": "611000"
			}, {
				"c": "611026",
				"n": "柞水县",
				"pc": "611000"
			}, {
				"c": "620000",
				"n": "甘肃省",
				"pc": "86"
			}, {
				"c": "620100",
				"n": "兰州市",
				"pc": "620000"
			}, {
				"c": "620101",
				"n": "市辖区",
				"pc": "620100"
			}, {
				"c": "620102",
				"n": "城关区",
				"pc": "620100"
			}, {
				"c": "620103",
				"n": "七里河区",
				"pc": "620100"
			}, {
				"c": "620104",
				"n": "西固区",
				"pc": "620100"
			}, {
				"c": "620105",
				"n": "安宁区",
				"pc": "620100"
			}, {
				"c": "620111",
				"n": "红古区",
				"pc": "620100"
			}, {
				"c": "620121",
				"n": "永登县",
				"pc": "620100"
			}, {
				"c": "620122",
				"n": "皋兰县",
				"pc": "620100"
			}, {
				"c": "620123",
				"n": "榆中县",
				"pc": "620100"
			}, {
				"c": "620200",
				"n": "嘉峪关市",
				"pc": "620000"
			}, {
				"c": "620201",
				"n": "市辖区",
				"pc": "620200"
			}, {
				"c": "620300",
				"n": "金昌市",
				"pc": "620000"
			}, {
				"c": "620301",
				"n": "市辖区",
				"pc": "620300"
			}, {
				"c": "620302",
				"n": "金川区",
				"pc": "620300"
			}, {
				"c": "620321",
				"n": "永昌县",
				"pc": "620300"
			}, {
				"c": "620400",
				"n": "白银市",
				"pc": "620000"
			}, {
				"c": "620401",
				"n": "市辖区",
				"pc": "620400"
			}, {
				"c": "620402",
				"n": "白银区",
				"pc": "620400"
			}, {
				"c": "620403",
				"n": "平川区",
				"pc": "620400"
			}, {
				"c": "620421",
				"n": "靖远县",
				"pc": "620400"
			}, {
				"c": "620422",
				"n": "会宁县",
				"pc": "620400"
			}, {
				"c": "620423",
				"n": "景泰县",
				"pc": "620400"
			}, {
				"c": "620500",
				"n": "天水市",
				"pc": "620000"
			}, {
				"c": "620501",
				"n": "市辖区",
				"pc": "620500"
			}, {
				"c": "620502",
				"n": "秦州区",
				"pc": "620500"
			}, {
				"c": "620503",
				"n": "麦积区",
				"pc": "620500"
			}, {
				"c": "620521",
				"n": "清水县",
				"pc": "620500"
			}, {
				"c": "620522",
				"n": "秦安县",
				"pc": "620500"
			}, {
				"c": "620523",
				"n": "甘谷县",
				"pc": "620500"
			}, {
				"c": "620524",
				"n": "武山县",
				"pc": "620500"
			}, {
				"c": "620525",
				"n": "张家川回族自治县",
				"pc": "620500"
			}, {
				"c": "620600",
				"n": "武威市",
				"pc": "620000"
			}, {
				"c": "620601",
				"n": "市辖区",
				"pc": "620600"
			}, {
				"c": "620602",
				"n": "凉州区",
				"pc": "620600"
			}, {
				"c": "620621",
				"n": "民勤县",
				"pc": "620600"
			}, {
				"c": "620622",
				"n": "古浪县",
				"pc": "620600"
			}, {
				"c": "620623",
				"n": "天祝藏族自治县",
				"pc": "620600"
			}, {
				"c": "620700",
				"n": "张掖市",
				"pc": "620000"
			}, {
				"c": "620701",
				"n": "市辖区",
				"pc": "620700"
			}, {
				"c": "620702",
				"n": "甘州区",
				"pc": "620700"
			}, {
				"c": "620721",
				"n": "肃南裕固族自治县",
				"pc": "620700"
			}, {
				"c": "620722",
				"n": "民乐县",
				"pc": "620700"
			}, {
				"c": "620723",
				"n": "临泽县",
				"pc": "620700"
			}, {
				"c": "620724",
				"n": "高台县",
				"pc": "620700"
			}, {
				"c": "620725",
				"n": "山丹县",
				"pc": "620700"
			}, {
				"c": "620800",
				"n": "平凉市",
				"pc": "620000"
			}, {
				"c": "620801",
				"n": "市辖区",
				"pc": "620800"
			}, {
				"c": "620802",
				"n": "崆峒区",
				"pc": "620800"
			}, {
				"c": "620821",
				"n": "泾川县",
				"pc": "620800"
			}, {
				"c": "620822",
				"n": "灵台县",
				"pc": "620800"
			}, {
				"c": "620823",
				"n": "崇信县",
				"pc": "620800"
			}, {
				"c": "620824",
				"n": "华亭县",
				"pc": "620800"
			}, {
				"c": "620825",
				"n": "庄浪县",
				"pc": "620800"
			}, {
				"c": "620826",
				"n": "静宁县",
				"pc": "620800"
			}, {
				"c": "620900",
				"n": "酒泉市",
				"pc": "620000"
			}, {
				"c": "620901",
				"n": "市辖区",
				"pc": "620900"
			}, {
				"c": "620902",
				"n": "肃州区",
				"pc": "620900"
			}, {
				"c": "620921",
				"n": "金塔县",
				"pc": "620900"
			}, {
				"c": "620922",
				"n": "瓜州县",
				"pc": "620900"
			}, {
				"c": "620923",
				"n": "肃北蒙古族自治县",
				"pc": "620900"
			}, {
				"c": "620924",
				"n": "阿克塞哈萨克族自治县",
				"pc": "620900"
			}, {
				"c": "620981",
				"n": "玉门市",
				"pc": "620900"
			}, {
				"c": "620982",
				"n": "敦煌市",
				"pc": "620900"
			}, {
				"c": "621000",
				"n": "庆阳市",
				"pc": "620000"
			}, {
				"c": "621001",
				"n": "市辖区",
				"pc": "621000"
			}, {
				"c": "621002",
				"n": "西峰区",
				"pc": "621000"
			}, {
				"c": "621021",
				"n": "庆城县",
				"pc": "621000"
			}, {
				"c": "621022",
				"n": "环县",
				"pc": "621000"
			}, {
				"c": "621023",
				"n": "华池县",
				"pc": "621000"
			}, {
				"c": "621024",
				"n": "合水县",
				"pc": "621000"
			}, {
				"c": "621025",
				"n": "正宁县",
				"pc": "621000"
			}, {
				"c": "621026",
				"n": "宁县",
				"pc": "621000"
			}, {
				"c": "621027",
				"n": "镇原县",
				"pc": "621000"
			}, {
				"c": "621100",
				"n": "定西市",
				"pc": "620000"
			}, {
				"c": "621101",
				"n": "市辖区",
				"pc": "621100"
			}, {
				"c": "621102",
				"n": "安定区",
				"pc": "621100"
			}, {
				"c": "621121",
				"n": "通渭县",
				"pc": "621100"
			}, {
				"c": "621122",
				"n": "陇西县",
				"pc": "621100"
			}, {
				"c": "621123",
				"n": "渭源县",
				"pc": "621100"
			}, {
				"c": "621124",
				"n": "临洮县",
				"pc": "621100"
			}, {
				"c": "621125",
				"n": "漳县",
				"pc": "621100"
			}, {
				"c": "621126",
				"n": "岷县",
				"pc": "621100"
			}, {
				"c": "621200",
				"n": "陇南市",
				"pc": "620000"
			}, {
				"c": "621201",
				"n": "市辖区",
				"pc": "621200"
			}, {
				"c": "621202",
				"n": "武都区",
				"pc": "621200"
			}, {
				"c": "621221",
				"n": "成县",
				"pc": "621200"
			}, {
				"c": "621222",
				"n": "文县",
				"pc": "621200"
			}, {
				"c": "621223",
				"n": "宕昌县",
				"pc": "621200"
			}, {
				"c": "621224",
				"n": "康县",
				"pc": "621200"
			}, {
				"c": "621225",
				"n": "西和县",
				"pc": "621200"
			}, {
				"c": "621226",
				"n": "礼县",
				"pc": "621200"
			}, {
				"c": "621227",
				"n": "徽县",
				"pc": "621200"
			}, {
				"c": "621228",
				"n": "两当县",
				"pc": "621200"
			}, {
				"c": "622900",
				"n": "临夏回族自治州",
				"pc": "620000"
			}, {
				"c": "622901",
				"n": "临夏市",
				"pc": "622900"
			}, {
				"c": "622921",
				"n": "临夏县",
				"pc": "622900"
			}, {
				"c": "622922",
				"n": "康乐县",
				"pc": "622900"
			}, {
				"c": "622923",
				"n": "永靖县",
				"pc": "622900"
			}, {
				"c": "622924",
				"n": "广河县",
				"pc": "622900"
			}, {
				"c": "622925",
				"n": "和政县",
				"pc": "622900"
			}, {
				"c": "622926",
				"n": "东乡族自治县",
				"pc": "622900"
			}, {
				"c": "622927",
				"n": "积石山保安族东乡族撒拉族自治县",
				"pc": "622900"
			}, {
				"c": "623000",
				"n": "甘南藏族自治州",
				"pc": "620000"
			}, {
				"c": "623001",
				"n": "合作市",
				"pc": "623000"
			}, {
				"c": "623021",
				"n": "临潭县",
				"pc": "623000"
			}, {
				"c": "623022",
				"n": "卓尼县",
				"pc": "623000"
			}, {
				"c": "623023",
				"n": "舟曲县",
				"pc": "623000"
			}, {
				"c": "623024",
				"n": "迭部县",
				"pc": "623000"
			}, {
				"c": "623025",
				"n": "玛曲县",
				"pc": "623000"
			}, {
				"c": "623026",
				"n": "碌曲县",
				"pc": "623000"
			}, {
				"c": "623027",
				"n": "夏河县",
				"pc": "623000"
			}, {
				"c": "630000",
				"n": "青海省",
				"pc": "86"
			}, {
				"c": "630100",
				"n": "西宁市",
				"pc": "630000"
			}, {
				"c": "630101",
				"n": "市辖区",
				"pc": "630100"
			}, {
				"c": "630102",
				"n": "城东区",
				"pc": "630100"
			}, {
				"c": "630103",
				"n": "城中区",
				"pc": "630100"
			}, {
				"c": "630104",
				"n": "城西区",
				"pc": "630100"
			}, {
				"c": "630105",
				"n": "城北区",
				"pc": "630100"
			}, {
				"c": "630121",
				"n": "大通回族土族自治县",
				"pc": "630100"
			}, {
				"c": "630122",
				"n": "湟中县",
				"pc": "630100"
			}, {
				"c": "630123",
				"n": "湟源县",
				"pc": "630100"
			}, {
				"c": "632100",
				"n": "海东地区",
				"pc": "630000"
			}, {
				"c": "632121",
				"n": "平安县",
				"pc": "632100"
			}, {
				"c": "632122",
				"n": "民和回族土族自治县",
				"pc": "632100"
			}, {
				"c": "632123",
				"n": "乐都县",
				"pc": "632100"
			}, {
				"c": "632126",
				"n": "互助土族自治县",
				"pc": "632100"
			}, {
				"c": "632127",
				"n": "化隆回族自治县",
				"pc": "632100"
			}, {
				"c": "632128",
				"n": "循化撒拉族自治县",
				"pc": "632100"
			}, {
				"c": "632200",
				"n": "海北藏族自治州",
				"pc": "630000"
			}, {
				"c": "632221",
				"n": "门源回族自治县",
				"pc": "632200"
			}, {
				"c": "632222",
				"n": "祁连县",
				"pc": "632200"
			}, {
				"c": "632223",
				"n": "海晏县",
				"pc": "632200"
			}, {
				"c": "632224",
				"n": "刚察县",
				"pc": "632200"
			}, {
				"c": "632300",
				"n": "黄南藏族自治州",
				"pc": "630000"
			}, {
				"c": "632321",
				"n": "同仁县",
				"pc": "632300"
			}, {
				"c": "632322",
				"n": "尖扎县",
				"pc": "632300"
			}, {
				"c": "632323",
				"n": "泽库县",
				"pc": "632300"
			}, {
				"c": "632324",
				"n": "河南蒙古族自治县",
				"pc": "632300"
			}, {
				"c": "632500",
				"n": "海南藏族自治州",
				"pc": "630000"
			}, {
				"c": "632521",
				"n": "共和县",
				"pc": "632500"
			}, {
				"c": "632522",
				"n": "同德县",
				"pc": "632500"
			}, {
				"c": "632523",
				"n": "贵德县",
				"pc": "632500"
			}, {
				"c": "632524",
				"n": "兴海县",
				"pc": "632500"
			}, {
				"c": "632525",
				"n": "贵南县",
				"pc": "632500"
			}, {
				"c": "632600",
				"n": "果洛藏族自治州",
				"pc": "630000"
			}, {
				"c": "632621",
				"n": "玛沁县",
				"pc": "632600"
			}, {
				"c": "632622",
				"n": "班玛县",
				"pc": "632600"
			}, {
				"c": "632623",
				"n": "甘德县",
				"pc": "632600"
			}, {
				"c": "632624",
				"n": "达日县",
				"pc": "632600"
			}, {
				"c": "632625",
				"n": "久治县",
				"pc": "632600"
			}, {
				"c": "632626",
				"n": "玛多县",
				"pc": "632600"
			}, {
				"c": "632700",
				"n": "玉树藏族自治州",
				"pc": "630000"
			}, {
				"c": "632721",
				"n": "玉树县",
				"pc": "632700"
			}, {
				"c": "632722",
				"n": "杂多县",
				"pc": "632700"
			}, {
				"c": "632723",
				"n": "称多县",
				"pc": "632700"
			}, {
				"c": "632724",
				"n": "治多县",
				"pc": "632700"
			}, {
				"c": "632725",
				"n": "囊谦县",
				"pc": "632700"
			}, {
				"c": "632726",
				"n": "曲麻莱县",
				"pc": "632700"
			}, {
				"c": "632800",
				"n": "海西蒙古族藏族自治州",
				"pc": "630000"
			}, {
				"c": "632801",
				"n": "格尔木市",
				"pc": "632800"
			}, {
				"c": "632802",
				"n": "德令哈市",
				"pc": "632800"
			}, {
				"c": "632821",
				"n": "乌兰县",
				"pc": "632800"
			}, {
				"c": "632822",
				"n": "都兰县",
				"pc": "632800"
			}, {
				"c": "632823",
				"n": "天峻县",
				"pc": "632800"
			}, {
				"c": "640000",
				"n": "宁夏回族自治区",
				"pc": "86"
			}, {
				"c": "640100",
				"n": "银川市",
				"pc": "640000"
			}, {
				"c": "640101",
				"n": "市辖区",
				"pc": "640100"
			}, {
				"c": "640104",
				"n": "兴庆区",
				"pc": "640100"
			}, {
				"c": "640105",
				"n": "西夏区",
				"pc": "640100"
			}, {
				"c": "640106",
				"n": "金凤区",
				"pc": "640100"
			}, {
				"c": "640121",
				"n": "永宁县",
				"pc": "640100"
			}, {
				"c": "640122",
				"n": "贺兰县",
				"pc": "640100"
			}, {
				"c": "640181",
				"n": "灵武市",
				"pc": "640100"
			}, {
				"c": "640200",
				"n": "石嘴山市",
				"pc": "640000"
			}, {
				"c": "640201",
				"n": "市辖区",
				"pc": "640200"
			}, {
				"c": "640202",
				"n": "大武口区",
				"pc": "640200"
			}, {
				"c": "640205",
				"n": "惠农区",
				"pc": "640200"
			}, {
				"c": "640221",
				"n": "平罗县",
				"pc": "640200"
			}, {
				"c": "640300",
				"n": "吴忠市",
				"pc": "640000"
			}, {
				"c": "640301",
				"n": "市辖区",
				"pc": "640300"
			}, {
				"c": "640302",
				"n": "利通区",
				"pc": "640300"
			}, {
				"c": "640303",
				"n": "红寺堡区",
				"pc": "640300"
			}, {
				"c": "640323",
				"n": "盐池县",
				"pc": "640300"
			}, {
				"c": "640324",
				"n": "同心县",
				"pc": "640300"
			}, {
				"c": "640381",
				"n": "青铜峡市",
				"pc": "640300"
			}, {
				"c": "640400",
				"n": "固原市",
				"pc": "640000"
			}, {
				"c": "640401",
				"n": "市辖区",
				"pc": "640400"
			}, {
				"c": "640402",
				"n": "原州区",
				"pc": "640400"
			}, {
				"c": "640422",
				"n": "西吉县",
				"pc": "640400"
			}, {
				"c": "640423",
				"n": "隆德县",
				"pc": "640400"
			}, {
				"c": "640424",
				"n": "泾源县",
				"pc": "640400"
			}, {
				"c": "640425",
				"n": "彭阳县",
				"pc": "640400"
			}, {
				"c": "640500",
				"n": "中卫市",
				"pc": "640000"
			}, {
				"c": "640501",
				"n": "市辖区",
				"pc": "640500"
			}, {
				"c": "640502",
				"n": "沙坡头区",
				"pc": "640500"
			}, {
				"c": "640521",
				"n": "中宁县",
				"pc": "640500"
			}, {
				"c": "640522",
				"n": "海原县",
				"pc": "640500"
			}, {
				"c": "650000",
				"n": "新疆维吾尔自治区",
				"pc": "86"
			}, {
				"c": "650100",
				"n": "乌鲁木齐市",
				"pc": "650000"
			}, {
				"c": "650101",
				"n": "市辖区",
				"pc": "650100"
			}, {
				"c": "650102",
				"n": "天山区",
				"pc": "650100"
			}, {
				"c": "650103",
				"n": "沙依巴克区",
				"pc": "650100"
			}, {
				"c": "650104",
				"n": "新市区",
				"pc": "650100"
			}, {
				"c": "650105",
				"n": "水磨沟区",
				"pc": "650100"
			}, {
				"c": "650106",
				"n": "头屯河区",
				"pc": "650100"
			}, {
				"c": "650107",
				"n": "达坂城区",
				"pc": "650100"
			}, {
				"c": "650109",
				"n": "米东区",
				"pc": "650100"
			}, {
				"c": "650121",
				"n": "乌鲁木齐县",
				"pc": "650100"
			}, {
				"c": "650200",
				"n": "克拉玛依市",
				"pc": "650000"
			}, {
				"c": "650201",
				"n": "市辖区",
				"pc": "650200"
			}, {
				"c": "650202",
				"n": "独山子区",
				"pc": "650200"
			}, {
				"c": "650203",
				"n": "克拉玛依区",
				"pc": "650200"
			}, {
				"c": "650204",
				"n": "白碱滩区",
				"pc": "650200"
			}, {
				"c": "650205",
				"n": "乌尔禾区",
				"pc": "650200"
			}, {
				"c": "652100",
				"n": "吐鲁番地区",
				"pc": "650000"
			}, {
				"c": "652101",
				"n": "吐鲁番市",
				"pc": "652100"
			}, {
				"c": "652122",
				"n": "鄯善县",
				"pc": "652100"
			}, {
				"c": "652123",
				"n": "托克逊县",
				"pc": "652100"
			}, {
				"c": "652200",
				"n": "哈密地区",
				"pc": "650000"
			}, {
				"c": "652201",
				"n": "哈密市",
				"pc": "652200"
			}, {
				"c": "652222",
				"n": "巴里坤哈萨克自治县",
				"pc": "652200"
			}, {
				"c": "652223",
				"n": "伊吾县",
				"pc": "652200"
			}, {
				"c": "652300",
				"n": "昌吉回族自治州",
				"pc": "650000"
			}, {
				"c": "652301",
				"n": "昌吉市",
				"pc": "652300"
			}, {
				"c": "652302",
				"n": "阜康市",
				"pc": "652300"
			}, {
				"c": "652323",
				"n": "呼图壁县",
				"pc": "652300"
			}, {
				"c": "652324",
				"n": "玛纳斯县",
				"pc": "652300"
			}, {
				"c": "652325",
				"n": "奇台县",
				"pc": "652300"
			}, {
				"c": "652327",
				"n": "吉木萨尔县",
				"pc": "652300"
			}, {
				"c": "652328",
				"n": "木垒哈萨克自治县",
				"pc": "652300"
			}, {
				"c": "652700",
				"n": "博尔塔拉蒙古自治州",
				"pc": "650000"
			}, {
				"c": "652701",
				"n": "博乐市",
				"pc": "652700"
			}, {
				"c": "652722",
				"n": "精河县",
				"pc": "652700"
			}, {
				"c": "652723",
				"n": "温泉县",
				"pc": "652700"
			}, {
				"c": "652800",
				"n": "巴音郭楞蒙古自治州",
				"pc": "650000"
			}, {
				"c": "652801",
				"n": "库尔勒市",
				"pc": "652800"
			}, {
				"c": "652822",
				"n": "轮台县",
				"pc": "652800"
			}, {
				"c": "652823",
				"n": "尉犁县",
				"pc": "652800"
			}, {
				"c": "652824",
				"n": "若羌县",
				"pc": "652800"
			}, {
				"c": "652825",
				"n": "且末县",
				"pc": "652800"
			}, {
				"c": "652826",
				"n": "焉耆回族自治县",
				"pc": "652800"
			}, {
				"c": "652827",
				"n": "和静县",
				"pc": "652800"
			}, {
				"c": "652828",
				"n": "和硕县",
				"pc": "652800"
			}, {
				"c": "652829",
				"n": "博湖县",
				"pc": "652800"
			}, {
				"c": "652900",
				"n": "阿克苏地区",
				"pc": "650000"
			}, {
				"c": "652901",
				"n": "阿克苏市",
				"pc": "652900"
			}, {
				"c": "652922",
				"n": "温宿县",
				"pc": "652900"
			}, {
				"c": "652923",
				"n": "库车县",
				"pc": "652900"
			}, {
				"c": "652924",
				"n": "沙雅县",
				"pc": "652900"
			}, {
				"c": "652925",
				"n": "新和县",
				"pc": "652900"
			}, {
				"c": "652926",
				"n": "拜城县",
				"pc": "652900"
			}, {
				"c": "652927",
				"n": "乌什县",
				"pc": "652900"
			}, {
				"c": "652928",
				"n": "阿瓦提县",
				"pc": "652900"
			}, {
				"c": "652929",
				"n": "柯坪县",
				"pc": "652900"
			}, {
				"c": "653000",
				"n": "克孜勒苏柯尔克孜自治州",
				"pc": "650000"
			}, {
				"c": "653001",
				"n": "阿图什市",
				"pc": "653000"
			}, {
				"c": "653022",
				"n": "阿克陶县",
				"pc": "653000"
			}, {
				"c": "653023",
				"n": "阿合奇县",
				"pc": "653000"
			}, {
				"c": "653024",
				"n": "乌恰县",
				"pc": "653000"
			}, {
				"c": "653100",
				"n": "喀什地区",
				"pc": "650000"
			}, {
				"c": "653101",
				"n": "喀什市",
				"pc": "653100"
			}, {
				"c": "653121",
				"n": "疏附县",
				"pc": "653100"
			}, {
				"c": "653122",
				"n": "疏勒县",
				"pc": "653100"
			}, {
				"c": "653123",
				"n": "英吉沙县",
				"pc": "653100"
			}, {
				"c": "653124",
				"n": "泽普县",
				"pc": "653100"
			}, {
				"c": "653125",
				"n": "莎车县",
				"pc": "653100"
			}, {
				"c": "653126",
				"n": "叶城县",
				"pc": "653100"
			}, {
				"c": "653127",
				"n": "麦盖提县",
				"pc": "653100"
			}, {
				"c": "653128",
				"n": "岳普湖县",
				"pc": "653100"
			}, {
				"c": "653129",
				"n": "伽师县",
				"pc": "653100"
			}, {
				"c": "653130",
				"n": "巴楚县",
				"pc": "653100"
			}, {
				"c": "653131",
				"n": "塔什库尔干塔吉克自治县",
				"pc": "653100"
			}, {
				"c": "653200",
				"n": "和田地区",
				"pc": "650000"
			}, {
				"c": "653201",
				"n": "和田市",
				"pc": "653200"
			}, {
				"c": "653221",
				"n": "和田县",
				"pc": "653200"
			}, {
				"c": "653222",
				"n": "墨玉县",
				"pc": "653200"
			}, {
				"c": "653223",
				"n": "皮山县",
				"pc": "653200"
			}, {
				"c": "653224",
				"n": "洛浦县",
				"pc": "653200"
			}, {
				"c": "653225",
				"n": "策勒县",
				"pc": "653200"
			}, {
				"c": "653226",
				"n": "于田县",
				"pc": "653200"
			}, {
				"c": "653227",
				"n": "民丰县",
				"pc": "653200"
			}, {
				"c": "654000",
				"n": "伊犁哈萨克自治州",
				"pc": "650000"
			}, {
				"c": "654002",
				"n": "伊宁市",
				"pc": "654000"
			}, {
				"c": "654003",
				"n": "奎屯市",
				"pc": "654000"
			}, {
				"c": "654021",
				"n": "伊宁县",
				"pc": "654000"
			}, {
				"c": "654022",
				"n": "察布查尔锡伯自治县",
				"pc": "654000"
			}, {
				"c": "654023",
				"n": "霍城县",
				"pc": "654000"
			}, {
				"c": "654024",
				"n": "巩留县",
				"pc": "654000"
			}, {
				"c": "654025",
				"n": "新源县",
				"pc": "654000"
			}, {
				"c": "654026",
				"n": "昭苏县",
				"pc": "654000"
			}, {
				"c": "654027",
				"n": "特克斯县",
				"pc": "654000"
			}, {
				"c": "654028",
				"n": "尼勒克县",
				"pc": "654000"
			}, {
				"c": "654200",
				"n": "塔城地区",
				"pc": "650000"
			}, {
				"c": "654201",
				"n": "塔城市",
				"pc": "654200"
			}, {
				"c": "654202",
				"n": "乌苏市",
				"pc": "654200"
			}, {
				"c": "654221",
				"n": "额敏县",
				"pc": "654200"
			}, {
				"c": "654223",
				"n": "沙湾县",
				"pc": "654200"
			}, {
				"c": "654224",
				"n": "托里县",
				"pc": "654200"
			}, {
				"c": "654225",
				"n": "裕民县",
				"pc": "654200"
			}, {
				"c": "654226",
				"n": "和布克赛尔蒙古自治县",
				"pc": "654200"
			}, {
				"c": "654300",
				"n": "阿勒泰地区",
				"pc": "650000"
			}, {
				"c": "654301",
				"n": "阿勒泰市",
				"pc": "654300"
			}, {
				"c": "654321",
				"n": "布尔津县",
				"pc": "654300"
			}, {
				"c": "654322",
				"n": "富蕴县",
				"pc": "654300"
			}, {
				"c": "654323",
				"n": "福海县",
				"pc": "654300"
			}, {
				"c": "654324",
				"n": "哈巴河县",
				"pc": "654300"
			}, {
				"c": "654325",
				"n": "青河县",
				"pc": "654300"
			}, {
				"c": "654326",
				"n": "吉木乃县",
				"pc": "654300"
			}, {
				"c": "659000",
				"n": "自治区直辖县级行政区划",
				"pc": "650000"
			}, {
				"c": "659001",
				"n": "石河子市",
				"pc": "659000"
			}, {
				"c": "659002",
				"n": "阿拉尔市",
				"pc": "659000"
			}, {
				"c": "659003",
				"n": "图木舒克市",
				"pc": "659000"
			}, {
				"c": "659004",
				"n": "五家渠市",
				"pc": "659000"
			}, {
				"c": "710000",
				"n": "台湾省",
				"pc": "86"
			}, {
				"c": "810000",
				"n": "香港特别行政区",
				"pc": "86"
			}, {
				"c": "820000",
				"n": "澳门特别行政区",
				"pc": "86"
			}];
			return regions;
		};
	})();
(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('regionBt', regionBt); 

    regionBt.$inject = ['RegionService'];
    function regionBt(RegionService) {
        var directive = {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                depends: '='
            },
            replace: true,
            template: '<select name="a" ng-options="o.c as o.n for o in options">' + //
            '            <option value="">请选择...</option>' + //
            '          </select>',
            link: function(scope, element, attrs, modelCtrl) {
                scope.$watch('depends', function(newVal, oldVal) {
                    if ('depends' in attrs&&attrs.depends!=null) {
                        var parent = RegionService.get(scope.depends);
                        scope.options = [];
                        if (parent) {
                            scope.options = parent.children;
                        }
                        var oldModelValue = modelCtrl.$modelValue;
                        modelCtrl.$setViewValue();
                        for (var i = 0; i < scope.options.length; i++) {
                            var option = scope.options[i];
                            if (option.c === oldModelValue) {
                                modelCtrl.$setViewValue(oldModelValue);
                            }
                        }
                    } else {
                        scope.options = RegionService.getCountries();
                    }
                });
            }
        };
        return directive;
    }
})();
(function() {
    'use strict';
    angular
        .module('gwApp')
        .directive('page', page);

    page.$inject = ['MessageService', '$timeout'];

    function page(MessageService, $timeout){
        var directive = {
            restrict:"EA",//指令调用模式
            priority: 0,//指令优先级
            terminal: false,
            replace:true,
            template: function(tElement, tAttrs){
                var template =  "<div style='padding-top: 20px; font-weight: 700'>"+
                                "<div style='width:{{pageList.length*40}}px;height:100%;display: inline-block;'>"+
                                "<div style='float:left;margin-top: -4px;'>"+
                                "<button class='pageB' ng-class='{pageColor:pageCp===p}' ng-click='stepTo(p);' ng-repeat='p in pageList track by $index'>{{p}}</button>"+
                                "</div>"+
                                "</div>"+
                                "<p style='margin: 10px 0 0 0'>共{{totalPages}}页，{{pageCount}}条记录</p>"+
                                "</div>";
                return template;
            },
            scope: {
                pageCp:'=',
                pagePs:'=',
                pageCount:'=',
                pageChange:'&'
            },
            controller: ['$scope','$element','$attrs',function($scope, $element, $attrs) {
                var vm = $scope;
                vm.sizeList = [
                    {name:"10条/页",code:10},
                    {name:"15条/页",code:15},
                    {name:"20条/页",code:20}
                ];
                vm.stepPage = null;
                vm.totalPages = 1;

                vm.$watch('pageCount',function () {
                    vm.totalPages = 1;
                    if ((vm.pageCount || vm.pageCount===0) && vm.pagePs) {
                        vm.totalPages = Math.ceil(vm.pageCount/vm.pagePs)===0?1:Math.ceil(vm.pageCount/vm.pagePs);
                        setTimeout(function () {
                            generatorPageList();
                        })
                    }
                });
                vm.$watch('pagePs',function () {
                    vm.totalPages = 1;
                    if ((vm.pageCount || vm.pageCount===0) && vm.pagePs) {
                        vm.totalPages = Math.ceil(vm.pageCount/vm.pagePs)===0?1:Math.ceil(vm.pageCount/vm.pagePs);
                        setTimeout(function () {
                            generatorPageList();
                        })
                    }
                });

                function generatorPageList() {
                    if (!vm.totalPages) {
                        return;
                    }
                    if(vm.totalPages<=6){
                        vm.pageList = [];
                        for(var i=0; i<vm.totalPages; i++) {
                            vm.pageList.push(i+1);
                        }
                    }else{
                        if(vm.pageCp<=2){
                            vm.pageList = [1,2,3,"...",vm.totalPages-1,vm.totalPages];
                        }else{
                            if(vm.totalPages-vm.pageCp<2){
                                vm.pageList = [1,2,"...",vm.totalPages-2,vm.totalPages-1,vm.totalPages];
                            }else{
                                vm.pageList = [1,"...",vm.pageCp-1,vm.pageCp,vm.pageCp+1,"...",vm.totalPages];
                            }
                        }
                    }
                }
                generatorPageList();

                vm.stepTo =  function(count){
                    if(count==="..."){
                        return;
                    }
                    if(count!=null&&count!==''){
                        if(count>vm.totalPages){
                            count = vm.totalPages;
                        }
                        vm.pageCp = count;
                        vm.stepPage = null;
                        generatorPageList();
                        $timeout(function () {
                            vm.pageChange();
                        });
                    }else{
                        generatorPageList();
                        $timeout(function () {
                            vm.pageChange();
                        });
                    }
                };
                vm.resetMin = function(direction){
                    if(direction==='left'){
                        if(vm.pageCp>1){
                            vm.pageCp--;
                            generatorPageList();
                            $timeout(function () {
                                vm.pageChange();
                            });
                        }
                    }else{
                        if(vm.pageCp<vm.totalPages){
                            vm.pageCp++;
                            generatorPageList();
                            $timeout(function () {
                                vm.pageChange();
                            });
                        }
                    }
                };
                vm.inputKeyUp = function (e) {
                    if (e.keyCode === 13) {
                        vm.stepTo(vm.stepPage);
                    }
                }
            }],
            link: function(scope, element, attrs, SomeController) {

            }
        };

        return directive;
    }
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal', '$state'];

    function MessageService($uibModal, $state) {
        var service = {
            contentKnow: contentKnow,
            contentConfirm: contentConfirm,
            confirm: confirm,
            confirm2: confirm2,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success,
            notify:notify


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            // addclass: "", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            // width: "300px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: true, // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            // closer: true, // Provide a button for the user to manually close the notice.
            // closer_hover: true, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 2000 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function error(content) {
            console.log("message.Service ----->info:"+content);
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.title = content;
            if (content == 'Access Denied') {
				$state.go('login');
				console.log("message.Service ----->accessDenied");
                error("用户已退出，请重新登录");
            } else {
                return this.notify(hash);
            }
        };

        function notify(hash) {
            if (current) {
                current.remove();
            }
            current = new PNotify(hash);
            return current;

            var modalInstance = $uibModal.open({
                index: 1000,
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + //
                    '</div>',
            });
        };

        function loading() {
            return $uibModal.open({
                template: '<i class="fa fa-5x fa-spinner fa-spin fa-white"></i>',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        };

        function confirm(msg, confirmCallback, cancelCallback) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                '<div style="text-align:center; padding-bottom: 0">' + //
                '<h3 style="font-size: 36px; font-weight: 700; color: #292929; margin-bottom: 20px">' + msg + '</h3>' + //
                '</div>' + //
                '<div class="modal-footer" style="width: 100%;text-align: center;">' + //
                '<button class="btn btn-default" type="button" ng-click="cancel()" style="margin-right: 20px; padding: 10px 50px">取消</button>' + //
                '<button class="btn btn-primary normal-btn" type="button" ng-click="ok()" style="padding: 10px 50px">确认</button>' + //
                '</div>' +
                '</div>',

                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });

        };

        function contentConfirm(option, confirmCallback, cancelCallback) {

            console.log('option',option);

            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.option = option;

                    $scope.showDescription = false;

                    $scope.showDescAction = function () {
                        $scope.showDescription=!$scope.showDescription
                    };

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                        '<div style="text-align:center; padding-bottom: 0">' + //
                            '<h3 style="font-size: 36px; font-weight: 700; color: #292929; margin-bottom: 20px">' + (option.title||"") + '</h3>' + //
                            '<p style="font-size: 20px; font-weight: 500px; color: #898989">' + (option.content||"") + '</p>' + //
                        '</div>' + //
                        '<div style="margin: 20px; padding: 12px; border-top: 1px solid #BEC4CB; color: #898989; font-size: 20px; text-align: center" ng-if="option.desc">'+option.desc+'</div>'+
                        '<div class="modal-footer" style="width: 100%;text-align: center;">' + //
                                '<button class="btn btn-default" type="button" ng-click="cancel()" style="margin-right: 20px;">'+(option.cancel||'取消')+'</button>' + //
                                '<button class="btn btn-primary normal-btn" type="button" ng-click="ok()">'+(option.issue||'确认')+'</button>' + //
                                '<div style="clear: both"></div>\n' +
                '                <p style="font-size: 18px; color: #AAAAAA; margin-top: 20px; cursor: pointer" ng-click="showDescAction()" ng-if="option.descTitle">'+option.descTitle+' <span class="iconfont icon-wenhao"></span></p>' +
                        '</div>' +
                        '<div style="text-align: left" ng-if="showDescription && option.descContent">\n' +
                '                <div class="appointment-modal-left" style="width: 100%">\n' +
                '                    <p>'+option.descContent+'</p>\n' +
                '                </div>\n' +
                '            </div>' +
                    '</div>',

                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });

        };

        function contentKnow(option) {

            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                '<div style="text-align:center; padding-bottom: 0">' + //
                '<h3 style="font-size: 36px; font-weight: 700; color: #292929; margin-bottom: 20px">' + (option.title||"") + '</h3>' + //
                '<p style="font-size: 20px; font-weight: 500px; color: #898989">' + (option.content||"") + '</p>' + //
                '</div>' + //
                '<div class="modal-footer" style="width: 100%;text-align: center;">' + //
                '<button class="btn btn-primary normal-btn" type="button" ng-click="ok()">'+(option.issue||'确认')+'</button>' + //
                '</div>' +
                '</div>',

                controller: ModalInstanceCtrl
            });

            modalInstance.result.then();

        };

        function confirm2(msg, confirmCallback) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + msg + '</h3>' + //
                    '</div>' + //
                    '<div class="row">' + //
                    '<button class="btn btn-primary pull-right" ng-click="ok()">确认</button>' + //
                    '</div>' + //
                    '</div>',
                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });

        };

        function successConfirm(msg, confirmCallback) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                controller: ModalInstanceCtrl
            });
            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        };

        function comment(msg, confirmCallback, cancelCallback, commentMust) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = "请输入评论(必填)";
                    } else {
                        $scope.placeholderMsg = "请输入评论(可空)";
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + msg + '</h3>' + //
                    '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                    '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                    '</div>' + //
                    '<div class="row" style="padding-top: 10px;">' + //
                    '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                    '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                    '</div>' + //
                    '</div>',
                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        };
        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

// (function() {
//     'use strict';
//
//     angular
//         .module('gwApp')
//         .controller('LoginController', LoginController);
//
//     LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];
//
//     function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
//         var vm = this;
//
//         vm.authenticationError = false;
//         vm.cancel = cancel;
//         vm.credentials = {};
//         vm.login = login;
//         vm.password = null;
//         vm.register = register;
//         vm.rememberMe = true;
//         vm.requestResetPassword = requestResetPassword;
//         vm.username = null;
//
//         $timeout(function (){angular.element('#username').focus();});
//
//         function cancel () {
//             vm.credentials = {
//                 username: null,
//                 password: null,
//                 rememberMe: true
//             };
//             vm.authenticationError = false;
//             $uibModalInstance.dismiss('cancel');
//         }
//
//         function login (event) {
//             event.preventDefault();
//             Auth.login({
//                 username: vm.username,
//                 password: vm.password,
//                 rememberMe: vm.rememberMe
//             }).then(function () {
//                 vm.authenticationError = false;
//                 $uibModalInstance.close();
//                 if ($state.current.name === 'register' || $state.current.name === 'activate' ||
//                     $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
//                     $state.go('home');
//                 }
//
//                 $rootScope.$broadcast('authenticationSuccess');
//
//                 // previousState was set in the authExpiredInterceptor before being redirected to login modal.
//                 // since login is successful, go to stored previousState and clear previousState
//                 if (Auth.getPreviousState()) {
//                     var previousState = Auth.getPreviousState();
//                     Auth.resetPreviousState();
//                     $state.go(previousState.name, previousState.params);
//                 }
//             }).catch(function () {
//                 vm.authenticationError = true;
//             });
//         }
//
//         function register () {
//             $uibModalInstance.dismiss('cancel');
//             $state.go('register');
//         }
//
//         function requestResetPassword () {
//             $uibModalInstance.dismiss('cancel');
//             $state.go('requestReset');
//         }
//     }
// })();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'zh-cn',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .directive('inputSelect', inputSelect);

    function inputSelect() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                //element.bind('mouseover',function(event){// 鼠标滑到数据时，选中
                //        this.select();
                //});
                // element.bind('click', function (event) {// 点击时，选中
                //     this.select();
                // });
                element.bind('focus', function (event) {// 获取焦点时，选中
                    this.select();
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('validate', validate);

    function validate () {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            ngModel.$validators.validate = function(modelValue,viewValue){
                if(modelValue!=null&&modelValue!=''){
                    if(attrs.pattern!=null&&attrs.pattern!=''){
                        if(modelValue.match(attrs.pattern)!=null){
                            ngModel.$error = {};
                            ngModel.$invalid = false;
                            ngModel.$dirty = false;
                            return ngModel.$error.pattern = false;
                        }else{
                            ngModel.$error = {};
                            ngModel.$invalid = true;
                            ngModel.$dirty = true;
                            return ngModel.$error.pattern = true;
                        }
                    }else{
                        if(attrs.name=="name"){
                            if(modelValue.match("^[\u4e00-\u9fa5_'.A-Za-z0-9-]{4,20}$")!=null){
                                ngModel.$error = {};
                                ngModel.$invalid = false;
                                ngModel.$dirty = false;
                                return ngModel.$error.pattern = false;
                            }else{
                                ngModel.$error = {};
                                ngModel.$invalid = true;
                                ngModel.$dirty = true;
                                return ngModel.$error.pattern = true;
                            }
                        }else{
                            ngModel.$error = {};
                            ngModel.$invalid = true;
                            ngModel.$dirty = true;
                            return ngModel.$error.pattern = true;
                        }
                    }
                }else{
                    if(JSON.stringify(ngModel.$error)=="{}"){
                        ngModel.$error = {};
                        ngModel.$invalid = false;
                        ngModel.$dirty = false;
                        return ngModel.$error.require = true;
                    }else{
                        ngModel.$error = {};
                        ngModel.$invalid = true;
                        ngModel.$dirty = true;
                        return ngModel.$error.require = true;
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('gwApp')
        .directive('focusMe', focusMe);

    function focusMe() {
        return {
            restrict: 'A',
            scope: {
                focusMe: '='
            },
            link: function (scope, element, attr, ngModel) {
                scope.$watch('focusMe', function (val) {
                    if (val) {
                        element[0].focus();
                    }
                });
            }
        };
    }
})();

// https://github.com/Gillardo/bootstrap-ui-datetime-picker
// Version: 2.4.3
// Released: 2016-07-14
angular.module('ui.bootstrap.datetimepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
    .constant('uiDatetimePickerConfig', {
        dateFormat: 'yyyy-MM-dd',
        // defaultTime: '00:00:00',
        html5Types: {
            date: 'yyyy-MM-dd',
            'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
            'month': 'yyyy-MM'
        },
        initialPicker: 'date',
        reOpenDefault: false,
        enableDate: true,
        enableTime: false,
        buttonBar: {
            show: true,
            now: {
                show: true,
                text: '当前'
            },
            today: {
                show: true,
                text: '今天'
            },
            clear: {
                show: true,
                text: '清空'
            },
            date: {
                show: true,
                text: 'Date'
            },
            time: {
                show: true,
                text: 'Time'
            },
            close: {
                show: true,
                text: '关闭'
            }
        },
        closeOnDateSelection: true,
        closeOnTimeNow: true,
        appendToBody: false,
        altInputFormats: [],
        ngModelOptions: {},
        saveAs: false,
        showWeeks: false,
        readAs: false
    })
    .controller('DateTimePickerController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$document', '$timeout', '$uibPosition', 'dateFilter', 'uibDateParser', 'uiDatetimePickerConfig', '$rootScope',
        function ($scope, $element, $attrs, $compile, $parse, $document, $timeout, $uibPosition, dateFilter, uibDateParser, uiDatetimePickerConfig, $rootScope) {
            var dateFormat = uiDatetimePickerConfig.dateFormat,
                ngModel, ngModelOptions, $popup, cache = {}, watchListeners = [],
                closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : uiDatetimePickerConfig.closeOnDateSelection,
                closeOnTimeNow = angular.isDefined($attrs.closeOnTimeNow) ? $scope.$parent.$eval($attrs.closeOnTimeNow) : uiDatetimePickerConfig.closeOnTimeNow,
                appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : uiDatetimePickerConfig.appendToBody,
                altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : uiDatetimePickerConfig.altInputFormats,
                saveAs = angular.isDefined($attrs.saveAs) ? $scope.$parent.$eval($attrs.saveAs) || $attrs.saveAs : uiDatetimePickerConfig.saveAs,
                readAs = angular.isDefined($attrs.readAs) ? $scope.$parent.$eval($attrs.readAs) : uiDatetimePickerConfig.readAs;

            this.init = function (_ngModel) {
                ngModel = _ngModel;
                ngModelOptions = ngModel.$options || uiDatetimePickerConfig.ngModelOptions;

                $scope.buttonBar = angular.isDefined($attrs.buttonBar) ? $scope.$parent.$eval($attrs.buttonBar) : uiDatetimePickerConfig.buttonBar;

                // determine which pickers should be available. Defaults to date and time
                $scope.enableDate = angular.isDefined($scope.enableDate) ? $scope.enableDate : uiDatetimePickerConfig.enableDate;
                $scope.enableTime = angular.isDefined($scope.enableTime) ? $scope.enableTime : uiDatetimePickerConfig.enableTime;

                // determine default picker
                $scope.initialPicker = angular.isDefined($attrs.initialPicker) ? $attrs.initialPicker : ($scope.enableDate ? uiDatetimePickerConfig.initialPicker : 'time');

                // determine the picker to open when control is re-opened
                $scope.reOpenDefault = angular.isDefined($attrs.reOpenDefault) ? $attrs.reOpenDefault : uiDatetimePickerConfig.reOpenDefault;

                // check if an illegal combination of options exists
                if ($scope.initialPicker == 'date' && !$scope.enableDate) {
                    throw new Error("datetimePicker can't have initialPicker set to date and have enableDate set to false.");
                }

                // default picker view
                $scope.showPicker = !$scope.enableDate ? 'time' : $scope.initialPicker;

                var isHtml5DateInput = false;

                if (uiDatetimePickerConfig.html5Types[$attrs.type]) {
                    dateFormat = uiDatetimePickerConfig.html5Types[$attrs.type];
                    isHtml5DateInput = true;
                } else {
                    dateFormat = $attrs.datetimePicker || uiDatetimePickerConfig.dateFormat;
                    $attrs.$observe('datetimePicker', function (value) {
                        var newDateFormat = value || uiDatetimePickerConfig.dateFormat;

                        if (newDateFormat !== dateFormat) {
                            dateFormat = newDateFormat;
                            ngModel.$modelValue = null;

                            if (!dateFormat) {
                                throw new Error('datetimePicker must have a date format specified.');
                            }
                        }
                    });
                }

                if (!dateFormat) {
                    throw new Error('datetimePicker must have a date format specified.');
                }

                // popup element used to display calendar
                var popupEl = angular.element('' +
                    '<div date-picker-wrap>' +
                    '<div uib-datepicker></div>' +
                    '</div>' +
                    '<div time-picker-wrap>' +
                    '<div uib-timepicker style="margin:0 auto"></div>' +
                    '</div>');

                if (ngModelOptions) {
                    timezone = ngModelOptions.timezone;
                    $scope.ngModelOptions = angular.copy(ngModelOptions);
                    $scope.ngModelOptions.timezone = null;
                    if ($scope.ngModelOptions.updateOnDefault === true) {
                        $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ?
                        $scope.ngModelOptions.updateOn + ' default' : 'default';
                    }

                    popupEl.attr('ng-model-options', 'ngModelOptions');
                } else {
                    timezone = null;
                }

                // get attributes from directive
                popupEl.attr({
                    'ng-model': 'date',
                    'ng-change': 'dateSelection(date)'
                });

                // datepicker element
                var datepickerEl = angular.element(popupEl.children()[0]);

                if (!$scope.datepickerOptions) {
                    $scope.datepickerOptions = {};
                }

                if (isHtml5DateInput) {
                    if ($attrs.type === 'month') {
                        $scope.datepickerOptions.datepickerMode = 'month';
                        $scope.datepickerOptions.minMode = 'month';
                    }
                }

                datepickerEl.attr('datepicker-options', 'datepickerOptions');

                // set datepickerMode to day by default as need to create watch
                // else disabled cannot pass in mode
                if (!angular.isDefined($scope.datepickerOptions.datepickerMode)) {
                    $scope.datepickerOptions.datepickerMode = 'day';
                }

                // timepicker element
                var timepickerEl = angular.element(popupEl.children()[1]);

                if (!$scope.timepickerOptions)
                    $scope.timepickerOptions = {};

                for (var key in $scope.timepickerOptions) {
                    timepickerEl.attr(cameltoDash(key), 'timepickerOptions.' + key);
                    // timepickerEl.attr(cameltoDash(key), $scope.timepickerOptions[key]);
                }

                // watch attrs - NOTE: minDate and maxDate are used with datePicker and timePicker.  By using the minDate and maxDate
                // with the timePicker, you can dynamically set the min and max time values.  This cannot be done using the min and max values
                // with the timePickerOptions
                angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
                    if ($scope.datepickerOptions[key]) {
                        if (key == 'minDate') {
                            timepickerEl.attr('min', 'datepickerOptions.minDate');
                        } else if (key == 'maxDate')
                            timepickerEl.attr('max', 'datepickerOptions.maxDate');
                    }
                });

                // do not check showWeeks attr, as should be used via datePickerOptions

                if (!isHtml5DateInput) {
                    // Internal API to maintain the correct ng-invalid-[key] class
                    ngModel.$$parserName = 'datetime';
                    ngModel.$validators.datetime = validator;
                    ngModel.$parsers.unshift(parseDate);
                    ngModel.$formatters.push(function (value) {
                        if (ngModel.$isEmpty(value)) {
                            $scope.date = value;
                            return value;
                        }

                        $scope.date = uibDateParser.fromTimezone(value, ngModelOptions.timezone);

                        dateFormat = dateFormat.replace(/M!/, 'MM')
                            .replace(/d!/, 'dd');

                        return uibDateParser.filter($scope.date, dateFormat);
                    });
                } else {
                    ngModel.$formatters.push(function (value) {
                        $scope.date = uibDateParser.fromTimezone(value, ngModelOptions.timezone);
                        return value;
                    });
                }

                if (saveAs) {
                    // If it is determined closure var's need to be exposed to the parser, don't add the formatter here.
                    // Instead just call the method from within the stock parser with this context and/or any needed closure variables.
                    if (angular.isFunction(saveAs))
                        ngModel.$parsers.push(saveAs);
                    else
                        ngModel.$parsers.push(saveAsParser);

                    // Assuming if saveAs is !false, we'll want to convert, either pass the function, or the stock str/num -> Date obj formatter.
                    if (angular.isFunction(readAs))
                        ngModel.$formatters.push(readAs);
                    else
                        ngModel.$formatters.push(readAsFormatter);
                }
                // Detect changes in the view from the text box
                ngModel.$viewChangeListeners.push(function () {
                    $scope.date = parseDateString(ngModel.$viewValue);
                });

                $element.bind('keydown', inputKeydownBind);

                $popup = $compile(popupEl)($scope);
                // Prevent jQuery cache memory leak (template is now redundant after linking)
                popupEl.remove();

                if (appendToBody) {
                    $document.find('body').append($popup);
                } else {
                    $element.after($popup);
                }

                function readAsFormatter(value) {
                    if (ngModel.$isEmpty(value))
                        return value;

                    var d = new Date(value);
                    if (angular.isDate(d) && !isNaN(d))
                        return d;

                    return value;
                }

                function saveAsParser(value) {
                    if (!value || angular.isString(value) || !angular.isDate(value) || isNaN(value))
                        return value;

                    if (saveAs === 'ISO')
                        return value.toISOString();

                    if (saveAs === 'json')
                        return value.toJSON();

                    if (saveAs === 'number')
                        return value.valueOf();

                    if (!isHtml5DateInput) {
                        dateFormat = dateFormat.replace(/M!/, 'MM')
                            .replace(/d!/, 'dd');
                        return uibDateParser.filter(uibDateParser.fromTimezone(value, ngModelOptions.timezone), dateFormat);
                    } else {
                        return uibDateParser.fromTimezone(value, ngModelOptions.timezone).toLocaleString();
                    }
                }
            };

            // get text
            $scope.getText = function (key) {
                return $scope.buttonBar[key].text || uiDatetimePickerConfig.buttonBar[key].text;
            };

            $scope.keydown = function (evt) {
                if (evt.which === 27) {
                    $scope.close(false);
                    $element[0].focus();
                }
            };

            // determine if button is to be shown or not
            $scope.doShow = function (key) {
                if (angular.isDefined($scope.buttonBar[key].show))
                    return $scope.buttonBar[key].show;
                else
                    return uiDatetimePickerConfig.buttonBar[key].show;
            };

            // Inner change
            $scope.dateSelection = function (dt, opt) {

                // check if timePicker is being shown and merge dates, so that the date
                // part is never changed, only the time
                if ($scope.enableTime && $scope.showPicker === 'time') {

                    // only proceed if dt is a date
                    if (dt || dt != null) {
                        // check if our $scope.date is null, and if so, set to todays date
                        if (!angular.isDefined($scope.date) || $scope.date == null) {
                            $scope.date = new Date();
                        }

                        // dt will not be undefined if the now or today button is pressed
                        if (dt && dt != null) {
                            // get the existing date and update the time
                            var date = new Date($scope.date);
                            date.setHours(dt.getHours());
                            date.setMinutes(dt.getMinutes());
                            date.setSeconds(dt.getSeconds());
                            date.setMilliseconds(dt.getMilliseconds());
                            dt = date;
                        }
                    }
                }

                if (angular.isDefined(dt)) {
                    if (!$scope.date) {
                        var defaultTime = angular.isDefined($attrs.defaultTime) ? $attrs.defaultTime : uiDatetimePickerConfig.defaultTime;
                        var t = new Date('2001-01-01 ' + defaultTime);

                        if (!isNaN(t) && dt != null) {
                            dt.setHours(t.getHours());
                            dt.setMinutes(t.getMinutes());
                            dt.setSeconds(t.getSeconds());
                            dt.setMilliseconds(t.getMilliseconds());
                        }
                    }
                    $scope.date = dt;
                }

                var date = $scope.date ? dateFilter($scope.date, dateFormat) : null;

                $element.val(date);
                ngModel.$setViewValue(date);

                if (closeOnDateSelection) {
                    // do not close when using timePicker as make impossible to choose a time
                    if ($scope.showPicker != 'time' && date != null) {
                        // if time is enabled, swap to timePicker
                        if ($scope.enableTime) {
                            $scope.open('time');
                        } else {
                            $scope.close(false);
                        }
                    } else if (closeOnTimeNow && $scope.showPicker === 'time' && date != null && opt === 'now') {
                        $scope.close(false);
                    }
                }

            };

            $scope.$watch('isOpen', function (value) {
                $scope.dropdownStyle = {
                    display: value ? 'block' : 'none'
                };

                if (value) {
                    cache['openDate'] = $scope.date;

                    var position = appendToBody ? $uibPosition.offset($element) : $uibPosition.position($element);

                    if (appendToBody) {
                        $scope.dropdownStyle.top = (position.top + $element.prop('offsetHeight')) + 'px';
                    } else {
                        $scope.dropdownStyle.top = undefined;
                    }

                    $scope.dropdownStyle.left = position.left + 'px';

                    $timeout(function () {
                        $scope.$broadcast('uib:datepicker.focus');
                        $document.bind('click', documentClickBind);
                    }, 0, false);

                    $scope.open($scope.showPicker);
                } else {
                    $document.unbind('click', documentClickBind);
                }
            });

            $scope.isDisabled = function (date) {
                if (date === 'today' || date === 'now')
                    date = uibDateParser.fromTimezone(new Date(), timezone);

                var dates = {};
                angular.forEach(['minDate', 'maxDate'], function (key) {
                    if (!$scope.datepickerOptions[key]) {
                        dates[key] = null;
                    } else if (angular.isDate($scope.datepickerOptions[key])) {
                        dates[key] = uibDateParser.fromTimezone(new Date($scope.datepickerOptions[key]), timezone);
                    } else {
                        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
                    }
                });

                return $scope.datepickerOptions &&
                    dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
                    dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
            };

            $scope.compare = function (date1, date2) {
                return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
            };

            $scope.select = function (opt, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                var date = null;
                var isNow = opt === 'now';

                if (opt === 'today' || opt == 'now') {
                    var now = new Date();
                    if (angular.isDate($scope.date)) {
                        date = new Date($scope.date);
                        date.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
                        date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
                    } else {
                        date = now;
                    }
                }

                $scope.dateSelection(date, opt);
            };

            $scope.open = function (picker, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                // need to delay this, else timePicker never shown
                $timeout(function () {
                    $scope.showPicker = picker;
                }, 0);

                // in order to update the timePicker, we need to update the model reference!
                // as found here https://angular-ui.github.io/bootstrap/#/timepicker
                if (picker == 'time') {
                    $timeout(function () {
                        $scope.date = parseDateString(ngModel.$viewValue);
                    }, 50);
                }
            };

            $scope.close = function (closePressed, evt) {
                if (angular.isDefined(evt)) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }

                $scope.isOpen = false;

                // if enableDate and enableTime are true, reopen the picker in date mode first
                if ($scope.enableDate && $scope.enableTime)
                    $scope.showPicker = $scope.reOpenDefault === false ? 'date' : $scope.reOpenDefault;

                // if a on-close-fn has been defined, lets call it
                // we only call this if closePressed is defined!
                if (angular.isDefined(closePressed)) {
                    $scope.whenClosed({args: {closePressed: closePressed, openDate: cache['openDate'] || null, closeDate: $scope.date}});
                } else {
                    $element[0].focus();
                }
            };

            $scope.$on('$destroy', function () {
                if ($scope.isOpen === true) {
                    if (!$rootScope.$$phase) {
                        $scope.$apply(function () {
                            $scope.close();
                        });
                    }
                }

                watchListeners.forEach(function (a) {
                    a();
                });
                $popup.remove();
                $element.unbind('keydown', inputKeydownBind);
                $document.unbind('click', documentClickBind);
            });

            function documentClickBind(evt) {
                var popup = $popup[0];
                var dpContainsTarget = $element[0].contains(evt.target);

                // The popup node may not be an element node
                // In some browsers (IE only) element nodes have the 'contains' function
                var popupContainsTarget = popup.contains !== undefined && popup.contains(evt.target);

                if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
                    $scope.$apply(function () {
                        $scope.close(false);
                    });
                }
            }

            function inputKeydownBind(evt) {
                if (evt.which === 27 && $scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.close(false);
                    });
                    $element[0].focus();
                } else if (evt.which === 40 && !$scope.isOpen) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $scope.$apply(function () {
                        $scope.isOpen = true;
                    });
                }
            }

            function cameltoDash(string) {
                return string.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }

            function parseDateString(viewValue) {
                var date = uibDateParser.parse(viewValue, dateFormat, $scope.date);
                if (isNaN(date)) {
                    for (var i = 0; i < altInputFormats.length; i++) {
                        date = uibDateParser.parse(viewValue, altInputFormats[i], $scope.date);
                        if (!isNaN(date)) {
                            return date;
                        }
                    }
                }
                return date;
            }

            function parseDate(viewValue) {
                if (angular.isNumber(viewValue) && !isNaN(viewValue)) {
                    // presumably timestamp to date object
                    viewValue = new Date(viewValue);
                }

                if (!viewValue) {
                    return null;
                }

                if (angular.isDate(viewValue) && !isNaN(viewValue)) {
                    return viewValue;
                }

                if (angular.isString(viewValue)) {
                    var date = parseDateString(viewValue);
                    if (!isNaN(date)) {
                        return uibDateParser.toTimezone(date, ngModelOptions.timezone);
                    }

                    return undefined;
                } else {
                    return undefined;
                }
            }

            function validateMinMax(value) {
                if ($scope.datepickerOptions.minDate && value < $scope.datepickerOptions.minDate) {
                    return false;
                } else if ($scope.datepickerOptions.maxDate && value > $scope.datepickerOptions.maxDate) {
                    return false;
                } else {
                    return true;
                }
            }

            function validator(modelValue, viewValue) {
                var value = modelValue || viewValue;

                if (!($attrs.ngRequired || $attrs.required) && !value) {
                    return true;
                }

                if (angular.isNumber(value)) {
                    value = new Date(value);
                }

                if (!value) {
                    return true;
                } else if (angular.isDate(value) && !isNaN(value)) {
                    return validateMinMax(value);
                } else if (angular.isDate(new Date(value)) && !isNaN(new Date(value).valueOf())) {
                    return validateMinMax(new Date(value));
                } else if (angular.isString(value)) {
                    return !isNaN(parseDateString(viewValue)) && validateMinMax(parseDateString(viewValue));
                } else {
                    return false;
                }
            }

        }])
    .directive('datetimePicker', function () {
        return {
            restrict: 'A',
            require: ['ngModel', 'datetimePicker'],
            controller: 'DateTimePickerController',
            scope: {
                isOpen: '=?',
                datepickerOptions: '=?',
                timepickerOptions: '=?',
                enableDate: '=?',
                enableTime: '=?',
                initialPicker: '=?',
                reOpenDefault: '=?',
                whenClosed: '&'
            },
            link: function (scope, element, attrs, ctrls) {
                var ngModel = ctrls[0],
                    ctrl = ctrls[1];

                ctrl.init(ngModel);
            }
        };
    })
    .directive('datePickerWrap', function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: 'template/date-picker.html'
        };
    })

    .directive('timePickerWrap', function () {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: 'template/time-picker.html'
        };
    });

angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('template/date-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'date'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=date-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('today') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('today')\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('today') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('time') && enableTime) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('time') && enableTime\" ng-click=\"open('time', $event)\">{{ getText('time')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );


  $templateCache.put('template/time-picker.html',
    "<ul class=\"dropdown-menu dropdown-menu-left datetime-picker-dropdown\" ng-if=\"isOpen && showPicker == 'time'\" ng-style=dropdownStyle style=left:inherit ng-keydown=keydown($event) ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><li style=\"padding:0 5px 5px 5px\" class=time-picker-menu><div ng-transclude></div></li><li style=padding:5px ng-if=buttonBar.show><span class=\"btn-group pull-left\" style=margin-right:10px ng-if=\"doShow('now') || doShow('clear')\"><button type=button class=\"btn btn-sm btn-info\" ng-if=\"doShow('now')\" ng-click=\"select('now', $event)\" ng-disabled=\"isDisabled('now')\">{{ getText('now') }}</button> <button type=button class=\"btn btn-sm btn-danger\" ng-if=\"doShow('clear')\" ng-click=\"select('clear', $event)\">{{ getText('clear') }}</button></span> <span class=\"btn-group pull-right\" ng-if=\"(doShow('date') && enableDate) || doShow('close')\"><button type=button class=\"btn btn-sm btn-default\" ng-if=\"doShow('date') && enableDate\" ng-click=\"open('date', $event)\">{{ getText('date')}}</button> <button type=button class=\"btn btn-sm btn-success\" ng-if=\"doShow('close')\" ng-click=\"close(true, $event)\">{{ getText('close') }}</button></span> <span class=clearfix></span></li></ul>"
  );

}]);

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('gwApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 500,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('gwApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('gwApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 500; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('gwApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('gwApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }

                // if (response.data.path !== '/api/member/account/current') {
                //
                // }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('gwApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "zh-cn"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('ol-client-');
        $sessionStorageProvider.setKeyPrefix('ol-client-');
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gwApp')
        .constant('VERSION', "1.0.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
(function(){angular.module('gwApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/default/default.html','<div class="container"></div>');
$templateCache.put('app/module/module.html','<div><div class="module-header" id="navigation-header" ng-class="{\'module-header-white\': !transparent}"><div class="module-header-content"><div class="logo-container" ui-sref="home" ng-style="{\'pointer-events\':preview?\'none\':\'auto\'}"><img src="content/images/3work_logo.png" ng-if="transparent"> <img src="content/images/logo_gold.png" ng-if="!transparent"></div><div class="navi-container" style="float: left; margin-left: 20px"><a ng-click="selCityAction()" ng-style="{\'pointer-events\':preview?\'none\':\'auto\'}"><i style="font-size: 20px" class="iconfont icon-location"></i> {{locationName}} <i class="iconfont icon-sanjiaoxing"></i></a></div><div class="navi-container navi" style="margin-right: 60px" ng-style="{\'pointer-events\':preview?\'none\':\'auto\'}"><a ui-sref="activities">\u4F1A\u5458\u6D3B\u52A8</a> <a ng-click="agentAction()">\u4E2D\u4ECB\u5408\u4F5C</a> <a id="contact-us-btn">\u8054\u7CFB\u6211\u4EEC</a><div class="contact-us-container"><div class="limit-container" style="background-color: transparent"><div class="limit-center-content"><div class="contact-us-left"><p style="font-size: 36px" class="bold-font">\u8054\u7CFB3work</p><p style="margin-bottom: 60px">\u8D44\u8BAF\u623F\u6E90\u7B49\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u6211\u4EEC\u7684\u51B3\u7B56\u987E\u95EE</p><!--<p><span class="bold-font" style="margin-right: 20px">\u7535\u8BDD</span> 021-23563104<br><span style="padding-left: 65px">021-23563105</span><br><span style="padding-left: 65px">021-23563106</span></p>--><p><span class="bold-font" style="margin-right: 20px">\u7535\u8BDD</span> 021-23563105</p><p><span class="bold-font" style="margin-right: 20px">\u90AE\u7BB1</span> jean-francoisxu@3work.com.cn<br><span style="padding-left: 65px">jean-charlesxu@3work.com.cn</span><br><span style="padding-left: 65px">ruanhaoxu@3work.com.cn</span></p><p><span class="bold-font" style="margin-right: 20px">\u5730\u5740</span> \u4E0A\u6D77\u5E02\u4E2D\u5C71\u897F\u8DEF1055\u53F7 soho\u4E2D\u5C71\u5E7F\u573A A\u5EA716\u697C</p></div><div class="contact-us-right"><p style="font-size: 36px" class="bold-font">\u5173\u6CE8\u6211\u4EEC\u83B7\u5F97\u6700\u65B0\u8D44\u8BAF</p><!--<p>\u5728\u624B\u673A\u4E0A\u9884\u5B9A\uFF0C\u7BA1\u7406\u623F\u6E90\uFF01</p>--><div class="footer-item" style="width: 100%"><p style="font-size: 20px; margin-bottom: 30px; white-space: nowrap">\u5728\u624B\u673A\u4E0A\u9884\u5B9A\uFF0C\u7BA1\u7406\u623F\u6E90\uFF01</p><ul><li><div style="text-align: center; float: left"><img src="content/images/qrcode_mini_app.jpg" alt="" style="width: 80px; height: 80px; border-radius: 10px"><p style="margin: 10px 0 0 0">\u626B\u7801\u5173\u6CE8</p><p>\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F</p></div><div style="text-align: center; float: left; margin-left: 60px"><img src="content/images/qrcode_wechat.jpg" alt="" style="width: 80px; height: 80px; border-radius: 10px"><p style="margin: 10px 0 0 0">\u626B\u7801\u5173\u6CE8</p><p>\u5FAE\u4FE1\u516C\u4F17\u53F7</p></div><div style="clear: both"></div></li></ul></div></div></div></div></div><button class="btn btn-primary normal-btn bold-button" style="color: white; margin-top: -8px" ng-click="loginAction()" ng-if="!userModel">\u767B\u5F55/\u6CE8\u518C</button> <button class="btn btn-primary normal-btn bold-button" style="color: white; margin-top: -8px" ui-sref="memberCenter" ng-if="userModel">\u6211\u7684\u7BA1\u5BB6</button></div></div></div><section><div ui-view="content" ng-cloak autoscroll="true"></div></section><footer class="footer-container"><div class="limit-container"><div class="limit-center-content"><div class="footer-item"><p>\u5173\u4E8E\u6211\u4EEC</p><ul><li>\u54C1\u724C\u5EFA\u7ACB\u4E8E2019\u5E74\u3002</li><li>\u5C5E\u4E8E\u672A\u6765\uFF0C\u65B0\u54C1\u724C\uFF0C\u65B0\u8840\u6DB2\uFF0C\u65B0\u4E16\u754C\u3002</li><li>\u6211\u4EEC\u4E0D\u662F\u63D0\u4F9B\u5DE5\u4F5C\u573A\u5730\uFF0C\u800C\u662F\u5E2E\u60A8\u5B9E\u73B0\u68A6\u60F3\u3002</li></ul></div><div class="footer-item"><p>\u8054\u7CFB\u6211\u4EEC</p><ul><!--<li>\u7535\u8BDD\uFF1A021-23563104<br><span style="padding-left: 41px">021-23563105</span><br><span style="padding-left: 41px">021-23563106</span></li>--><li>\u7535\u8BDD\uFF1A021-23563105</li><li>\u90AE\u7BB1\uFF1A jean-francoisxu@3work.com.cn<br><span style="padding-left: 45px">jean-charlesxu@3work.com.cn</span><br><span style="padding-left: 45px">ruanhaoxu@3work.com.cn</span></li><li>\u5730\u5740\uFF1A\u4E0A\u6D77\u5E02\u4E2D\u5C71\u897F\u8DEF1055\u53F7soho\u4E2D\u5C71\u5E7F\u573AA\u5EA716\u697C</li></ul></div><div class="footer-item"><p>\u5173\u6CE8\u6211\u4EEC</p><ul><li><div style="text-align: center; float: left"><img src="content/images/qrcode_mini_app.jpg" alt="" style="width: 65px; height: 68px; border-radius: 10px"><p style="margin-top: 8px">\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F</p></div><div style="text-align: center; float: left; margin-left: 20px"><img src="content/images/qrcode_wechat.jpg" alt="" style="width: 65px; height: 68px; border-radius: 10px"><p style="margin-top: 8px">\u5FAE\u4FE1\u516C\u4F17\u53F7</p></div><div style="clear: both"></div></li></ul></div><div style="clear: both"></div><p style="text-align: center; color: #292929; margin: 19px 0 0 0">\xA92019 \u4E0A\u6D77\u76DB\u5B97\u7693\u4F01\u4E1A\u7BA1\u7406\u6709\u9650\u516C\u53F8 <a href="http://www.beian.gov.cn" target="_blank" style="color: #292929">\u6CAAICP\u590719022050\u53F7-1</a></p></div></div></footer></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h3 data-translate="login.title">Sign in</h3></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="fa fa-bar"></span> <span class="fa fa-bar"></span> <span class="fa fa-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.png" alt="logo"> <span data-translate="global.title">Gw</span> <span class="navbar-version"></span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="product-stage" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.productStage">Product Stage</span></a></li><li ui-sref-active="active"><a ui-sref="sales-order" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.salesOrder">Sales Order</span></a></li><li ui-sref-active="active"><a ui-sref="customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.customer">Customer</span></a></li><li ui-sref-active="active"><a ui-sref="media" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.media">Media</span></a></li><li ui-sref-active="active"><a ui-sref="work-resource" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workResource">Work Resource</span></a></li><li ui-sref-active="active"><a ui-sref="worker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.worker">Worker</span></a></li><li ui-sref-active="active"><a ui-sref="work-team" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workTeam">Work Team</span></a></li><li ui-sref-active="active"><a ui-sref="manufacture-order" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.manufactureOrder">Manufacture Order</span></a></li><li ui-sref-active="active"><a ui-sref="work-task" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workTask">Work Task</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="gateway" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-road"></span>&nbsp; <span data-translate="global.menu.admin.gateway">Gateway</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/module/activity/activities.html','<div><div style="width: 100%; height: 515px; position: relative; margin-top: 85px; min-width: 1200px"><img lazy-src="{{recommendModel.posterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt="" style="top: 0;left: 0; width: 100%; height: 100%; position: absolute; object-fit: cover; overflow: hidden"><div style="position: absolute; top: 130px; width: 1200px; margin: 0 auto; left: 0; right: 0"><p style="margin: 0; font-size: 55px; font-weight: 500; color: white; margin-bottom: 20px">{{recommendModel.name}}<br>{{recommendModel.title}}</p><button class="bold-button" style="border: 1px solid white; color: white; background-color: transparent; padding: 10px 60px; border-radius: 5px" ui-sref="activity({id: recommendModel.id})">\u67E5\u770B\u8BE6\u60C5</button></div></div><div class="limit-container"><div class="limit-center-content"><div class="home-block-container"><p class="home-block-title">\u8FD1\u671F\u6D3B\u52A8</p><div class="activities-container clearfix"><div class="activities-item-2" ng-repeat="recently in recentlyList track by $index"><div class="activities-item-image-container" style="height: 352px"><img lazy-src="{{recently.posterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container" style="height: 509px"><p style="font-size: 32px; margin: 20px 0; text-align: center" class="bold-font">{{recently.name}}</p><p class="bold-font" style="margin-top: 50px; margin-bottom: 20px">\u62A5\u540D\u4EBA\u6570:{{recently.numberOfApplicants}}/{{recently.capacity}}</p><div class="activities-info clearfix"><p style="padding-right: 20px">\u65F6\u95F4\uFF1A<span style="font-size: 15px">{{recently.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{recently.endTime|date:\'yyyy-MM-dd HH:mm\'}}</span></p><p>\u5730\u70B9\uFF1A{{recently.addrProvince}}{{recently.addrCity}}{{recently.addrDistrict}}{{recently.addrAddress}}</p></div><div class="activities-info clearfix"><p style="padding-right: 20px">\u53D1\u8D77\uFF1A{{recently.publisheder}}</p><p>\u8D39\u7528\uFF1A{{recently.expense}}{{recently.expenseUnit}}</p></div><p style="text-align: center; height: 120px; overflow: hidden; white-space: normal; margin: 20px 0">{{recently.contents}}</p><div class="activities-footer-btn"><button class="btn btn-default" style="margin-right: 20px" ui-sref="activity({id: recently.id})">\u67E5\u770B\u8BE6\u60C5</button> <button class="btn btn-primary normal-btn" ng-click="applyAction(recently)">\u7ACB\u523B\u62A5\u540D</button></div></div></div></div><div class="text-center"><page page-cp="recentlyPage" page-ps="recentlySize" page-count="recentlyCount" page-change="recentlyPageChange()"></page></div></div><div class="home-block-container"><p class="home-block-title">\u5F80\u671F\u6D3B\u52A8</p><div class="activities-container clearfix"><div class="activities-item-2" ng-repeat="recently in historyList track by $index"><div class="activities-item-image-container" style="height: 352px"><img lazy-src="{{recently.posterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container" style="height: 509px"><p style="font-size: 32px; margin: 20px 0; text-align: center" class="bold-font">{{recently.name}}</p><p class="bold-font" style="margin-top: 50px; margin-bottom: 20px">\u62A5\u540D\u4EBA\u6570:{{recently.numberOfApplicants}}/{{recently.capacity}}</p><div class="activities-info clearfix"><p style="padding-right: 20px">\u65F6\u95F4\uFF1A<span style="font-size: 15px">{{recently.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{recently.endTime|date:\'yyyy-MM-dd HH:mm\'}}</span></p><p>\u5730\u70B9\uFF1A{{recently.addrProvince}}{{recently.addrCity}}{{recently.addrDistrict}}{{recently.addrAddress}}</p></div><div class="activities-info clearfix"><p style="padding-right: 20px">\u53D1\u8D77\uFF1A{{recently.publisheder}}</p><p>\u8D39\u7528\uFF1A{{recently.expense}}{{recently.expenseUnit}}</p></div><p style="text-align: center; height: 120px; overflow: hidden; white-space: normal; margin: 20px 0">{{recently.contents}}</p><div class="activities-footer-btn"><button class="btn btn-default" style="margin-right: 20px" ui-sref="activity({id: recently.id})">\u67E5\u770B\u8BE6\u60C5</button><!--<button class="btn btn-primary normal-btn">\u7ACB\u523B\u62A5\u540D</button>--></div></div></div></div><div class="text-center"><page page-cp="historyPage" page-ps="historySize" page-count="historyCount" page-change="historyPageChange()"></page></div></div></div></div></div>');
$templateCache.put('app/module/activity/activity.html','<div class="limit-container" style="margin-top: 85px"><div class="limit-center-content" style="padding: 60px"><div style="padding-bottom: 20px; border-bottom: 1px solid #C9C9C9" class="clearfix"><div class="building-detail-header building-detail-hoverable" ui-sref="home"><span>\u9996\u9875</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header building-detail-hoverable" ui-sref="activities"><span>\u6D3B\u52A8\u5217\u8868</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{activityModel.name}}</span></div></div><div style="padding: 54px 38px; color: #292929"><div style="margin-bottom: 50px" class="clearfix"><p style="line-height: 60px; font-size: 35px" class="bold-font pull-left">{{activityModel.name}}</p></div><div style="width: 100%; padding-right: 414px; position: relative"><div><div class="home-swiper" style="margin-bottom: 80px"><ul class="swiper-container home-swiper-container"><li class="swiper_animation" ng-style="swiper_animation"><img lazy-src="{{activityModel.posterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li></ul></div><div class="clearfix" style="margin-bottom: 30px"><p class="building-detail-title bold-font building-detail-navi" ng-class="{\'actived\': !showApplyInfo}" ng-click="showApplyInfo=false">\u6D3B\u52A8\u4FE1\u606F</p><p class="building-detail-title bold-font building-detail-navi" ng-class="{\'actived\': showApplyInfo}" ng-click="showApplyInfo=true" style="margin-left: 100px">\u5DF2\u62A5\u540D</p></div><div ng-if="!showApplyInfo"><div><div class="clearfix" style="margin-bottom: 40px"><div class="room-detail-info" style="float: none"><p class="bold-font room-detail-info-top">{{activityModel.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{activityModel.endTime|date:\'yyyy-MM-dd HH:mm\'}}</p><p class="room-detail-info-bottom">\u65F6\u95F4</p></div><div class="room-detail-info" style="float: none"><p class="bold-font room-detail-info-top">{{activityModel.addrProvince}}{{activityModel.addrCity}}{{activityModel.addrDistrict}}{{activityModel.addrAddress}}</p><p class="room-detail-info-bottom">\u5730\u70B9</p></div><div class="room-detail-info" style="float: none"><p class="bold-font room-detail-info-top">{{activityModel.expense}}{{activityModel.expenseUnit}}</p><p class="room-detail-info-bottom">\u8D39\u7528</p></div><div class="room-detail-info" style="float: none"><p class="bold-font room-detail-info-top">{{activityModel.numberOfApplicants}}/{{activityModel.capacity}}</p><p class="room-detail-info-bottom">\u62A5\u540D\u4EBA\u6570</p></div></div><div id="activity-content"></div></div><p class="building-detail-title bold-font">\u8FD1\u671F\u6D3B\u52A8</p><div class="activities-container clearfix"><div class="activities-item-3" ng-repeat="activity in recentlyList track by $index" style="width: 287px; cursor: pointer" ui-sref="activity({id: activity.id})"><div class="activities-item-image-container" style="height: 167px"><img lazy-src="{{activity.posterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt="" style="border-radius: 10px"></div><div class="activities-item-text-container" style="height: 138px; border: none"><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font">{{activity.name}}</p><p style="margin: 0 0 3px 0">\u65F6\u95F4 <span style="font-size: 15px">{{activity.startTime|date:\'MM-dd HH:mm\'}}-{{activity.endTime|date:\'MM-dd HH:mm\'}}</span></p><p style="margin: 0 0 10px 0">\u5730\u70B9 {{activity.addrProvince}}{{activity.addrCity}}{{activity.addrDistrict}}{{activity.addrAddress}}</p></div></div></div></div><div ng-if="showApplyInfo"><div class="clearfix" style="margin-bottom: 40px"><div class="room-detail-info" style="float: none"><p class="bold-font room-detail-info-top">{{activityModel.numberOfApplicants}}/{{activityModel.capacity}}</p><p class="room-detail-info-bottom">\u62A5\u540D\u4EBA\u6570</p></div></div><p class="building-detail-title bold-font">\u62A5\u540D\u8BE6\u60C5</p><div style="margin: -10px -30px"><div style="width: 50%; padding: 10px 30px; float: left" class="clearfix" ng-repeat="applyer in appliesList track by $index"><img lazy-src="{{applyer.memberImageUrl?applyer.memberImageUrl:\'content/images/header-placeholder.png\'}}" animate-visible="true" animate-speed="0.5s" alt="" style="width: 75px; height: 75px; border-radius: 50%; float: left; margin-right: 20px"><div class="card-detail-info" style="width: 70px; overflow: hidden; margin-right: 20px; margin-top: 8px"><p class="bold-font card-detail-info-top" style="font-size: 28px; white-space: nowrap">{{applyer.memberName}}</p><p class="card-detail-info-bottom" style="margin: 0; white-space: nowrap">{{applyer.companyName}}</p></div><div class="card-detail-info" style="min-width: 156px; overflow: hidden; margin-top: 8px"><p class="card-detail-info-top" style="font-size: 28px; white-space: nowrap">{{applyer.phone}}</p><p class="card-detail-info-bottom" style="margin: 0; white-space: nowrap">\u8054\u7CFB\u65B9\u5F0F</p></div></div></div><div class="text-center"><button class="btn btn-default absolute-btn" ng-click="loadMoreAction()" ng-if="appliesList.length < totalCount">\u5C55\u5F00\u66F4\u591A</button></div></div></div><div class="agency-container"><div class="agency-content" ng-style="{top: agencyContentTop+\'px\'}"><div class="modal-body" style="padding: 0" ng-if="!userModel && activityModel.timeStatus!=\'CLOSE\'"><div class="modal-header" style="margin-bottom: 50px"><h4 class="modal-title">\u767B\u5F55\u5E76\u62A5\u540D <span style="float: right;font-size: 18px;color: #9B9B9B; font-weight: 400">\u6CA1\u6709\u8D26\u53F7\uFF1F<a ng-click="requestRegisterAction()">\u6CE8\u518C</a></span></h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="loginAction()" show-validation><div><div class="vp-full-input-group"><input class="vp-full-input" type="text" placeholder="\u624B\u673A\u53F7" ng-model="loginModel.username" required ng-keyup="keyupAction($event)"></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" placeholder="\u767B\u5F55\u5BC6\u7801" ng-model="loginModel.password" required ng-keyup="keyupAction($event)"></div><div><vp-checkbox vp-model="loginModel.rememberMe"></vp-checkbox><span>\u8BB0\u4F4F\u8D26\u53F7\u5BC6\u7801</span> <span style="float: right">\u5FD8\u8BB0\u5BC6\u7801</span></div></div><div class="modal-footer"><div class="text-center"><button type="submit" class="btn btn-primary normal-btn absolute-btn">\u767B\u5F55</button></div></div></form></div><div ng-if="userModel && !isApply && activityModel.timeStatus!=\'CLOSE\'"><p class="building-detail-title bold-font" style="margin-top: 0">\u6B22\u8FCE\u56DE\u6765, {{userModel.fullname}}</p><div class="clearfix"><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u60A8\u9009\u62E9\u7684\u6D3B\u52A8\u662F</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.name}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u65F6\u95F4</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{activityModel.endTime|date:\'yyyy-MM-dd HH:mm\'}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u5730\u5740</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.addrProvince}}{{activityModel.addrCity}}{{activityModel.addrDistrict}}{{activityModel.addrAddress}}</p></div></div><div class="text-center" style="margin-top: 20px"><button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-click="applyAction()">\u7ACB\u5373\u62A5\u540D</button></div></div><div ng-if="userModel && isApply && activityModel.timeStatus!=\'CLOSE\'"><p class="building-detail-title bold-font" style="margin-top: 0">\u4F60\u5DF2\u6210\u529F\u62A5\u540D</p><div class="clearfix"><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u60A8\u9009\u62E9\u7684\u6D3B\u52A8\u662F</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.name}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u65F6\u95F4</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{activityModel.endTime|date:\'yyyy-MM-dd HH:mm\'}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u5730\u5740</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.addrProvince}}{{activityModel.addrCity}}{{activityModel.addrDistrict}}{{activityModel.addrAddress}}</p></div></div><div class="text-center" style="margin-top: 20px"><button type="submit" class="btn btn-default absolute-btn" ng-click="cancelApplyAction()">\u53D6\u6D88\u62A5\u540D</button></div></div><div ng-if="activityModel.timeStatus==\'CLOSE\'"><p class="building-detail-title bold-font" style="margin-top: 0">\u6D3B\u52A8\u5DF2\u8FC7\u671F</p><div class="clearfix"><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u60A8\u9009\u62E9\u7684\u6D3B\u52A8\u662F</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.name}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u65F6\u95F4</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.startTime|date:\'yyyy-MM-dd HH:mm\'}}\u81F3{{activityModel.endTime|date:\'yyyy-MM-dd HH:mm\'}}</p></div><div class="room-detail-info" style="float: none"><p class="room-detail-info-bottom" style="margin-bottom: 0; font-size: 20px">\u5730\u5740</p><p class="bold-font room-detail-info-top" style="margin-bottom: 10px; font-size: 28px">{{activityModel.addrProvince}}{{activityModel.addrCity}}{{activityModel.addrDistrict}}{{activityModel.addrAddress}}</p></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/module/building/building-detail.html','<div class="limit-container" style="margin-top: 85px"><div class="limit-center-content" style="padding: 60px"><div style="padding-bottom: 20px; border-bottom: 1px solid #C9C9C9" class="clearfix"><div class="building-detail-header building-detail-hoverable" ui-sref="home"><span>\u9996\u9875</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{buildingModel.cityName}}</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{buildingModel.regionName}}</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{buildingModel.name}}</span></div></div><div style="padding: 54px 38px; color: #292929"><div class="clearfix building-header-container"><p class="bold-font pull-left building-header-left">{{buildingModel.name}}</p><p class="pull-right building-header-right"><span uib-tooltip="{{buildingModel.address.length>37?buildingModel.address:null}}" tooltip-class="member-center-tooltip" tooltip-placement="bottom">{{buildingModel.address}}</span><br><span uib-tooltip="{{buildingModel.tranfficInfo.length>37?buildingModel.tranfficInfo:null}}" tooltip-class="member-center-tooltip" tooltip-placement="bottom">{{buildingModel.tranfficInfo}}</span></p></div><div style="width: 100%; padding-right: 414px; position: relative"><div><div class="home-swiper" style="margin-bottom: 80px"><ul class="swiper-container home-swiper-container"><li class="swiper_animation" ng-repeat="image in buildingModel.previewImages.images track by image.id" ng-style="swiper_animation"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li></ul><ul class="swiper-button-container home-swiper-button"><li ng-click="tapSwiperBtn($index)" ng-class="{\'swiper-active\':swiper_countor==$index}" ng-repeat="image in buildingModel.previewImages.images track by $index"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li></ul><div class="iconfont icon-ai-arrow-left-copy home-swiper-pre" ng-if="swiper_countor!=0" ng-click="previousImageAction()"></div><div class="iconfont icon-ai-arrow-right-copy home-swiper-next" ng-if="swiper_countor!=buildingModel.previewImages.images.length-1" ng-click="nextImageAction()"></div><a class="home-swiper-absolute" ng-if="buildingModel.arEnabled" ng-href="{{buildingModel.arSiteUrl}}" target="_blank">\u5168\u666F</a></div><p class="building-detail-title bold-font">\u623F\u95F4\u5206\u5E03\u56FE</p><p style="font-size: 16px; line-height: 30px; margin-bottom: 20px">{{buildingModel.roomIntroduction}}</p><div class="home-swiper" style="margin-bottom: 80px"><ul class="swiper-container home-swiper-container"><li class="swiper_animation" ng-repeat="image in buildingModel.roomImages.images track by image.id" ng-style="rooms_animation"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li><div class="iconfont icon-ai-arrow-left-copy home-swiper-pre" ng-if="rooms_countor!=0" ng-click="previousRoomImageAction()"></div><div class="iconfont icon-ai-arrow-right-copy home-swiper-next" ng-if="rooms_countor!=buildingModel.roomImages.images.length-1" ng-click="nextRoomImageAction()"></div></ul></div><p class="building-detail-title bold-font">\u623F\u95F4\u4FE1\u606F</p><div class="building-detail-filter"><p class="bold-font">\u7B5B\u9009\u5185\u5BB9</p><div class="building-detail-container"><button class="abutton bold-font" ng-class="{\'active\':selectedFloor}" uib-popover-template="\'building-detail/floor.html\'" ng-click="tempFloor=selectedFloor" popover-trigger="outsideClick" popover-is-open="floorSelStatus" popover-placement="bottom">{{selectedFloor?(selectedFloor+\'\u697C\'):"\u697C\u5C42"}}</button> <button class="abutton bold-font iconfont icon-close cbutton" ng-if="selectedFloor" ng-click="tonull(\'selectedFloor\')"></button></div><div class="building-detail-container"><button class="abutton bold-font" ng-class="{\'active\':holdQuantity}" uib-popover-template="\'building-detail/hold-quantity.html\'" ng-click="tempQuantity=holdQuantity" popover-trigger="outsideClick" popover-is-open="holdQuantityStatus" popover-placement="bottom">{{holdQuantity?(holdQuantity+\'\u4EBA\'):\'\u4EBA\u6570\'}}</button> <button class="abutton bold-font iconfont icon-close cbutton" ng-if="holdQuantity" ng-click="tonull(\'holdQuantity\')"></button></div><div class="building-detail-container"><button class="abutton bold-font" ng-class="{\'active\':typeIndex!=-1}" uib-popover-template="\'building-detail/type.html\'" ng-click="typeRegionIndex=typeIndex" popover-trigger="outsideClick" popover-is-open="typeSelStatus" popover-placement="bottom">{{typeIndex==-1?"\u7A7A\u95F4\u7C7B\u578B":typeNameList[typeIndex]}}</button> <button class="abutton bold-font iconfont icon-close cbutton" ng-if="typeIndex!=-1" ng-click="to_1(\'typeIndex\')"></button></div><div class="building-detail-container"><button class="abutton bold-font" ng-class="{\'active\':priceIndex!=-1}" uib-popover-template="\'building-detail/price.html\'" ng-click="priceRegionIndex=priceIndex" popover-trigger="outsideClick" popover-is-open="priceSelStatus" popover-placement="bottom">{{getRadioContent(priceIndex)}}</button> <button class="abutton bold-font iconfont icon-close cbutton" ng-if="priceIndex!=-1" ng-click="to_1(\'priceIndex\')"></button></div><div class="building-detail-container"><button class="abutton bold-font" ng-class="{\'active\':statusIndex!=-1}" uib-popover-template="\'building-detail/status.html\'" ng-click="statusRegionIndex=statusIndex" popover-trigger="outsideClick" popover-is-open="statusSelStatus" popover-placement="bottom">{{statusIndex==-1?"\u79DF\u7528\u72B6\u6001":statusNameList[statusIndex]}}</button> <button class="abutton bold-font iconfont icon-close cbutton" ng-if="statusIndex!=-1" ng-click="to_1(\'statusIndex\')"></button></div></div><div style="position: relative"><div class="clearfix building-detail-room-item" ng-repeat="room in roomList | sub:extendArea?10:3 track by $index"><div class="room-item-container" ui-sref="roomDetail({id: room.id})"><img lazy-src="{{room.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""> <span ng-class="{\'notRent-span\':room.state!==\'RENTED\'}">{{statusNameList[statusValueList.indexOf(room.state)]}}</span></div><div class="room-item-introduce"><p class="bold-font" style="font-size: 18px">{{room.title}}</p><p style="font-size: 16px">\u9762\u79EF\uFF1A{{room.areaSize}}m<sup>2</sup>\u53EF\u5BB9\u7EB3{{room.capacity||0}}\u4EBA</p><p style="font-size: 16px">\u671D\u5411\uFF1A{{room.orientation}}</p></div><div class="room-item-price"><p class="bold-font" style="font-size: 16px">\uFFE5{{room.price.toPrice()}}/{{room.priceUnit}}</p><!--<p style="font-size: 16px">\u6BCF\u5C0F\u65F6\u8D77</p>--> <button class="btn btn-primary normal-btn" ng-disabled="room.state==\'RENTED\'" style="padding: 10px 50px" ng-click="appointmentAction(room.name)">\u9884\u7EA6</button></div></div><div class="text-center" style="padding: 30px" ng-if="roomList.length==0"><p class="building-detail-title" style="color: #58585B; font-size: 24px">\u6682\u65E0\u623F\u95F4\u4FE1\u606F</p></div><div class="text-center" ng-show="extendArea && pageparams.count>10"><page page-cp="pageparams.page" page-ps="pageparams.size" page-count="pageparams.count" page-change="pageChangeAction()"></page></div><div class="text-center" style="padding-top: 20px" ng-if="pageparams.count>3"><button class="extend-button" ng-click="$parent.extendArea=!$parent.extendArea">{{$parent.extendArea?"\u6536\u8D77":"\u5C55\u5F00\u66F4\u591A"}}</button></div><div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255,255,255,.79)" ng-if="holdQuantityStatus || priceSelStatus || typeSelStatus || statusSelStatus || floorSelStatus"></div></div><p class="building-detail-title bold-font">\u914D\u5957\u8BBE\u65BD</p><div class="map-button-container clearfix" style="margin: -32px 0"><div class="map-button-item" ng-repeat="facility in buildingModel.facilities track by $index" style="margin: 30px 100px 30px 0" uib-tooltip-html="facility.description" tooltip-placement="bottom-left" tooltip-class="facility-tooltip"><div class="map-button-image"><img lazy-src="{{facility.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><br><p>{{facility.name}}</p></div></div><!--<div style="margin-right: -30px" class="clearfix">--><!--<div class="building-detail-facility" ng-repeat="facility in buildingModel.facilities track by facility.id">--><!--<p class="bold-font facility-name">{{facility.name}}</p>--><!--<p>{{facility.description}}</p>--><!--</div>--><!--</div>--><p class="building-detail-title bold-font">\u697C\u5B87\u5468\u8FB9</p><p style="font-size: 18px; line-height: 30px">{{buildingModel.address}}<br>{{buildingModel.tranfficInfo}}</p><p style="font-size: 18px; margin-bottom: 20px; margin-top: 20px" class="bold-font">\u663E\u793A\u9644\u8FD1\u7684\u8BBE\u65BD</p><div class="map-button-container clearfix"><div class="map-button-item" ng-click="nearbySearch([\'\u5730\u94C1\',\'\u516C\u4EA4\u7AD9\'])"><div class="map-button-image"><img src="content/images/map_traffic.png" alt=""></div><br><p>\u4EA4\u901A</p></div><div class="map-button-item" ng-click="nearbySearch([\'\u9910\u996E\',\'\u8D2D\u7269\'])"><div class="map-button-image"><img src="content/images/map_resterant.png" alt=""></div><br><p>\u9910\u996E\u8D2D\u7269</p></div><div class="map-button-item" ng-click="nearbySearch(\'\u6559\u80B2\u673A\u6784\')"><div class="map-button-image"><img src="content/images/map_education.png" alt=""></div><br><p>\u6559\u80B2\u673A\u6784</p></div><div class="map-button-item" ng-click="nearbySearch(\'\u533B\u7597\')"><div class="map-button-image"><img src="content/images/map_hospital.png" alt=""></div><br><p>\u533B\u7597\u8BBE\u65BD</p></div></div><div style="width: 100%; height: 484px" id="baiduMap"></div></div><div class="agency-container"><div class="agency-content" ng-style="{top: agencyContentTop+\'px\'}"><img lazy-src="{{buildingModel.managerHeadImage}}" animate-visible="true" animate-speed="0.5s" alt=""><div class="agency-title-name"><h1 class="bold-font">{{buildingModel.managerName}}</h1><p>\u4E13\u5C5E\u987E\u95EE</p></div><div style="clear: both"></div><div class="agency-content-text"><p>\u8054\u7CFB\u65B9\u5F0F\uFF1A{{buildingModel.managerPhone}}</p><p>\u54A8\u8BE2\u65F6\u95F4\uFF1A08:00 - 21:00</p><p style="margin: 15px 0; text-indent: 1em; overflow: hidden" ng-style="{\'max-height\': managerExtend?\'\':\'42px\'}">{{buildingModel.recommands && buildingModel.recommands.length>35 && !managerExtend ? (buildingModel.recommands.substring(0, 30)+"......"):buildingModel.recommands}}</p><div style="text-align: right; margin-bottom: 30px" ng-if="buildingModel.recommands && buildingModel.recommands.length>35"><a class="bold-font" style="font-size: 20px" ng-click="extendManagerAction()">{{managerExtend?\'\u6536\u8D77\u5C55\u5F00\':\'\u5C55\u5F00\u5168\u90E8\'}}</a></div><div style="text-align: center"><button class="btn btn-primary normal-btn bold-button" style="padding: 10px 50px" ng-click="appointmentAction()">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div></div></div></div></div></div></div></div><script type="text/ng-template" id="building-detail/hold-quantity.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 350px">\n        <div class="clearfix" style="white-space: nowrap;">\n            <p class="pull-left" style="line-height: 35px; margin-right: 0">\u4EBA\u6570</p>\n            <div style="height: 35px; margin-left: 80px; position: relative; border-radius: 5px; border: 1px solid #C9C9C9" class="pull-right">\n                <input type="text" style="height: 100%; width: 214px; padding: 5px 45px; border: none; box-shadow: none;text-align: center" ng-model="$parent.tempQuantity" ng-pattern="\'^[0-9]*$\'" name="tempQuantity">\n                <button style="width: 35px; height: 34px; border: none; background-color: #C9C9C9; border-right: 1px solid #C9C9C9; position: absolute; left: 0; top: 0" ng-click="changeQuantity(false)">-</button>\n                <button style="width: 35px; height: 34px; border: none; background-color: #C9C9C9; border-left: 1px solid #C9C9C9; position: absolute; right: 0; top: 0" ng-click="changeQuantity(true)">+</button>\n                <p ng-if="editForm.tempQuantity.$error.pattern && tempQuantity!==0" style="font-size: 12px; position: absolute; left: 0; bottom: -30px; color: red">\u8BF7\u586B\u5199\u4E0D\u4E3A0\u7684\u6B63\u6574\u6570</p>\n            </div>\n        </div>\n        <div class="clearfix" style="margin-top: 60px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(0)">\u53D6\u6D88</a>\n            <button class="button-as-a pull-right" ng-click="issuePopover(0)" ng-disabled="editForm.tempQuantity.$error.pattern">\u786E\u5B9A</button>\n        </div>\n    </form></script><script type="text/ng-template" id="building-detail/floor.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 420px">\n        <div class="clearfix" style="white-space: nowrap;">\n            <button class="button-as-a" style="float: left; color: #58585B; padding: 0" ng-style="{color:tempFloor?\'#58585B\':\'#D7A179\'}" ng-click="tonull(\'tempFloor\')">\u4E0D\u9650</button>\n            <div style="float: left;">\n                <table class="region-sel-table">\n                    <tbody>\n                    <tr ng-repeat="group in floorList track by $index" ng-init="a=$index">\n                        <td ng-repeat="floor in group track by $index"\n                            ng-init="b=$index"\n                            ng-click="selectFloor(a,b)"\n                            ng-class="{\'active\':tempFloor&&tempFloor==floor}">{{floor}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(1)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(1)">\u786E\u5B9A</a>\n        </div>\n    </form></script><script type="text/ng-template" id="building-detail/price.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 150px">\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(0)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==0,\'icon-radio-normal\':priceRegionIndex!=0}"></span>\n                <span style=\'color: #58585B\'> 1000-2000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(1)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==1,\'icon-radio-normal\':priceRegionIndex!=1}"></span>\n                <span style=\'color: #58585B\'> 2000-4000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(2)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==2,\'icon-radio-normal\':priceRegionIndex!=2}"></span>\n                <span style=\'color: #58585B\'> > 4000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(2)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(2)">\u786E\u5B9A</a>\n        </div>\n    </form></script><script type="text/ng-template" id="building-detail/type.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 150px">\n        <div style="padding-bottom: 5px" ng-repeat="type in typeNameList track by $index">\n            <span ng-click=\'radioTypeClick($index)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':typeRegionIndex==$index,\'icon-radio-normal\':typeRegionIndex!=$index}"></span>\n                <span style=\'color: #58585B\'> {{type}}</span>\n            </span>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(3)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(3)">\u786E\u5B9A</a>\n        </div>\n    </form></script><script type="text/ng-template" id="building-detail/status.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 150px">\n        <div style="padding-bottom: 5px" ng-repeat="status in statusNameList track by $index">\n            <span ng-click=\'radioStatusClick($index)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':statusRegionIndex==$index,\'icon-radio-normal\':statusRegionIndex!=$index}"></span>\n                <span style=\'color: #58585B\'> {{status}}</span>\n            </span>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(4)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(4)">\u786E\u5B9A</a>\n        </div>\n    </form></script>');
$templateCache.put('app/module/building/building.html','<div><div class="limit-container" style="background-color: #F7F7F7; padding-top: 85px; overflow: visible"><div class="limit-center-content" style="padding: 60px 60px 20px 60px"><div class="clearfix" style="padding-bottom: 30px; border-bottom: 1px solid #C9C9C9"><div class="pull-left search-input-container"><input type="text" ng-model="keyword" ng-keyup="keyupAction($event)"> <span class="iconfont icon-Magnifier" ng-click="searchAction()"></span></div><div class="pull-right segment-container"><button style="margin-right: -4px" ng-class="{\'segment-active\':roomType==\'OFFICE\'}" ng-click="selRoomType(\'OFFICE\')">\u529E\u516C\u5BA4</button> <span></span> <button style="margin-right: -4px; margin-left: -4px" ng-class="{\'segment-active\':roomType==\'CONFERENCE\'}" ng-click="selRoomType(\'CONFERENCE\')">\u4F1A\u8BAE\u5BA4</button> <span></span> <button style="margin-left: -4px" ng-class="{\'segment-active\':roomType==\'SHOW\'}" ng-click="selRoomType(\'SHOW\')">\u8DEF\u6F14\u5BA4</button></div></div><div style="margin-top: 30px" class="clearfix"><div style="height: 36px; line-height: 36px; float: left; margin-right: 30px;color: #292929; font-size: 16px; font-weight: 700">\u7B5B\u9009\u6761\u4EF6</div><div style="float: left" class="clearfix"><div style="float: left; margin-right: 15px; position: relative"><button class="building-condition" ng-class="{\'building-condition-sel\':holdQuantity}" uib-popover-template="\'building/hold-quantity.html\'" ng-click="tempQuantity=holdQuantity||5" popover-trigger="outsideClick" popover-is-open="holdQuantityStatus" popover-placement="bottom">{{holdQuantity?(holdQuantity+\'\u4EBA\'):\'\u5BB9\u7EB3\u4EBA\u6570\'}}</button> <button class="building-condition-b iconfont icon-close" ng-class="{\'building-condition-b-sel\':holdQuantity}" ng-click="holdQuantity=null;initByRoom()"></button></div><div style="float: left; margin-right: 15px; position: relative"><button class="building-condition" ng-class="{\'building-condition-sel\':selectedRegion}" uib-popover-template="\'building/region.html\'" ng-click="tempRegion=selectedRegion" popover-trigger="outsideClick" popover-is-open="regionSelStatus" popover-placement="bottom">{{selectedRegion?selectedRegion.name:\'\u5546\u4E1A\u533A\u5757\'}}</button> <button class="building-condition-b iconfont icon-close" ng-class="{\'building-condition-b-sel\':selectedRegion}" ng-click="selectedRegion=null;initByRoom()"></button></div><div style="float: left; margin-right: 15px; position: relative"><button class="building-condition" ng-class="{\'building-condition-sel\':priceIndex!=-1}" style="width: auto; min-width: 130px" uib-popover-template="\'building/price.html\'" ng-click="priceRegionIndex=priceIndex" popover-trigger="outsideClick" popover-is-open="priceSelStatus" popover-placement="bottom">{{getRadioContent(priceIndex)}}</button> <button class="building-condition-b iconfont icon-close" ng-class="{\'building-condition-b-sel\':priceIndex!=-1}" ng-click="priceIndex=-1;initByRoom()"></button></div></div></div></div></div><div class="limit-container" style="position: relative"><div class="limit-center-content" style="padding: 54px 80px 54px 80px"><p style="font-size: 36px; font-weight: 700; color: #58585B; margin-bottom: 40px">\u4E3A\u4F60\u627E\u5230\u4EE5\u4E0B\u623F\u6E90</p><div class="building-sort-container"><a style="margin-right: 30px" ng-class="{\'active\':!priceSort}" ng-click="changeSort(false)">\u9ED8\u8BA4\u6392\u5E8F</a> <a ng-class="{\'active\':priceSort}" ng-click="changeSort(true)">\u4EF7\u683C\u6392\u5E8F</a></div><div style="margin: -25px"><div class="building-listitem-container" ng-repeat="building in buildingList | sub:(extendMore?null:4) track by $index"><div class="building-listitem-image-container"><img lazy-src="{{building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="building-listitem-text-container" style="height: 428px"><p style="color: #58585B; font-size: 30px" class="bold-font">{{building.name}} <a class="pull-right" ui-sref="buildingDetail({id: building.id})" style="font-size: 20px">\u4E86\u89E3\u66F4\u591A ></a></p><p style="margin-bottom: 0; overflow: hidden; white-space: nowrap">{{building.addrProvince}}{{building.addrCity}}{{building.addrDistrict}}{{building.addrAddress}}</p><p style="margin-bottom: 15px; overflow: hidden; max-height: 52px">{{building.tranfficInfo}}</p><p class="bold-font">\u914D\u5957\u8BBE\u65BD</p><div class="clearfix building-listitem-facilities"><div class="building-listitem-facility" ng-repeat="facility in building.facilities track by facility.id"><div class="building-listitem-facility-image"><img lazy-src="{{facility.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><p>{{facility.name}}</p></div></div><p style="margin-top: 20px" class="bold-font">\u4EF7\u683C</p><div class="clearfix" ng-repeat="room in building.recommandRooms track by room.id"><p class="bold-font pull-left">{{room.title}}</p><p class="bold-font pull-right">\uFFE5{{room.price.toPrice()}}/{{room.priceUnit}}</p></div></div></div></div><div style="clear: both"></div><div class="text-center" style="padding: 30px" ng-show="extendMore && pageparams.count>10"><page page-cp="pageparams.page" page-ps="pageparams.size" page-count="pageparams.count" page-change="pageChangeAction()"></page></div><div class="text-center" style="padding-top: 30px" ng-if="buildingList.length > 4"><button class="btn btn-default bold-button" style="width: 200px" ng-click="$parent.extendMore=!$parent.extendMore">{{$parent.extendMore?\'\u6536\u8D77\':\'\u5C55\u5F00\u66F4\u591A\'}}</button></div></div><div class="popover-mask" ng-if="holdQuantityStatus||regionSelStatus||priceSelStatus"></div></div></div><script type="text/ng-template" id="building/hold-quantity.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 350px">\n        <div class="clearfix" style="white-space: nowrap;">\n            <p class="pull-left" style="line-height: 35px">\u4EBA\u6570</p>\n            <div class="pull-right ability-container">\n                <input type="text" ng-model="$parent.tempQuantity" ng-pattern="\'^[0-9]*$\'" name="holdQuantity">\n                <button ng-click="changeQuantity(false)">-</button>\n                <button ng-click="changeQuantity(true)" class="ability-right">+</button>\n                <p ng-if="editForm.holdQuantity.$error.pattern && tempQuantity!==0" class="ability-error">\u8BF7\u586B\u5199\u4E0D\u4E3A0\u7684\u6B63\u6574\u6570</p>\n            </div>\n        </div>\n        <div class="clearfix" style="margin-top: 60px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(0)">\u53D6\u6D88</a>\n            <button class="button-as-a pull-right" ng-click="issuePopover(0)" ng-disabled="editForm.holdQuantity.$error.pattern">\u786E\u5B9A</button>\n        </div>\n    </form></script><script type="text/ng-template" id="building/region.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 420px">\n        <div class="clearfix" style="white-space: nowrap;">\n            <a style="float: left; color: #58585B" ng-style="{color:tempRegion?\'#58585B\':\'#D7A179\'}" ng-click="clearTempRegion()">\u4E0D\u9650</a>\n            <div style="float: left;">\n                <table class="region-sel-table">\n                    <tbody>\n                        <tr ng-repeat="group in regionList track by $index" ng-init="a=$index">\n                            <td ng-repeat="region in group track by $index"\n                                ng-init="b=$index"\n                                ng-click="selectRegion(a,b)"\n                                ng-class="{\'active\':tempRegion&&tempRegion.id==region.id}">{{region.name}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(1)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(1)">\u786E\u5B9A</a>\n        </div>\n    </form></script><script type="text/ng-template" id="building/price.html"><form class="form-horizontal" name="editForm" role="form" novalidate show-validation style="padding: 5px; width: 150px">\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(0)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==0,\'icon-radio-normal\':priceRegionIndex!=0}"></span>\n                <span style=\'color: #58585B\'> 1000-2000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(1)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==1,\'icon-radio-normal\':priceRegionIndex!=1}"></span>\n                <span style=\'color: #58585B\'> 2000-4000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div style="padding-bottom: 5px">\n            <span ng-click=\'radioClick(2)\' class=\'radio-container\'>\n                <span class=\'iconfont radio-style\' ng-class="{\'icon-radio-active\':priceRegionIndex==2,\'icon-radio-normal\':priceRegionIndex!=2}"></span>\n                <span style=\'color: #58585B\'> > 4000\uFFE5/\u6708</span>\n            </span>\n        </div>\n        <div class="clearfix" style="margin-top: 10px">\n            <a class="pull-left" style="color: #9B9B9B" ng-click="cancelPopover(2)">\u53D6\u6D88</a>\n            <a class="pull-right" ng-click="issuePopover(2)">\u786E\u5B9A</a>\n        </div>\n    </form></script>');
$templateCache.put('app/module/appointment/appointment.html','<div class="modal-body"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="dismissModalAction()">--><!--<i class="iconfont icon-close"></i>--><!--</button>--><h4 class="modal-title" ng-if="!userModel">\u4F60\u597D\uFF0C\u586B\u5199\u5B8C\u4FE1\u606F\u540E\u6211\u4EEC\u7684\u987E\u95EE\u5C06\u4F1A\u7B2C\u4E00\u65F6\u95F4\u548C\u4F60\u8054\u7CFB</h4><h4 class="modal-title" ng-if="userModel">{{userModel.fullname}}\u4F60\u597D\uFF0C\u586B\u5199\u5B8C\u4FE1\u606F\u540E\u6211\u4EEC\u7684\u987E\u95EE\u5C06\u4F1A\u7B2C\u4E00\u65F6\u95F4\u548C\u4F60\u8054\u7CFB</h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="saveAction()" show-validation><div><div class="vp-full-input-group" ng-if="isAgent"><input class="vp-full-input" type="text" placeholder="\u516C\u53F8\u540D\u79F0" ng-model="appointmentModel.companyName" required><!--<p class="vp-input-error">\u59D3\u540D\u91CD\u590D</p>--></div><div class="vp-full-input-group" ng-if="!userModel"><input class="vp-full-input" type="text" placeholder="\u59D3\u540D" ng-model="appointmentModel.fullname" required><!--<p class="vp-input-error">\u59D3\u540D\u91CD\u590D</p>--></div><div class="vp-full-input-group" ng-if="!userModel"><input class="vp-full-input" type="text" placeholder="\u624B\u673A\u53F7" name="phone" ng-model="appointmentModel.phone" required ng-pattern="/^1[3456789]\\d{9}$/" ng-change="phoneChangeAction()"><p class="vp-input-error" ng-if="editForm.phone.$error.pattern">\u624B\u673A\u53F7\u683C\u5F0F\u4E0D\u6B63\u786E</p></div><div class="vp-full-input-group clearfix" ng-if="!userModel"><input class="vp-full-input" type="text" placeholder="\u77ED\u4FE1\u9A8C\u8BC1\u7801" style="width: calc(100% - 210px); float: left" ng-model="appointmentModel.phoneCode" required> <button type="button" class="btn btn-primary reverse-btn absolute-btn" style="width: 200px; float: right" ng-click="getVerification()" ng-disabled="editForm.phone.$error.pattern || !appointmentModel.phone || !canVerify">{{counter===0?"\u83B7\u53D6\u9A8C\u8BC1\u7801":(counter+"s\u540E\u91CD\u8BD5")}}</button></div><!--<div class="vp-full-input-group" ng-if="userModel">--><!--<p style="font-size: 18px; font-weight: 700; color: #292929">\u59D3\u540D\uFF1A{{appointmentModel.fullname}}</p>--><!--</div>--><!--<div class="vp-full-input-group" ng-if="userModel">--><!--<p style="font-size: 18px; font-weight: 700; color: #292929">\u624B\u673A\uFF1A{{appointmentModel.phone}}</p>--><!--</div>--><div class="vp-full-input-group"><textarea class="vp-full-textarea" ng-model="appointmentModel.requirements" placeholder="\u7ED9\u6211\u4EEC\u7559\u8A00" maxlength="500"></textarea></div><p style="font-size: 18px; font-weight: 700; color: #292929">\u65B9\u4FBF\u63A5\u542C\u7535\u8BDD\u7684\u65F6\u95F4</p><div class="vp-full-input-group clearfix" style="position: relative" id="date-range-picker-parent"><input class="vp-full-input" type="text" placeholder="\u8D77\u6B62\u65E5\u671F" style="width: calc(50% - 10px); float: left" ng-model="datePicker.date" date-range-picker options="dateRangeOptions" min="nowString" data-toggle="dropdown" readonly="readonly" required> <input class="vp-full-input" type="text" placeholder="\u8D77\u6B62\u65F6\u95F4" ng-click="timeSelectAction()" style="width: 50%; float: right" ng-model="datePicker.time" data-toggle="dropdown" btn-group readonly="readonly" required> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="right: calc(50% + 11px)"><span class="iconfont icon-sanjiaoxing"></span></button> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu vp-input-dropdown"><li class="vp-input-dropdown-container"><ul class="vp-input-dropdown-item"><li ng-repeat="item in startHours track by $index" ng-click="startHSel($index)" ng-class="{\'active\': timeSelector.startH==item}">{{item}}</li></ul></li><li class="vp-input-dropdown-container"><ul class="vp-input-dropdown-item"><li ng-repeat="item in startMinutes track by $index" ng-click="startMSel($index)" ng-class="{\'active\': timeSelector.startM==item}">{{item}}</li></ul></li><li class="vp-input-dropdown-container"><ul class="vp-input-dropdown-item"><li ng-repeat="item in endHours track by $index" ng-click="endHSel($index)" ng-class="{\'active\': timeSelector.endH==item}">{{item}}</li></ul></li><li class="vp-input-dropdown-container"><ul class="vp-input-dropdown-item"><li ng-repeat="item in endMinutes track by $index" ng-click="endMSel($index)" ng-class="{\'active\': timeSelector.endM==item}">{{item}}</li></ul></li><li style="clear: both"></li><li class="vp-input-dropdown-footer"><p class="pull-left vp-input-dropdown-error" ng-if="timeSelectorError">\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u65F6\u95F4\u533A\u57DF</p><p class="pull-right vp-input-dropdown-all" ng-click="allTimeSel()">\u786E\u5B9A</p></li></ul></div><div class="text-center" ng-if="!userModel && !isAgent"><vp-checkbox vp-model="$parent.agreementNegotiate"></vp-checkbox><span style="font-size: 20px; color: #292929" class="bold-font">\u52A0\u5165\u4F1A\u5458\uFF0C\u5DF2\u9605\u8BFB\u5E76\u540C\u610F<a ng-click="jumpNegotiation()">\u300A\u7528\u6237\u534F\u8BAE\u300B</a></span><p style="font-size: 12px; color: red" ng-if="!editForm.phone.$error.pattern && phoneExists && agreementNegotiate">\u5DF2\u6CE8\u518C\u4F1A\u5458\uFF0C\u518D\u6B21\u6CE8\u518C\u65E0\u6548\uFF01</p></div><div ng-if="agreementNegotiate && !userModel && !isAgent" style="margin-top: 20px"><div class="vp-float-input-group" style="width: calc(50% - 5px); margin-right: 10px"><input class="vp-float-input" name="password" type="text" placeholder="\u8F93\u51658-20\u4F4D\u767B\u5F55\u5BC6\u7801" ng-model="appointmentModel.passwordHash" ng-minlength="8" ng-maxlength="20" required autocomplete="off"><p class="vp-input-error" ng-if="editForm.password.$error.minlength||editForm.password.$error.maxlength">\u8BF7\u8F93\u51658-20\u4F4D\u767B\u5F55\u5BC6\u7801</p></div><div class="vp-float-input-group" style="width: calc(50% - 5px); margin-right: 0"><input class="vp-float-input" name="confirm" type="text" placeholder="\u786E\u8BA4\u5BC6\u7801" ng-model="appointmentModel.confirm" required autocomplete="off"><p class="vp-input-error" ng-if="appointmentModel.confirm&&appointmentModel.passwordHash&&(appointmentModel.confirm!=appointmentModel.passwordHash)">\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E00\u81F4</p></div></div></div><div class="modal-footer"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()" style="margin-right: 20px">\u5173\u95ED</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-disabled="editForm.$invalid || (appointmentModel.confirm&&appointmentModel.passwordHash&&(appointmentModel.confirm!=appointmentModel.passwordHash))" ng-if="agreementNegotiate">\u63D0\u4EA4</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-disabled="editForm.$invalid" ng-if="!agreementNegotiate">\u63D0\u4EA4</button></div></div></form></div>');
$templateCache.put('app/module/city-selector/city-selector.html','<div class="modal-body"><div class="modal-header"><h4 class="modal-title">\u8BF7\u4ECE\u4E0B\u5217\u57CE\u5E02\u91CC\u9009\u62E9</h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="saveAction()" show-validation><div class="clearfix" style="margin-bottom: 30px"><p ng-repeat="city in cityList track by $index" class="city-selector-item" ng-click="selCity(city)" ng-class="{\'actived\':locationId==city.id}">{{city.name}}</p></div><p class="city-selector-desc">\u6211\u4EEC\u4F1A\u5728\u672A\u6765\u52A0\u5165\u66F4\u591A\u7684\u57CE\u5E02\u4F19\u4F34\uFF0C\u656C\u8BF7\u671F\u5F85\u3002</p><div class="modal-footer" style="padding-top: 0"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()">\u5173\u95ED</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn">\u66F4\u6539</button></div></div></form></div>');
$templateCache.put('app/module/home/home.html','<div style="background-color: white"><div class="homepage-header"><div uib-carousel active="active" interval="myInterval" no-wrap="noWrapSlides" style="width: 100%; height: 41vw; overflow: hidden" ng-if="homeModel.type === \'SLIDE\'"><div uib-slide ng-repeat="image in bannerModel.category.images track by $index" index="$index"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" style="width: 100%; height: 41vw; object-fit: cover"></div></div><videogular vg-auto-play="true" ng-if="homeModel.type === \'VIDEO\'"><vg-media vg-src="videoModel.imageUrl" vg-native-controls="true" vg-loop="true"></vg-media></videogular><div class="homepage-search-container"><img src="content/images/triwork_center.png" alt="" class="homepage-search-logo"><div class="homepage-search-input"><span class="iconfont icon-Magnifier" ng-click="searchAction()"></span> <input type="text" placeholder="\u5BFB\u627E\u4E0B\u4E00\u4E2A\u68A6\u60F3\u529E\u516C\u5730\u70B9" ng-keyup="keyupAction($event)" ng-model="keyword"></div></div></div><div class="limit-container"><div class="limit-center-content"><div style="padding: 90px 100px 60px 100px"><p class="homepage-title bold-font">3work\u662F\u4E00\u4E2A\u5168\u65B0\u7684\u5171\u4EAB\u529E\u516C\u5E73\u53F0\u3002\u4E09\u4EBA\u884C\u5FC5\u6709\u6211\u5E08<br>\u6211\u4EEC\u6574\u5408\u8D44\u6E90\uFF0C\u4E92\u5E2E\u4E92\u52A9\uFF0C\u5171\u7B51\u68A6\u60F3\u3002</p><div class="homepage-btn"><button class="btn btn-default bold-button" style="margin-right: 30px" ui-sref="building">\u4E86\u89E3\u66F4\u591A</button> <button class="btn btn-primary normal-btn bold-button" ng-click="appointmentAction()">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div><div class="home-block-container"><p class="home-block-title">\u6211\u4EEC\u7684\u670D\u52A1</p><div class="homepage-service-container"><img src="content/images/home_convenient.png"><h1 class="bold-font">\u62CE\u5305\u5165\u4F4F</h1><p>3work\u65D7\u4E0B\u529E\u516C\u5BA4\u90FD\u5E26\u6709\u5BB6\u5177\uFF0C\u7535\u5668\u8BBE\u65BD\uFF0C\u53EF\u62CE\u5305\u5165\u4F4F\u3002</p></div><div class="homepage-service-container" style="margin-left: 90px"><img src="content/images/home_accounting.png"><h1 class="bold-font">\u53EF\u4EE3\u7406\u8BB0\u8D26</h1><p>\u4E3A\u4E86\u4F7F\u4F60\u7684\u5DE5\u4F5C\u66F4\u52A0\u7B80\u5355\uFF0C\u6211\u4EEC\u53EF\u5E2E\u52A9\u4EE3\u7406\u8BB0\u8D26\u3002</p></div><div class="homepage-service-container" style="margin-left: 90px"><img src="content/images/home_delivery.png"><h1 class="bold-font">\u5BC4\u6536\u5FEB\u9012</h1><p>\u914D\u6709\u4E13\u4E1A\u7BA1\u5BB6\u5BC4\u6536\u5FEB\u9012\u670D\u52A1\uFF0C\u4ECE\u4E0D\u62C5\u5FC3\u5FEB\u9012\u9057\u5931\u3002</p></div><div style="clear: both"></div></div><div class="home-block-container" ng-if="homeModel.advertise"><p class="home-block-title">\u4F18\u60E0\u6D3B\u52A8</p><div style="width: 100%; height: 400px; position: relative; background-color: #F5F5F5; color: white; border-radius: 5px; overflow: hidden"><img lazy-src="{{advertiseModel.category.images[0].imageUrl}}" animate-visible="true" animate-speed="0.5s" alt="" style="object-fit: cover; width: 100%; height: 100%"><div style="height: 150px; font-size: 40px; position: absolute; left: 60px; top: 0; bottom: 0; margin: auto 0; font-weight: 500; line-height: 60px"><p>{{homeModel.mainTitle}}</p><p>{{homeModel.subHead}}</p><a style="position: absolute; font-size: 18px; bottom: -30px; line-height: 1; color: white; white-space: nowrap" ui-sref="promotion">\u4E86\u89E3\u66F4\u591A ></a></div></div></div><div class="home-block-container"><p class="home-block-title">\u7CBE\u9009\u623F\u6E90 <a style="font-size: 20px; float: right" class="bold-font" ui-sref="building">\u4E86\u89E3\u66F4\u591A\u623F\u6E90 ></a></p><div class="building-container"><div class="building-right"><p style="font-size: 40px; margin: 0 0 10px 0" class="bold-font">{{buildingModel.building.name}}</p><p style="color: #58585B; margin: 0 0 5px 0">{{buildingModel.building.addrProvince}} {{buildingModel.building.addrCity}} {{buildingModel.building.addrDistrict}} {{buildingModel.building.addrAddress}}</p><p style="color: #58585B; margin: 0 0 20px 0; line-height: 24px">{{buildingModel.building.tranfficInfo}}</p><p style="color: #58585B; margin: 0 0 3px 0; height: 96px; white-space: normal; line-height: 24px">{{buildingModel.building.recommands}}</p><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>0">\u6700\u65B0\u4EF7\u683C</p><div class="clearfix" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>0"><p style="float: left" class="bold-font">{{buildingModel.building.recommandRooms[0].title}}</p><p style="float: right">\uFFE5{{buildingModel.building.recommandRooms[0].price.toPrice()}}/{{buildingModel.building.recommandRooms[0].priceUnit}}</p></div><div style="margin-bottom: 30px" class="clearfix" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>1"><p style="float: left" class="bold-font">{{buildingModel.building.recommandRooms[1].title}}</p><p style="float: right">\uFFE5{{buildingModel.building.recommandRooms[1].price.toPrice()}}/{{buildingModel.building.recommandRooms[1].priceUnit}}</p></div><a style="font-size: 20px; font-weight: 500; float: right" ui-sref="buildingDetail({id:buildingModel.building.id})">\u4E86\u89E3\u66F4\u591A ></a></div><div class="building-left"><img lazy-src="{{buildingModel.building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div></div><div class="building-container" style="margin-top: 20px" ng-if="buildingList.length == 1"><div class="building-right"><p style="font-size: 40px; margin: 0 0 10px 0" class="bold-font">{{buildingList[0].building.name}}</p><p style="color: #58585B; margin: 0 0 5px 0">{{buildingList[0].building.addrProvince}} {{buildingList[0].building.addrCity}} {{buildingList[0].building.addrDistrict}} {{buildingList[0].building.addrAddress}}</p><p style="color: #58585B; margin: 0 0 20px 0; line-height: 24px">{{buildingList[0].building.tranfficInfo}}</p><p style="color: #58585B; margin: 0 0 3px 0; height: 96px; white-space: normal; line-height: 24px">{{buildingList[0].building.recommands}}</p><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>0">\u6700\u65B0\u4EF7\u683C</p><div class="clearfix" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>0"><p style="float: left" class="bold-font">{{buildingList[0].building.recommandRooms[0].title}}</p><p style="float: right">\uFFE5{{buildingList[0].building.recommandRooms[0].price.toPrice()}}/{{buildingList[0].building.recommandRooms[0].priceUnit}}</p></div><div style="margin-bottom: 30px" class="clearfix" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>1"><p style="float: left" class="bold-font">{{buildingList[0].building.recommandRooms[1].title}}</p><p style="float: right">\uFFE5{{buildingList[0].building.recommandRooms[1].price.toPrice()}}/{{buildingList[0].building.recommandRooms[1].priceUnit}}</p></div><a style="font-size: 20px; font-weight: 500; float: right" ui-sref="buildingDetail({id:buildingList[0].building.id})">\u4E86\u89E3\u66F4\u591A ></a></div><div class="building-left"><img lazy-src="{{buildingList[0].building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div></div><div class="activities-container clearfix" ng-if="buildingList.length > 1"><div ng-class="{\'activities-item-2\':buildingList.length==2,\'activities-item-3\':buildingList.length!=2}" ng-repeat="building in buildingList track by $index"><div class="activities-item-image-container" style="height: 392px; overflow: hidden"><img lazy-src="{{building.building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container"><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font">{{building.building.name}}</p><p style="margin: 0 0 3px 0">{{building.building.addrProvince}} {{building.building.addrCity}} {{building.building.addrDistrict}} {{building.building.addrAddress}}</p><p style="margin: 0 0 10px 0">{{building.building.tranfficInfo}}</p><a class="bold-font" ui-sref="buildingDetail({id:building.building.id})">\u4E86\u89E3\u66F4\u591A ></a></div></div></div></div><div class="home-block-container"><p class="home-block-title">\u8FD1\u671F\u6D3B\u52A8 <a style="font-size: 20px; float: right" class="bold-font" ui-sref="activities">\u4E86\u89E3\u66F4\u591A\u8FD1\u671F\u6D3B\u52A8 ></a></p><div class="activities-container clearfix"><div class="activities-item-3" ng-repeat="activity in activityList track by $index" style="cursor: pointer" ui-sref="activity({id: activity.activityId})"><div class="activities-item-image-container" style="height: 229px"><img lazy-src="{{activity.activityPosterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container" style="height: 138px; border: none; background-color: #F5F5F5"><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font">{{activity.activityName}}</p><p style="margin: 0 0 3px 0">\u65F6\u95F4 {{activity.activityStart|date:\'MM\u6708dd\u65E5\'}}-{{activity.activityEnd|date:\'MM\u6708dd\u65E5\'}}</p><p style="margin: 0 0 10px 0">{{translateLevel(activity.authorityLevel)}}</p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/module/login/login.html','<div class="modal-body"><div class="modal-header"><h4 class="modal-title">\u767B\u5F553work\u8D26\u53F7 <span style="float: right;font-size: 18px;color: #9B9B9B; font-weight: 400">\u6CA1\u6709\u8D26\u53F7\uFF1F<a ng-click="requestRegisterAction()">\u6CE8\u518C</a></span></h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="loginAction()" show-validation><div><div class="vp-full-input-group"><input class="vp-full-input" type="text" placeholder="\u624B\u673A\u53F7" ng-model="loginModel.username" required ng-keyup="keyupAction($event)"><!--<p class="vp-input-error">\u624B\u673A\u53F7\u91CD\u590D</p>--></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" placeholder="\u767B\u5F55\u5BC6\u7801" ng-model="loginModel.password" required ng-keyup="keyupAction($event)"><!--<p class="vp-input-error">\u59D3\u540D\u91CD\u590D</p>--></div><div><vp-checkbox vp-model="loginModel.rememberMe"></vp-checkbox><span>\u8BB0\u4F4F\u8D26\u53F7\u5BC6\u7801</span> <span class="forgot-password-btn" ng-click="forgotPassword()">\u5FD8\u8BB0\u5BC6\u7801</span></div></div><div class="modal-footer"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()">\u5173\u95ED</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn">\u767B\u5F55</button></div></div></form></div>');
$templateCache.put('app/module/negotiation/negotiation.html','<!--<div style="background-color: white; padding-top: 90px">--><!--<div class="limit-container">--><!--<div class="limit-center-content">--><!--<p class="negotiation-title">\u7528\u6237\u6CE8\u518C\u534F\u8BAE</p>--><!--<p class="negotiation-content negotiation-indent">\u5728\u6B64\u7279\u522B\u63D0\u9192\u60A8\u5728\u6CE8\u518C\u6210\u4E3A3WORK\u7528\u6237\u4E4B\u524D,\u8BF7\u8BA4\u771F\u9605\u8BFB\u672C\u300A\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B(\u4EE5\u4E0B\u7B80\u79F0\u201C\u534F\u8BAE\u201D),\u786E\u4FDD\u60A8\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u8BF7\u60A8\u5BA1\u614E\u9605\u8BFB\u5E76\u9009\u62E9\u63A5\u53D7\u6216\u4E0D\u63A5\u53D7\u672C\u534F\u8BAE\u3002\u60A8\u540C\u610F\u5E76\u70B9\u51FB\u786E\u8BA4\u672C\u534F\u8BAE\u6761\u6B3E\u4E14\u5B8C\u6210\u6CE8\u518C\u7A0B\u5E8F\u540E,\u624D\u80FD\u6210\u4E3A3WORK\u7684\u6B63\u5F0F\u6CE8\u518C\u7528\u6237,\u5E76\u4EAB\u53D73WORK\u7684\u5404\u7C7B\u670D\u52A1\u3002\u60A8\u7684\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7B49\u884C\u4E3A\u5C06\u89C6\u4E3A\u5BF9\u672C\u534F\u8BAE\u7684\u63A5\u53D7,\u5E76\u540C\u610F\u63A5\u53D7\u672C\u534F\u8BAE\u5404\u9879\u6761\u6B3E\u7684\u7EA6\u675F\u3002\u82E5\u60A8\u4E0D\u540C\u610F\u672C\u534F\u8BAE,\u6216\u5BF9\u672C\u534F\u8BAE\u4E2D\u7684\u6761\u6B3E\u5B58\u5728\u4EFB\u4F55\u7591\u95EE,\u8BF7\u60A8\u7ACB\u5373\u505C\u6B623WORK\u7528\u6237\u6CE8\u518C\u7A0B\u5E8F,\u5E76\u53EF\u4EE5\u9009\u62E9\u4E0D\u4F7F\u75283WORK\u670D\u52A1\u3002\u672C\u534F\u8BAE\u6761\u6B3E\u662F\u4E0A\u6D77\u76DB\u5B97\u7693\u4F01\u4E1A\u7BA1\u7406\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u79F0\u201C3WORK\u201D\u6216\u201C\u6211\u4EEC\u201D\uFF09\u5BF9\u7528\u6237\u76F8\u5173\u653F\u7B56\u7684\u8BB8\u8BFA,\u8BF7\u60A8\u52A1\u5FC5\u4ED4\u7EC6\u9605\u8BFB\u3002</p>--><!--<p class="negotiation-subtitle">1.\t\u7528\u6237\u4FE1\u606F\u91C7\u96C6</p>--><!--<p class="negotiation-content negotiation-indent">\u5F53\u60A8\u5728\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u8FDB\u884C\u7528\u6237\u6CE8\u518C\u767B\u8BB0\uFF0C\u4F7F\u7528\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u670D\u52A1\uFF0C\u4EE5\u53CA\u53C2\u52A0\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u6D3B\u52A8\u65F6\uFF0C\u5373\u4E3A\u60A8\u540C\u610F\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5C06\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4FDD\u5B58\u8BB0\u5F55\u3002\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A\u59D3\u540D\u3001\u6027\u522B\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3001\u624B\u673A\u7535\u8BDD\u3001\u7B49\u3002\u60A8\u4E3B\u52A8\u63D0\u4F9B\u7684\u4FE1\u606F\u8D8A\u591A\u53CA\u8D8A\u51C6\u786E\uFF0C\u6211\u4EEC\u5C31\u80FD\u591F\u66F4\u597D\u5730\u4E3A\u60A8\u63D0\u4F9B\u6709\u5173\u670D\u52A1\u3002</p>--><!--<p class="negotiation-subtitle">2.\t\u7528\u6237\u4FE1\u606F\u7684\u4F7F\u7528</p>--><!--<p class="negotiation-content negotiation-indent">\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u57FA\u672C\u76EE\u7684\u662F\u4E3A\u4E86\u66F4\u597D\u7684\u4E86\u89E3\u6211\u4EEC\u7684\u7528\u6237\uFF0C\u4EE5\u4FBF\u5411\u60A8\u63D0\u4F9B\u7279\u8272\u670D\u52A1\u548C\u4E2A\u6027\u5316\u670D\u52A1\u3002\u4E2A\u4EBA\u4FE1\u606F\u5C06\u4E3B\u8981\u7528\u4E8E\u4EE5\u4E0B\u51E0\u4E2A\u76EE\u7684\uFF1A</p>--><!--<p class="negotiation-content">\uFF081\uFF09\u5B8C\u6210\u60A8\u5BF9\u7279\u5B9A\u670D\u52A1\u6216\u4EA7\u54C1\u7684\u8981\u6C42\u3002</p>--><!--<p class="negotiation-content">\uFF082\uFF09\u5728\u6211\u4EEC\u63D0\u4F9B\u670D\u52A1\u65F6,\u7528\u4E8E\u8EAB\u4EFD\u9A8C\u8BC1\u3001\u5BA2\u6237\u670D\u52A1\u3001\u5B89\u5168\u9632\u8303\u3001\u8BC8\u9A97\u76D1\u6D4B\u3001\u5B58\u6863\u548C\u5907\u4EFD\u7528\u9014,\u786E\u4FDD\u6211\u4EEC\u5411\u60A8\u63D0\u4F9B\u7684\u4EA7\u54C1\u548C\u670D\u52A1\u7684\u5B89\u5168\u6027\u3002</p>--><!--<p class="negotiation-content">\uFF083\uFF09\u5E2E\u52A9\u6211\u4EEC\u8BBE\u8BA1\u65B0\u670D\u52A1,\u6539\u5584\u6211\u4EEC\u73B0\u6709\u670D\u52A1\u3002</p>--><!--<p class="negotiation-content">\uFF084\uFF09\u4F7F\u6211\u4EEC\u66F4\u52A0\u4E86\u89E3\u60A8\u5982\u4F55\u63A5\u5165\u548C\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1,\u4ECE\u800C\u9488\u5BF9\u6027\u5730\u56DE\u5E94\u60A8\u7684\u4E2A\u6027\u5316\u9700\u6C42,\u4F8B\u5982\u8BED\u8A00\u8BBE\u5B9A\u3001\u4F4D\u7F6E\u8BBE\u5B9A\u3001\u4E2A\u6027\u5316\u7684\u5E2E\u52A9\u670D\u52A1\u548C\u6307\u793A,\u6216\u5BF9\u60A8\u548C\u5176\u4ED6\u7528\u6237\u4F5C\u51FA\u5176\u4ED6\u65B9\u9762\u7684\u56DE\u5E94\u3002</p>--><!--<p class="negotiation-content">\uFF085\uFF09\u7528\u4E8E\u5BF9\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7528\u6237\u6570\u636E\u7684\u7EDF\u8BA1\uFF08\u5982\u7528\u6237\u6570\u91CF\u3001\u6784\u6210\u3001\u5174\u8DA3\u3001\u8868\u73B0\u7B49\uFF09\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5411\u7528\u6237\u63D0\u4F9B\u66F4\u597D\u7684\u670D\u52A1\u548C\u4EA7\u54C1\uFF0C\u6216\u5411\u7B2C\u4E09\u65B9\u4E3A\u4E86\u4E00\u5B9A\u7684\u5408\u6CD5\u76EE\u7684\u62AB\u9732\u8BE5\u7C7B\u7EDF\u8BA1\u6570\u636E\u3002\u8BE5\u7C7B\u7EDF\u8BA1\u6570\u636E\u90FD\u662F\u7528\u6237\u7FA4\u6574\u4F53\u7684\u4FE1\u606F\uFF0C\u800C\u975E\u4E2A\u4EBA\u7684\u4FE1\u606F\u3002</p>--><!--<p class="negotiation-content">\uFF086\uFF09\u8BA9\u60A8\u53C2\u4E0E\u6709\u5173\u6211\u4EEC\u4EA7\u54C1\u548C\u670D\u52A1\u7684\u8C03\u67E5\u3002\u4E3A\u4E86\u8BA9\u60A8\u6709\u66F4\u597D\u7684\u4F53\u9A8C\u3001\u6539\u5584\u6211\u4EEC\u7684\u670D\u52A1\u6216\u60A8\u540C\u610F\u7684\u5176\u4ED6\u7528\u9014,\u5728\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u524D\u63D0\u4E0B,\u6211\u4EEC\u53EF\u80FD\u5C06\u901A\u8FC7\u67D0\u4E00\u9879\u670D\u52A1\u6240\u6536\u96C6\u7684\u4FE1\u606F,\u4EE5\u6C47\u96C6\u4FE1\u606F\u6216\u8005\u4E2A\u6027\u5316\u7684\u65B9\u5F0F,\u7528\u4E8E\u6211\u4EEC\u7684\u5176\u4ED6\u670D\u52A1\u3002\u4F8B\u5982,\u5728\u60A8\u4F7F\u7528\u6211\u4EEC\u7684\u4E00\u9879\u670D\u52A1\u65F6\u6240\u6536\u96C6\u7684\u4FE1\u606F,\u53EF\u80FD\u5728\u53E6\u4E00\u670D\u52A1\u4E2D\u7528\u4E8E\u5411\u60A8\u63D0\u4F9B\u7279\u5B9A\u5185\u5BB9,\u6216\u5411\u60A8\u5C55\u793A\u4E0E\u60A8\u76F8\u5173\u7684\u3001\u975E\u666E\u904D\u63A8\u9001\u7684\u4FE1\u606F\u3002\u5982\u679C\u6211\u4EEC\u5728\u76F8\u5173\u670D\u52A1\u4E2D\u63D0\u4F9B\u4E86\u76F8\u5E94\u9009\u9879,\u60A8\u4E5F\u53EF\u4EE5\u6388\u6743\u6211\u4EEC\u5C06\u8BE5\u670D\u52A1\u6240\u63D0\u4F9B\u548C\u50A8\u5B58\u7684\u4FE1\u606F\u7528\u4E8E\u6211\u4EEC\u7684\u5176\u4ED6\u670D\u52A1\u3002</p>--><!--<p class="negotiation-subtitle">3.\t\u7528\u6237\u4FE1\u606F\u7684\u5171\u4EAB\u548C\u62AB\u9732</p>--><!--<p class="negotiation-content negotiation-indent">3WORK\u6240\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5C06\u4EC5\u7528\u4E8E\u4E3A\u60A8\u63D0\u4F9B\u76F8\u5173\u670D\u52A1\u3002\u4E00\u822C\u60C5\u51B5\u4E0B\uFF0C\u5728\u672A\u5F97\u5230\u60A8\u7684\u540C\u610F\u4E4B\u524D\uFF0C\u60A8\u7684\u4EFB\u4F55\u4E2A\u4EBA\u4FE1\u606F\u5C06\u4E0D\u4F1A\u88AB\u63D0\u4F9B\u7ED9\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u3002 \u5728\u4E0B\u5217\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u63D0\u4F9B\u7ED9\u6709\u5173\u7684\u7B2C\u4E09\u65B9\uFF1A (1)\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u67D0\u4E9B\u670D\u52A1\u9700\u7531\u4E00\u4E2A\u5408\u4F5C\u4F19\u4F34(\u5982\u4EE3\u7406\u516C\u53F8\u3001\u63D0\u4F9B\u76F8\u5173\u6280\u672F\u670D\u52A1\u7684\u516C\u53F8\u3001\u8FD0\u8F93\u516C\u53F8\u3001\u90AE\u5BC4\u516C\u53F8\u3001\u63D0\u4F9B\u5956\u54C1\u7684\u516C\u53F8\u7B49)\u63D0\u4F9B\u6216\u5171\u540C\u63D0\u4F9B\u3002\u4E3A\u4E86\u5411\u60A8\u63D0\u4F9B\u6B64\u7C7B\u670D\u52A1\uFF0C\u672C\u7F51\u7AD9\u6709\u5FC5\u8981\u4E0E\u8BE5\u5408\u4F5C\u4F19\u4F34\u5206\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u5E0C\u671B\u60A8\u7684\u4FE1\u606F\u88AB\u5206\u4EAB\uFF0C\u60A8\u53EF\u4EE5\u4E0D\u4F7F\u7528\u8BE5\u5177\u4F53\u670D\u52A1\u4ECE\u800C\u62D2\u7EDD\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u88AB\u62AB\u9732\u3002 (2)\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5171\u540C\u8FDB\u884C\u63A8\u5E7F\u6D3B\u52A8\u3002\u5728\u63A8\u5E7F\u6D3B\u52A8\u4E2D\u6240\u6536\u96C6\u7684\u5168\u90E8\u6216\u90E8\u5206\u4E2A\u4EBA\u4FE1\u606F\u53EF\u80FD\u4F1A\u4E0E\u8BE5\u7B2C\u4E09\u65B9\u5206\u4EAB\u3002\u5982\u679C\u60A8\u4E0D\u60F3\u8BA9\u60A8\u7684\u4FE1\u606F\u88AB\u5206\u4EAB\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4E0D\u53C2\u52A0\u8BE5\u63A8\u5E7F\u6D3B\u52A8\u800C\u62D2\u7EDD\u3002 (3)\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u6216\u653F\u5E9C\u7684\u5F3A\u5236\u6027\u89C4\u5B9A\uFF0C\u6211\u4EEC\u5FC5\u987B\u5411\u6709\u5173\u53F8\u6CD5\u6216\u653F\u5E9C\u90E8\u95E8\u63D0\u4F9B\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002 (4)\u4E3A\u4E86\u9632\u6B62\u4ED6\u4EBA\u7684\u5408\u6CD5\u6743\u76CA\u6216\u793E\u4F1A\u516C\u5171\u5229\u76CA\u53D7\u5230\u91CD\u5927\u5371\u5BB3\u3002 (5)\u4E3A\u4E86\u9632\u6B62\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u91CD\u5927\u5371\u5BB3\u3002 (6)\u6211\u4EEC\u53D1\u73B0\u60A8\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u670D\u52A1\u6761\u6B3E\u6216\u5173\u4E8E\u7279\u5B9A\u670D\u52A1\u6216\u4EA7\u54C1\u7684\u4EFB\u4F55\u4F7F\u7528\u6307\u5F15\uFF0C \u6216\u5BF93WORK\u4FE1\u606F\u7684\u5408\u6CD5\u6743\u76CA\u6784\u6210\u91CD\u5927\u5371\u5BB3\u3002</p>--><!--<p class="negotiation-subtitle">4.\t\u7528\u6237\u7BA1\u7406</p>--><!--<p class="negotiation-content negotiation-indent">\u60A8\u53EF\u4EE5\u5728\u4EFB\u4F55\u65F6\u5019\u901A\u8FC7\u4F7F\u7528\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u6CE8\u518C\u7528\u6237\u540D\u548C\u5BC6\u7801\uFF0C\u67E5\u8BE2\uFF0C\u8865\u5145\u6216\u66F4\u6B63\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4E2D\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6216\u8981\u6C42\u5220\u9664\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4E2D\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u60A8\u5728\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u5E10\u6237\u53EF\u4EE5\u88AB\u5220\u9664\uFF0C\u4F46\u8FD9\u6837\u4F1A\u5BFC\u81F4\u60A8\u4E0D\u80FD\u591F\u767B\u5F55\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u53CA\u4F7F\u7528\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u4EFB\u4F55\u670D\u52A1\u3002\u82E5\u53D1\u73B0\u4EFB\u4F55\u975E\u6CD5\u4F7F\u7528\u7528\u6237\u5E10\u53F7\u6216\u5B58\u5728\u5B89\u5168\u6F0F\u6D1E\u7684\u60C5\u51B5,\u8BF7\u7ACB\u5373\u901A\u77E5\u672C\u7AD9\u5E76\u5411\u516C\u5B89\u673A\u5173\u62A5\u6848\u3002\u56E0\u7528\u6237\u672A\u59A5\u5584\u4FDD\u7BA1\u5176\u5E10\u53F7\u540D\u79F0\u53CA\u5BC6\u7801\u800C\u5BFC\u81F4\u7B2C\u4E09\u4EBA\u4F7F\u7528\u5E10\u53F7\u800C\u7ED9\u7528\u6237\u9020\u6210\u7684\u635F\u5931,\u7531\u7528\u6237\u81EA\u884C\u627F\u62C5</p>--><!--<p class="negotiation-content negotiation-indent">\u7528\u6237\u5728\u6CE8\u518C\u53CA\u4F7F\u7528\u65F6\u5E94\u627F\u8BFA\u9075\u5B88\u6CD5\u5F8B\u6CD5\u89C4\u3001\u793E\u4F1A\u4E3B\u4E49\u5236\u5EA6\u3001\u56FD\u5BB6\u5229\u76CA\u3001\u516C\u6C11\u5408\u6CD5\u6743\u76CA\u3001\u516C\u5171\u79E9\u5E8F\u3001\u793E\u4F1A\u9053\u5FB7\u98CE\u5C1A\u548C\u4FE1\u606F\u771F\u5B9E\u6027\u7B49\u4E03\u6761\u5E95\u7EBF,\u4E14\u7528\u6237\u5BF9\u5176\u53D1\u5E03\u7684\u5185\u5BB9(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u7247\u7B49)\u65F6,\u4E0D\u5F97\u6709\u4EE5\u4E0B\u60C5\u5F62\uFF1A</p>--><!--<p class="negotiation-content">(1)\u8FDD\u53CD\u5BAA\u6CD5\u6216\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684;</p>--><!--<p class="negotiation-content">(2)\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168,\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6,\u98A0\u8986\u56FD\u5BB6\u653F\u6743,\u7834\u574F\u56FD\u5BB6\u7EDF\u4E00\u7684;</p>--><!--<p class="negotiation-content">(3)\u635F\u5BB3\u56FD\u5BB6\u8363\u8A89\u548C\u5229\u76CA\u7684,\u635F\u5BB3\u516C\u5171\u5229\u76CA\u7684;</p>--><!--<p class="negotiation-content">(4)\u717D\u52A8\u6C11\u65CF\u4EC7\u6068\u3001\u6C11\u65CF\u6B67\u89C6,\u7834\u574F\u6C11\u65CF\u56E2\u7ED3\u7684;</p>--><!--<p class="negotiation-content">(5)\u7834\u574F\u56FD\u5BB6\u5B97\u6559\u653F\u7B56,\u5BA3\u626C\u90AA\u6559\u548C\u5C01\u5EFA\u8FF7\u4FE1\u7684;</p>--><!--<p class="negotiation-content">(6)\u6563\u5E03\u8C23\u8A00,\u6270\u4E71\u793E\u4F1A\u79E9\u5E8F,\u7834\u574F\u793E\u4F1A\u7A33\u5B9A\u7684;</p>--><!--<p class="negotiation-content">(7)\u6563\u5E03\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u66B4\u529B\u3001\u51F6\u6740\u3001\u6050\u6016\u6216\u8005\u6559\u5506\u72AF\u7F6A\u7684</p>--><!--<p class="negotiation-content">(8)\u4FAE\u8FB1\u6216\u8005\u8BFD\u8C24\u4ED6\u4EBA,\u4FB5\u5BB3\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684;</p>--><!--<p class="negotiation-content">(9)\u542B\u6709\u6CD5\u5F8B\u3001\u884C\u653F\u6CD5\u89C4\u7981\u6B62\u7684\u5176\u4ED6\u5185\u5BB9\u6216\u8FDD\u53CD3WORK\u7684\u5176\u4ED6\u89C4\u5B9A\u7684\u3002</p>--><!--<p class="negotiation-content negotiation-indent">\u7528\u6237\u4EE5\u865A\u5047\u4FE1\u606F\u9A97\u53D6\u5E10\u53F7\u540D\u79F0\u6CE8\u518C,\u6216\u5176\u5E10\u53F7\u5934\u50CF\u3001\u7B80\u4ECB\u7B49\u6CE8\u518C\u4FE1\u606F\u5B58\u5728\u8FDD\u6CD5\u548C\u4E0D\u826F\u4FE1\u606F\u7684, 3WORK\u6709\u6743\u91C7\u53D6\u901A\u77E5\u9650\u671F\u6539\u6B63\u3001\u6682\u505C\u4F7F\u7528\u3001\u6CE8\u9500\u767B\u8BB0\u7B49\u63AA\u65BD\u30023WORK\u5E10\u53F7\u4EC5\u9650\u4E8E\u7528\u6237\u672C\u4EBA\u4F7F\u7528,\u4E25\u7981\u5C06\u60A8\u76843WORK\u5E10\u53F7\u5141\u8BB8\u7B2C\u4E09\u4EBA\u4F7F\u7528,\u5426\u5219\u7528\u6237\u5E94\u627F\u62C5\u7531\u6B64\u4EA7\u751F\u7684\u5168\u90E8\u8D23\u4EFB,\u5E76\u4E0E\u5B9E\u9645\u4F7F\u7528\u4EBA\u627F\u62C5\u8FDE\u5E26\u8D23\u4EFB\u3002</p>--><!--<p class="negotiation-subtitle">5.\t\u4FE1\u606F\u5B89\u5168</p>--><!--<p class="negotiation-content negotiation-indent">\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4FE1\u606F\u548C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6863\u6848\u901A\u8FC7\u5BC6\u7801\u6765\u4FDD\u62A4\uFF0C\u53EA\u6709\u60A8\u4E2A\u4EBA\u624D\u6709\u6743\u83B7\u53D6\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u4E0D\u8981\u5411\u4EFB\u4F55\u4ED6\u4EBA\u6CC4\u9732\u60A8\u7684\u5BC6\u7801\u3002\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u4E5F\u4E0D\u4F1A\u4E3B\u52A8\u81F4\u7535\u6216\u4E3B\u52A8\u53D1\u7535\u5B50\u90AE\u4EF6\u7ED9\u60A8\u6765\u8BE2\u95EE\u60A8\u7684\u5BC6\u7801\uFF0C\u5982\u679C\u60A8\u9047\u5230\u6B64\u7C7B\u60C5\u51B5\u8BF7\u53CA\u65F6\u4E0E3WORK\u5BA2\u670D\u8054\u7CFB\u786E\u8BA4\u3002\u540C\u65F6\uFF0C\u8BF7\u60A8\u5728\u5B8C\u6210\u5DE5\u4F5C\u540E\uFF0C\u52A1\u5FC5\u9000\u51FA\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u5E76\u5173\u95ED\u60A8\u7684\u6D4F\u89C8\u5668\u7A97\u53E3\uFF0C\u4EE5\u4FBF\u5F53\u60A8\u4E0E\u4ED6\u4EBA\u5408\u7528\u4E00\u53F0\u7535\u8111\uFF0C\u6216\u6B63\u5728\u516C\u5171\u573A\u6240\u4F7F\u7528\u7535\u8111\u65F6\uFF0C\u4FDD\u8BC1\u4ED6\u4EBA\u65E0\u6CD5\u83B7\u53D6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u5F80\u6765\u901A\u4FE1\u3002\u9057\u61BE\u7684\u662F\uFF0C\u4EFB\u4F55\u901A\u8FC7\u4E92\u8054\u7F51\u6216\u65E0\u7EBF\u7F51\u7EDC\u7684\u6570\u636E\u4F20\u8F93\u90FD\u65E0\u6CD5\u83B7\u5F97\u7EDD\u5BF9\u7684\u5B89\u5168\u4FDD\u8BC1\u3002\u6240\u4EE5\uFF0C\u5728\u6211\u4EEC\u5C3D\u6700\u5927\u52AA\u529B\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u540C\u65F6\uFF0C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u4E0D\u80FD\u5BF9\u60A8\u5411\u6211\u4EEC\u8FDB\u884C\u7684\u4FE1\u606F\u4F20\u8F93\uFF0C\u6216\u6211\u4EEC\u6240\u53D1\u7684\u5728\u7EBF\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u4FE1\u606F\u7684\u5B89\u5168\u4F5C\u51FA\u80AF\u5B9A\u6216\u4FDD\u8BC1\u3002\u60A8\u4F5C\u51FA\u4E0A\u8FF0\u884C\u4E3A\u65F6\u5C06\u81EA\u5DF1\u627F\u62C5\u98CE\u9669\u3002\u4E00\u65E6\u6211\u4EEC\u6536\u5230\u60A8\u4F20\u8F93\u6765\u7684\u4FE1\u606F\uFF0C\u6211\u4EEC\u5C06\u5C3D\u6700\u5927\u52AA\u529B\u4FDD\u8BC1\u5176\u5728\u6211\u4EEC\u7CFB\u7EDF\u7684\u5B89\u5168\u3002</p>--><!--<p class="negotiation-subtitle">6.\t\u7528\u6237\u9690\u79C1\u5236\u5EA6</p>--><!--<p class="negotiation-content negotiation-indent">\u6211\u4EEC\u4F1A\u5728\u60A8\u81EA\u613F\u7684\u524D\u63D0\u4E0B\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u5C06\u8FD9\u4E9B\u4FE1\u606F\u8FDB\u884C\u6574\u5408,\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6CE8\u518C</p>--><!--<p class="negotiation-content negotiation-indent">\u5E10\u53F7\u65F6\u7684\u76F8\u5173\u4FE1\u606F\u548C\u6D3B\u52A8\u62A5\u540D\u4FE1\u606F\u7B49\u3002\u5C0A\u91CD\u7528\u6237\u4E2A\u4EBA\u9690\u79C1\u662F3WORK\u7684\u4E00\u9879\u57FA\u672C\u653F\u7B56\u3002\u6240\u4EE5,\u6211\u4EEC\u4E0D\u4F1A\u516C\u5F00\u6216\u5411\u4EFB\u4F55\u7B2C\u4E09\u65B9\u900F\u9732\u7528\u6237\u7684\u6CE8\u518C\u8D44\u6599\u4EE5\u53CA\u7528\u6237\u56E0\u4EAB\u53D73WORK\u670D\u52A1\u800C\u63D0\u4F9B\u7684\u4EFB\u4F55\u4FE1\u606F,\u4F46\u4EE5\u4E0B\u60C5\u5F62\u9664\u5916:</p>--><!--<p class="negotiation-content">(1)\u4E8B\u5148\u83B7\u5F97\u7528\u6237\u7684\u660E\u786E\u6388\u6743\u6216\u8BB8\u53EF;</p>--><!--<p class="negotiation-content">(2)\u9075\u5B88\u6709\u5173\u6CD5\u5F8B\u89C4\u5B9A,\u5305\u62EC\u5728\u56FD\u5BB6\u6709\u5173\u673A\u5173\u67E5\u8BE2\u65F6,\u63D0\u4F9B\u7528\u6237\u7684\u6CE8\u518C\u4FE1\u606F\u3001\u7528\u6237\u5728\u672C\u7AD9\u53D1\u5E03\u7684\u4FE1\u606F\u5185\u5BB9\u53CA\u5176\u53D1\u5E03\u65F6\u95F4\u3001\u4E92\u8054\u7F51\u5730\u5740\u6216\u8005\u57DF\u540D\u7B49</p>--><!--<p class="negotiation-content">(3)\u5728\u7D27\u6025\u60C5\u51B5\u4E0B\u7AED\u529B\u7EF4\u62A4\u7528\u6237\u4E2A\u4EBA\u548C\u793E\u4F1A\u5927\u4F17\u7684\u9690\u79C1\u5B89\u5168;</p>--><!--<p class="negotiation-content">(4)\u6839\u636E\u672C\u6761\u6B3E\u76F8\u5173\u89C4\u5B9A\u6216\u80053WORK\u8BA4\u4E3A\u5FC5\u8981\u7684\u5176\u4ED6\u60C5\u5F62\u30023WORK\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5408\u4F5C\u5411\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u7F51\u7EDC\u670D\u52A1,\u5728\u6B64\u60C5\u51B5\u4E0B,\u5982\u8BE5\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E3WORK\u540C\u7B49\u7684\u4FDD\u62A4\u7528\u6237\u9690\u79C1\u7684\u8D23\u4EFB,\u5219\u53EF\u5C06\u7528\u6237\u4FE1\u606F\u63D0\u4F9B\u7ED9\u8BE5\u7B2C\u4E09\u65B9\u3002</p>--><!--<p class="negotiation-subtitle">7.\t\u6240\u6709\u6743\u53CA\u77E5\u8BC6\u4EA7\u6743\u6761\u6B3E</p>--><!--<p class="negotiation-content negotiation-indent">\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u75313WORK\u62E5\u6709\u548C\u8FD0\u4F5C\u3002\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u516C\u5F00\u6216\u663E\u793A\u7684\u6240\u6709\u5185\u5BB9\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u8868\u3001\u7167\u7247\u3001\u56FE\u50CF\u3001\u52A8\u753B\u3001\u97F3\u6548\u3001\u63D2\u56FE\u53CA\u8F6F\u4EF6\uFF08\u7B80\u79F0\u201C\u5185\u5BB9\u201D\uFF09\u7B49\uFF0C\u5747\u5C5E3WORK\u53CA\u5176\u8BB8\u53EF\u4EBA\u6216\u5185\u5BB9\u4F9B\u5E94\u5546\u6240\u6709\u3002\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u5185\u7684\u6240\u6709\u7EC4\u6210\u8981\u7D20\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6574\u4F53\u8BBE\u8BA1\u53CA\u201C\u5185\u5BB9\u201D\uFF0C\u5747\u53D7\u5546\u4E1A\u5916\u89C2\u3001\u7248\u6743\u3001\u9053\u5FB7\u89C4\u8303\u3001\u5546\u6807\u53CA\u5176\u5B83\u6240\u6709\u76F8\u5173\u77E5\u8BC6\u4EA7\u6743\u7684\u6CD5\u5F8B\u4FDD\u62A4\u3002\u9664\u975E\u4F9D\u636E\u672C\u6761\u6B3E\u4E0E\u6761\u4EF6\u6216\u4E0E\u7ECF3WORK\u5728\u5176\u5B83\u534F\u8BAE\u7684\u58F0\u660E\u540C\u610F\u5916\uFF0C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5167\u7684\u4EFB\u4F55\u90E8\u5206\u6216\u7EC4\u6210\u8981\u7D20\u6216\u201C\u5167\u5BB9\u201D\u5747\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u590D\u5236\u6216\u4F20\u64AD\u3002\u9664\u975E\u6709\u660E\u786E\u534F\u8BAE\u540C\u610F\uFF0C\u5426\u5219\u7F51\u7AD9/\u8F6F\u4EF6\u4E2D\u7684\u201C\u5167\u5BB9\u201D\u53CA\u4E00\u5207\u76F8\u5173\u6743\u5229\u5C06\u4E3A3WORK\u6210\u5458\u6216\u5176\u8BB8\u53EF\u4EBA\u7684\u8D44\u4EA7\u3002</p>--><!--<p class="negotiation-subtitle">8.\t\u8D23\u4EFB\u9650\u5236</p>--><!--<p class="negotiation-content negotiation-indent">\u9664\u975E\u53E6\u6709\u660E\u786E\u7684\u4E66\u9762\u8BF4\u660E,\u672C\u7AD9\u53CA\u5176\u6240\u5305\u542B\u7684\u6216\u4EE5\u5176\u5B83\u65B9\u5F0F\u901A\u8FC7\u672C\u7AD9\u63D0\u4F9B\u7ED9\u60A8\u7684\u5168\u90E8\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u548C\u670D\u52A1,\u5747\u662F\u5728"\u6309\u73B0\u72B6"\u548C"\u6309\u73B0\u6709"\u7684\u57FA\u7840\u4E0A\u63D0\u4F9B\u7684\u3002</p>--><!--<p class="negotiation-content negotiation-indent">\u9664\u975E\u53E6\u6709\u660E\u786E\u7684\u4E66\u9762\u8BF4\u660E,\u6211\u4EEC\u4E0D\u5BF9\u672C\u7AD9\u7684\u8FD0\u8425\u53CA\u5176\u5305\u542B\u5728\u672C\u7AD9\u4E0A\u7684\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u6216\u670D\u52A1\u4F5C\u4EFB\u4F55\u5F62\u5F0F\u7684\u3001\u660E\u793A\u6216\u9ED8\u793A\u7684\u58F0\u660E\u6216\u62C5\u4FDD(\u6839\u636E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6CD5\u5F8B\u53E6\u6709\u89C4\u5B9A\u7684\u4EE5\u5916)\u3002\u6211\u4EEC\u4E0D\u62C5\u4FDD\u672C\u7AD9\u6240\u5305\u542B\u7684\u6216\u4EE5\u5176\u5B83\u65B9\u5F0F\u901A\u8FC7\u672C\u7AD9\u63D0\u4F9B\u7ED9\u60A8\u7684\u5168\u90E8\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u548C\u670D\u52A1\u3001\u5176\u670D\u52A1\u5668\u6216\u4ECE\u672C\u7AD9\u53D1\u51FA\u7684\u7535\u5B50\u4FE1\u4EF6\u3001\u4FE1\u606F\u6CA1\u6709\u75C5\u6BD2\u6216\u5176\u4ED6\u6709\u5BB3\u6210\u5206\u3002\u5982\u56E0\u4E0D\u53EF\u6297\u529B\u6216\u5176\u5B83\u672C\u7AD9\u65E0\u6CD5\u63A7\u5236\u7684\u539F\u56E0\u4F7F\u672C\u7AD9\u670D\u52A1\u7CFB\u7EDF\u6E83\u6216\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u5BFC\u81F4\u670D\u52A1\u4E0D\u53EF\u7528\u6216\u7F51\u4E0A\u4EA4\u6613\u65E0\u6CD5\u5B8C\u6210\u6216\u4E22\u5931\u6709\u5173\u7684\u4FE1\u606F\u3001\u8BB0\u5F55\u7B49,\u6211\u4EEC\u4F1A\u5408\u7406\u5730\u5C3D\u529B\u534F\u52A9\u5904\u7406\u5584\u540E\u4E8B\u5B9C\u3002</p>--><!--<p class="negotiation-subtitle">9.\t\u514D\u8D23\u58F0\u660E</p>--><!--<p class="negotiation-content negotiation-indent">\u5BA2\u6237\u660E\u786E\u540C\u610F\u4F7F\u75283WORK\u670D\u52A1\u7684\u98CE\u9669\u7531\u5BA2\u6237\u627F\u62C5\u30023WORK\u660E\u786E\u8868\u793A\u4E0D\u63D0\u4F9B\u4EFB\u4F55\u7C7B\u578B\u7684\u62C5\u4FDD\uFF0C\u4E0D\u8BBA\u662F\u660E\u786E\u7684\u6216\u9690\u542B\u7684\u30023WORK\u5C06\u5C3D\u529B\u7EF4\u62A4\u5BA2\u6237\u4F7F\u7528\u670D\u52A1\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u4F46\u4E0D\u62C5\u4FDD***\u670D\u52A1\u4E00\u5B9A\u80FD\u6EE1\u8DB3\u5BA2\u6237\u7684\u8981\u6C42\uFF0C\u4E5F\u4E0D\u62C5\u4FDD\u670D\u52A1\u7684\u53CA\u65F6\u6027\u3001\u5B89\u5168\u6027\u3001\u771F\u5B9E\u6027\u3001\u7A33\u5B9A\u6027\u3001\u6B63\u786E\u6027\u3002\u5BF9\u5BA2\u6237\u4F7F\u7528\u8BE5\u7B49\u670D\u52A1\u4E2D\u51FA\u73B0\u7684\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5BA2\u6237\u53D1\u5E03\u7684\u4FE1\u606F\uFF09\u5220\u9664\u6216\u50A8\u5B58\u5931\u8D25\uFF0C3WORK\u4EA6\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</p>--><!--<p class="negotiation-content negotiation-indent">\u5BA2\u6237\u7406\u89E3\u5E76\u63A5\u53D7\u4E0B\u8F7D\u6216\u901A\u8FC7\u76F8\u5E94\u4EA7\u54C1\u670D\u52A1\u53D6\u5F97\u7684\u4EFB\u4F55\u4FE1\u606F\u8D44\u6599\u53D6\u51B3\u4E8E\u5BA2\u6237\u81EA\u5DF1\uFF0C\u5E76\u81EA\u884C\u627F\u62C5\u7CFB\u7EDF\u53D7\u635F\u3001\u8D44\u6599\u4E22\u5931\u4EE5\u53CA\u5176\u4ED6\u4EFB\u4F55\u98CE\u9669\u30023WORK\u5BF9\u5BA2\u6237\u5728\u4E92\u8054\u7F51\u4E0A\u5F97\u5230\u7684\u4EFB\u4F55\u5546\u54C1\u8D2D\u7269\u670D\u52A1\u3001\u4EA4\u6613\u8FDB\u7A0B\u3001\u62DB\u8058\u4FE1\u606F\u7B49\uFF0C\u90FD\u4E0D\u4F5C\u62C5\u4FDD\u3002</p>--><!--<p class="negotiation-content negotiation-indent">3WORK\u5BF9\u76F4\u63A5\u3001\u95F4\u63A5\u3001\u5076\u7136\u3001\u7279\u6B8A\u53CA\u7EE7\u8D77\u7684\u635F\u5BB3\u4E0D\u8D1F\u8D23\u4EFB\uFF0C\u8FD9\u4E9B\u635F\u5BB3\u6765\u81EA\uFF1A\u4E0D\u6B63\u5F53\u4F7F\u75283WORK\u670D\u52A1\u53CA/\u6216\u5E94\u7528\u670D\u52A1\uFF0C\u5728\u7F51\u4E0A\u8D2D\u4E70\u5546\u54C1\u6216\u7C7B\u4F3C\u670D\u52A1\uFF0C\u5728\u7F51\u4E0A\u8FDB\u884C\u4EA4\u6613\uFF0C\u975E\u6CD5\u4F7F\u7528\u670D\u52A1\u6216\u5BA2\u6237\u4F20\u9001\u7684\u4FE1\u606F\u6709\u6240\u53D8\u52A8\u3002</p>--><!--<p class="negotiation-content negotiation-indent">3WORK\u5BF9\u672C\u9879\u670D\u52A1\u4E0B\u6D89\u53CA\u7684\u5883\u5185\u5916\u57FA\u7840\u8FD0\u8425\u5546\u7684\u901A\u4FE1\u7F51\u7EDC\u7684\u6545\u969C\u3001\u6280\u672F\u7F3A\u9677\u3001\u8986\u76D6\u8303\u56F4\u9650\u5236\u3001\u4E0D\u53EF\u6297\u529B\u3001\u8BA1\u7B97\u673A\u75C5\u6BD2\u3001\u9ED1\u5BA2\u653B\u51FB\u3001\u5BA2\u6237\u6240\u5728\u4F4D\u7F6E\u3001\u5BA2\u6237\u5173\u673A\u6216\u5176\u4ED6\u975E***\u6280\u672F\u80FD\u529B\u8303\u56F4\u5185\u7684\u4E8B\u56E0\u7B49\u9020\u6210\u7684\u670D\u52A1\u4E2D\u65AD\u3001\u5BA2\u6237\u90AE\u4EF6\u5185\u5BB9\u4E22\u5931\u3001\u51FA\u73B0\u4E71\u7801\u3001\u9519\u8BEF\u63A5\u6536\u3001\u65E0\u6CD5\u63A5\u6536\u3001\u8FDF\u5EF6\u63A5\u6536\u4E0D\u627F\u62C5\u8D23\u4EFB\u3002</p>--><!--<p class="negotiation-content negotiation-indent">\u6211\u4EEC\u4FDD\u7559\u5224\u5B9A\u5BA2\u6237\u7684\u884C\u4E3A\u662F\u5426\u7B26\u5408\u672C\u670D\u52A1\u534F\u8BAE\u8981\u6C42\u7684\u6743\u5229\uFF0C\u5982\u679C\u5BA2\u6237\u8FDD\u80CC\u4E86\u672C\u670D\u52A1\u534F\u8BAE\u7684\u89C4\u5B9A\uFF0C3WORK\u6709\u6743\u4E2D\u6B62\u6216\u7EC8\u6B62\u76F8\u5E94\u7684\u670D\u52A1\u3002</p>--><!--<p class="negotiation-content negotiation-indent">\u8F6C\u6237\u89C4\u5B9A\uFF1A\u5982\u679C\u5BA2\u6237\u5C06\u624B\u673A\u53F7\u7801\u8F6C\u8BA9\u7ED9\u4ED6\u4EBA\uFF0C\u8BF7\u7528\u6237\u63D0\u524D\u81EA\u884C\u5220\u9664\u8D44\u6599\u3002\u5426\u5219\uFF0C\u53D7\u8BA9\u8BE5\u53F7\u7801\u7684\u5BA2\u6237\u5C06\u80FD\u591F\u67E5\u770B\u60A8\u7684\u5BA2\u6237\u4E2A\u4EBA\u6570\u636E\u30023WORK\u4E0D\u627F\u62C5\u7531\u6B64\u5F15\u53D1\u7684\u5BA2\u6237\u6570\u636E\u4E22\u5931\u7B49\u8D23\u4EFB\u53CA\u7EA0\u7EB7\u3002</p>--><!--<p class="negotiation-subtitle">10.\t\u534F\u8BAE\u66F4\u65B0\u53CA\u7528\u6237\u5173\u6CE8\u4E49\u52A1</p>--><!--<p class="negotiation-content negotiation-indent">\u6839\u636E\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\u7684\u66F4\u65B0\u53CA\u7F51\u7AD9\u8FD0\u8425\u9700\u8981,\u6211\u4EEC\u6709\u6743\u5BF9\u672C\u6761\u6B3E\u4E0D\u65F6\u5730\u8FDB\u884C\u4FEE\u6539,\u4FEE\u6539\u540E\u7684\u670D\u52A1\u6761\u6B3E\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\u529B,\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u670D\u52A1\u6761\u6B3E\u3002\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u670D\u52A1</p>--><!--<p class="negotiation-content negotiation-indent">\u6761\u6B3E\u5185\u5BB9\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u670D\u52A1\u6761\u6B3E,\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1;\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1,\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u7528\u6237\u534F\u8BAE\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5728\u4F7F\u7528\u672C\u7AD9\u4E4B\u524D\u9605\u8BFB\u672C\u7528\u6237 \u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u516C\u544A\u3002\u5982\u679C\u672C\u7528\u6237\u534F\u8BAE\u4E2D\u4EFB\u4F55\u4E00\u6761\u88AB\u89C6\u4E3A\u5E9F\u6B62\u65E0\u6548\u6216\u56E0\u4EFB\u4F55\u7406\u7531\u4E0D\u53EF\u6267\u884C,\u8BE5\u6761\u5E94\u89C6\u4E3A\u53EF\u5206\u7684\u4E14\u5E76\u4E0D\u5F71\u54CD\u4EFB\u4F55\u5176\u4F59\u534F\u8BAE\u7684\u6709\u6548\u6027\u548C\u53EF\u6267\u884C\u6027\u3002</p>--><!--<p class="negotiation-subtitle">11.\t\u6CD5\u5F8B\u7BA1\u8F96\u548C\u9002\u7528</p>--><!--<p class="negotiation-content negotiation-indent">\u672C\u7528\u6237\u534F\u8BAE\u7684\u8BA2\u7ACB\u3001\u6267\u884C\u548C\u89E3\u91CA\u53CA\u4E89\u8BAE\u7684\u89E3\u51B3\u5747\u5E94\u9002\u7528\u5728\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u73B0\u884C\u4E4B\u6709\u6548\u6CD5\u5F8B\u3002\u5982\u53D1\u751F\u672C\u670D\u52A1\u6761\u6B3E\u7684\u67D0\u4E9B\u5185\u5BB9\u4E0E\u9002\u7528\u4E4B\u6CD5\u5F8B\u76F8\u62B5\u89E6\u65F6,\u5219\u8FD9\u4E9B\u6761\u6B3E\u5C06\u5B8C\u5168\u6309\u6CD5\u5F8B\u89C4\u5B9A\u91CD\u65B0\u89E3\u91CA,\u800C\u5176\u5B83\u6709\u6548\u6761\u6B3E\u7EE7\u7EED\u6709\u6548\u3002\u5982\u7F14\u7EA6\u65B9\u5C31\u672C\u6761\u6B3E\u5167\u5BB9\u6216\u5176\u6267\u884C\u53D1\u751F\u4EFB\u4F55\u4E89\u8BAE,\u53CC\u65B9\u5E94\u5C3D\u529B\u53CB\u597D\u534F\u5546\u89E3\u51B3;\u534F\u5546\u4E0D\u6210\u65F6,\u4EFB\u4F55\u4E00\u65B9\u5747\u53EF\u5411\u5495\u549A\u6240\u5728\u5730\u7684\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002</p>--><!--<p class="negotiation-subtitle">12.\t\u5176\u4ED6</p>--><!--<p class="negotiation-content negotiation-indent" style="margin-bottom: 60px">\u6211\u4EEC\u5C0A\u91CD\u7528\u6237\u548C\u6D88\u8D39\u8005\u7684\u5408\u6CD5\u6743\u5229,\u672C\u7528\u6237\u534F\u8BAE\u53CA\u672C\u7AD9\u4E0A\u53D1\u5E03\u7684\u5404\u7C7B\u89C4\u5219\u3001\u653F\u7B56\u3001\u58F0\u660E\u7B49\u5176\u4ED6\u5185\u5BB9,\u5747\u662F\u4E3A\u4E86\u66F4\u597D\u7684\u3001\u66F4\u52A0\u4FBF\u5229\u7684\u4E3A\u7528\u6237\u548C\u6D88\u8D39\u8005\u63D0\u4F9B\u670D\u52A1\u30023WORK\u6B22\u8FCE\u7528\u6237\u548C\u793E\u4F1A\u5404\u754C\u63D0\u51FA\u610F\u89C1\u548C\u5EFA\u8BAE,\u6211\u4EEC\u5C06\u865A\u5FC3\u63A5\u53D7\u5E76\u9002\u65F6\u4FEE\u6539\u672C\u670D\u52A1\u6761\u6B3E\u53CA\u76F8\u5173\u653F\u7B56\u3001\u89C4\u5219\u3002 \u60A8\u5B8C\u6210\u6CE8\u518C\u4E14\u6210\u4E3A3WORK\u7684\u6CE8\u518C\u7528\u6237\u5219\u610F\u5473\u7740\u60A8\u5B8C\u5168\u63A5\u53D7\u672C\u7528\u6237\u534F\u8BAE,\u5728\u6CE8\u518C\u4E4B\u524D\u8BF7\u60A8\u518D\u6B21\u786E\u8BA4\u5DF2\u77E5\u6089\u5E76\u5B8C\u5168\u7406\u89E3\u672C\u7528\u6237\u534F\u8BAE\u7684\u5168\u90E8\u5185\u5BB9\u3002</p>--><!--</div>--><!--</div>--><!--</div>--><div style="padding: 60px; max-height: 700px; overflow: auto"><a class="iconfont icon-close" ng-click="dismissModalAction()" style="font-size: 28px; position: absolute; top: 20px; right: 20px"></a><p class="negotiation-title">\u7528\u6237\u6CE8\u518C\u534F\u8BAE</p><div><p class="negotiation-content negotiation-indent">\u5728\u6B64\u7279\u522B\u63D0\u9192\u60A8\u5728\u6CE8\u518C\u6210\u4E3A3WORK\u7528\u6237\u4E4B\u524D,\u8BF7\u8BA4\u771F\u9605\u8BFB\u672C\u300A\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B(\u4EE5\u4E0B\u7B80\u79F0\u201C\u534F\u8BAE\u201D),\u786E\u4FDD\u60A8\u5145\u5206\u7406\u89E3\u672C\u534F\u8BAE\u4E2D\u5404\u6761\u6B3E\u3002\u8BF7\u60A8\u5BA1\u614E\u9605\u8BFB\u5E76\u9009\u62E9\u63A5\u53D7\u6216\u4E0D\u63A5\u53D7\u672C\u534F\u8BAE\u3002\u60A8\u540C\u610F\u5E76\u70B9\u51FB\u786E\u8BA4\u672C\u534F\u8BAE\u6761\u6B3E\u4E14\u5B8C\u6210\u6CE8\u518C\u7A0B\u5E8F\u540E,\u624D\u80FD\u6210\u4E3A3WORK\u7684\u6B63\u5F0F\u6CE8\u518C\u7528\u6237,\u5E76\u4EAB\u53D73WORK\u7684\u5404\u7C7B\u670D\u52A1\u3002\u60A8\u7684\u6CE8\u518C\u3001\u767B\u5F55\u3001\u4F7F\u7528\u7B49\u884C\u4E3A\u5C06\u89C6\u4E3A\u5BF9\u672C\u534F\u8BAE\u7684\u63A5\u53D7,\u5E76\u540C\u610F\u63A5\u53D7\u672C\u534F\u8BAE\u5404\u9879\u6761\u6B3E\u7684\u7EA6\u675F\u3002\u82E5\u60A8\u4E0D\u540C\u610F\u672C\u534F\u8BAE,\u6216\u5BF9\u672C\u534F\u8BAE\u4E2D\u7684\u6761\u6B3E\u5B58\u5728\u4EFB\u4F55\u7591\u95EE,\u8BF7\u60A8\u7ACB\u5373\u505C\u6B623WORK\u7528\u6237\u6CE8\u518C\u7A0B\u5E8F,\u5E76\u53EF\u4EE5\u9009\u62E9\u4E0D\u4F7F\u75283WORK\u670D\u52A1\u3002\u672C\u534F\u8BAE\u6761\u6B3E\u662F\u4E0A\u6D77\u76DB\u5B97\u7693\u4F01\u4E1A\u7BA1\u7406\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u79F0\u201C3WORK\u201D\u6216\u201C\u6211\u4EEC\u201D\uFF09\u5BF9\u7528\u6237\u76F8\u5173\u653F\u7B56\u7684\u8BB8\u8BFA,\u8BF7\u60A8\u52A1\u5FC5\u4ED4\u7EC6\u9605\u8BFB\u3002</p><p class="negotiation-subtitle">1.\t\u7528\u6237\u4FE1\u606F\u91C7\u96C6</p><p class="negotiation-content negotiation-indent">\u5F53\u60A8\u5728\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u8FDB\u884C\u7528\u6237\u6CE8\u518C\u767B\u8BB0\uFF0C\u4F7F\u7528\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u670D\u52A1\uFF0C\u4EE5\u53CA\u53C2\u52A0\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u6D3B\u52A8\u65F6\uFF0C\u5373\u4E3A\u60A8\u540C\u610F\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5C06\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5E76\u4FDD\u5B58\u8BB0\u5F55\u3002\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A\u59D3\u540D\u3001\u6027\u522B\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7801\u3001\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u3001\u624B\u673A\u7535\u8BDD\u3001\u7B49\u3002\u60A8\u4E3B\u52A8\u63D0\u4F9B\u7684\u4FE1\u606F\u8D8A\u591A\u53CA\u8D8A\u51C6\u786E\uFF0C\u6211\u4EEC\u5C31\u80FD\u591F\u66F4\u597D\u5730\u4E3A\u60A8\u63D0\u4F9B\u6709\u5173\u670D\u52A1\u3002</p><p class="negotiation-subtitle">2.\t\u7528\u6237\u4FE1\u606F\u7684\u4F7F\u7528</p><p class="negotiation-content negotiation-indent">\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6536\u96C6\u4E2A\u4EBA\u4FE1\u606F\u7684\u57FA\u672C\u76EE\u7684\u662F\u4E3A\u4E86\u66F4\u597D\u7684\u4E86\u89E3\u6211\u4EEC\u7684\u7528\u6237\uFF0C\u4EE5\u4FBF\u5411\u60A8\u63D0\u4F9B\u7279\u8272\u670D\u52A1\u548C\u4E2A\u6027\u5316\u670D\u52A1\u3002\u4E2A\u4EBA\u4FE1\u606F\u5C06\u4E3B\u8981\u7528\u4E8E\u4EE5\u4E0B\u51E0\u4E2A\u76EE\u7684\uFF1A</p><p class="negotiation-content">\uFF081\uFF09\u5B8C\u6210\u60A8\u5BF9\u7279\u5B9A\u670D\u52A1\u6216\u4EA7\u54C1\u7684\u8981\u6C42\u3002</p><p class="negotiation-content">\uFF082\uFF09\u5728\u6211\u4EEC\u63D0\u4F9B\u670D\u52A1\u65F6,\u7528\u4E8E\u8EAB\u4EFD\u9A8C\u8BC1\u3001\u5BA2\u6237\u670D\u52A1\u3001\u5B89\u5168\u9632\u8303\u3001\u8BC8\u9A97\u76D1\u6D4B\u3001\u5B58\u6863\u548C\u5907\u4EFD\u7528\u9014,\u786E\u4FDD\u6211\u4EEC\u5411\u60A8\u63D0\u4F9B\u7684\u4EA7\u54C1\u548C\u670D\u52A1\u7684\u5B89\u5168\u6027\u3002</p><p class="negotiation-content">\uFF083\uFF09\u5E2E\u52A9\u6211\u4EEC\u8BBE\u8BA1\u65B0\u670D\u52A1,\u6539\u5584\u6211\u4EEC\u73B0\u6709\u670D\u52A1\u3002</p><p class="negotiation-content">\uFF084\uFF09\u4F7F\u6211\u4EEC\u66F4\u52A0\u4E86\u89E3\u60A8\u5982\u4F55\u63A5\u5165\u548C\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1,\u4ECE\u800C\u9488\u5BF9\u6027\u5730\u56DE\u5E94\u60A8\u7684\u4E2A\u6027\u5316\u9700\u6C42,\u4F8B\u5982\u8BED\u8A00\u8BBE\u5B9A\u3001\u4F4D\u7F6E\u8BBE\u5B9A\u3001\u4E2A\u6027\u5316\u7684\u5E2E\u52A9\u670D\u52A1\u548C\u6307\u793A,\u6216\u5BF9\u60A8\u548C\u5176\u4ED6\u7528\u6237\u4F5C\u51FA\u5176\u4ED6\u65B9\u9762\u7684\u56DE\u5E94\u3002</p><p class="negotiation-content">\uFF085\uFF09\u7528\u4E8E\u5BF9\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7528\u6237\u6570\u636E\u7684\u7EDF\u8BA1\uFF08\u5982\u7528\u6237\u6570\u91CF\u3001\u6784\u6210\u3001\u5174\u8DA3\u3001\u8868\u73B0\u7B49\uFF09\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5411\u7528\u6237\u63D0\u4F9B\u66F4\u597D\u7684\u670D\u52A1\u548C\u4EA7\u54C1\uFF0C\u6216\u5411\u7B2C\u4E09\u65B9\u4E3A\u4E86\u4E00\u5B9A\u7684\u5408\u6CD5\u76EE\u7684\u62AB\u9732\u8BE5\u7C7B\u7EDF\u8BA1\u6570\u636E\u3002\u8BE5\u7C7B\u7EDF\u8BA1\u6570\u636E\u90FD\u662F\u7528\u6237\u7FA4\u6574\u4F53\u7684\u4FE1\u606F\uFF0C\u800C\u975E\u4E2A\u4EBA\u7684\u4FE1\u606F\u3002</p><p class="negotiation-content">\uFF086\uFF09\u8BA9\u60A8\u53C2\u4E0E\u6709\u5173\u6211\u4EEC\u4EA7\u54C1\u548C\u670D\u52A1\u7684\u8C03\u67E5\u3002\u4E3A\u4E86\u8BA9\u60A8\u6709\u66F4\u597D\u7684\u4F53\u9A8C\u3001\u6539\u5584\u6211\u4EEC\u7684\u670D\u52A1\u6216\u60A8\u540C\u610F\u7684\u5176\u4ED6\u7528\u9014,\u5728\u7B26\u5408\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u524D\u63D0\u4E0B,\u6211\u4EEC\u53EF\u80FD\u5C06\u901A\u8FC7\u67D0\u4E00\u9879\u670D\u52A1\u6240\u6536\u96C6\u7684\u4FE1\u606F,\u4EE5\u6C47\u96C6\u4FE1\u606F\u6216\u8005\u4E2A\u6027\u5316\u7684\u65B9\u5F0F,\u7528\u4E8E\u6211\u4EEC\u7684\u5176\u4ED6\u670D\u52A1\u3002\u4F8B\u5982,\u5728\u60A8\u4F7F\u7528\u6211\u4EEC\u7684\u4E00\u9879\u670D\u52A1\u65F6\u6240\u6536\u96C6\u7684\u4FE1\u606F,\u53EF\u80FD\u5728\u53E6\u4E00\u670D\u52A1\u4E2D\u7528\u4E8E\u5411\u60A8\u63D0\u4F9B\u7279\u5B9A\u5185\u5BB9,\u6216\u5411\u60A8\u5C55\u793A\u4E0E\u60A8\u76F8\u5173\u7684\u3001\u975E\u666E\u904D\u63A8\u9001\u7684\u4FE1\u606F\u3002\u5982\u679C\u6211\u4EEC\u5728\u76F8\u5173\u670D\u52A1\u4E2D\u63D0\u4F9B\u4E86\u76F8\u5E94\u9009\u9879,\u60A8\u4E5F\u53EF\u4EE5\u6388\u6743\u6211\u4EEC\u5C06\u8BE5\u670D\u52A1\u6240\u63D0\u4F9B\u548C\u50A8\u5B58\u7684\u4FE1\u606F\u7528\u4E8E\u6211\u4EEC\u7684\u5176\u4ED6\u670D\u52A1\u3002</p><p class="negotiation-subtitle">3.\t\u7528\u6237\u4FE1\u606F\u7684\u5171\u4EAB\u548C\u62AB\u9732</p><p class="negotiation-content negotiation-indent">3WORK\u6240\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5C06\u4EC5\u7528\u4E8E\u4E3A\u60A8\u63D0\u4F9B\u76F8\u5173\u670D\u52A1\u3002\u4E00\u822C\u60C5\u51B5\u4E0B\uFF0C\u5728\u672A\u5F97\u5230\u60A8\u7684\u540C\u610F\u4E4B\u524D\uFF0C\u60A8\u7684\u4EFB\u4F55\u4E2A\u4EBA\u4FE1\u606F\u5C06\u4E0D\u4F1A\u88AB\u63D0\u4F9B\u7ED9\u65E0\u5173\u7684\u7B2C\u4E09\u65B9\u3002 \u5728\u4E0B\u5217\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u63D0\u4F9B\u7ED9\u6709\u5173\u7684\u7B2C\u4E09\u65B9\uFF1A (1)\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u67D0\u4E9B\u670D\u52A1\u9700\u7531\u4E00\u4E2A\u5408\u4F5C\u4F19\u4F34(\u5982\u4EE3\u7406\u516C\u53F8\u3001\u63D0\u4F9B\u76F8\u5173\u6280\u672F\u670D\u52A1\u7684\u516C\u53F8\u3001\u8FD0\u8F93\u516C\u53F8\u3001\u90AE\u5BC4\u516C\u53F8\u3001\u63D0\u4F9B\u5956\u54C1\u7684\u516C\u53F8\u7B49)\u63D0\u4F9B\u6216\u5171\u540C\u63D0\u4F9B\u3002\u4E3A\u4E86\u5411\u60A8\u63D0\u4F9B\u6B64\u7C7B\u670D\u52A1\uFF0C\u672C\u7F51\u7AD9\u6709\u5FC5\u8981\u4E0E\u8BE5\u5408\u4F5C\u4F19\u4F34\u5206\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u60A8\u4E0D\u5E0C\u671B\u60A8\u7684\u4FE1\u606F\u88AB\u5206\u4EAB\uFF0C\u60A8\u53EF\u4EE5\u4E0D\u4F7F\u7528\u8BE5\u5177\u4F53\u670D\u52A1\u4ECE\u800C\u62D2\u7EDD\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u88AB\u62AB\u9732\u3002 (2)\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5171\u540C\u8FDB\u884C\u63A8\u5E7F\u6D3B\u52A8\u3002\u5728\u63A8\u5E7F\u6D3B\u52A8\u4E2D\u6240\u6536\u96C6\u7684\u5168\u90E8\u6216\u90E8\u5206\u4E2A\u4EBA\u4FE1\u606F\u53EF\u80FD\u4F1A\u4E0E\u8BE5\u7B2C\u4E09\u65B9\u5206\u4EAB\u3002\u5982\u679C\u60A8\u4E0D\u60F3\u8BA9\u60A8\u7684\u4FE1\u606F\u88AB\u5206\u4EAB\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u4E0D\u53C2\u52A0\u8BE5\u63A8\u5E7F\u6D3B\u52A8\u800C\u62D2\u7EDD\u3002 (3)\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u6216\u653F\u5E9C\u7684\u5F3A\u5236\u6027\u89C4\u5B9A\uFF0C\u6211\u4EEC\u5FC5\u987B\u5411\u6709\u5173\u53F8\u6CD5\u6216\u653F\u5E9C\u90E8\u95E8\u63D0\u4F9B\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002 (4)\u4E3A\u4E86\u9632\u6B62\u4ED6\u4EBA\u7684\u5408\u6CD5\u6743\u76CA\u6216\u793E\u4F1A\u516C\u5171\u5229\u76CA\u53D7\u5230\u91CD\u5927\u5371\u5BB3\u3002 (5)\u4E3A\u4E86\u9632\u6B62\u60A8\u7684\u5408\u6CD5\u6743\u76CA\u53D7\u5230\u91CD\u5927\u5371\u5BB3\u3002 (6)\u6211\u4EEC\u53D1\u73B0\u60A8\u7684\u884C\u4E3A\u8FDD\u53CD\u4E86\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u670D\u52A1\u6761\u6B3E\u6216\u5173\u4E8E\u7279\u5B9A\u670D\u52A1\u6216\u4EA7\u54C1\u7684\u4EFB\u4F55\u4F7F\u7528\u6307\u5F15\uFF0C \u6216\u5BF93WORK\u4FE1\u606F\u7684\u5408\u6CD5\u6743\u76CA\u6784\u6210\u91CD\u5927\u5371\u5BB3\u3002</p><p class="negotiation-subtitle">4.\t\u7528\u6237\u7BA1\u7406</p><p class="negotiation-content negotiation-indent">\u60A8\u53EF\u4EE5\u5728\u4EFB\u4F55\u65F6\u5019\u901A\u8FC7\u4F7F\u7528\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u6CE8\u518C\u7528\u6237\u540D\u548C\u5BC6\u7801\uFF0C\u67E5\u8BE2\uFF0C\u8865\u5145\u6216\u66F4\u6B63\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4E2D\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6216\u8981\u6C42\u5220\u9664\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4E2D\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u60A8\u5728\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u5E10\u6237\u53EF\u4EE5\u88AB\u5220\u9664\uFF0C\u4F46\u8FD9\u6837\u4F1A\u5BFC\u81F4\u60A8\u4E0D\u80FD\u591F\u767B\u5F55\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u53CA\u4F7F\u7528\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u7684\u4EFB\u4F55\u670D\u52A1\u3002\u82E5\u53D1\u73B0\u4EFB\u4F55\u975E\u6CD5\u4F7F\u7528\u7528\u6237\u5E10\u53F7\u6216\u5B58\u5728\u5B89\u5168\u6F0F\u6D1E\u7684\u60C5\u51B5,\u8BF7\u7ACB\u5373\u901A\u77E5\u672C\u7AD9\u5E76\u5411\u516C\u5B89\u673A\u5173\u62A5\u6848\u3002\u56E0\u7528\u6237\u672A\u59A5\u5584\u4FDD\u7BA1\u5176\u5E10\u53F7\u540D\u79F0\u53CA\u5BC6\u7801\u800C\u5BFC\u81F4\u7B2C\u4E09\u4EBA\u4F7F\u7528\u5E10\u53F7\u800C\u7ED9\u7528\u6237\u9020\u6210\u7684\u635F\u5931,\u7531\u7528\u6237\u81EA\u884C\u627F\u62C5</p><p class="negotiation-content negotiation-indent">\u7528\u6237\u5728\u6CE8\u518C\u53CA\u4F7F\u7528\u65F6\u5E94\u627F\u8BFA\u9075\u5B88\u6CD5\u5F8B\u6CD5\u89C4\u3001\u793E\u4F1A\u4E3B\u4E49\u5236\u5EA6\u3001\u56FD\u5BB6\u5229\u76CA\u3001\u516C\u6C11\u5408\u6CD5\u6743\u76CA\u3001\u516C\u5171\u79E9\u5E8F\u3001\u793E\u4F1A\u9053\u5FB7\u98CE\u5C1A\u548C\u4FE1\u606F\u771F\u5B9E\u6027\u7B49\u4E03\u6761\u5E95\u7EBF,\u4E14\u7528\u6237\u5BF9\u5176\u53D1\u5E03\u7684\u5185\u5BB9(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u7247\u7B49)\u65F6,\u4E0D\u5F97\u6709\u4EE5\u4E0B\u60C5\u5F62\uFF1A</p><p class="negotiation-content">(1)\u8FDD\u53CD\u5BAA\u6CD5\u6216\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684;</p><p class="negotiation-content">(2)\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168,\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6,\u98A0\u8986\u56FD\u5BB6\u653F\u6743,\u7834\u574F\u56FD\u5BB6\u7EDF\u4E00\u7684;</p><p class="negotiation-content">(3)\u635F\u5BB3\u56FD\u5BB6\u8363\u8A89\u548C\u5229\u76CA\u7684,\u635F\u5BB3\u516C\u5171\u5229\u76CA\u7684;</p><p class="negotiation-content">(4)\u717D\u52A8\u6C11\u65CF\u4EC7\u6068\u3001\u6C11\u65CF\u6B67\u89C6,\u7834\u574F\u6C11\u65CF\u56E2\u7ED3\u7684;</p><p class="negotiation-content">(5)\u7834\u574F\u56FD\u5BB6\u5B97\u6559\u653F\u7B56,\u5BA3\u626C\u90AA\u6559\u548C\u5C01\u5EFA\u8FF7\u4FE1\u7684;</p><p class="negotiation-content">(6)\u6563\u5E03\u8C23\u8A00,\u6270\u4E71\u793E\u4F1A\u79E9\u5E8F,\u7834\u574F\u793E\u4F1A\u7A33\u5B9A\u7684;</p><p class="negotiation-content">(7)\u6563\u5E03\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u66B4\u529B\u3001\u51F6\u6740\u3001\u6050\u6016\u6216\u8005\u6559\u5506\u72AF\u7F6A\u7684</p><p class="negotiation-content">(8)\u4FAE\u8FB1\u6216\u8005\u8BFD\u8C24\u4ED6\u4EBA,\u4FB5\u5BB3\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684;</p><p class="negotiation-content">(9)\u542B\u6709\u6CD5\u5F8B\u3001\u884C\u653F\u6CD5\u89C4\u7981\u6B62\u7684\u5176\u4ED6\u5185\u5BB9\u6216\u8FDD\u53CD3WORK\u7684\u5176\u4ED6\u89C4\u5B9A\u7684\u3002</p><p class="negotiation-content negotiation-indent">\u7528\u6237\u4EE5\u865A\u5047\u4FE1\u606F\u9A97\u53D6\u5E10\u53F7\u540D\u79F0\u6CE8\u518C,\u6216\u5176\u5E10\u53F7\u5934\u50CF\u3001\u7B80\u4ECB\u7B49\u6CE8\u518C\u4FE1\u606F\u5B58\u5728\u8FDD\u6CD5\u548C\u4E0D\u826F\u4FE1\u606F\u7684, 3WORK\u6709\u6743\u91C7\u53D6\u901A\u77E5\u9650\u671F\u6539\u6B63\u3001\u6682\u505C\u4F7F\u7528\u3001\u6CE8\u9500\u767B\u8BB0\u7B49\u63AA\u65BD\u30023WORK\u5E10\u53F7\u4EC5\u9650\u4E8E\u7528\u6237\u672C\u4EBA\u4F7F\u7528,\u4E25\u7981\u5C06\u60A8\u76843WORK\u5E10\u53F7\u5141\u8BB8\u7B2C\u4E09\u4EBA\u4F7F\u7528,\u5426\u5219\u7528\u6237\u5E94\u627F\u62C5\u7531\u6B64\u4EA7\u751F\u7684\u5168\u90E8\u8D23\u4EFB,\u5E76\u4E0E\u5B9E\u9645\u4F7F\u7528\u4EBA\u627F\u62C5\u8FDE\u5E26\u8D23\u4EFB\u3002</p><p class="negotiation-subtitle">5.\t\u4FE1\u606F\u5B89\u5168</p><p class="negotiation-content negotiation-indent">\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u4FE1\u606F\u548C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u6863\u6848\u901A\u8FC7\u5BC6\u7801\u6765\u4FDD\u62A4\uFF0C\u53EA\u6709\u60A8\u4E2A\u4EBA\u624D\u6709\u6743\u83B7\u53D6\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u4E0D\u8981\u5411\u4EFB\u4F55\u4ED6\u4EBA\u6CC4\u9732\u60A8\u7684\u5BC6\u7801\u3002\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u4E5F\u4E0D\u4F1A\u4E3B\u52A8\u81F4\u7535\u6216\u4E3B\u52A8\u53D1\u7535\u5B50\u90AE\u4EF6\u7ED9\u60A8\u6765\u8BE2\u95EE\u60A8\u7684\u5BC6\u7801\uFF0C\u5982\u679C\u60A8\u9047\u5230\u6B64\u7C7B\u60C5\u51B5\u8BF7\u53CA\u65F6\u4E0E3WORK\u5BA2\u670D\u8054\u7CFB\u786E\u8BA4\u3002\u540C\u65F6\uFF0C\u8BF7\u60A8\u5728\u5B8C\u6210\u5DE5\u4F5C\u540E\uFF0C\u52A1\u5FC5\u9000\u51FA\u60A8\u7684\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5E10\u6237\u5E76\u5173\u95ED\u60A8\u7684\u6D4F\u89C8\u5668\u7A97\u53E3\uFF0C\u4EE5\u4FBF\u5F53\u60A8\u4E0E\u4ED6\u4EBA\u5408\u7528\u4E00\u53F0\u7535\u8111\uFF0C\u6216\u6B63\u5728\u516C\u5171\u573A\u6240\u4F7F\u7528\u7535\u8111\u65F6\uFF0C\u4FDD\u8BC1\u4ED6\u4EBA\u65E0\u6CD5\u83B7\u53D6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u5F80\u6765\u901A\u4FE1\u3002\u9057\u61BE\u7684\u662F\uFF0C\u4EFB\u4F55\u901A\u8FC7\u4E92\u8054\u7F51\u6216\u65E0\u7EBF\u7F51\u7EDC\u7684\u6570\u636E\u4F20\u8F93\u90FD\u65E0\u6CD5\u83B7\u5F97\u7EDD\u5BF9\u7684\u5B89\u5168\u4FDD\u8BC1\u3002\u6240\u4EE5\uFF0C\u5728\u6211\u4EEC\u5C3D\u6700\u5927\u52AA\u529B\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\u540C\u65F6\uFF0C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u4E0D\u80FD\u5BF9\u60A8\u5411\u6211\u4EEC\u8FDB\u884C\u7684\u4FE1\u606F\u4F20\u8F93\uFF0C\u6216\u6211\u4EEC\u6240\u53D1\u7684\u5728\u7EBF\u4EA7\u54C1\u6216\u670D\u52A1\u7684\u4FE1\u606F\u7684\u5B89\u5168\u4F5C\u51FA\u80AF\u5B9A\u6216\u4FDD\u8BC1\u3002\u60A8\u4F5C\u51FA\u4E0A\u8FF0\u884C\u4E3A\u65F6\u5C06\u81EA\u5DF1\u627F\u62C5\u98CE\u9669\u3002\u4E00\u65E6\u6211\u4EEC\u6536\u5230\u60A8\u4F20\u8F93\u6765\u7684\u4FE1\u606F\uFF0C\u6211\u4EEC\u5C06\u5C3D\u6700\u5927\u52AA\u529B\u4FDD\u8BC1\u5176\u5728\u6211\u4EEC\u7CFB\u7EDF\u7684\u5B89\u5168\u3002</p><p class="negotiation-subtitle">6.\t\u7528\u6237\u9690\u79C1\u5236\u5EA6</p><p class="negotiation-content negotiation-indent">\u6211\u4EEC\u4F1A\u5728\u60A8\u81EA\u613F\u7684\u524D\u63D0\u4E0B\u6536\u96C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5E76\u5C06\u8FD9\u4E9B\u4FE1\u606F\u8FDB\u884C\u6574\u5408,\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6CE8\u518C</p><p class="negotiation-content negotiation-indent">\u5E10\u53F7\u65F6\u7684\u76F8\u5173\u4FE1\u606F\u548C\u6D3B\u52A8\u62A5\u540D\u4FE1\u606F\u7B49\u3002\u5C0A\u91CD\u7528\u6237\u4E2A\u4EBA\u9690\u79C1\u662F3WORK\u7684\u4E00\u9879\u57FA\u672C\u653F\u7B56\u3002\u6240\u4EE5,\u6211\u4EEC\u4E0D\u4F1A\u516C\u5F00\u6216\u5411\u4EFB\u4F55\u7B2C\u4E09\u65B9\u900F\u9732\u7528\u6237\u7684\u6CE8\u518C\u8D44\u6599\u4EE5\u53CA\u7528\u6237\u56E0\u4EAB\u53D73WORK\u670D\u52A1\u800C\u63D0\u4F9B\u7684\u4EFB\u4F55\u4FE1\u606F,\u4F46\u4EE5\u4E0B\u60C5\u5F62\u9664\u5916:</p><p class="negotiation-content">(1)\u4E8B\u5148\u83B7\u5F97\u7528\u6237\u7684\u660E\u786E\u6388\u6743\u6216\u8BB8\u53EF;</p><p class="negotiation-content">(2)\u9075\u5B88\u6709\u5173\u6CD5\u5F8B\u89C4\u5B9A,\u5305\u62EC\u5728\u56FD\u5BB6\u6709\u5173\u673A\u5173\u67E5\u8BE2\u65F6,\u63D0\u4F9B\u7528\u6237\u7684\u6CE8\u518C\u4FE1\u606F\u3001\u7528\u6237\u5728\u672C\u7AD9\u53D1\u5E03\u7684\u4FE1\u606F\u5185\u5BB9\u53CA\u5176\u53D1\u5E03\u65F6\u95F4\u3001\u4E92\u8054\u7F51\u5730\u5740\u6216\u8005\u57DF\u540D\u7B49</p><p class="negotiation-content">(3)\u5728\u7D27\u6025\u60C5\u51B5\u4E0B\u7AED\u529B\u7EF4\u62A4\u7528\u6237\u4E2A\u4EBA\u548C\u793E\u4F1A\u5927\u4F17\u7684\u9690\u79C1\u5B89\u5168;</p><p class="negotiation-content">(4)\u6839\u636E\u672C\u6761\u6B3E\u76F8\u5173\u89C4\u5B9A\u6216\u80053WORK\u8BA4\u4E3A\u5FC5\u8981\u7684\u5176\u4ED6\u60C5\u5F62\u30023WORK\u53EF\u80FD\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5408\u4F5C\u5411\u7528\u6237\u63D0\u4F9B\u76F8\u5173\u7684\u7F51\u7EDC\u670D\u52A1,\u5728\u6B64\u60C5\u51B5\u4E0B,\u5982\u8BE5\u7B2C\u4E09\u65B9\u540C\u610F\u627F\u62C5\u4E0E3WORK\u540C\u7B49\u7684\u4FDD\u62A4\u7528\u6237\u9690\u79C1\u7684\u8D23\u4EFB,\u5219\u53EF\u5C06\u7528\u6237\u4FE1\u606F\u63D0\u4F9B\u7ED9\u8BE5\u7B2C\u4E09\u65B9\u3002</p><p class="negotiation-subtitle">7.\t\u6240\u6709\u6743\u53CA\u77E5\u8BC6\u4EA7\u6743\u6761\u6B3E</p><p class="negotiation-content negotiation-indent">\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u75313WORK\u62E5\u6709\u548C\u8FD0\u4F5C\u3002\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u516C\u5F00\u6216\u663E\u793A\u7684\u6240\u6709\u5185\u5BB9\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u8868\u3001\u7167\u7247\u3001\u56FE\u50CF\u3001\u52A8\u753B\u3001\u97F3\u6548\u3001\u63D2\u56FE\u53CA\u8F6F\u4EF6\uFF08\u7B80\u79F0\u201C\u5185\u5BB9\u201D\uFF09\u7B49\uFF0C\u5747\u5C5E3WORK\u53CA\u5176\u8BB8\u53EF\u4EBA\u6216\u5185\u5BB9\u4F9B\u5E94\u5546\u6240\u6709\u3002\u672C\u201C\u7F51\u7AD9/\u8F6F\u4EF6\u201D\u5185\u7684\u6240\u6709\u7EC4\u6210\u8981\u7D20\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6574\u4F53\u8BBE\u8BA1\u53CA\u201C\u5185\u5BB9\u201D\uFF0C\u5747\u53D7\u5546\u4E1A\u5916\u89C2\u3001\u7248\u6743\u3001\u9053\u5FB7\u89C4\u8303\u3001\u5546\u6807\u53CA\u5176\u5B83\u6240\u6709\u76F8\u5173\u77E5\u8BC6\u4EA7\u6743\u7684\u6CD5\u5F8B\u4FDD\u62A4\u3002\u9664\u975E\u4F9D\u636E\u672C\u6761\u6B3E\u4E0E\u6761\u4EF6\u6216\u4E0E\u7ECF3WORK\u5728\u5176\u5B83\u534F\u8BAE\u7684\u58F0\u660E\u540C\u610F\u5916\uFF0C\u672C\u7F51\u7AD9/\u8F6F\u4EF6\u5167\u7684\u4EFB\u4F55\u90E8\u5206\u6216\u7EC4\u6210\u8981\u7D20\u6216\u201C\u5167\u5BB9\u201D\u5747\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u590D\u5236\u6216\u4F20\u64AD\u3002\u9664\u975E\u6709\u660E\u786E\u534F\u8BAE\u540C\u610F\uFF0C\u5426\u5219\u7F51\u7AD9/\u8F6F\u4EF6\u4E2D\u7684\u201C\u5167\u5BB9\u201D\u53CA\u4E00\u5207\u76F8\u5173\u6743\u5229\u5C06\u4E3A3WORK\u6210\u5458\u6216\u5176\u8BB8\u53EF\u4EBA\u7684\u8D44\u4EA7\u3002</p><p class="negotiation-subtitle">8.\t\u8D23\u4EFB\u9650\u5236</p><p class="negotiation-content negotiation-indent">\u9664\u975E\u53E6\u6709\u660E\u786E\u7684\u4E66\u9762\u8BF4\u660E,\u672C\u7AD9\u53CA\u5176\u6240\u5305\u542B\u7684\u6216\u4EE5\u5176\u5B83\u65B9\u5F0F\u901A\u8FC7\u672C\u7AD9\u63D0\u4F9B\u7ED9\u60A8\u7684\u5168\u90E8\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u548C\u670D\u52A1,\u5747\u662F\u5728"\u6309\u73B0\u72B6"\u548C"\u6309\u73B0\u6709"\u7684\u57FA\u7840\u4E0A\u63D0\u4F9B\u7684\u3002</p><p class="negotiation-content negotiation-indent">\u9664\u975E\u53E6\u6709\u660E\u786E\u7684\u4E66\u9762\u8BF4\u660E,\u6211\u4EEC\u4E0D\u5BF9\u672C\u7AD9\u7684\u8FD0\u8425\u53CA\u5176\u5305\u542B\u5728\u672C\u7AD9\u4E0A\u7684\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u6216\u670D\u52A1\u4F5C\u4EFB\u4F55\u5F62\u5F0F\u7684\u3001\u660E\u793A\u6216\u9ED8\u793A\u7684\u58F0\u660E\u6216\u62C5\u4FDD(\u6839\u636E\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6CD5\u5F8B\u53E6\u6709\u89C4\u5B9A\u7684\u4EE5\u5916)\u3002\u6211\u4EEC\u4E0D\u62C5\u4FDD\u672C\u7AD9\u6240\u5305\u542B\u7684\u6216\u4EE5\u5176\u5B83\u65B9\u5F0F\u901A\u8FC7\u672C\u7AD9\u63D0\u4F9B\u7ED9\u60A8\u7684\u5168\u90E8\u4FE1\u606F\u3001\u5185\u5BB9\u3001\u6750\u6599\u3001\u4EA7\u54C1(\u5305\u62EC\u8F6F\u4EF6)\u548C\u670D\u52A1\u3001\u5176\u670D\u52A1\u5668\u6216\u4ECE\u672C\u7AD9\u53D1\u51FA\u7684\u7535\u5B50\u4FE1\u4EF6\u3001\u4FE1\u606F\u6CA1\u6709\u75C5\u6BD2\u6216\u5176\u4ED6\u6709\u5BB3\u6210\u5206\u3002\u5982\u56E0\u4E0D\u53EF\u6297\u529B\u6216\u5176\u5B83\u672C\u7AD9\u65E0\u6CD5\u63A7\u5236\u7684\u539F\u56E0\u4F7F\u672C\u7AD9\u670D\u52A1\u7CFB\u7EDF\u6E83\u6216\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u5BFC\u81F4\u670D\u52A1\u4E0D\u53EF\u7528\u6216\u7F51\u4E0A\u4EA4\u6613\u65E0\u6CD5\u5B8C\u6210\u6216\u4E22\u5931\u6709\u5173\u7684\u4FE1\u606F\u3001\u8BB0\u5F55\u7B49,\u6211\u4EEC\u4F1A\u5408\u7406\u5730\u5C3D\u529B\u534F\u52A9\u5904\u7406\u5584\u540E\u4E8B\u5B9C\u3002</p><p class="negotiation-subtitle">9.\t\u514D\u8D23\u58F0\u660E</p><p class="negotiation-content negotiation-indent">\u5BA2\u6237\u660E\u786E\u540C\u610F\u4F7F\u75283WORK\u670D\u52A1\u7684\u98CE\u9669\u7531\u5BA2\u6237\u627F\u62C5\u30023WORK\u660E\u786E\u8868\u793A\u4E0D\u63D0\u4F9B\u4EFB\u4F55\u7C7B\u578B\u7684\u62C5\u4FDD\uFF0C\u4E0D\u8BBA\u662F\u660E\u786E\u7684\u6216\u9690\u542B\u7684\u30023WORK\u5C06\u5C3D\u529B\u7EF4\u62A4\u5BA2\u6237\u4F7F\u7528\u670D\u52A1\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u4F46\u4E0D\u62C5\u4FDD***\u670D\u52A1\u4E00\u5B9A\u80FD\u6EE1\u8DB3\u5BA2\u6237\u7684\u8981\u6C42\uFF0C\u4E5F\u4E0D\u62C5\u4FDD\u670D\u52A1\u7684\u53CA\u65F6\u6027\u3001\u5B89\u5168\u6027\u3001\u771F\u5B9E\u6027\u3001\u7A33\u5B9A\u6027\u3001\u6B63\u786E\u6027\u3002\u5BF9\u5BA2\u6237\u4F7F\u7528\u8BE5\u7B49\u670D\u52A1\u4E2D\u51FA\u73B0\u7684\u4FE1\u606F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u5BA2\u6237\u53D1\u5E03\u7684\u4FE1\u606F\uFF09\u5220\u9664\u6216\u50A8\u5B58\u5931\u8D25\uFF0C3WORK\u4EA6\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002</p><p class="negotiation-content negotiation-indent">\u5BA2\u6237\u7406\u89E3\u5E76\u63A5\u53D7\u4E0B\u8F7D\u6216\u901A\u8FC7\u76F8\u5E94\u4EA7\u54C1\u670D\u52A1\u53D6\u5F97\u7684\u4EFB\u4F55\u4FE1\u606F\u8D44\u6599\u53D6\u51B3\u4E8E\u5BA2\u6237\u81EA\u5DF1\uFF0C\u5E76\u81EA\u884C\u627F\u62C5\u7CFB\u7EDF\u53D7\u635F\u3001\u8D44\u6599\u4E22\u5931\u4EE5\u53CA\u5176\u4ED6\u4EFB\u4F55\u98CE\u9669\u30023WORK\u5BF9\u5BA2\u6237\u5728\u4E92\u8054\u7F51\u4E0A\u5F97\u5230\u7684\u4EFB\u4F55\u5546\u54C1\u8D2D\u7269\u670D\u52A1\u3001\u4EA4\u6613\u8FDB\u7A0B\u3001\u62DB\u8058\u4FE1\u606F\u7B49\uFF0C\u90FD\u4E0D\u4F5C\u62C5\u4FDD\u3002</p><p class="negotiation-content negotiation-indent">3WORK\u5BF9\u76F4\u63A5\u3001\u95F4\u63A5\u3001\u5076\u7136\u3001\u7279\u6B8A\u53CA\u7EE7\u8D77\u7684\u635F\u5BB3\u4E0D\u8D1F\u8D23\u4EFB\uFF0C\u8FD9\u4E9B\u635F\u5BB3\u6765\u81EA\uFF1A\u4E0D\u6B63\u5F53\u4F7F\u75283WORK\u670D\u52A1\u53CA/\u6216\u5E94\u7528\u670D\u52A1\uFF0C\u5728\u7F51\u4E0A\u8D2D\u4E70\u5546\u54C1\u6216\u7C7B\u4F3C\u670D\u52A1\uFF0C\u5728\u7F51\u4E0A\u8FDB\u884C\u4EA4\u6613\uFF0C\u975E\u6CD5\u4F7F\u7528\u670D\u52A1\u6216\u5BA2\u6237\u4F20\u9001\u7684\u4FE1\u606F\u6709\u6240\u53D8\u52A8\u3002</p><p class="negotiation-content negotiation-indent">3WORK\u5BF9\u672C\u9879\u670D\u52A1\u4E0B\u6D89\u53CA\u7684\u5883\u5185\u5916\u57FA\u7840\u8FD0\u8425\u5546\u7684\u901A\u4FE1\u7F51\u7EDC\u7684\u6545\u969C\u3001\u6280\u672F\u7F3A\u9677\u3001\u8986\u76D6\u8303\u56F4\u9650\u5236\u3001\u4E0D\u53EF\u6297\u529B\u3001\u8BA1\u7B97\u673A\u75C5\u6BD2\u3001\u9ED1\u5BA2\u653B\u51FB\u3001\u5BA2\u6237\u6240\u5728\u4F4D\u7F6E\u3001\u5BA2\u6237\u5173\u673A\u6216\u5176\u4ED6\u975E***\u6280\u672F\u80FD\u529B\u8303\u56F4\u5185\u7684\u4E8B\u56E0\u7B49\u9020\u6210\u7684\u670D\u52A1\u4E2D\u65AD\u3001\u5BA2\u6237\u90AE\u4EF6\u5185\u5BB9\u4E22\u5931\u3001\u51FA\u73B0\u4E71\u7801\u3001\u9519\u8BEF\u63A5\u6536\u3001\u65E0\u6CD5\u63A5\u6536\u3001\u8FDF\u5EF6\u63A5\u6536\u4E0D\u627F\u62C5\u8D23\u4EFB\u3002</p><p class="negotiation-content negotiation-indent">\u6211\u4EEC\u4FDD\u7559\u5224\u5B9A\u5BA2\u6237\u7684\u884C\u4E3A\u662F\u5426\u7B26\u5408\u672C\u670D\u52A1\u534F\u8BAE\u8981\u6C42\u7684\u6743\u5229\uFF0C\u5982\u679C\u5BA2\u6237\u8FDD\u80CC\u4E86\u672C\u670D\u52A1\u534F\u8BAE\u7684\u89C4\u5B9A\uFF0C3WORK\u6709\u6743\u4E2D\u6B62\u6216\u7EC8\u6B62\u76F8\u5E94\u7684\u670D\u52A1\u3002</p><p class="negotiation-content negotiation-indent">\u8F6C\u6237\u89C4\u5B9A\uFF1A\u5982\u679C\u5BA2\u6237\u5C06\u624B\u673A\u53F7\u7801\u8F6C\u8BA9\u7ED9\u4ED6\u4EBA\uFF0C\u8BF7\u7528\u6237\u63D0\u524D\u81EA\u884C\u5220\u9664\u8D44\u6599\u3002\u5426\u5219\uFF0C\u53D7\u8BA9\u8BE5\u53F7\u7801\u7684\u5BA2\u6237\u5C06\u80FD\u591F\u67E5\u770B\u60A8\u7684\u5BA2\u6237\u4E2A\u4EBA\u6570\u636E\u30023WORK\u4E0D\u627F\u62C5\u7531\u6B64\u5F15\u53D1\u7684\u5BA2\u6237\u6570\u636E\u4E22\u5931\u7B49\u8D23\u4EFB\u53CA\u7EA0\u7EB7\u3002</p><p class="negotiation-subtitle">10.\t\u534F\u8BAE\u66F4\u65B0\u53CA\u7528\u6237\u5173\u6CE8\u4E49\u52A1</p><p class="negotiation-content negotiation-indent">\u6839\u636E\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\u7684\u66F4\u65B0\u53CA\u7F51\u7AD9\u8FD0\u8425\u9700\u8981,\u6211\u4EEC\u6709\u6743\u5BF9\u672C\u6761\u6B3E\u4E0D\u65F6\u5730\u8FDB\u884C\u4FEE\u6539,\u4FEE\u6539\u540E\u7684\u670D\u52A1\u6761\u6B3E\u4E00\u65E6\u88AB\u5F20\u8D34\u5728\u672C\u7AD9\u4E0A\u5373\u751F\u6548\u529B,\u5E76\u4EE3\u66FF\u539F\u6765\u7684\u670D\u52A1\u6761\u6B3E\u3002\u7528\u6237\u53EF\u968F\u65F6\u767B\u5F55\u67E5\u9605\u6700\u65B0\u670D\u52A1</p><p class="negotiation-content negotiation-indent">\u6761\u6B3E\u5185\u5BB9\u3002\u5982\u7528\u6237\u4E0D\u540C\u610F\u66F4\u65B0\u540E\u7684\u670D\u52A1\u6761\u6B3E,\u5E94\u7ACB\u5373\u505C\u6B62\u63A5\u53D7\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1;\u5982\u7528\u6237\u7EE7\u7EED\u4F7F\u7528\u672C\u7AD9\u63D0\u4F9B\u7684\u670D\u52A1,\u5373\u89C6\u4E3A\u540C\u610F\u66F4\u65B0\u540E\u7684\u7528\u6237\u534F\u8BAE\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5728\u4F7F\u7528\u672C\u7AD9\u4E4B\u524D\u9605\u8BFB\u672C\u7528\u6237 \u534F\u8BAE\u53CA\u672C\u7AD9\u7684\u516C\u544A\u3002\u5982\u679C\u672C\u7528\u6237\u534F\u8BAE\u4E2D\u4EFB\u4F55\u4E00\u6761\u88AB\u89C6\u4E3A\u5E9F\u6B62\u65E0\u6548\u6216\u56E0\u4EFB\u4F55\u7406\u7531\u4E0D\u53EF\u6267\u884C,\u8BE5\u6761\u5E94\u89C6\u4E3A\u53EF\u5206\u7684\u4E14\u5E76\u4E0D\u5F71\u54CD\u4EFB\u4F55\u5176\u4F59\u534F\u8BAE\u7684\u6709\u6548\u6027\u548C\u53EF\u6267\u884C\u6027\u3002</p><p class="negotiation-subtitle">11.\t\u6CD5\u5F8B\u7BA1\u8F96\u548C\u9002\u7528</p><p class="negotiation-content negotiation-indent">\u672C\u7528\u6237\u534F\u8BAE\u7684\u8BA2\u7ACB\u3001\u6267\u884C\u548C\u89E3\u91CA\u53CA\u4E89\u8BAE\u7684\u89E3\u51B3\u5747\u5E94\u9002\u7528\u5728\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u73B0\u884C\u4E4B\u6709\u6548\u6CD5\u5F8B\u3002\u5982\u53D1\u751F\u672C\u670D\u52A1\u6761\u6B3E\u7684\u67D0\u4E9B\u5185\u5BB9\u4E0E\u9002\u7528\u4E4B\u6CD5\u5F8B\u76F8\u62B5\u89E6\u65F6,\u5219\u8FD9\u4E9B\u6761\u6B3E\u5C06\u5B8C\u5168\u6309\u6CD5\u5F8B\u89C4\u5B9A\u91CD\u65B0\u89E3\u91CA,\u800C\u5176\u5B83\u6709\u6548\u6761\u6B3E\u7EE7\u7EED\u6709\u6548\u3002\u5982\u7F14\u7EA6\u65B9\u5C31\u672C\u6761\u6B3E\u5167\u5BB9\u6216\u5176\u6267\u884C\u53D1\u751F\u4EFB\u4F55\u4E89\u8BAE,\u53CC\u65B9\u5E94\u5C3D\u529B\u53CB\u597D\u534F\u5546\u89E3\u51B3;\u534F\u5546\u4E0D\u6210\u65F6,\u4EFB\u4F55\u4E00\u65B9\u5747\u53EF\u5411\u5495\u549A\u6240\u5728\u5730\u7684\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002</p><p class="negotiation-subtitle">12.\t\u5176\u4ED6</p><p class="negotiation-content negotiation-indent" style="margin-bottom: 60px">\u6211\u4EEC\u5C0A\u91CD\u7528\u6237\u548C\u6D88\u8D39\u8005\u7684\u5408\u6CD5\u6743\u5229,\u672C\u7528\u6237\u534F\u8BAE\u53CA\u672C\u7AD9\u4E0A\u53D1\u5E03\u7684\u5404\u7C7B\u89C4\u5219\u3001\u653F\u7B56\u3001\u58F0\u660E\u7B49\u5176\u4ED6\u5185\u5BB9,\u5747\u662F\u4E3A\u4E86\u66F4\u597D\u7684\u3001\u66F4\u52A0\u4FBF\u5229\u7684\u4E3A\u7528\u6237\u548C\u6D88\u8D39\u8005\u63D0\u4F9B\u670D\u52A1\u30023WORK\u6B22\u8FCE\u7528\u6237\u548C\u793E\u4F1A\u5404\u754C\u63D0\u51FA\u610F\u89C1\u548C\u5EFA\u8BAE,\u6211\u4EEC\u5C06\u865A\u5FC3\u63A5\u53D7\u5E76\u9002\u65F6\u4FEE\u6539\u672C\u670D\u52A1\u6761\u6B3E\u53CA\u76F8\u5173\u653F\u7B56\u3001\u89C4\u5219\u3002 \u60A8\u5B8C\u6210\u6CE8\u518C\u4E14\u6210\u4E3A3WORK\u7684\u6CE8\u518C\u7528\u6237\u5219\u610F\u5473\u7740\u60A8\u5B8C\u5168\u63A5\u53D7\u672C\u7528\u6237\u534F\u8BAE,\u5728\u6CE8\u518C\u4E4B\u524D\u8BF7\u60A8\u518D\u6B21\u786E\u8BA4\u5DF2\u77E5\u6089\u5E76\u5B8C\u5168\u7406\u89E3\u672C\u7528\u6237\u534F\u8BAE\u7684\u5168\u90E8\u5185\u5BB9\u3002</p><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px">\u5173\u95ED</button></div></div></div></div>');
$templateCache.put('app/module/promotion/promotion.html','<div style="background-color: white; margin-top: 85px"><div style="position: relative; height: 600px"><img src="{{advertiseModel.imageUrl}}" alt="" style="width: 100%; height: 600px; position: absolute; top: 0; left: 0"><div style="position: absolute; top: 210px; width: 1200px; margin: 0 auto; left: 0; right: 0"><p style="margin: 0; font-size: 50px; font-weight: 700; color: white; margin-bottom: 20px">{{advertiseModel.mainTitle}}<br>{{advertiseModel.subHead}}</p></div></div><div class="limit-container"><div class="limit-center-content"><div style="padding: 80px 100px" id="advertise-container"></div></div></div></div>');
$templateCache.put('app/module/preview/preview.html','<div style="background-color: white"><div class="homepage-header"><div uib-carousel active="active" interval="myInterval" no-wrap="noWrapSlides" style="width: 100%; height: 41vw; overflow: hidden" ng-if="homeModel.type === \'SLIDE\'"><div uib-slide ng-repeat="image in bannerModel.category.images track by $index" index="$index"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" style="width: 100%; height: 41vw; object-fit: cover"></div></div><videogular vg-auto-play="true" ng-if="homeModel.type === \'VIDEO\'"><vg-media vg-src="videoModel.imageUrl" vg-native-controls="true" vg-loop="true"></vg-media></videogular><div class="homepage-search-container"><img src="content/images/triwork_center.png" alt="" class="homepage-search-logo"><div class="homepage-search-input"><span class="iconfont icon-Magnifier" ng-click="searchAction()"></span> <input type="text" placeholder="\u5BFB\u627E\u4E0B\u4E00\u4E2A\u68A6\u60F3\u529E\u516C\u5730\u70B9" ng-keyup="keyupAction($event)" ng-model="keyword"></div></div></div><div class="limit-container"><div class="limit-center-content"><div style="padding: 90px 100px 60px 100px"><p class="homepage-title bold-font">3work\u662F\u4E00\u4E2A\u5168\u65B0\u7684\u5171\u4EAB\u529E\u516C\u5E73\u53F0\u3002\u4E09\u4EBA\u884C\u5FC5\u6709\u6211\u5E08<br>\u6211\u4EEC\u6574\u5408\u8D44\u6E90\uFF0C\u4E92\u5E2E\u4E92\u52A9\uFF0C\u5171\u7B51\u68A6\u60F3\u3002</p><div class="homepage-btn"><button class="btn btn-default bold-button" style="margin-right: 30px">\u4E86\u89E3\u66F4\u591A</button> <button class="btn btn-primary normal-btn bold-button" ng-click="appointmentAction()">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div><div class="home-block-container"><p class="home-block-title">\u6211\u4EEC\u7684\u670D\u52A1</p><div class="homepage-service-container"><img src="content/images/home_flower.png"><h1 class="bold-font">\u5B89\u5FC3\u623F\u6E90</h1><p>3work\u63D0\u4F9B\u7684\u5DE5\u4F5C\u573A\u5730\u90FD\u7ECF\u8FC7\u5BA1\u6838\uFF0C\u653E\u5FC3\u5165\u9A7B\u3002</p></div><div class="homepage-service-container" style="margin-left: 90px"><img src="content/images/home_light.png"><h1 class="bold-font">\u4E92\u52A9\u793E\u533A</h1><p>\u4E0D\u4EC5\u662F\u529E\u516C\u573A\u6240\uFF0C\u800C\u662F\u5229\u7528\u66F4\u5927\u7684\u5E73\u53F0\u5B9E\u73B0\u68A6\u60F3\u3002</p></div><div class="homepage-service-container" style="margin-left: 90px"><img src="content/images/home_contact.png"><h1 class="bold-font">24/7\u7BA1\u5BB6\u670D\u52A1</h1><p>\u65E0\u8BBA\u9047\u5230\u4EFB\u4F55\u95EE\u9898\uFF0C\u90FD\u53EF\u4EE5\u8054\u7CFB\u6211\u4EEC\u7684\u53CC\u8BED\u56E2\u3002</p></div><div style="clear: both"></div></div><div class="home-block-container" ng-if="homeModel.advertise"><p class="home-block-title">\u4F18\u60E0\u6D3B\u52A8</p><div style="width: 100%; height: 400px; position: relative; background-color: #F5F5F5; color: white; border-radius: 5px; overflow: hidden"><img lazy-src="{{advertiseModel.category.images[0].imageUrl}}" animate-visible="true" animate-speed="0.5s" alt="" style="object-fit: cover; width: 100%; height: 100%"><div style="height: 150px; font-size: 40px; position: absolute; left: 60px; top: 0; bottom: 0; margin: auto 0; font-weight: 500; line-height: 60px"><p>{{homeModel.mainTitle}}</p><p>{{homeModel.subHead}}</p><a style="position: absolute; font-size: 18px; bottom: -30px; line-height: 1; color: white; white-space: nowrap">\u4E86\u89E3\u66F4\u591A ></a></div></div></div><div class="home-block-container"><p class="home-block-title">\u7CBE\u9009\u623F\u6E90 <a style="font-size: 20px; float: right" class="bold-font">\u4E86\u89E3\u66F4\u591A\u623F\u6E90 ></a></p><div class="building-container"><div class="building-right"><p style="font-size: 40px; margin: 0 0 10px 0" class="bold-font">{{buildingModel.building.name}}</p><p style="color: #58585B; margin: 0 0 5px 0">{{buildingModel.building.addrProvince}} {{buildingModel.building.addrCity}} {{buildingModel.building.addrDistrict}} {{buildingModel.building.addrAddress}}</p><p style="color: #58585B; margin: 0 0 20px 0; line-height: 24px">{{buildingModel.building.tranfficInfo}}</p><p style="color: #58585B; margin: 0 0 3px 0; height: 96px; white-space: normal; line-height: 24px">{{buildingModel.building.recommands}}</p><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>0">\u6700\u65B0\u4EF7\u683C</p><div class="clearfix" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>0"><p style="float: left" class="bold-font">{{buildingModel.building.recommandRooms[0].title}}</p><p style="float: right">\uFFE5{{buildingModel.building.recommandRooms[0].price.toPrice()}}/{{buildingModel.building.recommandRooms[0].priceUnit}}</p></div><div style="margin-bottom: 30px" class="clearfix" ng-if="buildingModel.building.recommandRooms && buildingModel.building.recommandRooms.length>1"><p style="float: left" class="bold-font">{{buildingModel.building.recommandRooms[1].title}}</p><p style="float: right">\uFFE5{{buildingModel.building.recommandRooms[1].price.toPrice()}}/{{buildingModel.building.recommandRooms[1].priceUnit}}</p></div><a style="font-size: 20px; font-weight: 500; float: right">\u4E86\u89E3\u66F4\u591A ></a></div><div class="building-left"><img lazy-src="{{buildingModel.building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div></div><div class="building-container" style="margin-top: 20px" ng-if="buildingList.length == 1"><div class="building-right"><p style="font-size: 40px; margin: 0 0 10px 0" class="bold-font">{{buildingList[0].building.name}}</p><p style="color: #58585B; margin: 0 0 5px 0">{{buildingList[0].building.addrProvince}} {{buildingList[0].building.addrCity}} {{buildingList[0].building.addrDistrict}} {{buildingList[0].building.addrAddress}}</p><p style="color: #58585B; margin: 0 0 20px 0; line-height: 24px">{{buildingList[0].building.tranfficInfo}}</p><p style="color: #58585B; margin: 0 0 3px 0; height: 96px; white-space: normal; line-height: 24px">{{buildingList[0].building.recommands}}</p><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>0">\u6700\u65B0\u4EF7\u683C</p><div class="clearfix" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>0"><p style="float: left" class="bold-font">{{buildingList[0].building.recommandRooms[0].title}}</p><p style="float: right">\uFFE5{{buildingList[0].building.recommandRooms[0].price.toPrice()}}/{{buildingList[0].building.recommandRooms[0].priceUnit}}</p></div><div style="margin-bottom: 30px" class="clearfix" ng-if="buildingList[0].building.recommandRooms && buildingList[0].building.recommandRooms.length>1"><p style="float: left" class="bold-font">{{buildingList[0].building.recommandRooms[1].title}}</p><p style="float: right">\uFFE5{{buildingList[0].building.recommandRooms[1].price.toPrice()}}/{{buildingList[0].building.recommandRooms[1].priceUnit}}</p></div><a style="font-size: 20px; font-weight: 500; float: right">\u4E86\u89E3\u66F4\u591A ></a></div><div class="building-left"><img lazy-src="{{buildingList[0].building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div></div><div class="activities-container clearfix" ng-if="buildingList.length > 1"><div ng-class="{\'activities-item-2\':buildingList.length==2,\'activities-item-3\':buildingList.length!=2}" ng-repeat="building in buildingList track by $index"><div class="activities-item-image-container" style="height: 392px; overflow: hidden"><img lazy-src="{{building.building.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container"><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font">{{building.building.name}}</p><p style="margin: 0 0 3px 0">{{building.building.addrProvince}} {{building.building.addrCity}} {{building.building.addrDistrict}} {{building.building.addrAddress}}</p><p style="margin: 0 0 10px 0">{{building.building.tranfficInfo}}</p><a class="bold-font">\u4E86\u89E3\u66F4\u591A ></a></div></div></div></div><div class="home-block-container"><p class="home-block-title">\u8FD1\u671F\u6D3B\u52A8 <a style="font-size: 20px; float: right" class="bold-font">\u4E86\u89E3\u66F4\u591A\u8FD1\u671F\u6D3B\u52A8 ></a></p><div class="activities-container clearfix"><div class="activities-item-3" ng-repeat="activity in activityList track by $index" style="cursor: pointer"><div class="activities-item-image-container" style="height: 229px"><img lazy-src="{{activity.activityPosterImageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><div class="activities-item-text-container" style="height: 138px; border: none; background-color: #F5F5F5"><p style="font-size: 20px; margin: 0 0 10px 0" class="bold-font">{{activity.activityName}}</p><p style="margin: 0 0 3px 0">\u65F6\u95F4 {{activity.activityStart|date:\'MM\u6708dd\u65E5\'}}-{{activity.activityEnd|date:\'MM\u6708dd\u65E5\'}}</p><p style="margin: 0 0 10px 0">{{translateLevel(activity.authorityLevel)}}</p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/module/member-center/member-access-record.html','<div style="padding: 60px"><a class="iconfont icon-close" ng-click="dismissModalAction()" style="font-size: 28px; position: absolute; top: 20px; right: 20px"></a><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">\u4F1A\u5458\u5237\u5361\u8BB0\u5F55</p><div><div class="clearfix"><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u65F6\u95F4\u8303\u56F4</label><div class="vp-float-input vp-float-select" style="width: 460px"><div class="vp-float-select-multi"><input type="text" style="width: 200px" name="startTime" ng-model="pageparams.startTime" placeholder="\u5E74/\u6708/\u65E5" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{maxDate: pageparams.endTime}" ng-click="endTimeSel=false;startTimeSel=true" is-open="startTimeSel" ng-change="reloadDataAction()" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div><p style="float: left; padding: 0 19px; margin: 0; line-height: 38px; font-size: 20px" class="bold-font">\u5230</p><div class="vp-float-select-multi"><input type="text" style="width: 200px" name="endTime" ng-model="pageparams.endTime" placeholder="\u5E74/\u6708/\u65E5" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{minDate: pageparams.startTime}" ng-click="endTimeSel=true;startTimeSel=false" is-open="endTimeSel" ng-change="reloadDataAction()" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div></div></div></div><div><div class="appointment-record-container" ng-repeat="access in accessRecords track by $index"><div class="appointment-record-title clearfix"><p class="pull-left bold-font">{{access.group}}</p><p class="pull-right bold-font">\u6D41\u6C34\u53F7{{access.id}}\uFF09</p></div><div class="appointment-record-content clearfix"><!--<div class="clearfix" style="margin-bottom: 30px">--><!--<p class="pull-left bold-font appointment-record-big">{{appointment.subject}}</p>--><!--<p class="pull-right bold-font">\u9884\u5B9A\u4EBA\uFF1A{{appointment.operator}}</p>--><!--</div>--><div class="clearfix"><div class="appointment-record-detail"><p class="appointment-record-big">{{access.consumerName}}</p><p class="appointment-record-small">\u6301\u5361\u4EBA</p></div><div class="appointment-record-detail"><p class="appointment-record-big">{{access.readDate|date:\'HH:mm\'}}</p><p class="appointment-record-small">\u5237\u5361\u65F6\u95F4</p></div><div class="appointment-record-detail"><p class="appointment-record-big">{{access.cardNo}}</p><p class="appointment-record-small">\u5361\u53F7</p></div></div></div></div></div><div class="text-center"><page page-cp="pageparams.page" page-ps="pageparams.size" page-count="pageparams.count" page-change="pageChangeAction()"></page></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px">\u5173\u95ED</button></div></div></div></div><style>.auto-width{width: auto}</style>');
$templateCache.put('app/module/member-center/member-appointment-cancel.html','<div class="modal-common-container"><p class="modal-common-title bold-font">\u53D6\u6D88\u4F1A\u8BAE\u5BA4\u9884\u5B9A</p><p class="modal-common-title bold-font" style="font-size: 36px; margin: 35px 0">{{meeting.inProgressItem.roomName}}</p><div><p class="member-wifi-content">\u53C2\u4E0E\u4EBA\u6570\uFF1A{{meeting.inProgressItem.numberOfParticipants}}\u4EBA</p><p class="member-wifi-content">\u4F1A\u8BAE\u4E3B\u9898\uFF1A{{meeting.inProgressItem.subject}}</p><p class="member-wifi-content">\u4F1A\u8BAE\u65F6\u95F4\uFF1A{{meeting.inProgressItem.date|date:\'yyyy-MM-dd\'}} {{meeting.inProgressItem.startTime|date:\'HH:mm\'}}-{{meeting.inProgressItem.endTime|date:\'HH:mm\'}} \u5171{{meeting.inProgressItem.durationInHours}}\u5C0F\u65F6</p><div style="margin-top: 30px"><vp-checkbox vp-model="selectAll" style="font-size: 18px; color: #333333">\u53D6\u6D88\u5C06\u6765\u7684\u5168\u90E8\u9884\u5B9A</vp-checkbox><span style="font-size: 14px; color: #898989">(\u4E0D\u52FE\u9009\u53EA\u53D6\u6D88\u5F53\u524D\u9884\u5B9A)</span></div><p class="repeat-p">\u91CD\u590D\u8BBE\u5B9A\uFF1A\u6BCF{{translateCycleType(meeting.inProgressItem.cycleType)}}\u91CD\u590D\u622A\u6B62 <span style="color: #292929">{{meeting.endDate|date:\'yyyy-MM-dd\'}}</span></p><div id="time-type" ng-init="insertAction()" style="font-size: 16px; text-align: center; margin-bottom: 30px"></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-default" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px">\u4FDD\u7559\u9884\u5B9A</button> <button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="cancelAction()" style="padding: 10px 50px; margin-top: 10px">\u53D6\u6D88\u9884\u5B9A</button><div style="clear: both"></div><p style="font-size: 18px; color: #AAAAAA; margin-top: 20px; cursor: pointer" ng-click="showDescription=!showDescription">\u53D6\u6D88\u4F1A\u8BAE\u5BA4\u8BF4\u660E <span class="iconfont icon-wenhao"></span></p></div><div style="text-align: left" ng-if="showDescription"><div class="appointment-modal-left" style="width: 100%"><p>1.\u4F1A\u8BAE\u5F00\u59CB\u524D3\u5C0F\u65F6(\u4E0D\u542B)\uFF0C\u514D\u8D39\u53D6\u6D88\u30022.\u4F1A\u8BAE\u5F00\u59CB\u524D1-3\u5C0F\u65F6\uFF0C\u6309\u5355\u6B21\u9884\u8BA2\u603B\u8D39\u752845%\u8BA1\u30023.\u4F1A\u8BAE\u5F00\u59CB\u524D\u4E0D\u8DB31(\u542B)\u5C0F\u65F6\uFF0C\u5C06\u6263\u9664\u9884\u5B9A\u7528\u65F6\u603B\u8D39\u7528(\u9884\u5B9A\u7528\u65F6*\u5355\u4EF7)\u30024.\u53D6\u6D88\u9884\u5B9A\u4EA7\u751F\u7684\u8D39\u7528\u4E0D\u53EF\u4F7F\u7528\u914D\u989D\u989D\u5EA6\u6263\u8D39\u3002</p></div></div></div></div></div><style>.member-wifi-content{font-size: 20px; margin-bottom: 10px}\n    .auto-width{width: auto}</style>');
$templateCache.put('app/module/member-center/member-appointment-confirm.html','<div class="container"></div>');
$templateCache.put('app/module/member-center/member-appointment-edit.html','<div class="modal-common-container"><p class="modal-common-title bold-font">\u4FEE\u6539\u4F1A\u8BAE\u5BA4\u9884\u5B9A</p><p class="modal-common-title bold-font" style="font-size: 36px; margin: 35px 0">{{meeting.inProgressItem.roomName}}</p><div><div class="clearfix"><p class="member-wifi-content">\u53C2\u4E0E\u4EBA\u6570\uFF1A{{meeting.inProgressItem.numberOfParticipants}}\u4EBA</p><p class="member-wifi-content">\u4F1A\u8BAE\u4E3B\u9898\uFF1A{{meeting.inProgressItem.subject}}</p><p class="member-wifi-content" style="margin-top: 10px; margin-bottom: 30px">\u539F\u59CB\u9884\u5B9A\u65F6\u95F4\uFF1A{{meeting.inProgressItem.date|date:\'yyyy-MM-dd\'}} {{meeting.inProgressItem.startTime|date:\'HH:mm\'}}-{{meeting.inProgressItem.endTime|date:\'HH:mm\'}} \u5171{{meeting.inProgressItem.durationInHours}}\u5C0F\u65F6</p><p class="member-wifi-content">\u4FEE\u6539\u9884\u5B9A\u65F6\u95F4</p><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u65E5\u671F</label><div class="vp-float-input vp-float-select" style="width: 269px"><input type="text" name="startTime" ng-model="appointmentModel.dateShow" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{minDate: now}" ng-click="dateSel=true" is-open="dateSel" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div></div><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u65F6\u95F4</label><div class="vp-float-input vp-float-select" style="width: 269px"><div class="vp-float-select-multi"><input type="text" style="width: 106px" name="startTime" ng-model="appointmentModel.startTime" class="ml-input-group-input1" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="startTimeEnum.length>0" style="max-height: 300px; overflow: auto"><li ng-repeat="item in startTimeEnum track by $index" ng-click="sStartTime(item)"><a>{{item}}</a></li></ul></div><p style="float: left; padding: 0 19px; margin: 0; line-height: 38px">\u5230</p><div class="vp-float-select-multi"><input type="text" style="width: 106px" name="endTime" ng-model="appointmentModel.endTime" class="ml-input-group-input1" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="endTimeEnum.length>0" style="max-height: 300px; overflow: auto"><li ng-repeat="item in endTimeEnum track by $index" ng-click="sEndTime(item)"><a>{{item}}</a></li></ul></div></div></div><div style="clear: both"></div><div ng-if="meeting.repeat"><div style="margin-top: 30px"><vp-checkbox vp-model="appointmentModel.global" style="font-size: 18px; color: #333333">\u5E94\u7528\u5230\u5C06\u6765\u7684\u5168\u90E8\u9884\u5B9A</vp-checkbox><span style="font-size: 14px; color: #898989">(\u4E0D\u52FE\u9009\u53EA\u4FEE\u6539\u5F53\u524D\u9884\u5B9A)</span></div><p class="repeat-p">\u91CD\u590D\u8BBE\u5B9A\uFF1A\u6BCF{{translateCycleType(meeting.inProgressItem.cycleType)}}\u91CD\u590D\u622A\u6B62 <span style="color: #292929">{{meeting.endDate|date:\'yyyy-MM-dd\'}}</span></p></div></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-default" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px; margin-right: 20px">\u53D6\u6D88</button> <button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="editAppointmentAction()" style="padding: 10px 50px; margin-top: 10px" ng-disabled="!appointmentModel.dateShow||!appointmentModel.startTime||!appointmentModel.endTime">\u4FEE\u6539</button><div style="clear: both"></div><p style="font-size: 18px; color: #AAAAAA; margin-top: 20px; cursor: pointer" ng-click="showDescription=!showDescription">\u66F4\u6539\u4F1A\u8BAE\u5BA4\u8BF4\u660E <span class="iconfont icon-wenhao"></span></p></div><div style="text-align: left" ng-if="showDescription"><div class="appointment-modal-left" style="width: 100%"><p>1.\u4F1A\u8BAE\u5F00\u59CB\u524D3\u5C0F\u65F6(\u4E0D\u542B)\uFF0C\u514D\u8D39\u4FEE\u6539\u30022.\u4F1A\u8BAE\u5F00\u59CB\u4E0D\u8DB33\u5C0F\u65F6\uFF0C\u4E0D\u652F\u6301\u4FEE\u6539\u3002</p></div></div></div></div></div><style>.member-wifi-content{font-size: 20px; margin-bottom: 10px}\n    .auto-width{width: auto}</style>');
$templateCache.put('app/module/member-center/member-appointment-record.html','<div style="padding: 60px"><a class="iconfont icon-close" ng-click="dismissModalAction()" style="font-size: 28px; position: absolute; top: 20px; right: 20px"></a><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">\u4F1A\u8BAE\u5BA4\u9884\u5B9A\u8BB0\u5F55</p><div><div class="clearfix"><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u65F6\u95F4\u8303\u56F4</label><div class="vp-float-input vp-float-select" style="width: 460px"><div class="vp-float-select-multi"><input type="text" style="width: 200px" name="startTime" ng-model="pageparams.startTime" placeholder="\u5E74/\u6708/\u65E5" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{maxDate: pageparams.endTime}" ng-click="endTimeSel=false;startTimeSel=true" is-open="startTimeSel" ng-change="reloadDataAction()" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div><p style="float: left; padding: 0 19px; margin: 0; line-height: 38px; font-size: 20px" class="bold-font">\u5230</p><div class="vp-float-select-multi"><input type="text" style="width: 200px" name="endTime" ng-model="pageparams.endTime" placeholder="\u5E74/\u6708/\u65E5" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{minDate: pageparams.startTime}" ng-click="endTimeSel=true;startTimeSel=false" is-open="endTimeSel" ng-change="reloadDataAction()" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div></div></div></div><div><div class="appointment-record-container" ng-repeat="appointment in appointmentRecords track by $index"><div class="appointment-record-title clearfix"><p class="pull-left bold-font">{{appointment.buildingName}}-{{appointment.roomName}}\u5BA4</p><p class="pull-right bold-font">{{appointment.createDate|date:\'yyyy\u5E74MM\u6708dd\u65E5\'}}\uFF08{{appointment.stateString}}\uFF09</p></div><div class="appointment-record-content clearfix"><div class="clearfix" style="margin-bottom: 30px"><p class="pull-left bold-font appointment-record-big">{{appointment.subject}}</p><p class="pull-right bold-font">\u9884\u5B9A\u4EBA\uFF1A{{appointment.operator}}</p></div><div class="clearfix"><div class="appointment-record-detail"><p class="appointment-record-big">{{appointment.date|date:\'yyyy\u5E74MM\u6708dd\u65E5\'}}</p><p class="appointment-record-small">\u4F1A\u8BAE\u65E5\u671F</p></div><div class="appointment-record-detail"><p class="appointment-record-big">{{appointment.startTime|date:\'HH:mm\'}} - {{appointment.endTime|date:\'HH:mm\'}}</p><p class="appointment-record-small">\u4F1A\u8BAE\u65F6\u95F4</p></div><div class="appointment-record-detail" ng-if="appointment.stateString === \'\u5DF2\u7ED3\u675F\'"><p class="appointment-record-big">{{appointment.totalPayAmount}} \xA5</p><p class="appointment-record-small" style="font-size: 12px">(\u6D88\u8D39{{appointment.payAmount||0}}\xA5+\u914D\u989D{{appointment.usedQuotaAmount||0}}\xA5)</p><p class="appointment-record-small">\u6D88\u8D39\u91D1\u989D</p></div><div class="appointment-record-detail" ng-if="appointment.stateString !== \'\u5DF2\u7ED3\u675F\'"><p class="appointment-record-big">{{appointment.prepayAmount}} \xA5</p><p class="appointment-record-small" style="font-size: 12px">(\u6D88\u8D39{{appointment.amount||0}}\xA5+\u62BC\u91D1{{(appointment.prepayAmount||0) - (appointment.amount||0)}}\xA5)</p><p class="appointment-record-small">\u6D88\u8D39\u91D1\u989D</p></div></div></div></div></div><div class="text-center"><page page-cp="pageparams.page" page-ps="pageparams.size" page-count="pageparams.count" page-change="pageChangeAction()"></page></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px">\u5173\u95ED</button></div></div></div></div><style>.auto-width{width: auto}</style>');
$templateCache.put('app/module/member-center/member-appointment.html','<div style="padding: 60px; position: relative"><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">\u4F1A\u8BAE\u5BA4\u9884\u5B9A</p><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="createBookJobAction()" show-validation=""><div class="clearfix"><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u57CE\u5E02</label><div class="vp-float-input vp-float-select" style="width: 169px"><input type="text" class="" ng-model="bsModel.city.name" readonly="readonly" data-toggle="dropdown" btn-group> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="cityList.length>0"><li ng-repeat="item in cityList track by $index" ng-click="sCity(item)"><a>{{item.name}}</a></li></ul></div></div><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u5546\u5708</label><div class="vp-float-input vp-float-select" style="width: 189px"><input type="text" class="" ng-model="bsModel.region.name" readonly="readonly" data-toggle="dropdown" btn-group> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="regionList.length>0"><li ng-repeat="item in regionList track by $index" ng-click="sRegion(item)"><a>{{item.name}}</a></li></ul></div></div><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u697C\u5B87</label><div class="vp-float-input vp-float-select" style="width: 249px; position: relative"><input type="text" class="" ng-model="bsModel.building.name" readonly="readonly" data-toggle="dropdown" btn-group> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="buildingList.length>0"><li ng-repeat="item in buildingList track by $index" ng-click="sBuilding(item)"><a>{{item.name}}</a></li></ul><div class="vp-input-error" style="bottom: -25px"><p ng-if="notMatch">\u975E\u79DF\u7528\u697C\u5B87\uFF0C\u8D39\u7528\u52A0\u653630%</p></div></div></div><div class="vp-float-input-group"><label class="vp-auto-input-label vp-triwork-input-label">\u9009\u62E9\u4F1A\u8BAE\u5BA4</label><div class="vp-float-input vp-float-select" style="width: 269px"><input type="text" class="" ng-model="bsModel.meeting.name" readonly="readonly" data-toggle="dropdown" btn-group> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="meetingList.length>0"><li ng-repeat="item in meetingList track by $index" ng-click="sMeeting(item)"><a>{{item.name}}</a></li></ul></div></div></div><div class="clearfix" style="padding: 20px 0; border-bottom: 1px solid #C9C9C9" ng-if="bsModel.meeting.id"><div class="pull-left appointment-modal-left"><p class="appointment-modal-title bold-font">\u4F1A\u8BAE\u5BA4\u4ECB\u7ECD</p><div class="appointment-modal-float" style="margin-right: 40px"><h1 class="bold-font" ng-if="!bsModel.meeting.promotionEnabled">{{bsModel.meeting.price}}<span ng-if="notMatch" style="color: red">+{{bsModel.meeting.price*0.3}}</span>/{{bsModel.meeting.priceUnit}}</h1><h1 class="bold-font" ng-if="bsModel.meeting.promotionEnabled">{{bsModel.meeting.promotionPrice}}<span ng-if="notMatch" style="color: red">+{{bsModel.meeting.promotionPrice*0.3}}</span>/{{bsModel.meeting.promotionPriceUnit}}</h1><p>\u4EF7\u683C</p></div><div class="appointment-modal-float"><h1 class="bold-font">{{bsModel.meeting.capacity}}\u4EBA</h1><p>\u53EF\u5BB9\u7EB3\u4EBA\u6570</p></div><div style="clear: both; margin-bottom: 20px"></div><p>{{bsModel.meeting.roomIntroduction}}</p></div><div class="pull-right" style="width: 653px"><img lazy-src="{{bsModel.meeting.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt="" style="width: 100%"></div></div><div class="clearfix" style="padding: 30px 0" ng-show="bsModel.meeting.id"><div class="pull-left appointment-modal-left"><p class="appointment-modal-title bold-font">\u9884\u5B9A\u8BE6\u60C5</p><div class="clearfix"><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u4F1A\u8BAE\u4E3B\u9898</label><div class="vp-float-input vp-float-select" style="width: 269px"><input type="text" class="" ng-model="appointmentModel.subject"></div></div><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u4EBA\u6570</label><div class="vp-float-input vp-float-select" style="width: 269px"><div class="pull-right ability-container" style="height: 100%"><input type="text" ng-model="appointmentModel.numberOfParticipants" ng-pattern="\'^[0-9]*$\'" name="numberOfParticipants" style="width: 269px; height: 38px"> <button type="button" ng-click="changeQuantity(false)" style="height: 38px">-</button> <button type="button" ng-click="changeQuantity(true)" class="ability-right" style="height: 38px">+</button><p ng-if="editForm.numberOfParticipants.$error.pattern && numberOfParticipants!==0" class="ability-error">\u8BF7\u586B\u5199\u4E0D\u4E3A0\u7684\u6B63\u6574\u6570</p></div></div></div><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u65E5\u671F</label><div class="vp-float-input vp-float-select" style="width: 269px"><input type="text" name="startTime" ng-model="appointmentModel.dateShow" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{minDate: now}" ng-click="startTimeSel=false;endTimeSel=false;dateSel=true;repeatDateSel=false" is-open="dateSel" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div></div><div class="vp-float-input-group" style="margin-right: 0"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u65F6\u95F4</label><div class="vp-float-input vp-float-select" style="width: 269px"><div class="vp-float-select-multi"><input type="text" style="width: 106px" name="startTime" ng-model="appointmentModel.startTime" class="ml-input-group-input1" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="startTimeEnum.length>0" style="max-height: 300px; overflow: auto"><li ng-repeat="item in startTimeEnum track by $index" ng-click="sStartTime(item)"><a>{{item}}</a></li></ul></div><p style="float: left; padding: 0 19px; margin: 0; line-height: 38px">\u5230</p><div class="vp-float-select-multi"><input type="text" style="width: 106px" name="endTime" ng-model="appointmentModel.endTimeShow" class="ml-input-group-input1" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="endTimeEnum.length>0" style="max-height: 300px; overflow: auto"><li ng-repeat="item in endTimeEnum track by $index" ng-click="sEndTime(item)"><a>{{item}}</a></li></ul></div></div></div><div class="vp-float-input-group" style="margin-right: 0; line-height: 40px"><vp-checkbox class="bold-font" vp-model="appointmentModel.repeat" style="float: left">\u91CD\u590D\u9884\u5B9A</vp-checkbox><div class="vp-float-input vp-float-select" style="width: 269px; position: relative" ng-if="appointmentModel.repeat"><input type="text" class="" name="cycleName" ng-model="appointmentModel.cycleName" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button><ul class="dropdown-menu dropdown-menu-right ml-input-group-menu1" ng-if="repeatList.length>0" style="max-height: 300px; overflow: auto"><li ng-repeat="item in repeatList track by $index" ng-click="sCycleType(item)"><a>{{item.name}}</a></li></ul></div></div><div class="vp-float-input-group" style="margin-right: 0" ng-if="appointmentModel.repeat"><label class="vp-auto-input-label vp-triwork-input-label" style="width: 80px">\u622A\u6B62\u65E5\u671F</label><div class="vp-float-input vp-float-select" style="width: 269px; position: relative"><input type="text" class="" name="endDate" ng-model="appointmentModel.endDateShow" class="ml-input-group-input1" datetime-picker="yyyy-MM-dd" enable-time="false" datepicker-options="{minDate: appointmentModel.dateShow}" ng-click="endTimeSel=false;startTimeSel=false;repeatDateSel=true;dateSel=false" is-open="repeatDateSel" data-toggle="dropdown" btn-group readonly="readonly"> <button type="button" class="btn btn-default vp-float-select-icon dropdown-toggle-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="iconfont icon-sanjiaoxing"></span></button></div></div></div></div><div class="pull-right float-up" style="width: 653px; border-radius: 10px"><div style="width: 653px; height: 531px; padding: 20px; position: relative"><div class="calendar-cus-container"><a class="iconfont icon-ai-arrow-left-copy" ng-click="prev()"></a> <span>{{titleDate}}</span> <a class="iconfont icon-ai-arrow-right-copy" ng-click="next()"></a></div><div ui-calendar="uiConfig.calendar" ng-model="eventSources" calendar="scheduleCalendar"></div></div></div></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-default bold-button" ng-click="cancelAction()" style="padding: 6px 50px; margin-right: 30px">\u5173\u95ED</button> <button type="submit" class="btn btn-primary normal-btn bold-button" style="padding: 5px 50px" ng-disabled="editForm.$invalid">\u9884\u5B9A</button><div style="clear: both"></div><p style="font-size: 18px; color: #AAAAAA; margin-top: 20px; cursor: pointer" ng-click="showDescription=!showDescription">\u4F1A\u8BAE\u5BA4\u9884\u5B9A\u8BF4\u660E <span class="iconfont icon-wenhao"></span></p></div><div style="text-align: left" ng-if="showDescription"><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">\u4F1A\u8BAE\u5BA4\u9884\u5B9A\u8BF4\u660E</p><div class="appointment-modal-left" style="width: 100%"><p class="appointment-modal-title bold-font" style="margin-bottom: 10px">\u6536\u8D39\u6807\u51C6\uFF1A</p><p>1.\u9884\u8BA2\u9884\u6263\u6B3E =\uFF08\u9884\u8BA2\u7528\u65F6+1\uFF09*\u5355\u4EF7\u30022.\u5F53\u4F59\u989D+\u914D\u989D\u2265\u9884\u8BA2\u9884\u6263\u6B3E\u65F6\u53EF\u4EE5\u9884\u5B9A\u4F1A\u8BAE\u5BA4\uFF0C\u9884\u8BA2\u4EE5\u62BC\u91D1\u65B9\u5F0F\u81EA\u52A8\u51BB\u7ED3\u8D39\u7528\u30023.\u4F1A\u8BAE\u5BA4\u4F7F\u7528\u540E\uFF0C\u4F18\u5148\u4F7F\u7528\u914D\u989D\u6263\u8D39\uFF0C\u914D\u989D\u4E0D\u8DB3\u65F6\u5C06\u4ECE\u8D26\u6237\u4F59\u989D\u6263\u8D39\u30024.\u4F1A\u8BAE\u7ED3\u675F\u540E\uFF0C\u5C06\u7531\u540E\u53F0\u786E\u8BA4\u540E\u8FDB\u884C\u6263\u8D39\u30024.\u4F1A\u8BAE\u8D85\u65F6\u5C06\u6839\u636E\u5B9E\u9645\u7528\u65F6\u8FDB\u884C\u6263\u8D39\uFF0C\u4E0D\u8DB330\u5206\u949F\uFF0C\u4EE530\u5206\u949F\u8BA1\u7B97\u3002</p><p class="appointment-modal-title bold-font" style="margin-bottom: 10px; margin-top: 30px">\u9884\u5B9A\u4FEE\u6539\uFF1A</p><p>\u9884\u5B9A\u6210\u529F\u540E\u53EF\u4EE5\u4FEE\u6539\u30021.\u4F1A\u8BAE\u5F00\u59CB\u524D3\u5C0F\u65F6(\u4E0D\u542B)\uFF0C\u514D\u8D39\u4FEE\u6539\u30022.\u4F1A\u8BAE\u5F00\u59CB\u4E0D\u8DB33\u5C0F\u65F6\uFF0C\u4E0D\u652F\u6301\u4FEE\u6539\u3002</p><p class="appointment-modal-title bold-font" style="margin-bottom: 10px; margin-top: 30px">\u9884\u5B9A\u53D6\u6D88\uFF1A</p><p>\u9884\u5B9A\u6210\u529F\u540E\u53EF\u4EE5\u53D6\u6D88\u30021.\u4F1A\u8BAE\u5F00\u59CB\u524D3\u5C0F\u65F6(\u4E0D\u542B)\uFF0C\u514D\u8D39\u53D6\u6D88\u30022.\u4F1A\u8BAE\u5F00\u59CB\u524D1-3\u5C0F\u65F6\uFF0C\u6309\u5355\u6B21\u9884\u8BA2\u603B\u8D39\u752845%\u8BA1\u30023.\u4F1A\u8BAE\u5F00\u59CB\u524D\u4E0D\u8DB31(\u542B)\u5C0F\u65F6\uFF0C\u5C06\u6263\u9664\u9884\u5B9A\u7528\u65F6\u603B\u8D39\u7528(\u9884\u5B9A\u7528\u65F6*\u5355\u4EF7)\u30024.\u53D6\u6D88\u9884\u5B9A\u4EA7\u751F\u7684\u8D39\u7528\u4E0D\u53EF\u4F7F\u7528\u914D\u989D\u989D\u5EA6\u6263\u8D39\u3002</p><p class="appointment-modal-title bold-font" style="margin-bottom: 10px; margin-top: 30px">\u5373\u65F6\u9884\u8BA2\uFF1A</p><p>\u652F\u6301\u5373\u65F6\u9884\u8BA2\uFF08\u4E0D\u8DB3\u534A\u5C0F\u65F6\u4EE5\u534A\u70B9\u5F00\u59CB\u8BA1\u65F6\uFF09\u3002</p></div></div></div></form></div><style>.auto-width{width: auto}\n    input{font-weight: 500}</style>');
$templateCache.put('app/module/member-center/member-center.html','<div class="limit-container" style="margin-top: 85px"><div class="limit-center-content" style="padding: 60px"><div style="padding-bottom: 20px; border-bottom: 1px solid #C9C9C9" class="clearfix"><div class="building-detail-header building-detail-hoverable" ui-sref="home"><span>\u9996\u9875</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>\u6211\u7684\u7BA1\u5BB6</span></div></div><div style="padding: 54px 38px; color: #292929"><div ng-if="!employeeModel"><div style="margin-bottom: 40px; font-size: 20px" class="clearfix member-center-header"><div class="clearfix" style="margin-bottom: 60px"><p style="line-height: 40px; font-size: 35px; max-width: 703px" class="bold-font pull-left">\u60A8\u8FD8\u672A\u6210\u4E3A3work\u7684\u79DF\u6237\uFF0C\u6B22\u8FCE\u52A0\u51653work\u5171\u4EAB\u529E\u516C\u5927\u5BB6\u5EAD\uFF01</p><a class="pull-right" style="margin-top: 10px; font-size: 20px" ng-click="logoutAction()">\u9000\u51FA\u767B\u5F55</a></div><div class="room-content-text-item"><h1><span style="font-size: 16px">\uFFE5</span>0</h1><p>\u5DF2\u6D88\u8D39\u91D1\u989D</p></div><div class="room-content-text-item"><h1><span style="font-size: 16px">\uFFE5</span>0</h1><p>\u8D26\u6237\u4F59\u989D</p></div><div class="room-content-text-item"><h1><span style="font-size: 16px">\uFFE5</span>0</h1><p>\u62B5\u7528\u5238</p></div><div class="room-content-text-item"><h1>0\u4EBA</h1><p>\u5458\u5DE5\u6570\u91CF</p></div></div><div class="member-center-container"><div class="member-center-left"><div class="clearfix member-room-null"><div class="pull-left"><h1>\u8FD8\u6CA1\u6709\u4E13\u5C5E\u7A7A\u95F4</h1><p>\u53BB\u623F\u6E90\u5217\u8868\u5BFB\u627E\u5408\u9002\u623F\u6E90\u5427</p></div><a class="pull-right" ui-sref="building">\u67E5\u770B\u623F\u6E90\u2192</a></div><div class="room-content-records" validate-authority=\'["ROLE_PERSONAL"]\'><p class="room-content-records-title">\u7BA1\u5BB6\u670D\u52A1</p><div class="room-content-records-box"><div class="box-center-item" ng-click="memberAccountInfo()"><div class="member-center-icon"><img src="content/images/mcenter_settings.png" alt=""></div><p>\u4FEE\u6539\u4E2A\u4EBA\u4FE1\u606F</p></div></div></div></div><div class="member-center-right"><div class="agency-content"><img lazy-src="{{defaultBuilding.managerHeadImage}}" animate-visible="true" animate-speed="0.5s" alt=""><div class="agency-title-name"><h1 class="bold-font">{{defaultBuilding.managerName}}</h1><p>\u4E13\u5C5E\u987E\u95EE</p></div><div style="clear: both"></div><div class="agency-content-text"><p>\u8054\u7CFB\u65B9\u5F0F\uFF1A{{defaultBuilding.managerPhone}}</p><p>\u54A8\u8BE2\u65F6\u95F4\uFF1A08:00 - 21:00</p><p style="margin: 15px 0; text-indent: 1em; overflow: hidden" ng-style="{\'max-height\': managerExtend?\'\':\'42px\'}">{{defaultBuilding.recommands && defaultBuilding.recommands.length>35 && !managerExtend ? (defaultBuilding.recommands.substring(0, 30)+"......"):defaultBuilding.recommands}}</p><div style="text-align: right; margin-bottom: 30px" ng-if="defaultBuilding.recommands && defaultBuilding.recommands.length>35"><a class="bold-font" style="font-size: 20px" ng-click="extendManagerAction()">{{managerExtend?\'\u6536\u8D77\u5C55\u5F00\':\'\u5C55\u5F00\u5168\u90E8\'}}</a></div><div style="text-align: center"><button class="btn btn-primary normal-btn bold-button" style="padding: 10px 50px" ng-click="appointmentAction(\'\u666E\u901A\u4F1A\u5458/\'+userModel.phone)">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div></div></div></div><div style="clear: both"></div></div></div><div style="margin-bottom: 40px; font-size: 20px" class="clearfix member-center-header" ng-if="employeeModel"><div class="clearfix" style="margin-bottom: 60px"><p style="line-height: 40px; font-size: 35px" class="bold-font pull-left">{{employeeModel.companyName}}\uFF0C\u60A8\u5DF2\u7ECF\u5165\u9A7B{{employeeModel.rentDays}}\u5929</p><a class="pull-right" style="margin-top: 10px; font-size: 20px" ng-click="logoutAction()">\u9000\u51FA\u767B\u5F55</a></div><div class="room-content-text-item"><h1><span style="font-size: 16px">\uFFE5</span>{{employeeModel.historyAmount}}</h1><p>\u5DF2\u6D88\u8D39\u91D1\u989D</p></div><div class="room-content-text-item"><h1><span style="font-size: 16px">\uFFE5</span>{{employeeModel.balance}}</h1><p>\u8D26\u6237\u4F59\u989D</p></div><div class="room-content-text-item" uib-tooltip-html="employeeModel.roomQuotaString" tooltip-placement="bottom" tooltip-class="member-center-tooltip"><h1><span style="font-size: 16px">\uFFE5</span>{{employeeModel.roomQuota.available}}</h1><p>\u62B5\u7528\u5238</p></div><div class="room-content-text-item"><h1>{{employeeModel.employeeCount}}\u4EBA</h1><p>\u5458\u5DE5\u6570\u91CF</p></div></div><div class="member-center-container clearfix" ng-if="companyModel" ng-repeat="office in offices track by $index" ng-init="officeIndex = $index" style="margin-bottom: 30px" validate-authority=\'["ROLE_COMPANY_INFO"]\'><div class="member-center-left"><div class="room-header-title"><h1>\u4F60\u7684\u4E13\u5C5E\u7A7A\u95F4{{officeIndex+1}}</h1><p>{{office.buildingName}}{{office.level}}\u5C42 <span ng-repeat="room in office.rooms track by $index" ng-init="ri = $index">{{ri==0||ri==office.rooms.length-1 ? room.name : (room.name+" ,")}}</span> \u5BA4</p></div><div class="room-content-image"><div uib-carousel active="active" interval="myInterval" no-wrap="noWrapSlides" style="width: 100%; height: 100%; overflow: hidden"><div uib-slide ng-repeat="room in office.rooms track by $index" index="roomIndex = $index"><img lazy-src="{{room.imageUrl}}" animate-visible="true" animate-speed="0.5s" style="width: 100%; height:100%; object-fit: cover"></div></div></div><div class="room-content-text clearfix"><div class="room-content-text-item"><h1>{{office.rentDays}}\u5929</h1><p>\u5DF2\u7ECF\u5165\u9A7B</p></div><div class="room-content-text-item"><h1>{{office.initialTime | date:\'yyyy\u5E74MM\u6708dd\u65E5\'}}</h1><p>\u5165\u9A7B\u65F6\u95F4</p></div><a ng-click="extendMeetingAtIndex(office)">{{office.extendArea?"\u6536\u8D77":"\u5C55\u5F00"}}</a></div><div class="room-content-records" ng-if="office.extendArea"><p class="room-content-records-title">\u9884\u5B9A\u7684\u4F1A\u8BAE\u5BA4</p><div class="clearfix" ng-repeat="meeting in office.meetings track by $index" ng-init="meetingIndex = $index"><div class="mc-meeting-title">\u4F1A\u8BAE\u4E3B\u9898: {{meeting.inProgressItem.subject}}</div><div class="room-content-absolute-box"><div class="box-left-item" style="width: 180px"><h1>{{meeting.inProgressItem.roomName}}\u5BA4</h1><p>\u623F\u95F4\u53F7</p></div><div class="box-left-item" style="width: 280px"><h1>{{meeting.inProgressItem.date | date:\'yyyy\u5E74MM\u6708dd\u65E5\'}}</h1><p>\u65E5\u671F</p></div><div class="box-left-item" style="padding-right: 0; width: 295px"><h1 style="white-space: nowrap; overflow: hidden; width: 100%">{{meeting.inProgressItem.durationInHours}}\u5C0F\u65F6\uFF0C{{meeting.inProgressItem.startTime|date:\'HH:mm\'}}-{{meeting.inProgressItem.endTime|date:\'HH:mm\'}}</h1><p>\u65F6\u95F4</p></div></div><div class="pull-right" style="margin-bottom: 10px"><a style="margin-right: 30px" ng-click="cancelAppointment(meeting, office)">\u53D6\u6D88\u9884\u5B9A</a> <a ng-click="editAppointment(meeting, office)">\u4FEE\u6539\u9884\u5B9A</a></div></div></div><!--<div class="text-center" ng-if="office.extendArea" validate-authority=\'["ROLE_APPOINT_MEETING_RECORD"]\'>--><!--<button class="btn btn-default" style="padding: 10px 30px; margin: 30px 0" ng-click="appointmentRecord()">\u67E5\u770B\u9884\u5B9A\u8BB0\u5F55</button>--><!--</div>--><div class="room-content-records" ng-if="office.extendArea"><p class="room-content-records-title">\u7BA1\u5BB6\u670D\u52A1</p><div class="room-content-records-box"><div class="box-center-item" ng-click="appointmentMeetingAction(office)" validate-authority=\'["ROLE_APPOINT_MEETING"]\'><div class="member-center-icon"><img src="content/images/mcenter_meeting.png" alt=""></div><p>\u4F1A\u8BAE\u5BA4\u9884\u5B9A</p></div><div class="box-center-item" ng-click="memberWiFi(office)" validate-authority=\'["ROLE_WIFI"]\'><div class="member-center-icon"><img src="content/images/mcenter_wifi.png" alt=""></div><p>Wi-Fi\u5BC6\u7801</p></div><div class="box-center-item" ng-click="accessRecords(office)" validate-authority=\'["ROLE_CREDIT_CARD_RECORD"]\'><div class="member-center-icon"><img src="content/images/mcenter_cre_records.png" alt=""></div><p>\u5237\u5361\u8BB0\u5F55</p></div><div class="box-center-item" ng-click="appointmentRecord()" validate-authority=\'["ROLE_APPOINT_MEETING_RECORD"]\'><div class="member-center-icon"><img src="content/images/mcenter_mrecords.jpeg" alt=""></div><p>\u67E5\u770B\u9884\u5B9A\u8BB0\u5F55</p></div><div class="box-center-item" ng-click="memberAccountInfo()" validate-authority=\'["ROLE_PERSONAL"]\'><div class="member-center-icon"><img src="content/images/mcenter_settings.png" alt=""></div><p>\u4FEE\u6539\u4E2A\u4EBA\u4FE1\u606F</p></div></div></div></div><div class="member-center-right"><div class="agency-content"><img lazy-src="{{office.managerHeadImage}}" animate-visible="true" animate-speed="0.5s" alt=""><div class="agency-title-name"><h1 class="bold-font">{{office.managerName}}</h1><p>\u4E13\u5C5E\u987E\u95EE</p></div><div style="clear: both"></div><div class="agency-content-text"><p>\u8054\u7CFB\u65B9\u5F0F\uFF1A{{office.managerPhone}}</p><p>\u670D\u52A1\u65F6\u95F4\uFF1A08:00 - 21:00</p><p style="margin: 15px 0; text-indent: 1em; overflow: hidden" ng-style="{\'max-height\': office.managerExtend?\'\':\'42px\'}">{{office.recommands && office.recommands.length>35 && !office.managerExtend ? (office.recommands.substring(0, 30)+"......"):office.recommands}}</p><div style="text-align: right; margin-bottom: 30px" ng-if="office.recommands && office.recommands.length>35"><a class="bold-font" style="font-size: 20px" ng-click="extendManagerAction(office)">{{office.managerExtend?\'\u6536\u8D77\u5C55\u5F00\':\'\u5C55\u5F00\u5168\u90E8\'}}</a></div><div style="text-align: center"><button class="btn btn-primary normal-btn bold-button" style="padding: 10px 50px" ng-click="appointmentAction(\'\u79DF\u6237\u4F1A\u5458/\'+userModel.phone+\'/\'+office.buildingName)">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div></div></div><!--<div class="agency-content" ng-style="{top: agencyContentTop+\'px\'}">--><!--<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1562320350402&di=c1636777856b12fa10be3eaaf25085da&imgtype=0&src=http%3A%2F%2Fe.hiphotos.baidu.com%2Fimage%2Fpic%2Fitem%2F4610b912c8fcc3cef70d70409845d688d53f20f7.jpg" alt="">--><!--<div class="agency-content-text">--><!--<p class="agency-name">\u5F20\u4E09 <span>\u51B3\u7B56\u987E\u95EE</span></p>--><!--<p>\u8054\u7CFB\u65B9\u5F0F\uFF1A18900000000</p>--><!--<p>\u670D\u52A1\u65F6\u95F4\uFF1A09:00 - 17:00</p>--><!--<p style="margin: 15px 0">\u201C\u4E5D\u5B89\u5E7F\u573A\u91D1\u5EA7\u662F\u9759\u5B89\u533A\u7684\u70ED\u95E8\u5546\u4E1A\u529E\u516C\u697C\uFF0C\u4EBA\u6C14\u65FA\uFF0C\u6211\u5341\u5206\u63A8\u8350\u2026\u2026\u201D</p>--><!--<div style="text-align: center">--><!--<button class="btn btn-primary normal-btn bold-font member-center-contact">\u8054\u7CFB\u5F20\u4E09</button>--><!--</div>--><!--</div>--><!--</div>--></div></div></div></div></div>');
$templateCache.put('app/module/member-center/member-forgot-password.html','<div class="modal-body"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="dismissModalAction()">--><!--<i class="iconfont icon-close"></i>--><!--</button>--><h4 class="modal-title">\u5FD8\u8BB0\u5BC6\u7801</h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="forgotPassword()" show-validation><div><div class="vp-full-input-group"><input class="vp-full-input" type="text" placeholder="\u624B\u673A\u53F7" ng-model="forgotModel.phone" ng-pattern="/^1[3456789]\\d{9}$/" name="phone" required><p class="vp-input-error" ng-if="editForm.phone.$error.pattern">\u624B\u673A\u53F7\u4E0D\u6B63\u786E</p></div><div class="vp-full-input-group clearfix"><input class="vp-full-input" type="text" placeholder="\u77ED\u4FE1\u9A8C\u8BC1\u7801" style="width: calc(100% - 210px); float: left" required ng-model="forgotModel.vCode"> <button type="button" class="btn btn-primary reverse-btn absolute-btn" style="width: 200px; float: right" ng-click="getVerification()" ng-disabled="editForm.phone.$error.pattern || !forgotModel.phone || !canVerify">{{counter===0?"\u83B7\u53D6\u9A8C\u8BC1\u7801":(counter+"s\u540E\u91CD\u8BD5")}}</button></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" name="passwordRaw" placeholder="\u8BBE\u7F6E\u65B0\u5BC6\u7801" required ng-minlength="8" ng-maxlength="20" ng-model="forgotModel.passwordRaw"><p class="vp-input-error" ng-if="editForm.passwordRaw.$error.minlength||editForm.passwordRaw.$error.maxlength">\u8BF7\u8F93\u51658-20\u4F4D\u5BC6\u7801</p></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" placeholder="\u518D\u6B21\u5F55\u5165\u5BC6\u7801" required ng-model="forgotModel.confirm"><p class="vp-input-error" ng-if="forgotModel.passwordRaw && forgotModel.confirm && forgotModel.passwordRaw!=forgotModel.confirm">\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4</p></div></div><div class="modal-footer"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()">\u53D6\u6D88</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-disabled="editForm.$invalid || forgotModel.passwordRaw!=forgotModel.confirm">\u91CD\u7F6E</button></div></div></form></div>');
$templateCache.put('app/module/member-center/member-info.html','<div class="member-account-container"><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">\u4FEE\u6539\u4E2A\u4EBA\u4FE1\u606F</p><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="updateProfile()" show-validation=""><div class="row"><div class="ml-input-group"><label class="ml-input-group-label" required>\u624B\u673A\u53F7<sup>*</sup></label><div class="ml-input-group-input" style="width: 310px">{{userModel.phone}}</div></div><div class="ml-input-group"><label class="ml-input-group-label" required>\u5BC6\u7801<sup>*</sup></label><div class="ml-input-group-input" style="width: 310px">********** <a ng-click="resetPassword()">\u4FEE\u6539\u5BC6\u7801</a></div></div><div class="ml-input-group"><label class="ml-input-group-label" required>\u59D3\u540D</label><div class="ml-input-group-input" style="width: 310px"><input type="text" class="ml-input-group-input1" autocomplete="off" name="fullname" ng-model="userModel.fullname" required></div></div><div class="ml-input-group"><label class="ml-input-group-label" required>\u6027\u522B</label><div class="ml-input-group-input" style="width: 310px"><span ng-click="userModel.gender=1" class="radio-container" style="margin-right: 50px"><span class="iconfont radio-style" ng-class="{\'icon-radio-active\':userModel.gender==1,\'icon-radio-normal\':userModel.gender!=1}"></span> <span style="color: #292929; font-size: 20px">\u7537</span> </span><span ng-click="userModel.gender=2" class="radio-container"><span class="iconfont radio-style" ng-class="{\'icon-radio-active\':userModel.gender==2,\'icon-radio-normal\':userModel.gender!=2}"></span> <span style="color: #292929; font-size: 20px">\u5973</span></span></div></div><div class="ml-input-group"><label class="ml-input-group-label" required>\u90AE\u7BB1<sup>*</sup></label><div class="ml-input-group-input" style="width: 310px"><input type="text" class="ml-input-group-input1" autocomplete="off" name="email" ng-pattern="/^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\\.[a-zA-Z]{2,3}$/" ng-model="userModel.email" required><div class="ml-form-error"><p ng-if="editForm.email.$error.pattern">\u90AE\u7BB1\u683C\u5F0F\u9519\u8BEF \uFF01</p></div></div></div><!--<div class="ml-input-group">--><!--<label class="ml-input-group-label" required>\u6301\u5361ID</label>--><!--<div class="ml-input-group-input" style="width: 310px">--><!--{{accessCardId}}--><!--</div>--><!--</div>--><div class="ml-input-group"><label class="ml-input-group-label" required>\u516C\u53F8\u540D</label><div class="ml-input-group-input" style="width: 310px">{{userModel.companyName}}</div></div><!--<div class="ml-input-group">--><!--<label class="ml-input-group-label" required>\u4E13\u5C5E\u7A7A\u95F4</label>--><!--<div class="ml-input-group-input" style="width: 310px">--><!--{{roomName}}--><!--</div>--><!--</div>--></div><div class="modal-footer"><div style="text-align: left"><button type="button" class="btn btn-default bold-button" style="padding: 5px 60px; margin-right: 30px" ng-click="dismissModalAction()">\u53D6\u6D88</button> <button type="submit" class="btn btn-primary normal-btn bold-button" style="padding: 5px 60px" ng-disabled="editForm.$invalid">\u66F4\u65B0</button></div></div></form><div class="member-account-header" style="padding: 60px 100px"><p class="bold-font">\u7528\u6237\u5934\u50CF</p><img lazy-src="{{userModel.imageUrl?userModel.imageUrl:\'content/images/header-placeholder.png\'}}" animate-visible="true" animate-speed="0.5s" alt="" style="width: 200px; height: 200px; margin: 20px 0; border-radius: 10px"><p class="bold-font">\u5EFA\u8BAE\u5C3A\u5BF8\uFF1A100 * 100\u50CF\u7D20</p><button type="button" class="btn btn-default bold-button" ng-click="headerUpload()">\u4E0A\u4F20</button></div></div><style>.row{margin: 0}\n    .ml-input-group{float: none !important;}\n    .ml-input-group:after{display: block; clear: both; content: \'\';}\n    .ml-input-group-label{color: #292929; text-align: left !important; font-size: 20px}\n    .ml-input-group-label:after{display: none}\n    .ml-input-group-input{font-weight: 300; color: #292929; font-size: 20px; font-family:STHeitiSC-Light}</style>');
$templateCache.put('app/module/member-center/member-reset-password.html','<div class="modal-body"><div class="modal-header"><h4 class="modal-title">\u4FEE\u6539\u4E2A\u4EBA\u5BC6\u7801</h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="resetPassword()" show-validation><div><div class="vp-full-input-group"><input class="vp-full-input" name="oldPassword" type="password" placeholder="\u8BF7\u8F93\u5165\u539F\u5BC6\u7801" ng-model="resetModel.oldPassword" required></div><div class="vp-full-input-group"><input class="vp-full-input" name="newPassword" type="password" placeholder="\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801" ng-model="resetModel.newPassword" required ng-minlength="8" ng-maxlength="20"><p class="vp-input-error" ng-if="editForm.newPassword.$error.minlength||editForm.newPassword.$error.maxlength">\u8BF7\u8F93\u51658-20\u4F4D\u5BC6\u7801</p></div><div class="vp-full-input-group"><input class="vp-full-input" name="confirm" type="password" placeholder="\u8BF7\u786E\u8BA4\u65B0\u5BC6\u7801" ng-model="resetModel.confirm" required><p class="vp-input-error" ng-if="resetModel.confirm&&resetModel.newPassword&&(resetModel.confirm!=resetModel.newPassword)">\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E00\u81F4</p></div></div><div class="modal-footer"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()">\u53D6\u6D88</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-disabled="editForm.$invalid || resetModel.confirm!=resetModel.newPassword">\u4FEE\u6539</button></div></div></form></div>');
$templateCache.put('app/module/member-center/member-wifi.html','<div style="padding: 60px"><p style="font-size: 28px; margin-bottom: 30px; color: #292929" class="bold-font">Wi-Fi\u5BC6\u7801</p><div><div style="margin-bottom: 20px"><p class="member-wifi-title">{{wifiModel.buildingName}}\u7684Wi-Fi</p><p class="member-wifi-content" ng-if="!wifiModel.wifi || !wifiModel.password">\u672A\u8BBE\u7F6EWi-Fi</p><div ng-if="wifiModel.wifi && wifiModel.password"><p class="member-wifi-content">{{wifiModel.wifi}}</p><p class="member-wifi-name">\u540D\u79F0</p><p class="member-wifi-content">{{wifiModel.password}}</p><p class="member-wifi-name">\u5BC6\u7801</p></div></div><div ng-repeat="wifi in wifiModel.roomWifiDTOS" style="margin-bottom: 20px"><p class="member-wifi-title">{{wifi.roomName}}\u7684Wi-Fi</p><p class="member-wifi-content" ng-if="!wifi.wifi || !wifi.password">\u672A\u8BBE\u7F6EWi-Fi</p><div ng-if="wifi.wifi && wifi.password"><p class="member-wifi-content">{{wifi.wifi}}</p><p class="member-wifi-name">\u540D\u79F0</p><p class="member-wifi-content">{{wifi.password}}</p><p class="member-wifi-name">\u5BC6\u7801</p></div></div><div class="modal-footer"><div class="text-center"><button type="button" data-dismiss="modal" class="btn btn-primary normal-btn" ng-click="dismissModalAction()" style="padding: 10px 50px; margin-top: 10px">\u5173\u95ED</button></div></div></div></div><style>.auto-width{width: auto}</style>');
$templateCache.put('app/module/register/register.html','<div class="modal-body"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="dismissModalAction()">--><!--<i class="iconfont icon-close"></i>--><!--</button>--><h4 class="modal-title">\u624B\u673A\u6CE8\u518C3work\u8D26\u53F7<span style="float: right;font-size: 18px;color: #9B9B9B; font-weight: 400">\u5DF2\u6709\u8D26\u53F7\uFF1F<a ng-click="requestLoginAction()">\u767B\u5F55</a></span></h4></div><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="registerAction()" show-validation><div><div class="vp-full-input-group"><input class="vp-full-input" type="text" placeholder="\u59D3\u540D" ng-model="registerModel.name" required></div><div class="vp-full-input-group"><input class="vp-full-input" type="text" placeholder="\u624B\u673A\u53F7" ng-model="registerModel.phone" ng-pattern="/^1[3456789]\\d{9}$/" name="phone" required><p class="vp-input-error" ng-if="editForm.phone.$error.pattern">\u624B\u673A\u53F7\u4E0D\u6B63\u786E</p></div><div class="vp-full-input-group clearfix"><input class="vp-full-input" type="text" placeholder="\u77ED\u4FE1\u9A8C\u8BC1\u7801" style="width: calc(100% - 210px); float: left" required ng-model="registerModel.code"> <button type="button" class="btn btn-primary reverse-btn absolute-btn" style="width: 200px; float: right" ng-click="getVerification()" ng-disabled="editForm.phone.$error.pattern || !registerModel.phone || !canVerify">{{counter===0?"\u83B7\u53D6\u9A8C\u8BC1\u7801":(counter+"s\u540E\u91CD\u8BD5")}}</button></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" placeholder="\u5BC6\u7801(8-20\u4F4D)" required ng-minlength="8" ng-maxlength="20" ng-model="registerModel.passwordRaw"><p class="vp-input-error" ng-if="editForm.password.$error.minlength||editForm.password.$error.maxlength">\u8BF7\u8F93\u51658-20\u4F4D\u5BC6\u7801</p></div><div class="vp-full-input-group"><input class="vp-full-input" type="password" placeholder="\u518D\u6B21\u5F55\u5165\u5BC6\u7801" required ng-model="registerModel.oldPassword"><p class="vp-input-error" ng-if="registerModel.passwordRaw && registerModel.oldPassword && registerModel.passwordRaw!=registerModel.oldPassword">\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u7EDF\u4E00</p></div><div class="text-center"><vp-checkbox vp-model="agreementNegotiate"></vp-checkbox><!--<span>\u5DF2\u9605\u8BFB\u5E76\u540C\u610F<span>\u300A\u7528\u6237\u534F\u8BAE\u300B</span></span>--> <span style="font-size: 20px; color: #292929" class="bold-font">\u52A0\u5165\u4F1A\u5458\uFF0C\u5DF2\u9605\u8BFB\u5E76\u540C\u610F<a ng-click="jumpNegotiation()">\u300A\u7528\u6237\u534F\u8BAE\u300B</a></span></div></div><div class="modal-footer"><div class="text-center"><button type="button" class="btn btn-default absolute-btn" ng-click="dismissModalAction()">\u5173\u95ED</button> <button type="submit" class="btn btn-primary normal-btn absolute-btn" ng-disabled="editForm.$invalid || (registerModel.passwordRaw && registerModel.oldPassword && registerModel.passwordRaw!=registerModel.oldPassword)">\u6CE8\u518C</button></div></div></form></div>');
$templateCache.put('app/module/room/room-detail.html','<div class="limit-container" style="margin-top: 85px"><div class="limit-center-content" style="padding: 60px"><div style="padding-bottom: 20px; border-bottom: 1px solid #C9C9C9" class="clearfix"><div class="building-detail-header building-detail-hoverable" ui-sref="home"><span>\u9996\u9875</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{buildingModel.cityName}}</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{buildingModel.regionName}}</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header building-detail-hoverable" ui-sref="buildingDetail({id: buildingModel.id})"><span>{{buildingModel.name}}</span> <span class="iconfont icon-ai-arrow-right-copy"></span></div><div class="building-detail-header"><span>{{roomModel.title}}</span></div></div><div style="padding: 54px 38px; color: #292929"><div class="clearfix building-header-container"><p class="bold-font pull-left building-header-left">{{roomModel.title}}</p><p class="pull-right building-header-right"><span uib-tooltip="{{buildingModel.address.length>37?buildingModel.address:null}}" tooltip-class="member-center-tooltip" tooltip-placement="bottom">{{buildingModel.address}}</span><br><span uib-tooltip="{{buildingModel.tranfficInfo.length>37?buildingModel.tranfficInfo:null}}" tooltip-class="member-center-tooltip" tooltip-placement="bottom">{{buildingModel.tranfficInfo}}</span></p></div><div style="width: 100%; padding-right: 414px; position: relative"><div><div class="home-swiper" style="margin-bottom: 80px"><ul class="swiper-container home-swiper-container"><li class="swiper_animation" ng-repeat="image in roomModel.previewImages.images track by image.id" ng-style="swiper_animation"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li></ul><ul class="swiper-button-container home-swiper-button"><li ng-click="tapSwiperBtn($index)" ng-class="{\'swiper-active\':swiper_countor==$index}" ng-repeat="image in roomModel.previewImages.images track by $index"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li></ul><div class="iconfont icon-ai-arrow-left-copy home-swiper-pre" ng-if="swiper_countor!=0" ng-click="previousImageAction()"></div><div class="iconfont icon-ai-arrow-right-copy home-swiper-next" ng-if="swiper_countor!=roomModel.previewImages.images.length-1" ng-click="nextImageAction()"></div><a class="home-swiper-absolute" ng-if="roomModel.arEnabled" ng-href="{{roomModel.arSiteUrl}}" target="_blank">\u5168\u666F</a></div><p class="building-detail-title bold-font">\u623F\u95F4\u4FE1\u606F</p><div><div class="clearfix" style="margin-bottom: 40px; margin-top: 40px"><div class="room-detail-info" ng-if="!roomModel.promotionEnabled"><p class="bold-font room-detail-info-top room-detail-info-gold">\uFFE5{{roomModel.price.toPrice()}}/{{roomModel.priceUnit}}</p><!--<p class="room-detail-info-bottom">\u4F18\u60E0\u6D3B\u52A8\u4EF7\u683C</p>--></div><div class="room-detail-info" ng-if="roomModel.promotionEnabled"><p class="bold-font room-detail-info-top room-detail-info-gold">\uFFE5{{roomModel.promotionPrice.toPrice()}}/{{roomModel.promotionPriceUnit}}</p><p class="room-detail-info-bottom">\u4F18\u60E0\u6D3B\u52A8\u4EF7\u683C</p></div></div><div class="clearfix" style="margin-bottom: 40px"><div class="room-detail-info"><p class="bold-font room-detail-info-top">{{roomModel.level}}\u5C42</p><p class="room-detail-info-bottom">\u697C\u5C42</p></div><div class="room-detail-info"><p class="bold-font room-detail-info-top">{{roomModel.areaSize}}m<sup>2</sup></p><p class="room-detail-info-bottom">\u9762\u79EF</p></div><div class="room-detail-info"><p class="bold-font room-detail-info-top">{{roomModel.capacity}}\u4EBA</p><p class="room-detail-info-bottom">\u53EF\u5BB9\u7EB3</p></div><div class="room-detail-info" ng-if="roomModel.orientation"><p class="bold-font room-detail-info-top">{{roomModel.orientation}}</p><p class="room-detail-info-bottom">\u671D\u5411</p></div></div><div class="clearfix room-detail-intro"><p>\u5C0F\u533A\u540D\u79F0\uFF1A{{buildingModel.name}}</p><p>\u79DF\u7528\u72B6\u6001\uFF1A{{statusNameList[statusValueList.indexOf(roomModel.state)]}}</p><p>\u6240\u5728\u533A\u57DF\uFF1A{{buildingModel.regionName}}</p><p>\u79DF\u7528\u5230\u671F\uFF1A{{roomModel.rentEndTime | date:"yyyy-MM-dd HH:mm"}}</p></div><button class="btn btn-primary normal-btn bold-font" ng-disabled="roomModel.state==\'RENTED\'" style="margin-top: 50px; padding: 5px 40px; font-size: 18px; margin-bottom: 20px" ng-click="appointmentAction()">\u9884\u7EA6</button></div><p class="building-detail-title bold-font">\u623F\u95F4\u4F4D\u7F6E\u56FE</p><p style="font-size: 16px; line-height: 30px; margin-bottom: 20px">{{roomModel.roomIntroduction}}</p><div class="home-swiper" style="margin-bottom: 80px"><ul class="swiper-container home-swiper-container"><li class="swiper_animation" ng-repeat="image in roomModel.roomImages.images track by image.id" ng-style="rooms_animation"><img lazy-src="{{image.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></li><div class="iconfont icon-ai-arrow-left-copy home-swiper-pre" ng-if="rooms_countor!=0" ng-click="previousRoomImageAction()"></div><div class="iconfont icon-ai-arrow-right-copy home-swiper-next" ng-if="rooms_countor!=roomModel.roomImages.images.length-1" ng-click="nextRoomImageAction()"></div></ul></div><p class="building-detail-title bold-font">\u914D\u5957\u8BBE\u65BD</p><div class="map-button-container clearfix"><div class="map-button-item" ng-repeat="facility in buildingModel.facilities track by $index" style="margin: 30px 100px 30px 0" uib-tooltip-html="facility.description" tooltip-placement="bottom-left" tooltip-class="facility-tooltip"><div class="map-button-image"><img lazy-src="{{facility.imageUrl}}" animate-visible="true" animate-speed="0.5s" alt=""></div><br><p>{{facility.name}}</p></div></div><!--<div style="margin-right: -30px" class="clearfix">--><!--<div class="building-detail-facility" ng-repeat="facility in buildingModel.facilities track by facility.id">--><!--<p style="" class="bold-font facility-name">{{facility.name}}</p>--><!--<p>{{facility.description}}</p>--><!--</div>--><!--</div>--><p class="building-detail-title bold-font">\u697C\u5B87\u5468\u8FB9</p><p style="font-size: 18px; line-height: 30px">{{buildingModel.address}}<br>{{buildingModel.tranfficInfo}}</p><p style="font-size: 18px; margin-bottom: 20px; margin-top: 20px" class="bold-font">\u663E\u793A\u9644\u8FD1\u7684\u8BBE\u65BD</p><div class="map-button-container clearfix"><div class="map-button-item" ng-click="nearbySearch([\'\u5730\u94C1\',\'\u516C\u4EA4\u7AD9\'])"><div class="map-button-image"><img src="content/images/map_traffic.png" alt=""></div><br><p>\u4EA4\u901A</p></div><div class="map-button-item" ng-click="nearbySearch([\'\u9910\u996E\',\'\u8D2D\u7269\'])"><div class="map-button-image"><img src="content/images/map_resterant.png" alt=""></div><br><p>\u9910\u996E\u8D2D\u7269</p></div><div class="map-button-item" ng-click="nearbySearch(\'\u6559\u80B2\u673A\u6784\')"><div class="map-button-image"><img src="content/images/map_education.png" alt=""></div><br><p>\u6559\u80B2\u673A\u6784</p></div><div class="map-button-item" ng-click="nearbySearch(\'\u533B\u7597\')"><div class="map-button-image"><img src="content/images/map_hospital.png" alt=""></div><br><p>\u533B\u7597\u8BBE\u65BD</p></div></div><div style="width: 100%; height: 484px" id="baiduMap"></div></div><div class="agency-container"><!--<div class="agency-content" ng-style="{top: agencyContentTop+\'px\'}">--><!--<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1562320350402&di=c1636777856b12fa10be3eaaf25085da&imgtype=0&src=http%3A%2F%2Fe.hiphotos.baidu.com%2Fimage%2Fpic%2Fitem%2F4610b912c8fcc3cef70d70409845d688d53f20f7.jpg" alt="">--><!--<div class="agency-content-text">--><!--<p class="agency-name">\u5F20\u4E09 <span>\u51B3\u7B56\u987E\u95EE</span></p>--><!--<p>\u8054\u7CFB\u65B9\u5F0F\uFF1A18900000000</p>--><!--<p>\u670D\u52A1\u65F6\u95F4\uFF1A09:00 - 17:00</p>--><!--<p style="margin: 15px 0">\u201C\u4E5D\u5B89\u5E7F\u573A\u91D1\u5EA7\u662F\u9759\u5B89\u533A\u7684\u70ED\u95E8\u5546\u4E1A\u529E\u516C\u697C\uFF0C\u4EBA\u6C14\u65FA\uFF0C\u6211\u5341\u5206\u63A8\u8350\u2026\u2026\u201D</p>--><!--<div style="text-align: right; margin-bottom: 15px">--><!--<a class="bold-font">\u5C55\u5F00\u5168\u90E8</a>--><!--</div>--><!--<div style="text-align: center">--><!--<button class="btn btn-primary normal-btn bold-font" style="padding: 10px 30px">\u987E\u95EE\u4E00\u5BF9\u4E00</button>--><!--</div>--><!--</div>--><!--</div>--><div class="agency-content" ng-style="{top: agencyContentTop+\'px\'}"><img lazy-src="{{roomModel.managerHeadImage}}" animate-visible="true" animate-speed="0.5s" alt=""><div class="agency-title-name"><h1 class="bold-font">{{roomModel.managerName}}</h1><p>\u4E13\u5C5E\u987E\u95EE</p></div><div style="clear: both"></div><div class="agency-content-text"><p>\u8054\u7CFB\u65B9\u5F0F\uFF1A{{roomModel.managerPhone}}</p><p>\u54A8\u8BE2\u65F6\u95F4\uFF1A08:00 - 21:00</p><p style="margin: 15px 0; text-indent: 1em; overflow: hidden" ng-style="{\'max-height\': managerExtend?\'\':\'42px\'}">{{roomModel.recommands && roomModel.recommands.length>35 && !managerExtend ? (roomModel.recommands.substring(0, 30)+"......"):roomModel.recommands}}</p><div style="text-align: right; margin-bottom: 30px" ng-if="roomModel.recommands && roomModel.recommands.length>35"><a class="bold-font" style="font-size: 20px" ng-click="extendManagerAction()">{{managerExtend?\'\u6536\u8D77\u5C55\u5F00\':\'\u5C55\u5F00\u5168\u90E8\'}}</a></div><div style="text-align: center"><button class="btn btn-primary normal-btn bold-button" style="padding: 10px 50px" ng-click="appointmentAction()">\u987E\u95EE\u4E00\u5BF9\u4E00</button></div></div></div></div></div></div></div></div>');}]);})();